//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AccountsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(command: CreateAccountCommand, cancelToken?: CancelToken): Promise<UserAccountDto> {
        let url_ = this.baseUrl + "/api/v1/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserAccountDto.fromJS(resultData200);
            return Promise.resolve<UserAccountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAccountDto>(null as any);
    }

    edit(command: EditAccountCommand, cancelToken?: CancelToken): Promise<UserAccountDto> {
        let url_ = this.baseUrl + "/api/v1/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<UserAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserAccountDto.fromJS(resultData200);
            return Promise.resolve<UserAccountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAccountDto>(null as any);
    }

    getLoggedInUserAccount(includeFields?: string | null | undefined, cancelToken?: CancelToken): Promise<UserAccountDto> {
        let url_ = this.baseUrl + "/api/v1/accounts?";
        if (includeFields !== undefined && includeFields !== null)
            url_ += "includeFields=" + encodeURIComponent("" + includeFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoggedInUserAccount(_response);
        });
    }

    protected processGetLoggedInUserAccount(response: AxiosResponse): Promise<UserAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserAccountDto.fromJS(resultData200);
            return Promise.resolve<UserAccountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAccountDto>(null as any);
    }

    linkUserToOpportunitiesAndContact(command: LinkUserToOpportunitiesAndContactCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/linkUserToOpportunitiesAndContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkUserToOpportunitiesAndContact(_response);
        });
    }

    protected processLinkUserToOpportunitiesAndContact(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    linkAccounts(command: LinkAccountsCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/accounts/linkAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkAccounts(_response);
        });
    }

    protected processLinkAccounts(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    editBroker(command: EditBrokerAccountCommand, cancelToken?: CancelToken): Promise<UserAccountDto> {
        let url_ = this.baseUrl + "/api/v1/accounts/broker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditBroker(_response);
        });
    }

    protected processEditBroker(response: AxiosResponse): Promise<UserAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserAccountDto.fromJS(resultData200);
            return Promise.resolve<UserAccountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAccountDto>(null as any);
    }

    editHiddenFields(command: EditHiddenFieldsCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/editHiddenFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditHiddenFields(_response);
        });
    }

    protected processEditHiddenFields(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    forgotPassword(command: ForgotPasswordCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    resetPassword(command: ResetPasswordCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/resetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    sendVerifyUserCodeEmailAccount(command: SendVerificationNotificationCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/sendVerifyUserCodeEmailAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendVerifyUserCodeEmailAccount(_response);
        });
    }

    protected processSendVerifyUserCodeEmailAccount(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    verifyAccountByUserCode(command: VerifyAccountByUserCodeCommand, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/accounts/verifyAccountByUserCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyAccountByUserCode(_response);
        });
    }

    protected processVerifyAccountByUserCode(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    verifyAccountByToken(token?: string | null | undefined, accountId?: string | null | undefined, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/accounts/verifyAccountByToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyAccountByToken(_response);
        });
    }

    protected processVerifyAccountByToken(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    getVerificationCode(query: GetAccountVerificationCodeQuery, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/verificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVerificationCode(_response);
        });
    }

    protected processGetVerificationCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createIdentityAndSelfieInquiry(command: CreateInquiryCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/createIdentityAndSelfieInquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIdentityAndSelfieInquiry(_response);
        });
    }

    protected processCreateIdentityAndSelfieInquiry(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createSelfieInquiry(command: CreateInquiryCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/createSelfieInquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSelfieInquiry(_response);
        });
    }

    protected processCreateSelfieInquiry(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    refreshSelfieVerificationAndRedirect(verificationId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/refreshSelfieVerificationRedirect?";
        if (verificationId !== undefined && verificationId !== null)
            url_ += "verificationId=" + encodeURIComponent("" + verificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshSelfieVerificationAndRedirect(_response);
        });
    }

    protected processRefreshSelfieVerificationAndRedirect(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    refreshIdentityVerificationAndRedirect(verificationId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/refreshIdentityVerificationAndRedirect?";
        if (verificationId !== undefined && verificationId !== null)
            url_ += "verificationId=" + encodeURIComponent("" + verificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshIdentityVerificationAndRedirect(_response);
        });
    }

    protected processRefreshIdentityVerificationAndRedirect(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getVerification( cancelToken?: CancelToken): Promise<PersonaVerificationDto> {
        let url_ = this.baseUrl + "/api/v1/accounts/verification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVerification(_response);
        });
    }

    protected processGetVerification(response: AxiosResponse): Promise<PersonaVerificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PersonaVerificationDto.fromJS(resultData200);
            return Promise.resolve<PersonaVerificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonaVerificationDto>(null as any);
    }

    createOrGetVerificationSession(command: CreateOrGetExistingVerificationSessionCommand, cancelToken?: CancelToken): Promise<VerifyResult> {
        let url_ = this.baseUrl + "/api/v1/accounts/verificationSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrGetVerificationSession(_response);
        });
    }

    protected processCreateOrGetVerificationSession(response: AxiosResponse): Promise<VerifyResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifyResult.fromJS(resultData200);
            return Promise.resolve<VerifyResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerifyResult>(null as any);
    }

    refreshVerificationAndRedirect(userId: string, redirectUrl?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/accounts/{userId}/refreshVerificationAndRedirect?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshVerificationAndRedirect(_response);
        });
    }

    protected processRefreshVerificationAndRedirect(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getIdentityFile( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/accounts/identityFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdentityFile(_response);
        });
    }

    protected processGetIdentityFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllIdentityFiles(userId?: string | null | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/accounts/identityFiles?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllIdentityFiles(_response);
        });
    }

    protected processGetAllIdentityFiles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    uploadProfileImage(file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/accounts/profileImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProfileImage(_response);
        });
    }

    protected processUploadProfileImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteProfileImage( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/accounts/profileImage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProfileImage(_response);
        });
    }

    protected processDeleteProfileImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addToWaitList(command: AddToWaitListCommand, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/accounts/waitlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToWaitList(_response);
        });
    }

    protected processAddToWaitList(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    setIdentityVerificationAsCompleted( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/accounts/setIdentityVerificationAsCompleted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIdentityVerificationAsCompleted(_response);
        });
    }

    protected processSetIdentityVerificationAsCompleted(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    debugIdentityImages( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/accounts/debugIdentityImages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDebugIdentityImages(_response);
        });
    }

    protected processDebugIdentityImages(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AdminClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    purgeListing(command: PurgeListingCommand, cancelToken?: CancelToken): Promise<PurgeListingResult> {
        let url_ = this.baseUrl + "/api/v1/admin/purgeListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurgeListing(_response);
        });
    }

    protected processPurgeListing(response: AxiosResponse): Promise<PurgeListingResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurgeListingResult.fromJS(resultData200);
            return Promise.resolve<PurgeListingResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurgeListingResult>(null as any);
    }

    purgeUserData(command: PurgeUserDataCommand, cancelToken?: CancelToken): Promise<PurgeUserDataResult> {
        let url_ = this.baseUrl + "/api/v1/admin/purgeUserData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurgeUserData(_response);
        });
    }

    protected processPurgeUserData(response: AxiosResponse): Promise<PurgeUserDataResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurgeUserDataResult.fromJS(resultData200);
            return Promise.resolve<PurgeUserDataResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurgeUserDataResult>(null as any);
    }

    generateSeedData(targetStage?: string | null | undefined, sellerEmails?: string[] | null | undefined, buyerEmails?: string[] | null | undefined, language?: string | null | undefined, autoConfirmEmails?: boolean | undefined, customAddress_LandRegistry?: string | null | undefined, customAddress_LandRegistryType?: string | null | undefined, customAddress_Street?: string | null | undefined, customAddress_UnitNumber?: string | null | undefined, customAddress_UnitName?: string | null | undefined, customAddress_City?: string | null | undefined, customAddress_Province?: string | null | undefined, customAddress_PostalCode?: string | null | undefined, customAddress_Country?: string | null | undefined, uploadImages?: boolean | undefined, price?: number | null | undefined, listingType?: string | null | undefined, buildStatus?: string | null | undefined, useCompanyOwnership?: boolean | undefined, useRandomizedData?: boolean | undefined, count?: number | undefined, city?: string | null | undefined, province?: string | null | undefined, externalSourceName?: string | null | undefined, externalSourceUrl?: string | null | undefined, externalSourceLogoPreset?: string | null | undefined, externalSourceLogoFile?: FileParameter | null | undefined, coverPhotoFile?: FileParameter | null | undefined, projectId?: number | null | undefined, useGeocoding?: boolean | undefined, offeringMode?: string | null | undefined, openHouseCount?: number | undefined, contentType?: string | null | undefined, contentDisposition?: string | null | undefined, headers?: any[] | null | undefined, length?: number | undefined, name?: string | null | undefined, fileName?: string | null | undefined, cancelToken?: CancelToken): Promise<GenerateSeedDataResult> {
        let url_ = this.baseUrl + "/api/v1/admin/generateSeedData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (targetStage !== null && targetStage !== undefined)
            content_.append("TargetStage", targetStage.toString());
        if (sellerEmails !== null && sellerEmails !== undefined)
            sellerEmails.forEach(item_ => content_.append("SellerEmails", item_.toString()));
        if (buyerEmails !== null && buyerEmails !== undefined)
            buyerEmails.forEach(item_ => content_.append("BuyerEmails", item_.toString()));
        if (language !== null && language !== undefined)
            content_.append("Language", language.toString());
        if (autoConfirmEmails === null || autoConfirmEmails === undefined)
            throw new Error("The parameter 'autoConfirmEmails' cannot be null.");
        else
            content_.append("AutoConfirmEmails", autoConfirmEmails.toString());
        if (customAddress_LandRegistry !== null && customAddress_LandRegistry !== undefined)
            content_.append("CustomAddress.LandRegistry", customAddress_LandRegistry.toString());
        if (customAddress_LandRegistryType !== null && customAddress_LandRegistryType !== undefined)
            content_.append("CustomAddress.LandRegistryType", customAddress_LandRegistryType.toString());
        if (customAddress_Street !== null && customAddress_Street !== undefined)
            content_.append("CustomAddress.Street", customAddress_Street.toString());
        if (customAddress_UnitNumber !== null && customAddress_UnitNumber !== undefined)
            content_.append("CustomAddress.UnitNumber", customAddress_UnitNumber.toString());
        if (customAddress_UnitName !== null && customAddress_UnitName !== undefined)
            content_.append("CustomAddress.UnitName", customAddress_UnitName.toString());
        if (customAddress_City !== null && customAddress_City !== undefined)
            content_.append("CustomAddress.City", customAddress_City.toString());
        if (customAddress_Province !== null && customAddress_Province !== undefined)
            content_.append("CustomAddress.Province", customAddress_Province.toString());
        if (customAddress_PostalCode !== null && customAddress_PostalCode !== undefined)
            content_.append("CustomAddress.PostalCode", customAddress_PostalCode.toString());
        if (customAddress_Country !== null && customAddress_Country !== undefined)
            content_.append("CustomAddress.Country", customAddress_Country.toString());
        if (uploadImages === null || uploadImages === undefined)
            throw new Error("The parameter 'uploadImages' cannot be null.");
        else
            content_.append("UploadImages", uploadImages.toString());
        if (price !== null && price !== undefined)
            content_.append("Price", price.toString());
        if (listingType !== null && listingType !== undefined)
            content_.append("ListingType", listingType.toString());
        if (buildStatus !== null && buildStatus !== undefined)
            content_.append("BuildStatus", buildStatus.toString());
        if (useCompanyOwnership === null || useCompanyOwnership === undefined)
            throw new Error("The parameter 'useCompanyOwnership' cannot be null.");
        else
            content_.append("UseCompanyOwnership", useCompanyOwnership.toString());
        if (useRandomizedData === null || useRandomizedData === undefined)
            throw new Error("The parameter 'useRandomizedData' cannot be null.");
        else
            content_.append("UseRandomizedData", useRandomizedData.toString());
        if (count === null || count === undefined)
            throw new Error("The parameter 'count' cannot be null.");
        else
            content_.append("Count", count.toString());
        if (city !== null && city !== undefined)
            content_.append("City", city.toString());
        if (province !== null && province !== undefined)
            content_.append("Province", province.toString());
        if (externalSourceName !== null && externalSourceName !== undefined)
            content_.append("ExternalSourceName", externalSourceName.toString());
        if (externalSourceUrl !== null && externalSourceUrl !== undefined)
            content_.append("ExternalSourceUrl", externalSourceUrl.toString());
        if (externalSourceLogoPreset !== null && externalSourceLogoPreset !== undefined)
            content_.append("ExternalSourceLogoPreset", externalSourceLogoPreset.toString());
        if (externalSourceLogoFile !== null && externalSourceLogoFile !== undefined)
            content_.append("ExternalSourceLogoFile", externalSourceLogoFile.data, externalSourceLogoFile.fileName ? externalSourceLogoFile.fileName : "ExternalSourceLogoFile");
        if (coverPhotoFile !== null && coverPhotoFile !== undefined)
            content_.append("CoverPhotoFile", coverPhotoFile.data, coverPhotoFile.fileName ? coverPhotoFile.fileName : "CoverPhotoFile");
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (useGeocoding === null || useGeocoding === undefined)
            throw new Error("The parameter 'useGeocoding' cannot be null.");
        else
            content_.append("UseGeocoding", useGeocoding.toString());
        if (offeringMode !== null && offeringMode !== undefined)
            content_.append("OfferingMode", offeringMode.toString());
        if (openHouseCount === null || openHouseCount === undefined)
            throw new Error("The parameter 'openHouseCount' cannot be null.");
        else
            content_.append("OpenHouseCount", openHouseCount.toString());
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSeedData(_response);
        });
    }

    protected processGenerateSeedData(response: AxiosResponse): Promise<GenerateSeedDataResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenerateSeedDataResult.fromJS(resultData200);
            return Promise.resolve<GenerateSeedDataResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateSeedDataResult>(null as any);
    }

    generateContractDryRun(command: GenerateContractDryRunCommand, cancelToken?: CancelToken): Promise<CreateContractResult> {
        let url_ = this.baseUrl + "/api/v1/admin/contracts/dryRun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateContractDryRun(_response);
        });
    }

    protected processGenerateContractDryRun(response: AxiosResponse): Promise<CreateContractResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateContractResult.fromJS(resultData200);
            return Promise.resolve<CreateContractResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateContractResult>(null as any);
    }

    testShiftDealTimeline(command: ShiftDealTimelineCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/admin/shiftTimeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestShiftDealTimeline(_response);
        });
    }

    protected processTestShiftDealTimeline(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setDealToFirmIfDueDiligencePast( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/admin/setDealToFirmIfDueDiligencePast";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDealToFirmIfDueDiligencePast(_response);
        });
    }

    protected processSetDealToFirmIfDueDiligencePast(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    setListingProject(listingId: number, projectId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/admin/listings/{listingId}/setProject/{projectId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetListingProject(_response);
        });
    }

    protected processSetListingProject(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    geocodeExistingListings( cancelToken?: CancelToken): Promise<GeocodeExistingListingsResult> {
        let url_ = this.baseUrl + "/api/v1/admin/geocodeExistingListings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeocodeExistingListings(_response);
        });
    }

    protected processGeocodeExistingListings(response: AxiosResponse): Promise<GeocodeExistingListingsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeocodeExistingListingsResult.fromJS(resultData200);
            return Promise.resolve<GeocodeExistingListingsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeocodeExistingListingsResult>(null as any);
    }
}

export class ApiKeyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    generateApiCredentials(command: CreateApiKeyCommand, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/apiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateApiCredentials(_response);
        });
    }

    protected processGenerateApiCredentials(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    auth(clientCredentialRequestInfo: ClientCredentialRequestInfo, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientCredentialRequestInfo);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth(_response);
        });
    }

    protected processAuth(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    refresh(refreshAccessToken: RefreshAccessTokenRequest, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(refreshAccessToken);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    loginAsUserType(command: SwitchToUserTypeCommand, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/auth/loginAsUserType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginAsUserType(_response);
        });
    }

    protected processLoginAsUserType(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    login(command: LoginCommand, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    authWithGoogle(request: GoogleTokenRequest, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/auth/google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthWithGoogle(_response);
        });
    }

    protected processAuthWithGoogle(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    authWithApple(request: AppleTokenRequest, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/auth/apple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthWithApple(_response);
        });
    }

    protected processAuthWithApple(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    logout( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    verifyMagicLink(command: VerifyMagicLinkCommand, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/auth/verifyMagicLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyMagicLink(_response);
        });
    }

    protected processVerifyMagicLink(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }

    requestOtp(command: RequestOtpCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/auth/requestOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestOtp(_response);
        });
    }

    protected processRequestOtp(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    validateOtp(command: ValidateOtpCommand, cancelToken?: CancelToken): Promise<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v1/auth/validateOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateOtp(_response);
        });
    }

    protected processValidateOtp(response: AxiosResponse): Promise<AccessTokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessTokenDto.fromJS(resultData200);
            return Promise.resolve<AccessTokenDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessTokenDto>(null as any);
    }
}

export class BuildersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPage(sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfBuilderLookUpDto> {
        let url_ = this.baseUrl + "/api/v1/builders?";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PaginatedResultOfBuilderLookUpDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfBuilderLookUpDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfBuilderLookUpDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfBuilderLookUpDto>(null as any);
    }

    create(command: CreateBuilderCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/builders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    delete(builderId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/builders/{builderId}";
        if (builderId === undefined || builderId === null)
            throw new Error("The parameter 'builderId' must be defined.");
        url_ = url_.replace("{builderId}", encodeURIComponent("" + builderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class BuilderUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getBuilderUsers(filterByStatus?: BuilderUserStatus | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfBuilderUserLookupDto> {
        let url_ = this.baseUrl + "/api/v1/builderUsers?";
        if (filterByStatus === null)
            throw new Error("The parameter 'filterByStatus' cannot be null.");
        else if (filterByStatus !== undefined)
            url_ += "FilterByStatus=" + encodeURIComponent("" + filterByStatus) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuilderUsers(_response);
        });
    }

    protected processGetBuilderUsers(response: AxiosResponse): Promise<PaginatedResultOfBuilderUserLookupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfBuilderUserLookupDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfBuilderUserLookupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfBuilderUserLookupDto>(null as any);
    }

    create(query: CreateBuilderUserProfileCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/builderUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    edit(builderUserId: string, command: EditBuilderUserCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/builderUsers/{builderUserId}";
        if (builderUserId === undefined || builderUserId === null)
            throw new Error("The parameter 'builderUserId' must be defined.");
        url_ = url_.replace("{builderUserId}", encodeURIComponent("" + builderUserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    delete(builderUserId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/builderUsers/{builderUserId}";
        if (builderUserId === undefined || builderUserId === null)
            throw new Error("The parameter 'builderUserId' must be defined.");
        url_ = url_.replace("{builderUserId}", encodeURIComponent("" + builderUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    acceptInvite(builderUserId: string, token: string, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/builderUsers/{builderUserId}/acceptInvite/{token}";
        if (builderUserId === undefined || builderUserId === null)
            throw new Error("The parameter 'builderUserId' must be defined.");
        url_ = url_.replace("{builderUserId}", encodeURIComponent("" + builderUserId));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptInvite(_response);
        });
    }

    protected processAcceptInvite(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    rejectInvite(builderUserId: string, token: string, cancelToken?: CancelToken): Promise<Unit> {
        let url_ = this.baseUrl + "/api/v1/builderUsers/{builderUserId}/rejectInvite/{token}";
        if (builderUserId === undefined || builderUserId === null)
            throw new Error("The parameter 'builderUserId' must be defined.");
        url_ = url_.replace("{builderUserId}", encodeURIComponent("" + builderUserId));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectInvite(_response);
        });
    }

    protected processRejectInvite(response: AxiosResponse): Promise<Unit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Unit.fromJS(resultData200);
            return Promise.resolve<Unit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Unit>(null as any);
    }

    editRoles(builderUserId: string, command: EditBuilderUserRolesCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/builderUsers/{builderUserId}/roles";
        if (builderUserId === undefined || builderUserId === null)
            throw new Error("The parameter 'builderUserId' must be defined.");
        url_ = url_.replace("{builderUserId}", encodeURIComponent("" + builderUserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditRoles(_response);
        });
    }

    protected processEditRoles(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getRoles(builderUserId: string, cancelToken?: CancelToken): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/v1/builderUsers/{builderUserId}/roles";
        if (builderUserId === undefined || builderUserId === null)
            throw new Error("The parameter 'builderUserId' must be defined.");
        url_ = url_.replace("{builderUserId}", encodeURIComponent("" + builderUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }

    deactivate(builderUserId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/builderUsers/{builderUserId}/deactivate";
        if (builderUserId === undefined || builderUserId === null)
            throw new Error("The parameter 'builderUserId' must be defined.");
        url_ = url_.replace("{builderUserId}", encodeURIComponent("" + builderUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    reactivate(builderUserId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/builderUsers/{builderUserId}/reactivate";
        if (builderUserId === undefined || builderUserId === null)
            throw new Error("The parameter 'builderUserId' must be defined.");
        url_ = url_.replace("{builderUserId}", encodeURIComponent("" + builderUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate(_response);
        });
    }

    protected processReactivate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ClientsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPage(projectId?: number | null | undefined, filterByStatuses?: LeadStatus[] | null | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfClientLookupDto> {
        let url_ = this.baseUrl + "/api/v1/clients?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (filterByStatuses !== undefined && filterByStatuses !== null)
            filterByStatuses && filterByStatuses.forEach(item => { url_ += "FilterByStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PaginatedResultOfClientLookupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfClientLookupDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfClientLookupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfClientLookupDto>(null as any);
    }

    create(command: CreateClientCommand, cancelToken?: CancelToken): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/v1/clients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientDto.fromJS(resultData200);
            return Promise.resolve<ClientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientDto>(null as any);
    }

    get(clientId: number, cancelToken?: CancelToken): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientDto.fromJS(resultData200);
            return Promise.resolve<ClientDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientDto>(null as any);
    }

    edit(clientId: number, command: EditClientCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createClientNote(clientId: number, command: CreateNoteCommand, noteId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}/notes?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (noteId !== undefined && noteId !== null)
            url_ += "noteId=" + encodeURIComponent("" + noteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateClientNote(_response);
        });
    }

    protected processCreateClientNote(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getClientNotes(clientId: number, filterByProjectIds?: (number | undefined)[] | null | undefined, cancelToken?: CancelToken): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}/notes?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (filterByProjectIds !== undefined && filterByProjectIds !== null)
            filterByProjectIds && filterByProjectIds.forEach(item => { url_ += "filterByProjectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientNotes(_response);
        });
    }

    protected processGetClientNotes(response: AxiosResponse): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NoteDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    editClientNote(clientId: number, noteId: string, command: EditNoteCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}/notes/{noteId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditClientNote(_response);
        });
    }

    protected processEditClientNote(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDeals(clientId: number, filterByStates?: DealState[] | null | undefined, filterByProjectIds?: number[] | null | undefined, filterByListingIds?: number[] | null | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfDealLookupDto> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}/deals?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (filterByStates !== undefined && filterByStates !== null)
            filterByStates && filterByStates.forEach(item => { url_ += "FilterByStates=" + encodeURIComponent("" + item) + "&"; });
        if (filterByProjectIds !== undefined && filterByProjectIds !== null)
            filterByProjectIds && filterByProjectIds.forEach(item => { url_ += "FilterByProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterByListingIds !== undefined && filterByListingIds !== null)
            filterByListingIds && filterByListingIds.forEach(item => { url_ += "FilterByListingIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeals(_response);
        });
    }

    protected processGetDeals(response: AxiosResponse): Promise<PaginatedResultOfDealLookupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfDealLookupDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfDealLookupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfDealLookupDto>(null as any);
    }

    getContacts(clientId: number, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfContactDto> {
        let url_ = this.baseUrl + "/api/v1/clients/{clientId}/contacts?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContacts(_response);
        });
    }

    protected processGetContacts(response: AxiosResponse): Promise<PaginatedResultOfContactDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfContactDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfContactDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfContactDto>(null as any);
    }
}

export class ConfigClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(culture?: LanguageType | undefined, cancelToken?: CancelToken): Promise<ConfigDto> {
        let url_ = this.baseUrl + "/api/v1/config?";
        if (culture === null)
            throw new Error("The parameter 'culture' cannot be null.");
        else if (culture !== undefined)
            url_ += "Culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ConfigDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigDto.fromJS(resultData200);
            return Promise.resolve<ConfigDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigDto>(null as any);
    }
}

export class DealsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPage(filterByStates?: DealState[] | null | undefined, filterByProjectIds?: number[] | null | undefined, filterByListingIds?: number[] | null | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfDealLookupDto> {
        let url_ = this.baseUrl + "/api/v1/deals?";
        if (filterByStates !== undefined && filterByStates !== null)
            filterByStates && filterByStates.forEach(item => { url_ += "FilterByStates=" + encodeURIComponent("" + item) + "&"; });
        if (filterByProjectIds !== undefined && filterByProjectIds !== null)
            filterByProjectIds && filterByProjectIds.forEach(item => { url_ += "FilterByProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterByListingIds !== undefined && filterByListingIds !== null)
            filterByListingIds && filterByListingIds.forEach(item => { url_ += "FilterByListingIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PaginatedResultOfDealLookupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfDealLookupDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfDealLookupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfDealLookupDto>(null as any);
    }

    get(dealId: string, culture: string | null, includeFields?: string | null | undefined, cancelToken?: CancelToken): Promise<DealDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (culture === undefined)
            throw new Error("The parameter 'culture' must be defined.");
        else if(culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        if (includeFields !== undefined && includeFields !== null)
            url_ += "includeFields=" + encodeURIComponent("" + includeFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DealDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealDto.fromJS(resultData200);
            return Promise.resolve<DealDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealDto>(null as any);
    }

    edit(dealId: string, command: EditDealCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    deleteDeal(dealId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDeal(_response);
        });
    }

    protected processDeleteDeal(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getCancellation(dealId: string, cancelToken?: CancelToken): Promise<DealCancellationDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/cancellation";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCancellation(_response);
        });
    }

    protected processGetCancellation(response: AxiosResponse): Promise<DealCancellationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealCancellationDto.fromJS(resultData200);
            return Promise.resolve<DealCancellationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealCancellationDto>(null as any);
    }

    updateCancellation(dealId: string, command: UpdateDealCancellationCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/cancellation";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCancellation(_response);
        });
    }

    protected processUpdateCancellation(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    startCancellation(dealId: string, command: StartDealCancellationCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/startCancellation";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartCancellation(_response);
        });
    }

    protected processStartCancellation(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    startSigningContract(dealId: string, command: StartSigningDealCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/startSigning";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartSigningContract(_response);
        });
    }

    protected processStartSigningContract(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    startFulfillmentSigning(dealId: string, command: StartFulfillmentSigningCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/startFulfillmentSigning";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartFulfillmentSigning(_response);
        });
    }

    protected processStartFulfillmentSigning(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    resetToPendingBuyerSignature(dealId: string, command: ResetDealToPendingBuyerSignatureCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/resetToPendingBuyerSignature";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetToPendingBuyerSignature(_response);
        });
    }

    protected processResetToPendingBuyerSignature(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateFulfilmentConditions(dealId: string, command: UpdateDealFulfilmentConditionsCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/fulfilmentConditions";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFulfilmentConditions(_response);
        });
    }

    protected processUpdateFulfilmentConditions(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    setNotPreApprovedPaymentMethodDetails(dealId: string, command: SetDealAsNotPreApprovedPaymentMethodCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/notPreApprovedPaymentMethodDetails";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetNotPreApprovedPaymentMethodDetails(_response);
        });
    }

    protected processSetNotPreApprovedPaymentMethodDetails(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    setCashPaymentMethodDetails(dealId: string, command: SetDealAsCashPaymentMethodCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/cashPaymentMethodDetails";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCashPaymentMethodDetails(_response);
        });
    }

    protected processSetCashPaymentMethodDetails(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    setPreApprovedPaymentMethodDetails(dealId: string, command: SetDealAsPreApprovedPaymentMethodCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/preApprovedPaymentMethodDetails";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPreApprovedPaymentMethodDetails(_response);
        });
    }

    protected processSetPreApprovedPaymentMethodDetails(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    invitePurchaser(dealId: string, command: InvitePurchaserCommand, cancelToken?: CancelToken): Promise<PurchaserDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/invite";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvitePurchaser(_response);
        });
    }

    protected processInvitePurchaser(response: AxiosResponse): Promise<PurchaserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchaserDto.fromJS(resultData200);
            return Promise.resolve<PurchaserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaserDto>(null as any);
    }

    reSendPurchaserEmail(dealId: string, purchaserId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/{purchaserId}/resendInvite";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (purchaserId === undefined || purchaserId === null)
            throw new Error("The parameter 'purchaserId' must be defined.");
        url_ = url_.replace("{purchaserId}", encodeURIComponent("" + purchaserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReSendPurchaserEmail(_response);
        });
    }

    protected processReSendPurchaserEmail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createPurchaser(dealId: string, command: CreateDealPurchaserCommand, cancelToken?: CancelToken): Promise<PurchaserDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePurchaser(_response);
        });
    }

    protected processCreatePurchaser(response: AxiosResponse): Promise<PurchaserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = PurchaserDto.fromJS(resultData201);
            return Promise.resolve<PurchaserDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaserDto>(null as any);
    }

    getPurchaser(dealId: string, purchaserId: string, cancelToken?: CancelToken): Promise<PurchaserDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/{purchaserId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (purchaserId === undefined || purchaserId === null)
            throw new Error("The parameter 'purchaserId' must be defined.");
        url_ = url_.replace("{purchaserId}", encodeURIComponent("" + purchaserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchaser(_response);
        });
    }

    protected processGetPurchaser(response: AxiosResponse): Promise<PurchaserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchaserDto.fromJS(resultData200);
            return Promise.resolve<PurchaserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaserDto>(null as any);
    }

    editPurchaser(dealId: string, purchaserId: string, command: EditDealPurchaserCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/{purchaserId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (purchaserId === undefined || purchaserId === null)
            throw new Error("The parameter 'purchaserId' must be defined.");
        url_ = url_.replace("{purchaserId}", encodeURIComponent("" + purchaserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditPurchaser(_response);
        });
    }

    protected processEditPurchaser(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    deletePurchaser(dealId: string, purchaserId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/{purchaserId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (purchaserId === undefined || purchaserId === null)
            throw new Error("The parameter 'purchaserId' must be defined.");
        url_ = url_.replace("{purchaserId}", encodeURIComponent("" + purchaserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePurchaser(_response);
        });
    }

    protected processDeletePurchaser(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateCompletedStep(dealId: string, command: UpdateDealCompletedStepCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/updateCompletedStep";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompletedStep(_response);
        });
    }

    protected processUpdateCompletedStep(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    agreeToSection(dealId: string, command: AgreeToContractSectionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/contract/agreeToSection";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAgreeToSection(_response);
        });
    }

    protected processAgreeToSection(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    sendWatermarkedContract(dealId: string, command: SendWatermarkedContractCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/sendWatermarkedContract";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendWatermarkedContract(_response);
        });
    }

    protected processSendWatermarkedContract(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getVerificationDocumentIds(dealId: string, purchaserId: string, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/{purchaserId}/verificationDocumentIds";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (purchaserId === undefined || purchaserId === null)
            throw new Error("The parameter 'purchaserId' must be defined.");
        url_ = url_.replace("{purchaserId}", encodeURIComponent("" + purchaserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVerificationDocumentIds(_response);
        });
    }

    protected processGetVerificationDocumentIds(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    accept(dealId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/accept";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createDeposit(dealId: string, command: CreateDealDepositCommand, cancelToken?: CancelToken): Promise<DepositResult> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/deposit";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDeposit(_response);
        });
    }

    protected processCreateDeposit(response: AxiosResponse): Promise<DepositResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DepositResult.fromJS(resultData200);
            return Promise.resolve<DepositResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DepositResult>(null as any);
    }

    refreshDepositPaymentStatus(dealId: string, skip?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/deposit/refreshPaymentStatus?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshDepositPaymentStatus(_response);
        });
    }

    protected processRefreshDepositPaymentStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateDepositPaymentStatus(dealId: string, cancelToken?: CancelToken): Promise<UpdateDealPaymentStatusResult> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/deposit/updatePaymentStatus";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDepositPaymentStatus(_response);
        });
    }

    protected processUpdateDepositPaymentStatus(response: AxiosResponse): Promise<UpdateDealPaymentStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateDealPaymentStatusResult.fromJS(resultData200);
            return Promise.resolve<UpdateDealPaymentStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateDealPaymentStatusResult>(null as any);
    }

    createDealDocument(dealId: string, command: CreateDealDocumentCommand, cancelToken?: CancelToken): Promise<DealDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/document";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDealDocument(_response);
        });
    }

    protected processCreateDealDocument(response: AxiosResponse): Promise<DealDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealDocumentDto.fromJS(resultData200);
            return Promise.resolve<DealDocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealDocumentDto>(null as any);
    }

    editDealDocument(dealId: string, command: EditDealDocumentCommand, cancelToken?: CancelToken): Promise<DealDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/document";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditDealDocument(_response);
        });
    }

    protected processEditDealDocument(response: AxiosResponse): Promise<DealDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealDocumentDto.fromJS(resultData200);
            return Promise.resolve<DealDocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealDocumentDto>(null as any);
    }

    deleteDealDocument(dealId: string, command: DeleteDealDocumentCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/document";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDealDocument(_response);
        });
    }

    protected processDeleteDealDocument(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    uploadDealFile(dealId: string, category?: string | null | undefined, isPrivate?: boolean | undefined, formFile?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<DealDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/file?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (category !== undefined && category !== null)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (isPrivate === null)
            throw new Error("The parameter 'isPrivate' cannot be null.");
        else if (isPrivate !== undefined)
            url_ += "isPrivate=" + encodeURIComponent("" + isPrivate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDealFile(_response);
        });
    }

    protected processUploadDealFile(response: AxiosResponse): Promise<DealDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = DealDocumentDto.fromJS(resultData201);
            return Promise.resolve<DealDocumentDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealDocumentDto>(null as any);
    }

    getDocuments(dealId: string, cancelToken?: CancelToken): Promise<DealDocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/documents";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: AxiosResponse): Promise<DealDocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealDocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealDocumentDto[]>(null as any);
    }

    getDeposits(dealId: string, cancelToken?: CancelToken): Promise<DealPaymentDto[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/deposits";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeposits(_response);
        });
    }

    protected processGetDeposits(response: AxiosResponse): Promise<DealPaymentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealPaymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealPaymentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealPaymentDto[]>(null as any);
    }

    getContracts(dealId: string, cancelToken?: CancelToken): Promise<ContractSummaryDto[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/contracts";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContracts(_response);
        });
    }

    protected processGetContracts(response: AxiosResponse): Promise<ContractSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContractSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractSummaryDto[]>(null as any);
    }

    getSampleContract(requestedCulture?: string | null | undefined, listingId?: number | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/deals/sampleContract?";
        if (requestedCulture !== undefined && requestedCulture !== null)
            url_ += "requestedCulture=" + encodeURIComponent("" + requestedCulture) + "&";
        if (listingId !== undefined && listingId !== null)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleContract(_response);
        });
    }

    protected processGetSampleContract(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updatePurchaserNameToNameOnDocument(dealId: string, purchaserId: string, command: UpdatePurchaserNameToNameOnDocumentCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/{purchaserId}/updateNameToNameOnDocument";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (purchaserId === undefined || purchaserId === null)
            throw new Error("The parameter 'purchaserId' must be defined.");
        url_ = url_.replace("{purchaserId}", encodeURIComponent("" + purchaserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePurchaserNameToNameOnDocument(_response);
        });
    }

    protected processUpdatePurchaserNameToNameOnDocument(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    useAnotherDocument(dealId: string, purchaserId: string, command: UseAnotherDocumentCommand, cancelToken?: CancelToken): Promise<UseAnotherDocumentResult> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/{purchaserId}/useAnotherDocument";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (purchaserId === undefined || purchaserId === null)
            throw new Error("The parameter 'purchaserId' must be defined.");
        url_ = url_.replace("{purchaserId}", encodeURIComponent("" + purchaserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUseAnotherDocument(_response);
        });
    }

    protected processUseAnotherDocument(response: AxiosResponse): Promise<UseAnotherDocumentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UseAnotherDocumentResult.fromJS(resultData200);
            return Promise.resolve<UseAnotherDocumentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UseAnotherDocumentResult>(null as any);
    }

    verifyEmail(dealId: string, purchaserId: string, command: VerifyDealPurchaserCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchasers/{purchaserId}/verifyEmail";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (purchaserId === undefined || purchaserId === null)
            throw new Error("The parameter 'purchaserId' must be defined.");
        url_ = url_.replace("{purchaserId}", encodeURIComponent("" + purchaserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getPurchaserSteps(dealId: string, culture: string | null, cancelToken?: CancelToken): Promise<DealStepsDto[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/purchaserSteps?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (culture === undefined)
            throw new Error("The parameter 'culture' must be defined.");
        else if(culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchaserSteps(_response);
        });
    }

    protected processGetPurchaserSteps(response: AxiosResponse): Promise<DealStepsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealStepsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealStepsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealStepsDto[]>(null as any);
    }

    skipContractGenerationAndSigning(command: SkipContractGenerationCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/deals/skipContractGenerationAndSigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSkipContractGenerationAndSigning(_response);
        });
    }

    protected processSkipContractGenerationAndSigning(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    submit(dealId: string, command: SubmitDealCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/submit";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createTransactionFeeCheckoutSession(dealId: string, command: CreateTransactionFeeCheckoutSessionCommand, cancelToken?: CancelToken): Promise<StripeCheckoutSessionOutput> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/createTransactionFeeCheckoutSession";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTransactionFeeCheckoutSession(_response);
        });
    }

    protected processCreateTransactionFeeCheckoutSession(response: AxiosResponse): Promise<StripeCheckoutSessionOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StripeCheckoutSessionOutput.fromJS(resultData200);
            return Promise.resolve<StripeCheckoutSessionOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StripeCheckoutSessionOutput>(null as any);
    }

    verifyTransactionFeeAndAcceptOffer(dealId: string, redirect?: string | null | undefined, result?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/verifyTransactionFeeAndAcceptOffer?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (redirect !== undefined && redirect !== null)
            url_ += "redirect=" + encodeURIComponent("" + redirect) + "&";
        if (result !== undefined && result !== null)
            url_ += "result=" + encodeURIComponent("" + result) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyTransactionFeeAndAcceptOffer(_response);
        });
    }

    protected processVerifyTransactionFeeAndAcceptOffer(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    decline(dealId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/decline";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDecline(_response);
        });
    }

    protected processDecline(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getAllOfferExtensions(dealId: string, cancelToken?: CancelToken): Promise<OfferExtensionDto[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/offerExtensions";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOfferExtensions(_response);
        });
    }

    protected processGetAllOfferExtensions(response: AxiosResponse): Promise<OfferExtensionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfferExtensionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OfferExtensionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferExtensionDto[]>(null as any);
    }

    requestOfferExtension(dealId: string, command: RequestOfferExtensionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/requestOfferExtension";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestOfferExtension(_response);
        });
    }

    protected processRequestOfferExtension(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    acceptOfferExtension(dealId: string, command: AcceptOfferExtensionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/acceptOfferExtension";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptOfferExtension(_response);
        });
    }

    protected processAcceptOfferExtension(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    declineOfferExtension(dealId: string, command: DeclineOfferExtensionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/declineOfferExtension";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclineOfferExtension(_response);
        });
    }

    protected processDeclineOfferExtension(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    setOffer(dealId: string, command: SetOfferCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/setOffer";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOffer(_response);
        });
    }

    protected processSetOffer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    acceptOffer(dealId: string, command: AcceptOfferCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/acceptOffer";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptOffer(_response);
        });
    }

    protected processAcceptOffer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    declineOffer(dealId: string, command: DeclineOfferCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/declineOffer";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclineOffer(_response);
        });
    }

    protected processDeclineOffer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    cancelOffer(dealId: string, command: CancelOfferCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/cancelOffer";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelOffer(_response);
        });
    }

    protected processCancelOffer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    sendOffer(dealId: string, command: SendOfferCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/sendOffer";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendOffer(_response);
        });
    }

    protected processSendOffer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getAllOffer(dealId: string, cancelToken?: CancelToken): Promise<OfferDto[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/offer";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOffer(_response);
        });
    }

    protected processGetAllOffer(response: AxiosResponse): Promise<OfferDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfferDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OfferDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferDto[]>(null as any);
    }

    getCurrentOffer(dealId: string, excludeDrafts?: boolean | undefined, cancelToken?: CancelToken): Promise<OfferDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/currentOffer?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (excludeDrafts === null)
            throw new Error("The parameter 'excludeDrafts' cannot be null.");
        else if (excludeDrafts !== undefined)
            url_ += "excludeDrafts=" + encodeURIComponent("" + excludeDrafts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentOffer(_response);
        });
    }

    protected processGetCurrentOffer(response: AxiosResponse): Promise<OfferDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferDto.fromJS(resultData200);
            return Promise.resolve<OfferDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferDto>(null as any);
    }

    expireOffer( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/expireOffer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExpireOffer(_response);
        });
    }

    protected processExpireOffer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getOfferHistory(dealId: string, cancelToken?: CancelToken): Promise<GetOfferHistoryResponseDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/offerHistory";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfferHistory(_response);
        });
    }

    protected processGetOfferHistory(response: AxiosResponse): Promise<GetOfferHistoryResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOfferHistoryResponseDto.fromJS(resultData200);
            return Promise.resolve<GetOfferHistoryResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOfferHistoryResponseDto>(null as any);
    }

    requestExtension(dealId: string, command: RequestDealExtensionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/requestExtension";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestExtension(_response);
        });
    }

    protected processRequestExtension(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    acceptExtension(dealId: string, command: AcceptDealExtensionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/acceptExtension";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptExtension(_response);
        });
    }

    protected processAcceptExtension(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    declineExtension(dealId: string, command: DeclineDealExtensionCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/declineExtension";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclineExtension(_response);
        });
    }

    protected processDeclineExtension(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getAllExtensions(dealId: string, cancelToken?: CancelToken): Promise<DealExtensionsDto[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/extensions";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllExtensions(_response);
        });
    }

    protected processGetAllExtensions(response: AxiosResponse): Promise<DealExtensionsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DealExtensionsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DealExtensionsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealExtensionsDto[]>(null as any);
    }

    getContract(dealId: string, contractType?: ContractType | undefined, contractDownloadOptions?: ContractDownloadOptions | undefined, cancelToken?: CancelToken): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/contract?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (contractType === null)
            throw new Error("The parameter 'contractType' cannot be null.");
        else if (contractType !== undefined)
            url_ += "contractType=" + encodeURIComponent("" + contractType) + "&";
        if (contractDownloadOptions === null)
            throw new Error("The parameter 'contractDownloadOptions' cannot be null.");
        else if (contractDownloadOptions !== undefined)
            url_ += "contractDownloadOptions=" + encodeURIComponent("" + contractDownloadOptions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContract(_response);
        });
    }

    protected processGetContract(response: AxiosResponse): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractDto.fromJS(resultData200);
            return Promise.resolve<ContractDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDto>(null as any);
    }

    createContract(dealId: string, contractType?: ContractType | undefined, forceRegenerate?: boolean | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/contracts/create?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (contractType === null)
            throw new Error("The parameter 'contractType' cannot be null.");
        else if (contractType !== undefined)
            url_ += "contractType=" + encodeURIComponent("" + contractType) + "&";
        if (forceRegenerate === null)
            throw new Error("The parameter 'forceRegenerate' cannot be null.");
        else if (forceRegenerate !== undefined)
            url_ += "forceRegenerate=" + encodeURIComponent("" + forceRegenerate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContract(_response);
        });
    }

    protected processCreateContract(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    signContract(dealId: string, contractId: string, command: SignContractCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/contracts/{contractId}/sign";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignContract(_response);
        });
    }

    protected processSignContract(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getContractSignatures(dealId: string, contractId: string, cancelToken?: CancelToken): Promise<ContractSignatureDto[]> {
        let url_ = this.baseUrl + "/api/v1/deals/{dealId}/contracts/{contractId}/signatures";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractSignatures(_response);
        });
    }

    protected processGetContractSignatures(response: AxiosResponse): Promise<ContractSignatureDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractSignatureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContractSignatureDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractSignatureDto[]>(null as any);
    }
}

export class FilesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(id: string, cancelToken?: CancelToken): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class LeadsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(command: CreateClientLeadSelfRegisterCommand, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/leads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ListingOfferingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    generateSubscriptionCodes(command: GenerateSubscriptionCodeCommand, cancelToken?: CancelToken): Promise<SubscriptionCodeDto[]> {
        let url_ = this.baseUrl + "/api/v1/listingOfferings/subscriptionCodes/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSubscriptionCodes(_response);
        });
    }

    protected processGenerateSubscriptionCodes(response: AxiosResponse): Promise<SubscriptionCodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionCodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriptionCodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriptionCodeDto[]>(null as any);
    }

    getSubscriptionCode(code: string, cancelToken?: CancelToken): Promise<SubscriptionCodeDto> {
        let url_ = this.baseUrl + "/api/v1/listingOfferings/subscriptionCodes/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscriptionCode(_response);
        });
    }

    protected processGetSubscriptionCode(response: AxiosResponse): Promise<SubscriptionCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubscriptionCodeDto.fromJS(resultData200);
            return Promise.resolve<SubscriptionCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriptionCodeDto>(null as any);
    }
}

export class ListingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPage(projectId?: number | null | undefined, phaseId?: string | null | undefined, buildingId?: string | null | undefined, builderId?: number | null | undefined, onlyShowUserProperties?: boolean | undefined, requestedCulture?: string | null | undefined, filterByListingStates?: ListingState[] | null | undefined, filterByListingTiers?: ListingTier[] | null | undefined, ownedByUserId?: string | null | undefined, onlyArchived?: boolean | undefined, includedFields?: string[] | null | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfListingLookupDto> {
        let url_ = this.baseUrl + "/api/v1/listings?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (phaseId !== undefined && phaseId !== null)
            url_ += "PhaseId=" + encodeURIComponent("" + phaseId) + "&";
        if (buildingId !== undefined && buildingId !== null)
            url_ += "BuildingId=" + encodeURIComponent("" + buildingId) + "&";
        if (builderId !== undefined && builderId !== null)
            url_ += "BuilderId=" + encodeURIComponent("" + builderId) + "&";
        if (onlyShowUserProperties === null)
            throw new Error("The parameter 'onlyShowUserProperties' cannot be null.");
        else if (onlyShowUserProperties !== undefined)
            url_ += "OnlyShowUserProperties=" + encodeURIComponent("" + onlyShowUserProperties) + "&";
        if (requestedCulture !== undefined && requestedCulture !== null)
            url_ += "RequestedCulture=" + encodeURIComponent("" + requestedCulture) + "&";
        if (filterByListingStates !== undefined && filterByListingStates !== null)
            filterByListingStates && filterByListingStates.forEach(item => { url_ += "FilterByListingStates=" + encodeURIComponent("" + item) + "&"; });
        if (filterByListingTiers !== undefined && filterByListingTiers !== null)
            filterByListingTiers && filterByListingTiers.forEach(item => { url_ += "FilterByListingTiers=" + encodeURIComponent("" + item) + "&"; });
        if (ownedByUserId !== undefined && ownedByUserId !== null)
            url_ += "OwnedByUserId=" + encodeURIComponent("" + ownedByUserId) + "&";
        if (onlyArchived === null)
            throw new Error("The parameter 'onlyArchived' cannot be null.");
        else if (onlyArchived !== undefined)
            url_ += "OnlyArchived=" + encodeURIComponent("" + onlyArchived) + "&";
        if (includedFields !== undefined && includedFields !== null)
            includedFields && includedFields.forEach(item => { url_ += "IncludedFields=" + encodeURIComponent("" + item) + "&"; });
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PaginatedResultOfListingLookupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfListingLookupDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfListingLookupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfListingLookupDto>(null as any);
    }

    createListing(command: CreateOrEditListingCommand, cancelToken?: CancelToken): Promise<ListingDto> {
        let url_ = this.baseUrl + "/api/v1/listings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateListing(_response);
        });
    }

    protected processCreateListing(response: AxiosResponse): Promise<ListingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingDto.fromJS(resultData200);
            return Promise.resolve<ListingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingDto>(null as any);
    }

    getPublicPage(requestedCulture?: string | null | undefined, minLatitude?: number | null | undefined, maxLatitude?: number | null | undefined, minLongitude?: number | null | undefined, maxLongitude?: number | null | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfListingLookupDto> {
        let url_ = this.baseUrl + "/api/v1/listings/public?";
        if (requestedCulture !== undefined && requestedCulture !== null)
            url_ += "RequestedCulture=" + encodeURIComponent("" + requestedCulture) + "&";
        if (minLatitude !== undefined && minLatitude !== null)
            url_ += "MinLatitude=" + encodeURIComponent("" + minLatitude) + "&";
        if (maxLatitude !== undefined && maxLatitude !== null)
            url_ += "MaxLatitude=" + encodeURIComponent("" + maxLatitude) + "&";
        if (minLongitude !== undefined && minLongitude !== null)
            url_ += "MinLongitude=" + encodeURIComponent("" + minLongitude) + "&";
        if (maxLongitude !== undefined && maxLongitude !== null)
            url_ += "MaxLongitude=" + encodeURIComponent("" + maxLongitude) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicPage(_response);
        });
    }

    protected processGetPublicPage(response: AxiosResponse): Promise<PaginatedResultOfListingLookupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfListingLookupDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfListingLookupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfListingLookupDto>(null as any);
    }

    getListingImages(listingId: number, isDraft?: boolean | undefined, cancelToken?: CancelToken): Promise<ListingImageDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/images?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "isDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingImages(_response);
        });
    }

    protected processGetListingImages(response: AxiosResponse): Promise<ListingImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingImageDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingImageDto[]>(null as any);
    }

    archive(listingId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/archive";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    unarchive(listingId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/unarchive";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnarchive(_response);
        });
    }

    protected processUnarchive(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    cancel(listingId: number, command: CancelListingCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/cancel";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    pause(listingId: number, command: PauseListingCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/pause";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPause(_response);
        });
    }

    protected processPause(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    resubmit(listingId: number, command: ResubmitListingCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/resubmit";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResubmit(_response);
        });
    }

    protected processResubmit(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    unpause(listingId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/unpause";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnpause(_response);
        });
    }

    protected processUnpause(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    approve(listingId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/approve";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    deny(listingId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/deny";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeny(_response);
        });
    }

    protected processDeny(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    approveFree(listingId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/approveFree";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveFree(_response);
        });
    }

    protected processApproveFree(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    rejectFree(listingId: number, command: RejectFreeListingCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/rejectFree";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectFree(_response);
        });
    }

    protected processRejectFree(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    submitDraftForApproval(listingId: number, cancelToken?: CancelToken): Promise<SubmitListingDraftForApprovalResult> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/submitDraftForApproval";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitDraftForApproval(_response);
        });
    }

    protected processSubmitDraftForApproval(response: AxiosResponse): Promise<SubmitListingDraftForApprovalResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitListingDraftForApprovalResult.fromJS(resultData200);
            return Promise.resolve<SubmitListingDraftForApprovalResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitListingDraftForApprovalResult>(null as any);
    }

    getAuditHistory(listingId: number, cancelToken?: CancelToken): Promise<ListingAuditHistoryDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/auditHistory";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditHistory(_response);
        });
    }

    protected processGetAuditHistory(response: AxiosResponse): Promise<ListingAuditHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingAuditHistoryDto.fromJS(resultData200);
            return Promise.resolve<ListingAuditHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingAuditHistoryDto>(null as any);
    }

    processSectionApproval(listingId: number, request: ProcessSectionApprovalRequest, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/processSectionApproval";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessSectionApproval(_response);
        });
    }

    protected processProcessSectionApproval(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    approveListingUpdates(listingId: number, cancelToken?: CancelToken): Promise<ApproveListingUpdatesResult> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/approveListingUpdates";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveListingUpdates(_response);
        });
    }

    protected processApproveListingUpdates(response: AxiosResponse): Promise<ApproveListingUpdatesResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApproveListingUpdatesResult.fromJS(resultData200);
            return Promise.resolve<ApproveListingUpdatesResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApproveListingUpdatesResult>(null as any);
    }

    updateListingStatus(propertyId: number, command: UpdateListingStateCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{propertyId}/updateListingStatus";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateListingStatus(_response);
        });
    }

    protected processUpdateListingStatus(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateListingCompletedStep(listingId: number, command: UpdateListingCompletedStepCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/updateListingCompletedStep";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateListingCompletedStep(_response);
        });
    }

    protected processUpdateListingCompletedStep(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    confirmContract(listingId: number, command: ConfirmListingContractCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/confirmContract";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmContract(_response);
        });
    }

    protected processConfirmContract(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    editImage(listingId: number, imageId: string, command: EditListingImageCommand, cancelToken?: CancelToken): Promise<ListingImageDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/images/{imageId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditImage(_response);
        });
    }

    protected processEditImage(response: AxiosResponse): Promise<ListingImageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingImageDto.fromJS(resultData200);
            return Promise.resolve<ListingImageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingImageDto>(null as any);
    }

    getListingDocuments(listingId: number, isDraft?: boolean | undefined, filterOnSupplementaryDocumentName?: string | null | undefined, cancelToken?: CancelToken): Promise<ListingDocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/documents?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "IsDraft=" + encodeURIComponent("" + isDraft) + "&";
        if (filterOnSupplementaryDocumentName !== undefined && filterOnSupplementaryDocumentName !== null)
            url_ += "FilterOnSupplementaryDocumentName=" + encodeURIComponent("" + filterOnSupplementaryDocumentName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingDocuments(_response);
        });
    }

    protected processGetListingDocuments(response: AxiosResponse): Promise<ListingDocumentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingDocumentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingDocumentDto[]>(null as any);
    }

    getPriceChanges(listingId: number, cancelToken?: CancelToken): Promise<ListingPriceChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/priceChanges";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPriceChanges(_response);
        });
    }

    protected processGetPriceChanges(response: AxiosResponse): Promise<ListingPriceChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingPriceChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingPriceChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingPriceChangeDto[]>(null as any);
    }

    verifyPreview(listingId: number, token?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/verify-preview?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyPreview(_response);
        });
    }

    protected processVerifyPreview(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(listingId: number, requestedCulture?: string | undefined, isDraft?: boolean | undefined, cancelToken?: CancelToken): Promise<ListingDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (requestedCulture === null)
            throw new Error("The parameter 'requestedCulture' cannot be null.");
        else if (requestedCulture !== undefined)
            url_ += "requestedCulture=" + encodeURIComponent("" + requestedCulture) + "&";
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "isDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ListingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingDto.fromJS(resultData200);
            return Promise.resolve<ListingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingDto>(null as any);
    }

    edit(listingId: number, command: CreateOrEditListingCommand, cancelToken?: CancelToken): Promise<ListingDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<ListingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingDto.fromJS(resultData200);
            return Promise.resolve<ListingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingDto>(null as any);
    }

    patch(listingId: number, command: CreateOrEditListingCommand, cancelToken?: CancelToken): Promise<ListingDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: AxiosResponse): Promise<ListingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingDto.fromJS(resultData200);
            return Promise.resolve<ListingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingDto>(null as any);
    }

    delete(listingId: number, command: DeleteListingCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getListingContractDocument(listingId: number, requestedCulture?: string | undefined, cancelToken?: CancelToken): Promise<ListingContractDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/contractDocument?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (requestedCulture === null)
            throw new Error("The parameter 'requestedCulture' cannot be null.");
        else if (requestedCulture !== undefined)
            url_ += "requestedCulture=" + encodeURIComponent("" + requestedCulture) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingContractDocument(_response);
        });
    }

    protected processGetListingContractDocument(response: AxiosResponse): Promise<ListingContractDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingContractDocumentDto.fromJS(resultData200);
            return Promise.resolve<ListingContractDocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingContractDocumentDto>(null as any);
    }

    editPrice(listingId: number, command: EditListingPriceCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/price";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditPrice(_response);
        });
    }

    protected processEditPrice(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    registerVisits(listingId: number, command: RegisterListingVisitCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/registerVisit";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterVisits(_response);
        });
    }

    protected processRegisterVisits(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    editFiles(listingId: number, files?: FileParameter[] | null | undefined, fileTypes?: string[] | null | undefined, supplementaryDocumentNames?: string[] | null | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/files";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (fileTypes !== null && fileTypes !== undefined)
            fileTypes.forEach(item_ => content_.append("fileTypes", item_.toString()));
        if (supplementaryDocumentNames !== null && supplementaryDocumentNames !== undefined)
            supplementaryDocumentNames.forEach(item_ => content_.append("supplementaryDocumentNames", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditFiles(_response);
        });
    }

    protected processEditFiles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    deleteListingImages(listingId: number, command: DeleteSpecificListingFileCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/files";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteListingImages(_response);
        });
    }

    protected processDeleteListingImages(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getCategories(listingId: number, isDraft?: boolean | undefined, cancelToken?: CancelToken): Promise<ListingCategoryDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "isDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategories(_response);
        });
    }

    protected processGetCategories(response: AxiosResponse): Promise<ListingCategoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingCategoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingCategoryDto[]>(null as any);
    }

    createCategory(listingId: number, command: CreateOrEditListingCategoryCommand, cancelToken?: CancelToken): Promise<ListingCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCategory(_response);
        });
    }

    protected processCreateCategory(response: AxiosResponse): Promise<ListingCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingCategoryDto.fromJS(resultData200);
            return Promise.resolve<ListingCategoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingCategoryDto>(null as any);
    }

    editCategory(listingId: number, categoryId: string, command: CreateOrEditListingCategoryCommand, cancelToken?: CancelToken): Promise<ListingCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories/{categoryId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditCategory(_response);
        });
    }

    protected processEditCategory(response: AxiosResponse): Promise<ListingCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingCategoryDto.fromJS(resultData200);
            return Promise.resolve<ListingCategoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingCategoryDto>(null as any);
    }

    deleteCategory(listingId: number, categoryId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories/{categoryId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCategory(_response);
        });
    }

    protected processDeleteCategory(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getCategoryImages(listingId: number, categoryId: string, isDraft?: boolean | undefined, cancelToken?: CancelToken): Promise<ListingCategoryDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories/{categoryId}/images?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "isDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategoryImages(_response);
        });
    }

    protected processGetCategoryImages(response: AxiosResponse): Promise<ListingCategoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingCategoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingCategoryDto[]>(null as any);
    }

    uploadImagesToCategory(listingId: number, categoryId: string, formFiles?: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<ListingImageDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories/{categoryId}/uploadImages";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFiles !== null && formFiles !== undefined)
            formFiles.forEach(item_ => content_.append("formFiles", item_.data, item_.fileName ? item_.fileName : "formFiles") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadImagesToCategory(_response);
        });
    }

    protected processUploadImagesToCategory(response: AxiosResponse): Promise<ListingImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingImageDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingImageDto[]>(null as any);
    }

    reorderImagesInCategory(listingId: number, categoryId: string, command: ReorderListingCategoryImagesCommand, cancelToken?: CancelToken): Promise<ListingImageDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories/{categoryId}/reorder";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReorderImagesInCategory(_response);
        });
    }

    protected processReorderImagesInCategory(response: AxiosResponse): Promise<ListingImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingImageDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingImageDto[]>(null as any);
    }

    deleteListingDocuments(listingId: number, documentId: string, command: DeleteListingDocumentCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/documents/{documentId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteListingDocuments(_response);
        });
    }

    protected processDeleteListingDocuments(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    deleteListingImages2(listingId: number, imageMediaId: string, command: DeleteListingImageCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/images/{imageMediaId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (imageMediaId === undefined || imageMediaId === null)
            throw new Error("The parameter 'imageMediaId' must be defined.");
        url_ = url_.replace("{imageMediaId}", encodeURIComponent("" + imageMediaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteListingImages2(_response);
        });
    }

    protected processDeleteListingImages2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getCheckoutQrCode(listingId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/checkoutQrCode";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCheckoutQrCode(_response);
        });
    }

    protected processGetCheckoutQrCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getSellersDeclaration(listingId: number, isDraft?: boolean | undefined, cancelToken?: CancelToken): Promise<SellersDeclarationDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellersDeclaration?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "isDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSellersDeclaration(_response);
        });
    }

    protected processGetSellersDeclaration(response: AxiosResponse): Promise<SellersDeclarationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SellersDeclarationDto.fromJS(resultData200);
            return Promise.resolve<SellersDeclarationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SellersDeclarationDto>(null as any);
    }

    createCheckoutSession(id: number, command: CreateSubscriptionCheckoutSessionCommand, cancelToken?: CancelToken): Promise<StripeCheckoutSessionOutput> {
        let url_ = this.baseUrl + "/api/v1/listings/{id}/createCheckoutSession";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCheckoutSession(_response);
        });
    }

    protected processCreateCheckoutSession(response: AxiosResponse): Promise<StripeCheckoutSessionOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StripeCheckoutSessionOutput.fromJS(resultData200);
            return Promise.resolve<StripeCheckoutSessionOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StripeCheckoutSessionOutput>(null as any);
    }

    checkSubscriptionStatus(id: number, redirect?: string | undefined, result?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/listings/{id}/checkSubscriptionStatus?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (redirect === null)
            throw new Error("The parameter 'redirect' cannot be null.");
        else if (redirect !== undefined)
            url_ += "redirect=" + encodeURIComponent("" + redirect) + "&";
        if (result === null)
            throw new Error("The parameter 'result' cannot be null.");
        else if (result !== undefined)
            url_ += "result=" + encodeURIComponent("" + result) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckSubscriptionStatus(_response);
        });
    }

    protected processCheckSubscriptionStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSubscriptionPortalUrl(id: number, redirect?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{id}/subscriptionPortalUrl?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (redirect === null)
            throw new Error("The parameter 'redirect' cannot be null.");
        else if (redirect !== undefined)
            url_ += "redirect=" + encodeURIComponent("" + redirect) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscriptionPortalUrl(_response);
        });
    }

    protected processGetSubscriptionPortalUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getListingPricing(id: number, cancelToken?: CancelToken): Promise<StripeProductDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{id}/pricing";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingPricing(_response);
        });
    }

    protected processGetListingPricing(response: AxiosResponse): Promise<StripeProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StripeProductDto.fromJS(resultData200);
            return Promise.resolve<StripeProductDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StripeProductDto>(null as any);
    }

    getListingProducts(id: number, cancelToken?: CancelToken): Promise<StripeProductDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{id}/products";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingProducts(_response);
        });
    }

    protected processGetListingProducts(response: AxiosResponse): Promise<StripeProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StripeProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StripeProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StripeProductDto[]>(null as any);
    }

    createSeller(listingId: number, command: CreateOrEditListingSellerCommand, cancelToken?: CancelToken): Promise<SellerDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSeller(_response);
        });
    }

    protected processCreateSeller(response: AxiosResponse): Promise<SellerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SellerDto.fromJS(resultData200);
            return Promise.resolve<SellerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SellerDto>(null as any);
    }

    getSellers(listingId: number, isDraft?: boolean | undefined, cancelToken?: CancelToken): Promise<SellerDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "isDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSellers(_response);
        });
    }

    protected processGetSellers(response: AxiosResponse): Promise<SellerDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SellerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SellerDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SellerDto[]>(null as any);
    }

    editSeller(listingId: number, sellerId: string, command: CreateOrEditListingSellerCommand, cancelToken?: CancelToken): Promise<SellerDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers/{sellerId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (sellerId === undefined || sellerId === null)
            throw new Error("The parameter 'sellerId' must be defined.");
        url_ = url_.replace("{sellerId}", encodeURIComponent("" + sellerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditSeller(_response);
        });
    }

    protected processEditSeller(response: AxiosResponse): Promise<SellerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SellerDto.fromJS(resultData200);
            return Promise.resolve<SellerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SellerDto>(null as any);
    }

    getSeller(listingId: number, sellerId: string, isDraft?: boolean | undefined, cancelToken?: CancelToken): Promise<SellerDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers/{sellerId}?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (sellerId === undefined || sellerId === null)
            throw new Error("The parameter 'sellerId' must be defined.");
        url_ = url_.replace("{sellerId}", encodeURIComponent("" + sellerId));
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "isDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSeller(_response);
        });
    }

    protected processGetSeller(response: AxiosResponse): Promise<SellerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SellerDto.fromJS(resultData200);
            return Promise.resolve<SellerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SellerDto>(null as any);
    }

    inviteSeller(listingId: number, command: InviteSellerCommand, cancelToken?: CancelToken): Promise<SellerDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers/invite";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteSeller(_response);
        });
    }

    protected processInviteSeller(response: AxiosResponse): Promise<SellerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SellerDto.fromJS(resultData200);
            return Promise.resolve<SellerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SellerDto>(null as any);
    }

    editInvitedSeller(listingId: number, sellerId: string, command: EditInvitedSellerCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers/{sellerId}/invite";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (sellerId === undefined || sellerId === null)
            throw new Error("The parameter 'sellerId' must be defined.");
        url_ = url_.replace("{sellerId}", encodeURIComponent("" + sellerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditInvitedSeller(_response);
        });
    }

    protected processEditInvitedSeller(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    confirmInviteSeller(listingId: number, sellerId: string, command: ConfirmInviteSellerCommand, cancelToken?: CancelToken): Promise<SellerDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers/{sellerId}/confirm";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (sellerId === undefined || sellerId === null)
            throw new Error("The parameter 'sellerId' must be defined.");
        url_ = url_.replace("{sellerId}", encodeURIComponent("" + sellerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmInviteSeller(_response);
        });
    }

    protected processConfirmInviteSeller(response: AxiosResponse): Promise<SellerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SellerDto.fromJS(resultData200);
            return Promise.resolve<SellerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SellerDto>(null as any);
    }

    declineInviteSeller(listingId: number, sellerId: string, command: DeclineInviteSellerCommand, cancelToken?: CancelToken): Promise<SellerDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers/{sellerId}/decline";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (sellerId === undefined || sellerId === null)
            throw new Error("The parameter 'sellerId' must be defined.");
        url_ = url_.replace("{sellerId}", encodeURIComponent("" + sellerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclineInviteSeller(_response);
        });
    }

    protected processDeclineInviteSeller(response: AxiosResponse): Promise<SellerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SellerDto.fromJS(resultData200);
            return Promise.resolve<SellerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SellerDto>(null as any);
    }

    reSendSellerEmail(listingId: number, sellerId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/sellers/{sellerId}/resendInvite";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (sellerId === undefined || sellerId === null)
            throw new Error("The parameter 'sellerId' must be defined.");
        url_ = url_.replace("{sellerId}", encodeURIComponent("" + sellerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReSendSellerEmail(_response);
        });
    }

    protected processReSendSellerEmail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getListingReviewGroupSections(listingId: number, cancelToken?: CancelToken): Promise<ListingReviewGroupSectionDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/reviewGroupSections";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingReviewGroupSections(_response);
        });
    }

    protected processGetListingReviewGroupSections(response: AxiosResponse): Promise<ListingReviewGroupSectionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingReviewGroupSectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingReviewGroupSectionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingReviewGroupSectionDto[]>(null as any);
    }

    updateListingReviewGroupSection(listingId: number, command: EditListingReviewGroupSectionCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/reviewGroupSections";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateListingReviewGroupSection(_response);
        });
    }

    protected processUpdateListingReviewGroupSection(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getListingStateChangeRecords(listingId: number, cancelToken?: CancelToken): Promise<ListingStateChangeRecordDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/listingStateChangeRecords";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingStateChangeRecords(_response);
        });
    }

    protected processGetListingStateChangeRecords(response: AxiosResponse): Promise<ListingStateChangeRecordDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingStateChangeRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingStateChangeRecordDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingStateChangeRecordDto[]>(null as any);
    }

    reSubmitListingReviewGroupSections(listingId: number, command: ReSubmitListingReviewGroupSectionsCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/reSubmitPropertyReviewGroupSections";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReSubmitListingReviewGroupSections(_response);
        });
    }

    protected processReSubmitListingReviewGroupSections(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    generateReviewDealContract(listingId: number, command: GenerateReviewDealContractCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/generateReviewDealContract";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateReviewDealContract(_response);
        });
    }

    protected processGenerateReviewDealContract(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getVideoUploadSignature(listingId: number, categoryId: string, cancelToken?: CancelToken): Promise<CloudinaryVideoSignatureDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories/{categoryId}/videoUploadSignature";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVideoUploadSignature(_response);
        });
    }

    protected processGetVideoUploadSignature(response: AxiosResponse): Promise<CloudinaryVideoSignatureDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloudinaryVideoSignatureDto.fromJS(resultData200);
            return Promise.resolve<CloudinaryVideoSignatureDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloudinaryVideoSignatureDto>(null as any);
    }

    attachVideo(listingId: number, categoryId: string, command: AttachVideoToListingCommand, cancelToken?: CancelToken): Promise<ListingImageDto> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/categories/{categoryId}/attachVideo";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAttachVideo(_response);
        });
    }

    protected processAttachVideo(response: AxiosResponse): Promise<ListingImageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingImageDto.fromJS(resultData200);
            return Promise.resolve<ListingImageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingImageDto>(null as any);
    }

    createSimpleListing(command: CreateSimpleListingCommand, cancelToken?: CancelToken): Promise<SimpleListingCreatedDto> {
        let url_ = this.baseUrl + "/api/v1/listings/simpleCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSimpleListing(_response);
        });
    }

    protected processCreateSimpleListing(response: AxiosResponse): Promise<SimpleListingCreatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SimpleListingCreatedDto.fromJS(resultData200);
            return Promise.resolve<SimpleListingCreatedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleListingCreatedDto>(null as any);
    }

    uploadListingImages(listingId: number, email?: string | undefined, otpCode?: string | undefined, formFiles?: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<ListingImageDto[]> {
        let url_ = this.baseUrl + "/api/v1/listings/{listingId}/uploadImages?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (otpCode === null)
            throw new Error("The parameter 'otpCode' cannot be null.");
        else if (otpCode !== undefined)
            url_ += "otpCode=" + encodeURIComponent("" + otpCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFiles !== null && formFiles !== undefined)
            formFiles.forEach(item_ => content_.append("formFiles", item_.data, item_.fileName ? item_.fileName : "formFiles") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadListingImages(_response);
        });
    }

    protected processUploadListingImages(response: AxiosResponse): Promise<ListingImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingImageDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingImageDto[]>(null as any);
    }
}

export class LogTestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    testLogs( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/logTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestLogs(_response);
        });
    }

    protected processTestLogs(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    testLogsWithContext(userEmail?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/logTest/withContext?";
        if (userEmail !== undefined && userEmail !== null)
            url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestLogsWithContext(_response);
        });
    }

    protected processTestLogsWithContext(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MockEmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMockEmails(api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MockEmail?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMockEmails(_response);
        });
    }

    protected processGetMockEmails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    clearMockEmails(api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MockEmail?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearMockEmails(_response);
        });
    }

    protected processClearMockEmails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getMockEmail(id: string, api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MockEmail/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMockEmail(_response);
        });
    }

    protected processGetMockEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MockSmsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllMockSms(api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/v1/MockSms?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllMockSms(_response);
        });
    }

    protected processGetAllMockSms(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    clearAllMockSms(api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MockSms?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearAllMockSms(_response);
        });
    }

    protected processClearAllMockSms(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getMockSmsById(id: string, api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MockSms/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMockSmsById(_response);
        });
    }

    protected processGetMockSmsById(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteMockSms(id: string, api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MockSms/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMockSms(_response);
        });
    }

    protected processDeleteMockSms(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class NotificationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getNotifications(pageNumber?: number | undefined, pageSize?: number | undefined, isRead?: boolean | null | undefined, locale?: string | null | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfInAppNotificationDto> {
        let url_ = this.baseUrl + "/api/v1/notifications?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isRead !== undefined && isRead !== null)
            url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
        if (locale !== undefined && locale !== null)
            url_ += "Locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: AxiosResponse): Promise<PaginatedResultOfInAppNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfInAppNotificationDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfInAppNotificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfInAppNotificationDto>(null as any);
    }

    getNotificationById(notificationId: string, locale?: string | null | undefined, cancelToken?: CancelToken): Promise<InAppNotificationDto> {
        let url_ = this.baseUrl + "/api/v1/notifications/{notificationId}?";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        if (locale !== undefined && locale !== null)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationById(_response);
        });
    }

    protected processGetNotificationById(response: AxiosResponse): Promise<InAppNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InAppNotificationDto.fromJS(resultData200);
            return Promise.resolve<InAppNotificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InAppNotificationDto>(null as any);
    }

    deleteNotification(notificationId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNotification(_response);
        });
    }

    protected processDeleteNotification(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    markAsRead(notificationId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/notifications/{notificationId}/read";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsRead(_response);
        });
    }

    protected processMarkAsRead(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    markAllAsRead( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/notifications/readAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAllAsRead(_response);
        });
    }

    protected processMarkAllAsRead(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    deleteAll(onlyRead?: boolean | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/notifications/deleteAll?";
        if (onlyRead === null)
            throw new Error("The parameter 'onlyRead' cannot be null.");
        else if (onlyRead !== undefined)
            url_ += "onlyRead=" + encodeURIComponent("" + onlyRead) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    bulkMarkAsRead(notificationIds: string[], cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/notifications/bulkRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkMarkAsRead(_response);
        });
    }

    protected processBulkMarkAsRead(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    bulkDelete(notificationIds: string[], cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/notifications/bulkDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkDelete(_response);
        });
    }

    protected processBulkDelete(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class NotificationTestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    sendTestEmail(request: TestEmailRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/notification-test/test-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendTestSms(request: TestSmsRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/notification-test/test-sms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestSms(_response);
        });
    }

    protected processSendTestSms(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendTestImmediate(request: TestImmediateRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/notification-test/test-immediate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestImmediate(_response);
        });
    }

    protected processSendTestImmediate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getNotificationStatus(outboxId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/notification-test/status/{outboxId}";
        if (outboxId === undefined || outboxId === null)
            throw new Error("The parameter 'outboxId' must be defined.");
        url_ = url_.replace("{outboxId}", encodeURIComponent("" + outboxId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationStatus(_response);
        });
    }

    protected processGetNotificationStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendTestBatch(request: TestBatchRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/notification-test/test-batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestBatch(_response);
        });
    }

    protected processSendTestBatch(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PdfGeneratorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    generateFromHtml(request: GeneratePdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/pdfGenerator/generateFromHtml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateFromHtml(_response);
        });
    }

    protected processGenerateFromHtml(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addWatermark(request: AddWatermarkRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/pdfGenerator/addWatermark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddWatermark(_response);
        });
    }

    protected processAddWatermark(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProjects(builderId?: number | null | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfProjectLookupDto> {
        let url_ = this.baseUrl + "/api/v1/projects?";
        if (builderId !== undefined && builderId !== null)
            url_ += "BuilderId=" + encodeURIComponent("" + builderId) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjects(_response);
        });
    }

    protected processGetProjects(response: AxiosResponse): Promise<PaginatedResultOfProjectLookupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfProjectLookupDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfProjectLookupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfProjectLookupDto>(null as any);
    }

    generateProjectEmailCopy(projectId: number, query: GetProjectEmailCopyQuery, cancelToken?: CancelToken): Promise<ProjectEmailContentDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{projectId}/emailCopy";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateProjectEmailCopy(_response);
        });
    }

    protected processGenerateProjectEmailCopy(response: AxiosResponse): Promise<ProjectEmailContentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectEmailContentDto.fromJS(resultData200);
            return Promise.resolve<ProjectEmailContentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectEmailContentDto>(null as any);
    }

    get(projectId: number, culture: string | null, includeFields?: string | null | undefined, cancelToken?: CancelToken): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (culture === undefined)
            throw new Error("The parameter 'culture' must be defined.");
        else if(culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        if (includeFields !== undefined && includeFields !== null)
            url_ += "includeFields=" + encodeURIComponent("" + includeFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectDto.fromJS(resultData200);
            return Promise.resolve<ProjectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    uploadCustomContract(projectId: number, includeSellersDeclaration?: boolean | null | undefined, saleTemplateEn?: FileParameter | null | undefined, saleTemplateFr?: FileParameter | null | undefined, sampleContractEn?: FileParameter | null | undefined, sampleContractFr?: FileParameter | null | undefined, termsAndConditionsEn?: FileParameter | null | undefined, termsAndConditionsFr?: FileParameter | null | undefined, appendixEn?: FileParameter | null | undefined, appendixFr?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/projects/{projectId}/customContract?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (includeSellersDeclaration !== undefined && includeSellersDeclaration !== null)
            url_ += "includeSellersDeclaration=" + encodeURIComponent("" + includeSellersDeclaration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (saleTemplateEn !== null && saleTemplateEn !== undefined)
            content_.append("saleTemplateEn", saleTemplateEn.data, saleTemplateEn.fileName ? saleTemplateEn.fileName : "saleTemplateEn");
        if (saleTemplateFr !== null && saleTemplateFr !== undefined)
            content_.append("saleTemplateFr", saleTemplateFr.data, saleTemplateFr.fileName ? saleTemplateFr.fileName : "saleTemplateFr");
        if (sampleContractEn !== null && sampleContractEn !== undefined)
            content_.append("sampleContractEn", sampleContractEn.data, sampleContractEn.fileName ? sampleContractEn.fileName : "sampleContractEn");
        if (sampleContractFr !== null && sampleContractFr !== undefined)
            content_.append("sampleContractFr", sampleContractFr.data, sampleContractFr.fileName ? sampleContractFr.fileName : "sampleContractFr");
        if (termsAndConditionsEn !== null && termsAndConditionsEn !== undefined)
            content_.append("termsAndConditionsEn", termsAndConditionsEn.data, termsAndConditionsEn.fileName ? termsAndConditionsEn.fileName : "termsAndConditionsEn");
        if (termsAndConditionsFr !== null && termsAndConditionsFr !== undefined)
            content_.append("termsAndConditionsFr", termsAndConditionsFr.data, termsAndConditionsFr.fileName ? termsAndConditionsFr.fileName : "termsAndConditionsFr");
        if (appendixEn !== null && appendixEn !== undefined)
            content_.append("appendixEn", appendixEn.data, appendixEn.fileName ? appendixEn.fileName : "appendixEn");
        if (appendixFr !== null && appendixFr !== undefined)
            content_.append("appendixFr", appendixFr.data, appendixFr.fileName ? appendixFr.fileName : "appendixFr");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCustomContract(_response);
        });
    }

    protected processUploadCustomContract(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class QrCodesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    generateQrCodes(command: GenerateQrCodesCommand, cancelToken?: CancelToken): Promise<QrCodeDto[]> {
        let url_ = this.baseUrl + "/api/v1/qrCodes/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateQrCodes(_response);
        });
    }

    protected processGenerateQrCodes(response: AxiosResponse): Promise<QrCodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QrCodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QrCodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QrCodeDto[]>(null as any);
    }

    deleteAllQrCodes( cancelToken?: CancelToken): Promise<QrCodeDto[]> {
        let url_ = this.baseUrl + "/api/v1/qrCodes/deleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAllQrCodes(_response);
        });
    }

    protected processDeleteAllQrCodes(response: AxiosResponse): Promise<QrCodeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QrCodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QrCodeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QrCodeDto[]>(null as any);
    }

    linkQrCodesToUsers(command: LinkQRCodesToUserCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/qrCodes/linkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkQrCodesToUsers(_response);
        });
    }

    protected processLinkQrCodesToUsers(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    linkQrCodesToListing(command: LinkQrCodesToListingCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/qrCodes/linkToListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkQrCodesToListing(_response);
        });
    }

    protected processLinkQrCodesToListing(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    unlinkQrCodesToListing(command: UnlinkQRCodesToListingCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/qrCodes/unlinkToListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkQrCodesToListing(_response);
        });
    }

    protected processUnlinkQrCodesToListing(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getQrCode(code: string, cancelToken?: CancelToken): Promise<QrCodeDto> {
        let url_ = this.baseUrl + "/api/v1/qrCodes/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQrCode(_response);
        });
    }

    protected processGetQrCode(response: AxiosResponse): Promise<QrCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QrCodeDto.fromJS(resultData200);
            return Promise.resolve<QrCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QrCodeDto>(null as any);
    }

    getCodes(page?: number | null | undefined, pageSize?: number | undefined, onlyGetImportedQrCodes?: boolean | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, ascSortDirection?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfQrCodeDto> {
        let url_ = this.baseUrl + "/api/v1/qrCodes?";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (onlyGetImportedQrCodes === null)
            throw new Error("The parameter 'onlyGetImportedQrCodes' cannot be null.");
        else if (onlyGetImportedQrCodes !== undefined)
            url_ += "onlyGetImportedQrCodes=" + encodeURIComponent("" + onlyGetImportedQrCodes) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "ascSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodes(_response);
        });
    }

    protected processGetCodes(response: AxiosResponse): Promise<PaginatedResultOfQrCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfQrCodeDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfQrCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfQrCodeDto>(null as any);
    }

    importQrCodes(command: ImportQrCodesCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/qrCodes/importQrCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportQrCodes(_response);
        });
    }

    protected processImportQrCodes(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getUserQrCodes(page?: number | null | undefined, pageSize?: number | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, ascSortDirection?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfQrCodeDto> {
        let url_ = this.baseUrl + "/api/v1/qrCodes/user?";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "ascSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserQrCodes(_response);
        });
    }

    protected processGetUserQrCodes(response: AxiosResponse): Promise<PaginatedResultOfQrCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfQrCodeDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfQrCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfQrCodeDto>(null as any);
    }
}

export class ReferrersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    referrers( cancelToken?: CancelToken): Promise<ReferrerLookUpDto[]> {
        let url_ = this.baseUrl + "/api/v1/referrers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReferrers(_response);
        });
    }

    protected processReferrers(response: AxiosResponse): Promise<ReferrerLookUpDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferrerLookUpDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReferrerLookUpDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferrerLookUpDto[]>(null as any);
    }
}

export class RfbClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    authCheck( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/rfb/authCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthCheck(_response);
        });
    }

    protected processAuthCheck(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    linkAllBuyers( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/rfb/linkAllBuyers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkAllBuyers(_response);
        });
    }

    protected processLinkAllBuyers(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class RolesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRoles( cancelToken?: CancelToken): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }
}

export class SchedulingAppointmentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(command: CreateAppointmentCommand, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/scheduling/appointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getMyAppointments(role?: AppointmentRoleFilter | undefined, statuses?: AppointmentStatus[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, listingId?: number | null | undefined, page?: number | undefined, pageSize?: number | undefined, cancelToken?: CancelToken): Promise<AppointmentListDto[]> {
        let url_ = this.baseUrl + "/api/v1/scheduling/appointments/me?";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (listingId !== undefined && listingId !== null)
            url_ += "ListingId=" + encodeURIComponent("" + listingId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyAppointments(_response);
        });
    }

    protected processGetMyAppointments(response: AxiosResponse): Promise<AppointmentListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppointmentListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentListDto[]>(null as any);
    }

    getDetails(appointmentId: number, cancelToken?: CancelToken): Promise<AppointmentDetailDto> {
        let url_ = this.baseUrl + "/api/v1/scheduling/appointments/{appointmentId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<AppointmentDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppointmentDetailDto.fromJS(resultData200);
            return Promise.resolve<AppointmentDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentDetailDto>(null as any);
    }

    accept(appointmentId: number, command: AcceptAppointmentCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/scheduling/appointments/{appointmentId}/accept";
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    decline(appointmentId: number, command: DeclineAppointmentCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/scheduling/appointments/{appointmentId}/decline";
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDecline(_response);
        });
    }

    protected processDecline(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    reschedule(appointmentId: number, command: ProposeRescheduleCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/scheduling/appointments/{appointmentId}/reschedule";
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReschedule(_response);
        });
    }

    protected processReschedule(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    cancel(appointmentId: number, command: CancelAppointmentCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/scheduling/appointments/{appointmentId}/cancel";
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SchedulingAvailabilityClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    setAvailability(command: SetAvailabilityCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/scheduling/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAvailability(_response);
        });
    }

    protected processSetAvailability(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getMyAvailability( cancelToken?: CancelToken): Promise<AvailabilityDto> {
        let url_ = this.baseUrl + "/api/v1/scheduling/availability";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyAvailability(_response);
        });
    }

    protected processGetMyAvailability(response: AxiosResponse): Promise<AvailabilityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailabilityDto.fromJS(resultData200);
            return Promise.resolve<AvailabilityDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityDto>(null as any);
    }

    editAppointmentDetails(command: EditAppointmentDetailsCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/scheduling/availability/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditAppointmentDetails(_response);
        });
    }

    protected processEditAppointmentDetails(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    editWeeklyAvailability(command: EditWeeklyAvailabilityCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/scheduling/availability/weeklyRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditWeeklyAvailability(_response);
        });
    }

    protected processEditWeeklyAvailability(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    editOverrides(command: EditOverridesCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/scheduling/availability/overrides";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditOverrides(_response);
        });
    }

    protected processEditOverrides(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SchedulingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAvailableSlots(userId: string, from?: Date | undefined, to?: Date | undefined, durationMinutes?: number | undefined, cancelToken?: CancelToken): Promise<AvailableSlot[]> {
        let url_ = this.baseUrl + "/api/v1/scheduling/users/{userId}/availableSlots?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (durationMinutes === null)
            throw new Error("The parameter 'durationMinutes' cannot be null.");
        else if (durationMinutes !== undefined)
            url_ += "durationMinutes=" + encodeURIComponent("" + durationMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableSlots(_response);
        });
    }

    protected processGetAvailableSlots(response: AxiosResponse): Promise<AvailableSlot[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableSlot.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AvailableSlot[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableSlot[]>(null as any);
    }

    getMutualAvailability(userAId?: string | null | undefined, userBId?: string | null | undefined, from?: Date | undefined, to?: Date | undefined, durationMinutes?: number | undefined, timezone?: string | null | undefined, cancelToken?: CancelToken): Promise<MutualAvailabilityResult> {
        let url_ = this.baseUrl + "/api/v1/scheduling/mutualAvailability?";
        if (userAId !== undefined && userAId !== null)
            url_ += "userAId=" + encodeURIComponent("" + userAId) + "&";
        if (userBId !== undefined && userBId !== null)
            url_ += "userBId=" + encodeURIComponent("" + userBId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (durationMinutes === null)
            throw new Error("The parameter 'durationMinutes' cannot be null.");
        else if (durationMinutes !== undefined)
            url_ += "durationMinutes=" + encodeURIComponent("" + durationMinutes) + "&";
        if (timezone !== undefined && timezone !== null)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMutualAvailability(_response);
        });
    }

    protected processGetMutualAvailability(response: AxiosResponse): Promise<MutualAvailabilityResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MutualAvailabilityResult.fromJS(resultData200);
            return Promise.resolve<MutualAvailabilityResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MutualAvailabilityResult>(null as any);
    }

    checkConflicts(query: CheckConflictsQuery, cancelToken?: CancelToken): Promise<ConflictCheckResult[]> {
        let url_ = this.baseUrl + "/api/v1/scheduling/conflicts/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckConflicts(_response);
        });
    }

    protected processCheckConflicts(response: AxiosResponse): Promise<ConflictCheckResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConflictCheckResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConflictCheckResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConflictCheckResult[]>(null as any);
    }

    getSchedulingSummary(listingId: number, from?: Date | null | undefined, to?: Date | null | undefined, includeAvailableSlots?: boolean | undefined, includeOpenHouses?: boolean | undefined, cancelToken?: CancelToken): Promise<ListingSchedulingSummaryDto> {
        let url_ = this.baseUrl + "/api/v1/scheduling/listings/{listingId}/summary?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (includeAvailableSlots === null)
            throw new Error("The parameter 'includeAvailableSlots' cannot be null.");
        else if (includeAvailableSlots !== undefined)
            url_ += "includeAvailableSlots=" + encodeURIComponent("" + includeAvailableSlots) + "&";
        if (includeOpenHouses === null)
            throw new Error("The parameter 'includeOpenHouses' cannot be null.");
        else if (includeOpenHouses !== undefined)
            url_ += "includeOpenHouses=" + encodeURIComponent("" + includeOpenHouses) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchedulingSummary(_response);
        });
    }

    protected processGetSchedulingSummary(response: AxiosResponse): Promise<ListingSchedulingSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingSchedulingSummaryDto.fromJS(resultData200);
            return Promise.resolve<ListingSchedulingSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingSchedulingSummaryDto>(null as any);
    }
}

export class SchedulingOpenHousesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    create(command: CreateOpenHouseCommand, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getMyOpenHouses(status?: OpenHouseStatus | null | undefined, listingId?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, cancelToken?: CancelToken): Promise<OpenHouseListDto[]> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/me?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (listingId !== undefined && listingId !== null)
            url_ += "ListingId=" + encodeURIComponent("" + listingId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyOpenHouses(_response);
        });
    }

    protected processGetMyOpenHouses(response: AxiosResponse): Promise<OpenHouseListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpenHouseListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OpenHouseListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OpenHouseListDto[]>(null as any);
    }

    getMyRsvps(openHouseStatus?: OpenHouseStatus | null | undefined, listingId?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, cancelToken?: CancelToken): Promise<MyRsvpDto[]> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/me/rsvps?";
        if (openHouseStatus !== undefined && openHouseStatus !== null)
            url_ += "OpenHouseStatus=" + encodeURIComponent("" + openHouseStatus) + "&";
        if (listingId !== undefined && listingId !== null)
            url_ += "ListingId=" + encodeURIComponent("" + listingId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyRsvps(_response);
        });
    }

    protected processGetMyRsvps(response: AxiosResponse): Promise<MyRsvpDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyRsvpDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MyRsvpDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyRsvpDto[]>(null as any);
    }

    getListingOpenHouses(listingId: number, cancelToken?: CancelToken): Promise<ListingOpenHouseDto[]> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/listing/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListingOpenHouses(_response);
        });
    }

    protected processGetListingOpenHouses(response: AxiosResponse): Promise<ListingOpenHouseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingOpenHouseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingOpenHouseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingOpenHouseDto[]>(null as any);
    }

    getDetails(openHouseId: number, cancelToken?: CancelToken): Promise<OpenHouseDetailDto> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/{openHouseId}";
        if (openHouseId === undefined || openHouseId === null)
            throw new Error("The parameter 'openHouseId' must be defined.");
        url_ = url_.replace("{openHouseId}", encodeURIComponent("" + openHouseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<OpenHouseDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OpenHouseDetailDto.fromJS(resultData200);
            return Promise.resolve<OpenHouseDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OpenHouseDetailDto>(null as any);
    }

    update(openHouseId: number, command: UpdateOpenHouseCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/{openHouseId}";
        if (openHouseId === undefined || openHouseId === null)
            throw new Error("The parameter 'openHouseId' must be defined.");
        url_ = url_.replace("{openHouseId}", encodeURIComponent("" + openHouseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    cancel(openHouseId: number, command: CancelOpenHouseCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/{openHouseId}/cancel";
        if (openHouseId === undefined || openHouseId === null)
            throw new Error("The parameter 'openHouseId' must be defined.");
        url_ = url_.replace("{openHouseId}", encodeURIComponent("" + openHouseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    rsvp(openHouseId: number, command: RsvpToOpenHouseCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/{openHouseId}/rsvp";
        if (openHouseId === undefined || openHouseId === null)
            throw new Error("The parameter 'openHouseId' must be defined.");
        url_ = url_.replace("{openHouseId}", encodeURIComponent("" + openHouseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRsvp(_response);
        });
    }

    protected processRsvp(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    cancelRsvp(openHouseId: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/{openHouseId}/rsvp";
        if (openHouseId === undefined || openHouseId === null)
            throw new Error("The parameter 'openHouseId' must be defined.");
        url_ = url_.replace("{openHouseId}", encodeURIComponent("" + openHouseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelRsvp(_response);
        });
    }

    protected processCancelRsvp(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getRsvps(openHouseId: number, cancelToken?: CancelToken): Promise<RsvpDto[]> {
        let url_ = this.baseUrl + "/api/v1/scheduling/openHouses/{openHouseId}/rsvps";
        if (openHouseId === undefined || openHouseId === null)
            throw new Error("The parameter 'openHouseId' must be defined.");
        url_ = url_.replace("{openHouseId}", encodeURIComponent("" + openHouseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRsvps(_response);
        });
    }

    protected processGetRsvps(response: AxiosResponse): Promise<RsvpDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RsvpDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RsvpDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RsvpDto[]>(null as any);
    }
}

export class SendbirdWebhookClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    receiveWebhook(payload: any, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/webhooks/sendbird";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReceiveWebhook(_response);
        });
    }

    protected processReceiveWebhook(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SharedOpportunitiesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPage(filterByStates?: SharedOpportunityStatus[] | null | undefined, includedFields?: string[] | null | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfSharedOpportunityLookupDto> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities?";
        if (filterByStates !== undefined && filterByStates !== null)
            filterByStates && filterByStates.forEach(item => { url_ += "FilterByStates=" + encodeURIComponent("" + item) + "&"; });
        if (includedFields !== undefined && includedFields !== null)
            includedFields && includedFields.forEach(item => { url_ += "IncludedFields=" + encodeURIComponent("" + item) + "&"; });
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PaginatedResultOfSharedOpportunityLookupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfSharedOpportunityLookupDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfSharedOpportunityLookupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfSharedOpportunityLookupDto>(null as any);
    }

    create(command: CreateSharedOpportunityCommand, cancelToken?: CancelToken): Promise<SharedOpportunityDto> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SharedOpportunityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SharedOpportunityDto.fromJS(resultData201);
            return Promise.resolve<SharedOpportunityDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SharedOpportunityDto>(null as any);
    }

    deleteAll( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    get(opportunityId: string, includeFields?: string | null | undefined, cancelToken?: CancelToken): Promise<SharedOpportunityDto> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}?";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        if (includeFields !== undefined && includeFields !== null)
            url_ += "includeFields=" + encodeURIComponent("" + includeFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SharedOpportunityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SharedOpportunityDto.fromJS(resultData200);
            return Promise.resolve<SharedOpportunityDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SharedOpportunityDto>(null as any);
    }

    getChats(opportunityId: string, limit?: number | undefined, cancelToken?: CancelToken): Promise<SendbirdMessage> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}/chats?";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChats(_response);
        });
    }

    protected processGetChats(response: AxiosResponse): Promise<SendbirdMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendbirdMessage.fromJS(resultData200);
            return Promise.resolve<SendbirdMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendbirdMessage>(null as any);
    }

    requestToChat(opportunityId: string, command: RequestOpportunityChatCommand, cancelToken?: CancelToken): Promise<SendbirdMessage> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}/requestToChat";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestToChat(_response);
        });
    }

    protected processRequestToChat(response: AxiosResponse): Promise<SendbirdMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendbirdMessage.fromJS(resultData200);
            return Promise.resolve<SendbirdMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendbirdMessage>(null as any);
    }

    acceptRequestToChat(opportunityId: string, command: AcceptRequestOpportunityChatCommand, cancelToken?: CancelToken): Promise<SendbirdMessage> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}/acceptRequestToChat";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptRequestToChat(_response);
        });
    }

    protected processAcceptRequestToChat(response: AxiosResponse): Promise<SendbirdMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendbirdMessage.fromJS(resultData200);
            return Promise.resolve<SendbirdMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendbirdMessage>(null as any);
    }

    declineRequestToChat(opportunityId: string, command: DeclineRequestOpportunityChatCommand, cancelToken?: CancelToken): Promise<SendbirdMessage> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}/declineRequestToChat";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclineRequestToChat(_response);
        });
    }

    protected processDeclineRequestToChat(response: AxiosResponse): Promise<SendbirdMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendbirdMessage.fromJS(resultData200);
            return Promise.resolve<SendbirdMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendbirdMessage>(null as any);
    }

    rejoinChat(opportunityId: string, command: RejoinOpportunityChatCommand, cancelToken?: CancelToken): Promise<SendbirdMessage> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}/rejoinChat";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejoinChat(_response);
        });
    }

    protected processRejoinChat(response: AxiosResponse): Promise<SendbirdMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendbirdMessage.fromJS(resultData200);
            return Promise.resolve<SendbirdMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendbirdMessage>(null as any);
    }

    leaveChat(opportunityId: string, command: LeaveOpportunityChatCommand, cancelToken?: CancelToken): Promise<SendbirdMessage> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}/leaveChat";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLeaveChat(_response);
        });
    }

    protected processLeaveChat(response: AxiosResponse): Promise<SendbirdMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendbirdMessage.fromJS(resultData200);
            return Promise.resolve<SendbirdMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendbirdMessage>(null as any);
    }

    removeSelfFromOpportunity(opportunityId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}/removeSelf";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSelfFromOpportunity(_response);
        });
    }

    protected processRemoveSelfFromOpportunity(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateStatus(opportunityId: string, command: UpdateSharedOpportunityStatusCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{opportunityId}/updateStatus";
        if (opportunityId === undefined || opportunityId === null)
            throw new Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/sharedOpportunities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class StripeWebhookClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    index( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/stripeWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserConsentCommunicationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    checkCommunicationConsent(giverEmail?: string | null | undefined, recipientEmail?: string | null | undefined, cancelToken?: CancelToken): Promise<CommunicationConsentStatus> {
        let url_ = this.baseUrl + "/api/v1/userConsent?";
        if (giverEmail !== undefined && giverEmail !== null)
            url_ += "GiverEmail=" + encodeURIComponent("" + giverEmail) + "&";
        if (recipientEmail !== undefined && recipientEmail !== null)
            url_ += "RecipientEmail=" + encodeURIComponent("" + recipientEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckCommunicationConsent(_response);
        });
    }

    protected processCheckCommunicationConsent(response: AxiosResponse): Promise<CommunicationConsentStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<CommunicationConsentStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunicationConsentStatus>(null as any);
    }

    create(command: CreateCommunicationConsentCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/userConsent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class UserLeadsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(leadId: string, cancelToken?: CancelToken): Promise<LeadDto> {
        let url_ = this.baseUrl + "/api/v1/userLeads/{leadId}";
        if (leadId === undefined || leadId === null)
            throw new Error("The parameter 'leadId' must be defined.");
        url_ = url_.replace("{leadId}", encodeURIComponent("" + leadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<LeadDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LeadDto.fromJS(resultData200);
            return Promise.resolve<LeadDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LeadDto>(null as any);
    }

    getMyLeads( cancelToken?: CancelToken): Promise<LeadDto[]> {
        let url_ = this.baseUrl + "/api/v1/userLeads";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyLeads(_response);
        });
    }

    protected processGetMyLeads(response: AxiosResponse): Promise<LeadDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeadDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LeadDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LeadDto[]>(null as any);
    }

    create(command: CreateLeadCommand, cancelToken?: CancelToken): Promise<LeadDto> {
        let url_ = this.baseUrl + "/api/v1/userLeads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<LeadDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = LeadDto.fromJS(resultData201);
            return Promise.resolve<LeadDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LeadDto>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(userId: string, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getPage(filterByUserType?: UserType | null | undefined, verificationFilter?: VerificationFilter | undefined, sortOrder?: string | null | undefined, searchString?: string | null | undefined, page?: number | null | undefined, ascSortDirection?: boolean | undefined, pageSize?: number | undefined, shouldRetrieveAllEntities?: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResultOfUserDto> {
        let url_ = this.baseUrl + "/api/v1/users?";
        if (filterByUserType !== undefined && filterByUserType !== null)
            url_ += "FilterByUserType=" + encodeURIComponent("" + filterByUserType) + "&";
        if (verificationFilter === null)
            throw new Error("The parameter 'verificationFilter' cannot be null.");
        else if (verificationFilter !== undefined)
            url_ += "VerificationFilter=" + encodeURIComponent("" + verificationFilter) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (page !== undefined && page !== null)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (ascSortDirection === null)
            throw new Error("The parameter 'ascSortDirection' cannot be null.");
        else if (ascSortDirection !== undefined)
            url_ += "AscSortDirection=" + encodeURIComponent("" + ascSortDirection) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (shouldRetrieveAllEntities === null)
            throw new Error("The parameter 'shouldRetrieveAllEntities' cannot be null.");
        else if (shouldRetrieveAllEntities !== undefined)
            url_ += "ShouldRetrieveAllEntities=" + encodeURIComponent("" + shouldRetrieveAllEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PaginatedResultOfUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResultOfUserDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResultOfUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResultOfUserDto>(null as any);
    }
}

export class UserVerificationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    sendVerification(command: SendVerificationCommand, api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/verification/send?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendVerification(_response);
        });
    }

    protected processSendVerification(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    validateVerification(command: ValidateVerificationCommand, api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/verification/validate?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateVerification(_response);
        });
    }

    protected processValidateVerification(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    resendVerification(command: ResendVerificationCommand, api_version?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/verification/resend?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendVerification(_response);
        });
    }

    protected processResendVerification(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserAccountDto implements IUserAccountDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name?: string | undefined;
    preferredName?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumber?: string | undefined;
    phoneExtensionNumber?: string | undefined;
    dealIds?: string[] | undefined;
    assignedPolicies?: string[] | undefined;
    hasBrokerProfile?: boolean;
    canAccessHostSystem?: boolean;
    builderUsers?: BuilderUserDto[] | undefined;
    websiteUrl?: string | undefined;
    linkedinUrl?: string | undefined;
    instagram?: string | undefined;
    tikTok?: string | undefined;
    agreeToPostProfile?: boolean;
    fieldsHiddenFromPublic?: string[] | undefined;
    profileImage?: ImageMediaDto | undefined;
    identityVerification?: IdentityVerificationDto | undefined;
    personaVerification?: PersonaVerificationDto | undefined;
    brokerProfile?: BrokerProfileDto | undefined;
    address?: AddressDto | undefined;
    creationDateTimeUtc?: Date | undefined;
    birthDate?: string | undefined;
    identityConsentDateUtc?: Date | undefined;
    sendbirdAccessToken?: string | undefined;
    loggedInAsUserType?: UserType;

    constructor(data?: IUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.name = _data["name"];
            this.preferredName = _data["preferredName"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtensionNumber = _data["phoneExtensionNumber"];
            if (Array.isArray(_data["dealIds"])) {
                this.dealIds = [] as any;
                for (let item of _data["dealIds"])
                    this.dealIds!.push(item);
            }
            if (Array.isArray(_data["assignedPolicies"])) {
                this.assignedPolicies = [] as any;
                for (let item of _data["assignedPolicies"])
                    this.assignedPolicies!.push(item);
            }
            this.hasBrokerProfile = _data["hasBrokerProfile"];
            this.canAccessHostSystem = _data["canAccessHostSystem"];
            if (Array.isArray(_data["builderUsers"])) {
                this.builderUsers = [] as any;
                for (let item of _data["builderUsers"])
                    this.builderUsers!.push(BuilderUserDto.fromJS(item));
            }
            this.websiteUrl = _data["websiteUrl"];
            this.linkedinUrl = _data["linkedinUrl"];
            this.instagram = _data["instagram"];
            this.tikTok = _data["tikTok"];
            this.agreeToPostProfile = _data["agreeToPostProfile"];
            if (Array.isArray(_data["fieldsHiddenFromPublic"])) {
                this.fieldsHiddenFromPublic = [] as any;
                for (let item of _data["fieldsHiddenFromPublic"])
                    this.fieldsHiddenFromPublic!.push(item);
            }
            this.profileImage = _data["profileImage"] ? ImageMediaDto.fromJS(_data["profileImage"]) : <any>undefined;
            this.identityVerification = _data["identityVerification"] ? IdentityVerificationDto.fromJS(_data["identityVerification"]) : <any>undefined;
            this.personaVerification = _data["personaVerification"] ? PersonaVerificationDto.fromJS(_data["personaVerification"]) : <any>undefined;
            this.brokerProfile = _data["brokerProfile"] ? BrokerProfileDto.fromJS(_data["brokerProfile"]) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.birthDate = _data["birthDate"];
            this.identityConsentDateUtc = _data["identityConsentDateUtc"] ? new Date(_data["identityConsentDateUtc"].toString()) : <any>undefined;
            this.sendbirdAccessToken = _data["sendbirdAccessToken"];
            this.loggedInAsUserType = _data["loggedInAsUserType"];
        }
    }

    static fromJS(data: any): UserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["name"] = this.name;
        data["preferredName"] = this.preferredName;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtensionNumber"] = this.phoneExtensionNumber;
        if (Array.isArray(this.dealIds)) {
            data["dealIds"] = [];
            for (let item of this.dealIds)
                data["dealIds"].push(item);
        }
        if (Array.isArray(this.assignedPolicies)) {
            data["assignedPolicies"] = [];
            for (let item of this.assignedPolicies)
                data["assignedPolicies"].push(item);
        }
        data["hasBrokerProfile"] = this.hasBrokerProfile;
        data["canAccessHostSystem"] = this.canAccessHostSystem;
        if (Array.isArray(this.builderUsers)) {
            data["builderUsers"] = [];
            for (let item of this.builderUsers)
                data["builderUsers"].push(item.toJSON());
        }
        data["websiteUrl"] = this.websiteUrl;
        data["linkedinUrl"] = this.linkedinUrl;
        data["instagram"] = this.instagram;
        data["tikTok"] = this.tikTok;
        data["agreeToPostProfile"] = this.agreeToPostProfile;
        if (Array.isArray(this.fieldsHiddenFromPublic)) {
            data["fieldsHiddenFromPublic"] = [];
            for (let item of this.fieldsHiddenFromPublic)
                data["fieldsHiddenFromPublic"].push(item);
        }
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["identityVerification"] = this.identityVerification ? this.identityVerification.toJSON() : <any>undefined;
        data["personaVerification"] = this.personaVerification ? this.personaVerification.toJSON() : <any>undefined;
        data["brokerProfile"] = this.brokerProfile ? this.brokerProfile.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["birthDate"] = this.birthDate;
        data["identityConsentDateUtc"] = this.identityConsentDateUtc ? this.identityConsentDateUtc.toISOString() : <any>undefined;
        data["sendbirdAccessToken"] = this.sendbirdAccessToken;
        data["loggedInAsUserType"] = this.loggedInAsUserType;
        return data;
    }
}

export interface IUserAccountDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name?: string | undefined;
    preferredName?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumber?: string | undefined;
    phoneExtensionNumber?: string | undefined;
    dealIds?: string[] | undefined;
    assignedPolicies?: string[] | undefined;
    hasBrokerProfile?: boolean;
    canAccessHostSystem?: boolean;
    builderUsers?: BuilderUserDto[] | undefined;
    websiteUrl?: string | undefined;
    linkedinUrl?: string | undefined;
    instagram?: string | undefined;
    tikTok?: string | undefined;
    agreeToPostProfile?: boolean;
    fieldsHiddenFromPublic?: string[] | undefined;
    profileImage?: ImageMediaDto | undefined;
    identityVerification?: IdentityVerificationDto | undefined;
    personaVerification?: PersonaVerificationDto | undefined;
    brokerProfile?: BrokerProfileDto | undefined;
    address?: AddressDto | undefined;
    creationDateTimeUtc?: Date | undefined;
    birthDate?: string | undefined;
    identityConsentDateUtc?: Date | undefined;
    sendbirdAccessToken?: string | undefined;
    loggedInAsUserType?: UserType;
}

export class BuilderUserDto implements IBuilderUserDto {
    id?: string | undefined;
    builderId?: string | undefined;
    builderName?: string | undefined;

    constructor(data?: IBuilderUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.builderId = _data["builderId"];
            this.builderName = _data["builderName"];
        }
    }

    static fromJS(data: any): BuilderUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuilderUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["builderId"] = this.builderId;
        data["builderName"] = this.builderName;
        return data;
    }
}

export interface IBuilderUserDto {
    id?: string | undefined;
    builderId?: string | undefined;
    builderName?: string | undefined;
}

export class ImageMediaDto implements IImageMediaDto {
    id?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    sizeInBytes?: number;
    width?: number | undefined;
    height?: number | undefined;
    filePath?: string | undefined;
    mediaPrivacyType?: MediaPrivacyType;

    constructor(data?: IImageMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.filePath = _data["filePath"];
            this.mediaPrivacyType = _data["mediaPrivacyType"];
        }
    }

    static fromJS(data: any): ImageMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["url"] = this.url;
        data["description"] = this.description;
        data["sizeInBytes"] = this.sizeInBytes;
        data["width"] = this.width;
        data["height"] = this.height;
        data["filePath"] = this.filePath;
        data["mediaPrivacyType"] = this.mediaPrivacyType;
        return data;
    }
}

export interface IImageMediaDto {
    id?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    sizeInBytes?: number;
    width?: number | undefined;
    height?: number | undefined;
    filePath?: string | undefined;
    mediaPrivacyType?: MediaPrivacyType;
}

export enum MediaPrivacyType {
    Public = 0,
    Confidential = 1,
}

export class IdentityVerificationDto implements IIdentityVerificationDto {
    status?: StripeVerificationSessionStatus;
    isIdentityFailed?: boolean;
    completedDate?: Date | undefined;
    documentExpirationDate?: Date | undefined;
    documentType?: string | undefined;
    documentAddress?: AddressDto | undefined;
    nameVerifyStatus?: NameVerifyStatus;
    birthdateVerifyStatus?: BirthdateVerifyStatus;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: string | undefined;

    constructor(data?: IIdentityVerificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.isIdentityFailed = _data["isIdentityFailed"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.documentExpirationDate = _data["documentExpirationDate"] ? new Date(_data["documentExpirationDate"].toString()) : <any>undefined;
            this.documentType = _data["documentType"];
            this.documentAddress = _data["documentAddress"] ? AddressDto.fromJS(_data["documentAddress"]) : <any>undefined;
            this.nameVerifyStatus = _data["nameVerifyStatus"];
            this.birthdateVerifyStatus = _data["birthdateVerifyStatus"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"];
        }
    }

    static fromJS(data: any): IdentityVerificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityVerificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["isIdentityFailed"] = this.isIdentityFailed;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["documentExpirationDate"] = this.documentExpirationDate ? this.documentExpirationDate.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["documentAddress"] = this.documentAddress ? this.documentAddress.toJSON() : <any>undefined;
        data["nameVerifyStatus"] = this.nameVerifyStatus;
        data["birthdateVerifyStatus"] = this.birthdateVerifyStatus;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate;
        return data;
    }
}

export interface IIdentityVerificationDto {
    status?: StripeVerificationSessionStatus;
    isIdentityFailed?: boolean;
    completedDate?: Date | undefined;
    documentExpirationDate?: Date | undefined;
    documentType?: string | undefined;
    documentAddress?: AddressDto | undefined;
    nameVerifyStatus?: NameVerifyStatus;
    birthdateVerifyStatus?: BirthdateVerifyStatus;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: string | undefined;
}

export enum StripeVerificationSessionStatus {
    Canceled = 0,
    Processing = 1,
    RequiresInput = 2,
    Verified = 3,
}

export class AddressDto implements IAddressDto {
    id?: number | undefined;
    unitNumber?: string | undefined;
    unitName?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    fullAddress?: string | undefined;
    googleMapUrl?: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitNumber = _data["unitNumber"];
            this.unitName = _data["unitName"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.fullAddress = _data["fullAddress"];
            this.googleMapUrl = _data["googleMapUrl"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitNumber"] = this.unitNumber;
        data["unitName"] = this.unitName;
        data["street"] = this.street;
        data["city"] = this.city;
        data["province"] = this.province;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["fullAddress"] = this.fullAddress;
        data["googleMapUrl"] = this.googleMapUrl;
        return data;
    }
}

export interface IAddressDto {
    id?: number | undefined;
    unitNumber?: string | undefined;
    unitName?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    fullAddress?: string | undefined;
    googleMapUrl?: string | undefined;
}

export enum NameVerifyStatus {
    TypoDetected = 0,
    Mismatch = 1,
    Matched = 2,
}

export enum BirthdateVerifyStatus {
    Mismatch = 0,
    Matched = 1,
}

export class PersonaVerificationDto implements IPersonaVerificationDto {
    inquiryId?: string | undefined;
    status?: PersonaVerificationStatus;
    creationDateTimeUtc?: Date;
    lastUpdatedDateTimeUtc?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nameVerifyStatus?: NameVerifyStatus;
    isIdentityFailed?: boolean;
    documentExpirationDate?: Date | undefined;
    completedDate?: Date | undefined;
    documentType?: string | undefined;
    documentAddress?: AddressDto | undefined;
    documentAddressId?: number | undefined;
    birthDate?: string | undefined;
    identificationNumber?: string | undefined;
    birthdateVerifyStatus?: BirthdateVerifyStatus | undefined;

    constructor(data?: IPersonaVerificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inquiryId = _data["inquiryId"];
            this.status = _data["status"];
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.lastUpdatedDateTimeUtc = _data["lastUpdatedDateTimeUtc"] ? new Date(_data["lastUpdatedDateTimeUtc"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nameVerifyStatus = _data["nameVerifyStatus"];
            this.isIdentityFailed = _data["isIdentityFailed"];
            this.documentExpirationDate = _data["documentExpirationDate"] ? new Date(_data["documentExpirationDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.documentType = _data["documentType"];
            this.documentAddress = _data["documentAddress"] ? AddressDto.fromJS(_data["documentAddress"]) : <any>undefined;
            this.documentAddressId = _data["documentAddressId"];
            this.birthDate = _data["birthDate"];
            this.identificationNumber = _data["identificationNumber"];
            this.birthdateVerifyStatus = _data["birthdateVerifyStatus"];
        }
    }

    static fromJS(data: any): PersonaVerificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonaVerificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inquiryId"] = this.inquiryId;
        data["status"] = this.status;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["lastUpdatedDateTimeUtc"] = this.lastUpdatedDateTimeUtc ? this.lastUpdatedDateTimeUtc.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nameVerifyStatus"] = this.nameVerifyStatus;
        data["isIdentityFailed"] = this.isIdentityFailed;
        data["documentExpirationDate"] = this.documentExpirationDate ? this.documentExpirationDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["documentAddress"] = this.documentAddress ? this.documentAddress.toJSON() : <any>undefined;
        data["documentAddressId"] = this.documentAddressId;
        data["birthDate"] = this.birthDate;
        data["identificationNumber"] = this.identificationNumber;
        data["birthdateVerifyStatus"] = this.birthdateVerifyStatus;
        return data;
    }
}

export interface IPersonaVerificationDto {
    inquiryId?: string | undefined;
    status?: PersonaVerificationStatus;
    creationDateTimeUtc?: Date;
    lastUpdatedDateTimeUtc?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nameVerifyStatus?: NameVerifyStatus;
    isIdentityFailed?: boolean;
    documentExpirationDate?: Date | undefined;
    completedDate?: Date | undefined;
    documentType?: string | undefined;
    documentAddress?: AddressDto | undefined;
    documentAddressId?: number | undefined;
    birthDate?: string | undefined;
    identificationNumber?: string | undefined;
    birthdateVerifyStatus?: BirthdateVerifyStatus | undefined;
}

export enum PersonaVerificationStatus {
    Created = 0,
    Pending = 1,
    Completed = 2,
    Expired = 3,
    Failed = 4,
    NeedsReview = 5,
    Approved = 6,
    Declined = 7,
}

export class BrokerProfileDto implements IBrokerProfileDto {
    creationDateTimeUtc?: Date;
    licenseNumber?: string | undefined;
    licenseJurisdiction?: string | undefined;
    licenseExpiryDate?: Date | undefined;
    brokerageName?: string | undefined;
    brokerageAddress?: Address | undefined;
    brokerageTaxNumber?: string | undefined;
    brokeragePhoneNumber?: string | undefined;
    approved?: boolean;

    constructor(data?: IBrokerProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.licenseNumber = _data["licenseNumber"];
            this.licenseJurisdiction = _data["licenseJurisdiction"];
            this.licenseExpiryDate = _data["licenseExpiryDate"] ? new Date(_data["licenseExpiryDate"].toString()) : <any>undefined;
            this.brokerageName = _data["brokerageName"];
            this.brokerageAddress = _data["brokerageAddress"] ? Address.fromJS(_data["brokerageAddress"]) : <any>undefined;
            this.brokerageTaxNumber = _data["brokerageTaxNumber"];
            this.brokeragePhoneNumber = _data["brokeragePhoneNumber"];
            this.approved = _data["approved"];
        }
    }

    static fromJS(data: any): BrokerProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["licenseNumber"] = this.licenseNumber;
        data["licenseJurisdiction"] = this.licenseJurisdiction;
        data["licenseExpiryDate"] = this.licenseExpiryDate ? this.licenseExpiryDate.toISOString() : <any>undefined;
        data["brokerageName"] = this.brokerageName;
        data["brokerageAddress"] = this.brokerageAddress ? this.brokerageAddress.toJSON() : <any>undefined;
        data["brokerageTaxNumber"] = this.brokerageTaxNumber;
        data["brokeragePhoneNumber"] = this.brokeragePhoneNumber;
        data["approved"] = this.approved;
        return data;
    }
}

export interface IBrokerProfileDto {
    creationDateTimeUtc?: Date;
    licenseNumber?: string | undefined;
    licenseJurisdiction?: string | undefined;
    licenseExpiryDate?: Date | undefined;
    brokerageName?: string | undefined;
    brokerageAddress?: Address | undefined;
    brokerageTaxNumber?: string | undefined;
    brokeragePhoneNumber?: string | undefined;
    approved?: boolean;
}

export class Address implements IAddress {
    id?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    municipalityId?: string | undefined;
    municipality?: Municipality | undefined;
    province?: string | undefined;
    regionId?: string | undefined;
    region?: Region | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    countryRefId?: string | undefined;
    countryRef?: Country | undefined;
    unitNumber?: string | undefined;
    unitName?: string | undefined;
    fullAddress?: string | undefined;
    formattedAddress?: string | undefined;
    timeZone?: string | undefined;
    googleMapUrl?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.municipalityId = _data["municipalityId"];
            this.municipality = _data["municipality"] ? Municipality.fromJS(_data["municipality"]) : <any>undefined;
            this.province = _data["province"];
            this.regionId = _data["regionId"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : <any>undefined;
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.countryRefId = _data["countryRefId"];
            this.countryRef = _data["countryRef"] ? Country.fromJS(_data["countryRef"]) : <any>undefined;
            this.unitNumber = _data["unitNumber"];
            this.unitName = _data["unitName"];
            this.fullAddress = _data["fullAddress"];
            this.formattedAddress = _data["formattedAddress"];
            this.timeZone = _data["timeZone"];
            this.googleMapUrl = _data["googleMapUrl"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["street"] = this.street;
        data["city"] = this.city;
        data["municipalityId"] = this.municipalityId;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        data["province"] = this.province;
        data["regionId"] = this.regionId;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["countryRefId"] = this.countryRefId;
        data["countryRef"] = this.countryRef ? this.countryRef.toJSON() : <any>undefined;
        data["unitNumber"] = this.unitNumber;
        data["unitName"] = this.unitName;
        data["fullAddress"] = this.fullAddress;
        data["formattedAddress"] = this.formattedAddress;
        data["timeZone"] = this.timeZone;
        data["googleMapUrl"] = this.googleMapUrl;
        return data;
    }
}

export interface IAddress {
    id?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    municipalityId?: string | undefined;
    municipality?: Municipality | undefined;
    province?: string | undefined;
    regionId?: string | undefined;
    region?: Region | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    countryRefId?: string | undefined;
    countryRef?: Country | undefined;
    unitNumber?: string | undefined;
    unitName?: string | undefined;
    fullAddress?: string | undefined;
    formattedAddress?: string | undefined;
    timeZone?: string | undefined;
    googleMapUrl?: string | undefined;
}

export class Municipality implements IMunicipality {
    id?: string;
    countryId?: string | undefined;
    country?: Country | undefined;
    region?: Region | undefined;
    regionId?: string;
    name?: string | undefined;

    constructor(data?: IMunicipality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : <any>undefined;
            this.regionId = _data["regionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Municipality {
        data = typeof data === 'object' ? data : {};
        let result = new Municipality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        return data;
    }
}

export interface IMunicipality {
    id?: string;
    countryId?: string | undefined;
    country?: Country | undefined;
    region?: Region | undefined;
    regionId?: string;
    name?: string | undefined;
}

export class Country implements ICountry {
    isoAlpha3Code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isoAlpha3Code = _data["isoAlpha3Code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isoAlpha3Code"] = this.isoAlpha3Code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountry {
    isoAlpha3Code?: string | undefined;
    name?: string | undefined;
}

export class Region implements IRegion {
    id?: string;
    code?: string | undefined;
    country?: Country | undefined;
    countryId?: string | undefined;
    name?: string | undefined;
    regionTypeDescription?: string | undefined;

    constructor(data?: IRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.regionTypeDescription = _data["regionTypeDescription"];
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["regionTypeDescription"] = this.regionTypeDescription;
        return data;
    }
}

export interface IRegion {
    id?: string;
    code?: string | undefined;
    country?: Country | undefined;
    countryId?: string | undefined;
    name?: string | undefined;
    regionTypeDescription?: string | undefined;
}

export enum UserType {
    Buyer = 0,
    Seller = 1,
    Developer = 2,
    Broker = 3,
    Ambassador = 4,
    Host = 5,
}

export class CreateAccountCommand implements ICreateAccountCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    recaptchaToken?: string | undefined;

    constructor(data?: ICreateAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): CreateAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface ICreateAccountCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    recaptchaToken?: string | undefined;
}

export class LinkUserToOpportunitiesAndContactCommand implements ILinkUserToOpportunitiesAndContactCommand {
    email?: string | undefined;

    constructor(data?: ILinkUserToOpportunitiesAndContactCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): LinkUserToOpportunitiesAndContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LinkUserToOpportunitiesAndContactCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ILinkUserToOpportunitiesAndContactCommand {
    email?: string | undefined;
}

export class LinkAccountsCommand implements ILinkAccountsCommand {

    constructor(data?: ILinkAccountsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): LinkAccountsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LinkAccountsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ILinkAccountsCommand {
}

export class EditAccountCommand implements IEditAccountCommand {
    preferredName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    personalAddress?: AddressInput | undefined;
    websiteUrl?: string | undefined;
    linkedinUrl?: string | undefined;
    instagram?: string | undefined;
    tikTok?: string | undefined;
    birthDate?: string | undefined;
    agreeToPostProfile?: boolean;

    constructor(data?: IEditAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredName = _data["preferredName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.personalAddress = _data["personalAddress"] ? AddressInput.fromJS(_data["personalAddress"]) : <any>undefined;
            this.websiteUrl = _data["websiteUrl"];
            this.linkedinUrl = _data["linkedinUrl"];
            this.instagram = _data["instagram"];
            this.tikTok = _data["tikTok"];
            this.birthDate = _data["birthDate"];
            this.agreeToPostProfile = _data["agreeToPostProfile"];
        }
    }

    static fromJS(data: any): EditAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredName"] = this.preferredName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["personalAddress"] = this.personalAddress ? this.personalAddress.toJSON() : <any>undefined;
        data["websiteUrl"] = this.websiteUrl;
        data["linkedinUrl"] = this.linkedinUrl;
        data["instagram"] = this.instagram;
        data["tikTok"] = this.tikTok;
        data["birthDate"] = this.birthDate;
        data["agreeToPostProfile"] = this.agreeToPostProfile;
        return data;
    }
}

export interface IEditAccountCommand {
    preferredName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    personalAddress?: AddressInput | undefined;
    websiteUrl?: string | undefined;
    linkedinUrl?: string | undefined;
    instagram?: string | undefined;
    tikTok?: string | undefined;
    birthDate?: string | undefined;
    agreeToPostProfile?: boolean;
}

export class AddressInput implements IAddressInput {
    street?: string | undefined;
    unitNumber?: string | undefined;
    unitName?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.unitNumber = _data["unitNumber"];
            this.unitName = _data["unitName"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): AddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["unitNumber"] = this.unitNumber;
        data["unitName"] = this.unitName;
        data["city"] = this.city;
        data["province"] = this.province;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddressInput {
    street?: string | undefined;
    unitNumber?: string | undefined;
    unitName?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export class EditBrokerAccountCommand implements IEditBrokerAccountCommand {
    licenseNumber?: string | undefined;
    licenseJurisdiction?: string | undefined;
    licenseExpiryDate?: Date | undefined;
    brokerageName?: string | undefined;
    brokerageAddress?: AddressInput | undefined;
    brokerageTaxNumber?: string | undefined;
    brokeragePhoneNumber?: string | undefined;

    constructor(data?: IEditBrokerAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseNumber = _data["licenseNumber"];
            this.licenseJurisdiction = _data["licenseJurisdiction"];
            this.licenseExpiryDate = _data["licenseExpiryDate"] ? new Date(_data["licenseExpiryDate"].toString()) : <any>undefined;
            this.brokerageName = _data["brokerageName"];
            this.brokerageAddress = _data["brokerageAddress"] ? AddressInput.fromJS(_data["brokerageAddress"]) : <any>undefined;
            this.brokerageTaxNumber = _data["brokerageTaxNumber"];
            this.brokeragePhoneNumber = _data["brokeragePhoneNumber"];
        }
    }

    static fromJS(data: any): EditBrokerAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditBrokerAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseNumber"] = this.licenseNumber;
        data["licenseJurisdiction"] = this.licenseJurisdiction;
        data["licenseExpiryDate"] = this.licenseExpiryDate ? this.licenseExpiryDate.toISOString() : <any>undefined;
        data["brokerageName"] = this.brokerageName;
        data["brokerageAddress"] = this.brokerageAddress ? this.brokerageAddress.toJSON() : <any>undefined;
        data["brokerageTaxNumber"] = this.brokerageTaxNumber;
        data["brokeragePhoneNumber"] = this.brokeragePhoneNumber;
        return data;
    }
}

export interface IEditBrokerAccountCommand {
    licenseNumber?: string | undefined;
    licenseJurisdiction?: string | undefined;
    licenseExpiryDate?: Date | undefined;
    brokerageName?: string | undefined;
    brokerageAddress?: AddressInput | undefined;
    brokerageTaxNumber?: string | undefined;
    brokeragePhoneNumber?: string | undefined;
}

export class EditHiddenFieldsCommand implements IEditHiddenFieldsCommand {
    hiddenFields?: string[] | undefined;

    constructor(data?: IEditHiddenFieldsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hiddenFields"])) {
                this.hiddenFields = [] as any;
                for (let item of _data["hiddenFields"])
                    this.hiddenFields!.push(item);
            }
        }
    }

    static fromJS(data: any): EditHiddenFieldsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditHiddenFieldsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hiddenFields)) {
            data["hiddenFields"] = [];
            for (let item of this.hiddenFields)
                data["hiddenFields"].push(item);
        }
        return data;
    }
}

export interface IEditHiddenFieldsCommand {
    hiddenFields?: string[] | undefined;
}

export class ForgotPasswordCommand implements IForgotPasswordCommand {
    email?: string | undefined;
    resetPasswordLinkUrl?: string | undefined;
    culture?: string | undefined;

    constructor(data?: IForgotPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.resetPasswordLinkUrl = _data["resetPasswordLinkUrl"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): ForgotPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["resetPasswordLinkUrl"] = this.resetPasswordLinkUrl;
        data["culture"] = this.culture;
        return data;
    }
}

export interface IForgotPasswordCommand {
    email?: string | undefined;
    resetPasswordLinkUrl?: string | undefined;
    culture?: string | undefined;
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    newPassword?: string | undefined;
    email?: string | undefined;
    code?: string | undefined;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.email = _data["email"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["email"] = this.email;
        data["code"] = this.code;
        return data;
    }
}

export interface IResetPasswordCommand {
    newPassword?: string | undefined;
    email?: string | undefined;
    code?: string | undefined;
}

export class SendVerificationNotificationCommand implements ISendVerificationNotificationCommand {
    accountId?: string | undefined;
    culture?: string | undefined;

    constructor(data?: ISendVerificationNotificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): SendVerificationNotificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationNotificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["culture"] = this.culture;
        return data;
    }
}

export interface ISendVerificationNotificationCommand {
    accountId?: string | undefined;
    culture?: string | undefined;
}

export class AccessTokenDto implements IAccessTokenDto {
    token?: string | undefined;
    tokenExpirationDateTime?: Date;
    refreshToken?: string | undefined;
    refreshTokenExpirationDateTime?: Date | undefined;

    constructor(data?: IAccessTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenExpirationDateTime = _data["tokenExpirationDateTime"] ? new Date(_data["tokenExpirationDateTime"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpirationDateTime = _data["refreshTokenExpirationDateTime"] ? new Date(_data["refreshTokenExpirationDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AccessTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenExpirationDateTime"] = this.tokenExpirationDateTime ? this.tokenExpirationDateTime.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpirationDateTime"] = this.refreshTokenExpirationDateTime ? this.refreshTokenExpirationDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAccessTokenDto {
    token?: string | undefined;
    tokenExpirationDateTime?: Date;
    refreshToken?: string | undefined;
    refreshTokenExpirationDateTime?: Date | undefined;
}

export class VerifyAccountByUserCodeCommand implements IVerifyAccountByUserCodeCommand {
    userCode?: string | undefined;

    constructor(data?: IVerifyAccountByUserCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCode = _data["userCode"];
        }
    }

    static fromJS(data: any): VerifyAccountByUserCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyAccountByUserCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCode"] = this.userCode;
        return data;
    }
}

export interface IVerifyAccountByUserCodeCommand {
    userCode?: string | undefined;
}

export class GetAccountVerificationCodeQuery implements IGetAccountVerificationCodeQuery {
    userEmail?: string | undefined;

    constructor(data?: IGetAccountVerificationCodeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): GetAccountVerificationCodeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountVerificationCodeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IGetAccountVerificationCodeQuery {
    userEmail?: string | undefined;
}

export class CreateInquiryCommand implements ICreateInquiryCommand {
    forceNewInquiry?: boolean;
    redirectUrl?: string | undefined;

    constructor(data?: ICreateInquiryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forceNewInquiry = _data["forceNewInquiry"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): CreateInquiryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInquiryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forceNewInquiry"] = this.forceNewInquiry;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ICreateInquiryCommand {
    forceNewInquiry?: boolean;
    redirectUrl?: string | undefined;
}

export class VerifyResult implements IVerifyResult {
    alreadyExisted?: boolean;
    redirectUrl?: string | undefined;

    constructor(data?: IVerifyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisted = _data["alreadyExisted"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): VerifyResult {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisted"] = this.alreadyExisted;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IVerifyResult {
    alreadyExisted?: boolean;
    redirectUrl?: string | undefined;
}

export class CreateOrGetExistingVerificationSessionCommand implements ICreateOrGetExistingVerificationSessionCommand {
    returnUrlWhenVerified?: string | undefined;
    forceNewVerificationSession?: boolean;

    constructor(data?: ICreateOrGetExistingVerificationSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnUrlWhenVerified = _data["returnUrlWhenVerified"];
            this.forceNewVerificationSession = _data["forceNewVerificationSession"];
        }
    }

    static fromJS(data: any): CreateOrGetExistingVerificationSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrGetExistingVerificationSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnUrlWhenVerified"] = this.returnUrlWhenVerified;
        data["forceNewVerificationSession"] = this.forceNewVerificationSession;
        return data;
    }
}

export interface ICreateOrGetExistingVerificationSessionCommand {
    returnUrlWhenVerified?: string | undefined;
    forceNewVerificationSession?: boolean;
}

export class AddToWaitListCommand implements IAddToWaitListCommand {
    name?: string | undefined;
    email?: string | undefined;
    recaptchaToken?: string | undefined;

    constructor(data?: IAddToWaitListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): AddToWaitListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddToWaitListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface IAddToWaitListCommand {
    name?: string | undefined;
    email?: string | undefined;
    recaptchaToken?: string | undefined;
}

export class PurgeListingResult implements IPurgeListingResult {
    dryRun?: boolean;
    listingId?: number;
    listingsCount?: number;
    listingsDeleted?: number;
    dealsCount?: number;
    dealsDeleted?: number;
    imagesCount?: number;
    filesDeleted?: number;

    constructor(data?: IPurgeListingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dryRun = _data["dryRun"];
            this.listingId = _data["listingId"];
            this.listingsCount = _data["listingsCount"];
            this.listingsDeleted = _data["listingsDeleted"];
            this.dealsCount = _data["dealsCount"];
            this.dealsDeleted = _data["dealsDeleted"];
            this.imagesCount = _data["imagesCount"];
            this.filesDeleted = _data["filesDeleted"];
        }
    }

    static fromJS(data: any): PurgeListingResult {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeListingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dryRun"] = this.dryRun;
        data["listingId"] = this.listingId;
        data["listingsCount"] = this.listingsCount;
        data["listingsDeleted"] = this.listingsDeleted;
        data["dealsCount"] = this.dealsCount;
        data["dealsDeleted"] = this.dealsDeleted;
        data["imagesCount"] = this.imagesCount;
        data["filesDeleted"] = this.filesDeleted;
        return data;
    }
}

export interface IPurgeListingResult {
    dryRun?: boolean;
    listingId?: number;
    listingsCount?: number;
    listingsDeleted?: number;
    dealsCount?: number;
    dealsDeleted?: number;
    imagesCount?: number;
    filesDeleted?: number;
}

export class PurgeListingCommand implements IPurgeListingCommand {
    listingId?: number;
    dryRun?: boolean;

    constructor(data?: IPurgeListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingId = _data["listingId"];
            this.dryRun = _data["dryRun"];
        }
    }

    static fromJS(data: any): PurgeListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        data["dryRun"] = this.dryRun;
        return data;
    }
}

export interface IPurgeListingCommand {
    listingId?: number;
    dryRun?: boolean;
}

export class PurgeUserDataResult implements IPurgeUserDataResult {
    email?: string | undefined;
    userId?: string | undefined;
    userFound?: boolean;
    dryRun?: boolean;
    listingsDeleted?: number;
    dealsDeleted?: number;
    contractsDeleted?: number;
    offersDeleted?: number;
    sharedOpportunitiesDeleted?: number;
    leadsDeleted?: number;
    rsvpsDeleted?: number;

    constructor(data?: IPurgeUserDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.userFound = _data["userFound"];
            this.dryRun = _data["dryRun"];
            this.listingsDeleted = _data["listingsDeleted"];
            this.dealsDeleted = _data["dealsDeleted"];
            this.contractsDeleted = _data["contractsDeleted"];
            this.offersDeleted = _data["offersDeleted"];
            this.sharedOpportunitiesDeleted = _data["sharedOpportunitiesDeleted"];
            this.leadsDeleted = _data["leadsDeleted"];
            this.rsvpsDeleted = _data["rsvpsDeleted"];
        }
    }

    static fromJS(data: any): PurgeUserDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeUserDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["userFound"] = this.userFound;
        data["dryRun"] = this.dryRun;
        data["listingsDeleted"] = this.listingsDeleted;
        data["dealsDeleted"] = this.dealsDeleted;
        data["contractsDeleted"] = this.contractsDeleted;
        data["offersDeleted"] = this.offersDeleted;
        data["sharedOpportunitiesDeleted"] = this.sharedOpportunitiesDeleted;
        data["leadsDeleted"] = this.leadsDeleted;
        data["rsvpsDeleted"] = this.rsvpsDeleted;
        return data;
    }
}

export interface IPurgeUserDataResult {
    email?: string | undefined;
    userId?: string | undefined;
    userFound?: boolean;
    dryRun?: boolean;
    listingsDeleted?: number;
    dealsDeleted?: number;
    contractsDeleted?: number;
    offersDeleted?: number;
    sharedOpportunitiesDeleted?: number;
    leadsDeleted?: number;
    rsvpsDeleted?: number;
}

export class PurgeUserDataCommand implements IPurgeUserDataCommand {
    email?: string | undefined;
    dryRun?: boolean;

    constructor(data?: IPurgeUserDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.dryRun = _data["dryRun"];
        }
    }

    static fromJS(data: any): PurgeUserDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeUserDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["dryRun"] = this.dryRun;
        return data;
    }
}

export interface IPurgeUserDataCommand {
    email?: string | undefined;
    dryRun?: boolean;
}

export class GenerateSeedDataResult implements IGenerateSeedDataResult {
    reachedStage?: WorkflowStage;
    listingId?: number | undefined;
    dealId?: string | undefined;
    opportunityId?: string | undefined;
    contractId?: string | undefined;
    offerId?: string | undefined;
    sellerIds?: string[] | undefined;
    buyerIds?: string[] | undefined;
    listingIds?: number[] | undefined;
    createdEntities?: EntityCreationInfo[] | undefined;
    message?: string | undefined;

    constructor(data?: IGenerateSeedDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reachedStage = _data["reachedStage"];
            this.listingId = _data["listingId"];
            this.dealId = _data["dealId"];
            this.opportunityId = _data["opportunityId"];
            this.contractId = _data["contractId"];
            this.offerId = _data["offerId"];
            if (Array.isArray(_data["sellerIds"])) {
                this.sellerIds = [] as any;
                for (let item of _data["sellerIds"])
                    this.sellerIds!.push(item);
            }
            if (Array.isArray(_data["buyerIds"])) {
                this.buyerIds = [] as any;
                for (let item of _data["buyerIds"])
                    this.buyerIds!.push(item);
            }
            if (Array.isArray(_data["listingIds"])) {
                this.listingIds = [] as any;
                for (let item of _data["listingIds"])
                    this.listingIds!.push(item);
            }
            if (Array.isArray(_data["createdEntities"])) {
                this.createdEntities = [] as any;
                for (let item of _data["createdEntities"])
                    this.createdEntities!.push(EntityCreationInfo.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): GenerateSeedDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateSeedDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reachedStage"] = this.reachedStage;
        data["listingId"] = this.listingId;
        data["dealId"] = this.dealId;
        data["opportunityId"] = this.opportunityId;
        data["contractId"] = this.contractId;
        data["offerId"] = this.offerId;
        if (Array.isArray(this.sellerIds)) {
            data["sellerIds"] = [];
            for (let item of this.sellerIds)
                data["sellerIds"].push(item);
        }
        if (Array.isArray(this.buyerIds)) {
            data["buyerIds"] = [];
            for (let item of this.buyerIds)
                data["buyerIds"].push(item);
        }
        if (Array.isArray(this.listingIds)) {
            data["listingIds"] = [];
            for (let item of this.listingIds)
                data["listingIds"].push(item);
        }
        if (Array.isArray(this.createdEntities)) {
            data["createdEntities"] = [];
            for (let item of this.createdEntities)
                data["createdEntities"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IGenerateSeedDataResult {
    reachedStage?: WorkflowStage;
    listingId?: number | undefined;
    dealId?: string | undefined;
    opportunityId?: string | undefined;
    contractId?: string | undefined;
    offerId?: string | undefined;
    sellerIds?: string[] | undefined;
    buyerIds?: string[] | undefined;
    listingIds?: number[] | undefined;
    createdEntities?: EntityCreationInfo[] | undefined;
    message?: string | undefined;
}

export enum WorkflowStage {
    ListingDraft = 0,
    ListingDetailedInfo = 1,
    ListingPendingReview = 2,
    ListingActive = 3,
    OpportunityCreated = 4,
    OfferSent = 5,
    OfferAccepted = 6,
    DealNeedsToBeFilled = 7,
    ContractReadyToSignByBuyer = 8,
    ContractSignedByBuyersAndReadyToSubmit = 9,
    ContractReadyToSignBySeller = 10,
    ContractFullySignedByAll = 11,
    ContractPast24HourCancellation = 12,
    DealPastDueDiligence = 13,
}

export class EntityCreationInfo implements IEntityCreationInfo {
    entityType?: string | undefined;
    entityId?: string | undefined;
    status?: string | undefined;
    wasCreated?: boolean;

    constructor(data?: IEntityCreationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.status = _data["status"];
            this.wasCreated = _data["wasCreated"];
        }
    }

    static fromJS(data: any): EntityCreationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EntityCreationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["status"] = this.status;
        data["wasCreated"] = this.wasCreated;
        return data;
    }
}

export interface IEntityCreationInfo {
    entityType?: string | undefined;
    entityId?: string | undefined;
    status?: string | undefined;
    wasCreated?: boolean;
}

export class CreateContractResult implements ICreateContractResult {
    contractId?: string | undefined;
    isDryRun?: boolean;
    sections?: ContractSectionInfo[] | undefined;
    message?: string | undefined;

    constructor(data?: ICreateContractResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.isDryRun = _data["isDryRun"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ContractSectionInfo.fromJS(item));
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateContractResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["isDryRun"] = this.isDryRun;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateContractResult {
    contractId?: string | undefined;
    isDryRun?: boolean;
    sections?: ContractSectionInfo[] | undefined;
    message?: string | undefined;
}

export class ContractSectionInfo implements IContractSectionInfo {
    sectionType?: string | undefined;
    pdfUrl?: string | undefined;

    constructor(data?: IContractSectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionType = _data["sectionType"];
            this.pdfUrl = _data["pdfUrl"];
        }
    }

    static fromJS(data: any): ContractSectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionType"] = this.sectionType;
        data["pdfUrl"] = this.pdfUrl;
        return data;
    }
}

export interface IContractSectionInfo {
    sectionType?: string | undefined;
    pdfUrl?: string | undefined;
}

export class GenerateContractDryRunCommand implements IGenerateContractDryRunCommand {
    dealId?: string | undefined;
    contractType?: ContractType;
    conditionsForCancellation?: CancellationReason[] | undefined;
    detailedReason?: string | undefined;
    saveIdentityImagesForDebugging?: boolean;

    constructor(data?: IGenerateContractDryRunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.contractType = _data["contractType"];
            if (Array.isArray(_data["conditionsForCancellation"])) {
                this.conditionsForCancellation = [] as any;
                for (let item of _data["conditionsForCancellation"])
                    this.conditionsForCancellation!.push(item);
            }
            this.detailedReason = _data["detailedReason"];
            this.saveIdentityImagesForDebugging = _data["saveIdentityImagesForDebugging"];
        }
    }

    static fromJS(data: any): GenerateContractDryRunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateContractDryRunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["contractType"] = this.contractType;
        if (Array.isArray(this.conditionsForCancellation)) {
            data["conditionsForCancellation"] = [];
            for (let item of this.conditionsForCancellation)
                data["conditionsForCancellation"].push(item);
        }
        data["detailedReason"] = this.detailedReason;
        data["saveIdentityImagesForDebugging"] = this.saveIdentityImagesForDebugging;
        return data;
    }
}

export interface IGenerateContractDryRunCommand {
    dealId?: string | undefined;
    contractType?: ContractType;
    conditionsForCancellation?: CancellationReason[] | undefined;
    detailedReason?: string | undefined;
    saveIdentityImagesForDebugging?: boolean;
}

export enum ContractType {
    Sale = 0,
    Cancellation = 1,
    Fulfillment = 2,
    Amendment = 3,
}

export enum CancellationReason {
    UnableToObtainFinancing = 0,
    InspectionDueDiligenceUnsatisfactory = 1,
    UnableToSellPreviousHome = 2,
    ContractConditionsNotMet = 3,
    InspectionDispute = 4,
    SellersCircumstancesChanged = 5,
    Other = 6,
}

export class ShiftDealTimelineCommand implements IShiftDealTimelineCommand {
    dealId?: string | undefined;
    hours?: number;
    minutes?: number;

    constructor(data?: IShiftDealTimelineCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): ShiftDealTimelineCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDealTimelineCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface IShiftDealTimelineCommand {
    dealId?: string | undefined;
    hours?: number;
    minutes?: number;
}

export class GeocodeExistingListingsResult implements IGeocodeExistingListingsResult {
    total?: number;
    geocoded?: number;

    constructor(data?: IGeocodeExistingListingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.geocoded = _data["geocoded"];
        }
    }

    static fromJS(data: any): GeocodeExistingListingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeExistingListingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["geocoded"] = this.geocoded;
        return data;
    }
}

export interface IGeocodeExistingListingsResult {
    total?: number;
    geocoded?: number;
}

export class CreateApiKeyCommand implements ICreateApiKeyCommand {
    tenantId?: number;
    password?: string | undefined;
    usedByApplication?: string | undefined;

    constructor(data?: ICreateApiKeyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.password = _data["password"];
            this.usedByApplication = _data["usedByApplication"];
        }
    }

    static fromJS(data: any): CreateApiKeyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApiKeyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["password"] = this.password;
        data["usedByApplication"] = this.usedByApplication;
        return data;
    }
}

export interface ICreateApiKeyCommand {
    tenantId?: number;
    password?: string | undefined;
    usedByApplication?: string | undefined;
}

export class ClientCredentialRequestInfo implements IClientCredentialRequestInfo {
    clientId?: string | undefined;
    secretKey?: string | undefined;

    constructor(data?: IClientCredentialRequestInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.secretKey = _data["secretKey"];
        }
    }

    static fromJS(data: any): ClientCredentialRequestInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ClientCredentialRequestInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["secretKey"] = this.secretKey;
        return data;
    }
}

export interface IClientCredentialRequestInfo {
    clientId?: string | undefined;
    secretKey?: string | undefined;
}

export class RefreshAccessTokenRequest implements IRefreshAccessTokenRequest {
    refreshToken?: string | undefined;

    constructor(data?: IRefreshAccessTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshAccessTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshAccessTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshAccessTokenRequest {
    refreshToken?: string | undefined;
}

export class SwitchToUserTypeCommand implements ISwitchToUserTypeCommand {
    userType?: UserType;
    developerId?: number | undefined;

    constructor(data?: ISwitchToUserTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userType = _data["userType"];
            this.developerId = _data["developerId"];
        }
    }

    static fromJS(data: any): SwitchToUserTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToUserTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userType"] = this.userType;
        data["developerId"] = this.developerId;
        return data;
    }
}

export interface ISwitchToUserTypeCommand {
    userType?: UserType;
    developerId?: number | undefined;
}

export class LoginCommand implements ILoginCommand {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginCommand {
    username?: string | undefined;
    password?: string | undefined;
}

export class GoogleTokenRequest implements IGoogleTokenRequest {
    idToken?: string | undefined;

    constructor(data?: IGoogleTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idToken = _data["idToken"];
        }
    }

    static fromJS(data: any): GoogleTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idToken"] = this.idToken;
        return data;
    }
}

export interface IGoogleTokenRequest {
    idToken?: string | undefined;
}

export class AppleTokenRequest implements IAppleTokenRequest {
    idToken?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IAppleTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idToken = _data["idToken"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): AppleTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppleTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idToken"] = this.idToken;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IAppleTokenRequest {
    idToken?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class VerifyMagicLinkCommand implements IVerifyMagicLinkCommand {
    token?: string | undefined;

    constructor(data?: IVerifyMagicLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): VerifyMagicLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyMagicLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IVerifyMagicLinkCommand {
    token?: string | undefined;
}

export class RequestOtpCommand implements IRequestOtpCommand {
    email?: string | undefined;
    redirectUrl?: string | undefined;

    constructor(data?: IRequestOtpCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): RequestOtpCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestOtpCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IRequestOtpCommand {
    email?: string | undefined;
    redirectUrl?: string | undefined;
}

export class ValidateOtpCommand implements IValidateOtpCommand {
    email?: string | undefined;
    otpCode?: string | undefined;

    constructor(data?: IValidateOtpCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.otpCode = _data["otpCode"];
        }
    }

    static fromJS(data: any): ValidateOtpCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateOtpCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["otpCode"] = this.otpCode;
        return data;
    }
}

export interface IValidateOtpCommand {
    email?: string | undefined;
    otpCode?: string | undefined;
}

export class PaginationModel implements IPaginationModel {
    sortOrder?: string | undefined;
    searchString?: string | undefined;
    page?: number | undefined;
    ascSortDirection?: boolean;
    pageSize?: number;
    shouldRetrieveAllEntities?: boolean;

    constructor(data?: IPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.searchString = _data["searchString"];
            this.page = _data["page"];
            this.ascSortDirection = _data["ascSortDirection"];
            this.pageSize = _data["pageSize"];
            this.shouldRetrieveAllEntities = _data["shouldRetrieveAllEntities"];
        }
    }

    static fromJS(data: any): PaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["searchString"] = this.searchString;
        data["page"] = this.page;
        data["ascSortDirection"] = this.ascSortDirection;
        data["pageSize"] = this.pageSize;
        data["shouldRetrieveAllEntities"] = this.shouldRetrieveAllEntities;
        return data;
    }
}

export interface IPaginationModel {
    sortOrder?: string | undefined;
    searchString?: string | undefined;
    page?: number | undefined;
    ascSortDirection?: boolean;
    pageSize?: number;
    shouldRetrieveAllEntities?: boolean;
}

export class PaginatedResult extends PaginationModel implements IPaginatedResult {
    count?: number;
    totalPages?: number;

    constructor(data?: IPaginatedResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.count = _data["count"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): PaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResult extends IPaginationModel {
    count?: number;
    totalPages?: number;
}

export class PaginatedResultOfBuilderLookUpDto extends PaginatedResult implements IPaginatedResultOfBuilderLookUpDto {
    entities?: BuilderLookUpDto[] | undefined;

    constructor(data?: IPaginatedResultOfBuilderLookUpDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(BuilderLookUpDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfBuilderLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfBuilderLookUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfBuilderLookUpDto extends IPaginatedResult {
    entities?: BuilderLookUpDto[] | undefined;
}

export class BuilderLookUpDto implements IBuilderLookUpDto {
    index?: number;
    id?: number;
    name?: string | undefined;

    constructor(data?: IBuilderLookUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BuilderLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuilderLookUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBuilderLookUpDto {
    index?: number;
    id?: number;
    name?: string | undefined;
}

export class CreateBuilderCommand implements ICreateBuilderCommand {
    name?: string | undefined;

    constructor(data?: ICreateBuilderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateBuilderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBuilderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateBuilderCommand {
    name?: string | undefined;
}

export class PaginatedResultOfBuilderUserLookupDto extends PaginatedResult implements IPaginatedResultOfBuilderUserLookupDto {
    entities?: BuilderUserLookupDto[] | undefined;

    constructor(data?: IPaginatedResultOfBuilderUserLookupDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(BuilderUserLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfBuilderUserLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfBuilderUserLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfBuilderUserLookupDto extends IPaginatedResult {
    entities?: BuilderUserLookupDto[] | undefined;
}

export class BuilderUserLookupDto implements IBuilderUserLookupDto {
    index?: number;
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: IBuilderUserLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): BuilderUserLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuilderUserLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IBuilderUserLookupDto {
    index?: number;
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
}

export enum BuilderUserStatus {
    PendingAcceptance = 0,
    Active = 1,
    Deactivated = 2,
}

export class CreateBuilderUserProfileCommand implements ICreateBuilderUserProfileCommand {
    phoneNumber?: string | undefined;
    phoneExtensionNumber?: string | undefined;
    personalEmail?: string | undefined;
    birthDate?: Date | undefined;
    preferredLanguage?: LanguageType;
    email?: string | undefined;

    constructor(data?: ICreateBuilderUserProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtensionNumber = _data["phoneExtensionNumber"];
            this.personalEmail = _data["personalEmail"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.preferredLanguage = _data["preferredLanguage"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateBuilderUserProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBuilderUserProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtensionNumber"] = this.phoneExtensionNumber;
        data["personalEmail"] = this.personalEmail;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["preferredLanguage"] = this.preferredLanguage;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateBuilderUserProfileCommand {
    phoneNumber?: string | undefined;
    phoneExtensionNumber?: string | undefined;
    personalEmail?: string | undefined;
    birthDate?: Date | undefined;
    preferredLanguage?: LanguageType;
    email?: string | undefined;
}

export enum LanguageType {
    English = 0,
    French = 1,
    All = 2,
}

export class EditBuilderUserCommand implements IEditBuilderUserCommand {
    phoneNumber?: string | undefined;
    phoneExtensionNumber?: string | undefined;
    personalEmail?: string | undefined;
    birthDate?: Date | undefined;
    preferredLanguage?: LanguageType;

    constructor(data?: IEditBuilderUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.phoneExtensionNumber = _data["phoneExtensionNumber"];
            this.personalEmail = _data["personalEmail"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.preferredLanguage = _data["preferredLanguage"];
        }
    }

    static fromJS(data: any): EditBuilderUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditBuilderUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["phoneExtensionNumber"] = this.phoneExtensionNumber;
        data["personalEmail"] = this.personalEmail;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["preferredLanguage"] = this.preferredLanguage;
        return data;
    }
}

export interface IEditBuilderUserCommand {
    phoneNumber?: string | undefined;
    phoneExtensionNumber?: string | undefined;
    personalEmail?: string | undefined;
    birthDate?: Date | undefined;
    preferredLanguage?: LanguageType;
}

/** Represents a void type, since Void is not a valid return type in C#. */
export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface IUnit {
}

export class EditBuilderUserRolesCommand implements IEditBuilderUserRolesCommand {
    roleIds?: string[] | undefined;
    roleNames?: string[] | undefined;

    constructor(data?: IEditBuilderUserRolesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): EditBuilderUserRolesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditBuilderUserRolesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }
}

export interface IEditBuilderUserRolesCommand {
    roleIds?: string[] | undefined;
    roleNames?: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRoleDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class PaginatedResultOfClientLookupDto extends PaginatedResult implements IPaginatedResultOfClientLookupDto {
    entities?: ClientLookupDto[] | undefined;

    constructor(data?: IPaginatedResultOfClientLookupDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ClientLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfClientLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfClientLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfClientLookupDto extends IPaginatedResult {
    entities?: ClientLookupDto[] | undefined;
}

export class ClientLookupDto implements IClientLookupDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberExtension?: string | undefined;
    languageType?: LanguageType;
    projectId?: number | undefined;
    createdDateTime?: Date;
    leadStatus?: LeadStatus;
    index?: number;

    constructor(data?: IClientLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.languageType = _data["languageType"];
            this.projectId = _data["projectId"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.leadStatus = _data["leadStatus"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): ClientLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["languageType"] = this.languageType;
        data["projectId"] = this.projectId;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["leadStatus"] = this.leadStatus;
        data["index"] = this.index;
        return data;
    }
}

export interface IClientLookupDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberExtension?: string | undefined;
    languageType?: LanguageType;
    projectId?: number | undefined;
    createdDateTime?: Date;
    leadStatus?: LeadStatus;
    index?: number;
}

export enum LeadStatus {
    Open = 0,
    Closed = 1,
    NotInterested = 2,
}

export class ClientDto implements IClientDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberExtension?: string | undefined;
    languageType?: LanguageType;
    projectId?: number | undefined;
    createdDateTime?: Date;
    leadStatus?: LeadStatus;
    avatarImage?: ImageMediaDto | undefined;
    totalPendingDeals?: number;
    totalFirmDeals?: number;
    totalCancelledDeals?: number;
    joinedDateTimeUtc?: Date | undefined;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.languageType = _data["languageType"];
            this.projectId = _data["projectId"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.leadStatus = _data["leadStatus"];
            this.avatarImage = _data["avatarImage"] ? ImageMediaDto.fromJS(_data["avatarImage"]) : <any>undefined;
            this.totalPendingDeals = _data["totalPendingDeals"];
            this.totalFirmDeals = _data["totalFirmDeals"];
            this.totalCancelledDeals = _data["totalCancelledDeals"];
            this.joinedDateTimeUtc = _data["joinedDateTimeUtc"] ? new Date(_data["joinedDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["languageType"] = this.languageType;
        data["projectId"] = this.projectId;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["leadStatus"] = this.leadStatus;
        data["avatarImage"] = this.avatarImage ? this.avatarImage.toJSON() : <any>undefined;
        data["totalPendingDeals"] = this.totalPendingDeals;
        data["totalFirmDeals"] = this.totalFirmDeals;
        data["totalCancelledDeals"] = this.totalCancelledDeals;
        data["joinedDateTimeUtc"] = this.joinedDateTimeUtc ? this.joinedDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberExtension?: string | undefined;
    languageType?: LanguageType;
    projectId?: number | undefined;
    createdDateTime?: Date;
    leadStatus?: LeadStatus;
    avatarImage?: ImageMediaDto | undefined;
    totalPendingDeals?: number;
    totalFirmDeals?: number;
    totalCancelledDeals?: number;
    joinedDateTimeUtc?: Date | undefined;
}

export class CreateClientCommand implements ICreateClientCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    leadStatus?: LeadStatus;
    projectId?: number | undefined;
    language?: LanguageType;

    constructor(data?: ICreateClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.leadStatus = _data["leadStatus"];
            this.projectId = _data["projectId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): CreateClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["leadStatus"] = this.leadStatus;
        data["projectId"] = this.projectId;
        data["language"] = this.language;
        return data;
    }
}

export interface ICreateClientCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    leadStatus?: LeadStatus;
    projectId?: number | undefined;
    language?: LanguageType;
}

export class EditClientCommand implements IEditClientCommand {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    leadStatus?: LeadStatus;
    projectId?: number;
    language?: LanguageType;

    constructor(data?: IEditClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.leadStatus = _data["leadStatus"];
            this.projectId = _data["projectId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): EditClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["leadStatus"] = this.leadStatus;
        data["projectId"] = this.projectId;
        data["language"] = this.language;
        return data;
    }
}

export interface IEditClientCommand {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    leadStatus?: LeadStatus;
    projectId?: number;
    language?: LanguageType;
}

export class NoteCommand implements INoteCommand {
    id?: string | undefined;
    brokerId?: string | undefined;
    builderClientId?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    dateTimeOfNoteUtc?: Date | undefined;
    sendNotification?: boolean;
    createdDateTime?: Date;
    lastUpdatedById?: string | undefined;
    projectId?: number | undefined;
    listingId?: number | undefined;
    languageType?: LanguageType | undefined;
    attachedDocument?: DocumentMediaDto | undefined;
    attachedImage?: ImageMediaDto | undefined;
    attachmentIds?: string[] | undefined;
    tags?: string[] | undefined;

    constructor(data?: INoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brokerId = _data["brokerId"];
            this.builderClientId = _data["builderClientId"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.dateTimeOfNoteUtc = _data["dateTimeOfNoteUtc"] ? new Date(_data["dateTimeOfNoteUtc"].toString()) : <any>undefined;
            this.sendNotification = _data["sendNotification"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastUpdatedById = _data["lastUpdatedById"];
            this.projectId = _data["projectId"];
            this.listingId = _data["listingId"];
            this.languageType = _data["languageType"];
            this.attachedDocument = _data["attachedDocument"] ? DocumentMediaDto.fromJS(_data["attachedDocument"]) : <any>undefined;
            this.attachedImage = _data["attachedImage"] ? ImageMediaDto.fromJS(_data["attachedImage"]) : <any>undefined;
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [] as any;
                for (let item of _data["attachmentIds"])
                    this.attachmentIds!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): NoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new NoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brokerId"] = this.brokerId;
        data["builderClientId"] = this.builderClientId;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["dateTimeOfNoteUtc"] = this.dateTimeOfNoteUtc ? this.dateTimeOfNoteUtc.toISOString() : <any>undefined;
        data["sendNotification"] = this.sendNotification;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastUpdatedById"] = this.lastUpdatedById;
        data["projectId"] = this.projectId;
        data["listingId"] = this.listingId;
        data["languageType"] = this.languageType;
        data["attachedDocument"] = this.attachedDocument ? this.attachedDocument.toJSON() : <any>undefined;
        data["attachedImage"] = this.attachedImage ? this.attachedImage.toJSON() : <any>undefined;
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (let item of this.attachmentIds)
                data["attachmentIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface INoteCommand {
    id?: string | undefined;
    brokerId?: string | undefined;
    builderClientId?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    dateTimeOfNoteUtc?: Date | undefined;
    sendNotification?: boolean;
    createdDateTime?: Date;
    lastUpdatedById?: string | undefined;
    projectId?: number | undefined;
    listingId?: number | undefined;
    languageType?: LanguageType | undefined;
    attachedDocument?: DocumentMediaDto | undefined;
    attachedImage?: ImageMediaDto | undefined;
    attachmentIds?: string[] | undefined;
    tags?: string[] | undefined;
}

export class CreateNoteCommand extends NoteCommand implements ICreateNoteCommand {
    noteType?: NoteType;
    createdById?: string | undefined;

    constructor(data?: ICreateNoteCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.noteType = _data["noteType"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): CreateNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteType"] = this.noteType;
        data["createdById"] = this.createdById;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateNoteCommand extends INoteCommand {
    noteType?: NoteType;
    createdById?: string | undefined;
}

export enum NoteType {
    FollowUp = 0,
    Comment = 1,
    Appointment = 2,
    Call = 3,
    Other = 4,
    Inquiry = 5,
    LeftMessage = 6,
    NoAnswer = 7,
    MadeContact = 8,
    ThankYouForVisiting = 9,
    ThankYouForCalling = 10,
    DocumentUpload = 11,
    StatusChange = 12,
    NoResponseEmail = 13,
    AgentAssigned = 14,
    AgentRegistered = 15,
}

export class DocumentMediaDto implements IDocumentMediaDto {
    id?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    sizeInBytes?: number;
    filePath?: string | undefined;
    mediaPrivacyType?: MediaPrivacyType;

    constructor(data?: IDocumentMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.filePath = _data["filePath"];
            this.mediaPrivacyType = _data["mediaPrivacyType"];
        }
    }

    static fromJS(data: any): DocumentMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["url"] = this.url;
        data["description"] = this.description;
        data["sizeInBytes"] = this.sizeInBytes;
        data["filePath"] = this.filePath;
        data["mediaPrivacyType"] = this.mediaPrivacyType;
        return data;
    }
}

export interface IDocumentMediaDto {
    id?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    sizeInBytes?: number;
    filePath?: string | undefined;
    mediaPrivacyType?: MediaPrivacyType;
}

export class EditNoteCommand extends NoteCommand implements IEditNoteCommand {

    constructor(data?: IEditNoteCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EditNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEditNoteCommand extends INoteCommand {
}

export class NoteDto implements INoteDto {
    id?: string | undefined;
    noteType?: NoteType;
    subject?: string | undefined;
    description?: string | undefined;
    createdBy?: NestedUserDto | undefined;
    createdById?: string | undefined;
    followUpDateTime?: Date | undefined;
    appointmentDateTime?: Date | undefined;
    callOccuredDateTime?: Date | undefined;
    sendNotification?: boolean;
    userCreatedDateTime?: Date | undefined;
    lastUpdatedById?: string | undefined;
    projectId?: number | undefined;
    project?: NestedProjectDto | undefined;
    listing?: NestedListingDto | undefined;
    listingId?: number | undefined;
    languageType?: LanguageType | undefined;
    attachedDocument?: DocumentMediaDto | undefined;
    attachedImage?: ImageMediaDto | undefined;
    brokerId?: string | undefined;
    builderClientId?: number | undefined;
    createdDateTime?: Date;
    tags?: string[] | undefined;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.noteType = _data["noteType"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"] ? NestedUserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdById = _data["createdById"];
            this.followUpDateTime = _data["followUpDateTime"] ? new Date(_data["followUpDateTime"].toString()) : <any>undefined;
            this.appointmentDateTime = _data["appointmentDateTime"] ? new Date(_data["appointmentDateTime"].toString()) : <any>undefined;
            this.callOccuredDateTime = _data["callOccuredDateTime"] ? new Date(_data["callOccuredDateTime"].toString()) : <any>undefined;
            this.sendNotification = _data["sendNotification"];
            this.userCreatedDateTime = _data["userCreatedDateTime"] ? new Date(_data["userCreatedDateTime"].toString()) : <any>undefined;
            this.lastUpdatedById = _data["lastUpdatedById"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? NestedProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.listing = _data["listing"] ? NestedListingDto.fromJS(_data["listing"]) : <any>undefined;
            this.listingId = _data["listingId"];
            this.languageType = _data["languageType"];
            this.attachedDocument = _data["attachedDocument"] ? DocumentMediaDto.fromJS(_data["attachedDocument"]) : <any>undefined;
            this.attachedImage = _data["attachedImage"] ? ImageMediaDto.fromJS(_data["attachedImage"]) : <any>undefined;
            this.brokerId = _data["brokerId"];
            this.builderClientId = _data["builderClientId"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["noteType"] = this.noteType;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdById"] = this.createdById;
        data["followUpDateTime"] = this.followUpDateTime ? this.followUpDateTime.toISOString() : <any>undefined;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>undefined;
        data["callOccuredDateTime"] = this.callOccuredDateTime ? this.callOccuredDateTime.toISOString() : <any>undefined;
        data["sendNotification"] = this.sendNotification;
        data["userCreatedDateTime"] = this.userCreatedDateTime ? this.userCreatedDateTime.toISOString() : <any>undefined;
        data["lastUpdatedById"] = this.lastUpdatedById;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        data["listingId"] = this.listingId;
        data["languageType"] = this.languageType;
        data["attachedDocument"] = this.attachedDocument ? this.attachedDocument.toJSON() : <any>undefined;
        data["attachedImage"] = this.attachedImage ? this.attachedImage.toJSON() : <any>undefined;
        data["brokerId"] = this.brokerId;
        data["builderClientId"] = this.builderClientId;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface INoteDto {
    id?: string | undefined;
    noteType?: NoteType;
    subject?: string | undefined;
    description?: string | undefined;
    createdBy?: NestedUserDto | undefined;
    createdById?: string | undefined;
    followUpDateTime?: Date | undefined;
    appointmentDateTime?: Date | undefined;
    callOccuredDateTime?: Date | undefined;
    sendNotification?: boolean;
    userCreatedDateTime?: Date | undefined;
    lastUpdatedById?: string | undefined;
    projectId?: number | undefined;
    project?: NestedProjectDto | undefined;
    listing?: NestedListingDto | undefined;
    listingId?: number | undefined;
    languageType?: LanguageType | undefined;
    attachedDocument?: DocumentMediaDto | undefined;
    attachedImage?: ImageMediaDto | undefined;
    brokerId?: string | undefined;
    builderClientId?: number | undefined;
    createdDateTime?: Date;
    tags?: string[] | undefined;
}

export class NestedUserDto implements INestedUserDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;

    constructor(data?: INestedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.modifiedDateTimeUtc = _data["modifiedDateTimeUtc"] ? new Date(_data["modifiedDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NestedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["modifiedDateTimeUtc"] = this.modifiedDateTimeUtc ? this.modifiedDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface INestedUserDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;
}

export class NestedProjectDto implements INestedProjectDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    builderName?: string | undefined;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;

    constructor(data?: INestedProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.builderName = _data["builderName"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.modifiedDateTimeUtc = _data["modifiedDateTimeUtc"] ? new Date(_data["modifiedDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NestedProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["builderName"] = this.builderName;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["modifiedDateTimeUtc"] = this.modifiedDateTimeUtc ? this.modifiedDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface INestedProjectDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    builderName?: string | undefined;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;
}

export class NestedListingDto implements INestedListingDto {
    id?: number;
    price?: number | undefined;
    name?: string | undefined;
    payments?: ListingPaymentDto[] | undefined;
    leadPropertyStatus?: LeadPropertyStatus;
    displayImage?: ImageMediaDto | undefined;
    address?: AddressDto | undefined;
    state?: ListingState;

    constructor(data?: INestedListingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.name = _data["name"];
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(ListingPaymentDto.fromJS(item));
            }
            this.leadPropertyStatus = _data["leadPropertyStatus"];
            this.displayImage = _data["displayImage"] ? ImageMediaDto.fromJS(_data["displayImage"]) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): NestedListingDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedListingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["name"] = this.name;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["leadPropertyStatus"] = this.leadPropertyStatus;
        data["displayImage"] = this.displayImage ? this.displayImage.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface INestedListingDto {
    id?: number;
    price?: number | undefined;
    name?: string | undefined;
    payments?: ListingPaymentDto[] | undefined;
    leadPropertyStatus?: LeadPropertyStatus;
    displayImage?: ImageMediaDto | undefined;
    address?: AddressDto | undefined;
    state?: ListingState;
}

export class ListingPaymentDto implements IListingPaymentDto {
    id?: string | undefined;
    listingId?: number;
    createdByEmployeeId?: string | undefined;
    createdDateTimeUtc?: Date;
    scheduledDateUtc?: Date;
    paidDateUtc?: Date | undefined;
    isPaid?: boolean;
    setToPaidByEmployeeId?: string | undefined;
    amount?: number;
    paymentType?: PaymentType;
    comment?: string | undefined;

    constructor(data?: IListingPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listingId = _data["listingId"];
            this.createdByEmployeeId = _data["createdByEmployeeId"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.scheduledDateUtc = _data["scheduledDateUtc"] ? new Date(_data["scheduledDateUtc"].toString()) : <any>undefined;
            this.paidDateUtc = _data["paidDateUtc"] ? new Date(_data["paidDateUtc"].toString()) : <any>undefined;
            this.isPaid = _data["isPaid"];
            this.setToPaidByEmployeeId = _data["setToPaidByEmployeeId"];
            this.amount = _data["amount"];
            this.paymentType = _data["paymentType"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ListingPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listingId"] = this.listingId;
        data["createdByEmployeeId"] = this.createdByEmployeeId;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["scheduledDateUtc"] = this.scheduledDateUtc ? this.scheduledDateUtc.toISOString() : <any>undefined;
        data["paidDateUtc"] = this.paidDateUtc ? this.paidDateUtc.toISOString() : <any>undefined;
        data["isPaid"] = this.isPaid;
        data["setToPaidByEmployeeId"] = this.setToPaidByEmployeeId;
        data["amount"] = this.amount;
        data["paymentType"] = this.paymentType;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IListingPaymentDto {
    id?: string | undefined;
    listingId?: number;
    createdByEmployeeId?: string | undefined;
    createdDateTimeUtc?: Date;
    scheduledDateUtc?: Date;
    paidDateUtc?: Date | undefined;
    isPaid?: boolean;
    setToPaidByEmployeeId?: string | undefined;
    amount?: number;
    paymentType?: PaymentType;
    comment?: string | undefined;
}

export enum PaymentType {
    Cash = 0,
    Cheque = 1,
    Credit = 2,
    Wire = 3,
}

export enum LeadPropertyStatus {
    Prospect = 0,
    Reserved = 1,
    Purchased = 2,
    Inactive = 3,
    WaitList = 4,
}

export enum ListingState {
    Incomplete = 0,
    Pending = 1,
    Denied = 2,
    Active = 3,
    Paused = 4,
    Reserved = 5,
    Sold = 6,
    Cancelled = 7,
    DeclinedBySeller = 8,
}

export class PaginatedResultOfDealLookupDto extends PaginatedResult implements IPaginatedResultOfDealLookupDto {
    entities?: DealLookupDto[] | undefined;

    constructor(data?: IPaginatedResultOfDealLookupDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(DealLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfDealLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfDealLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfDealLookupDto extends IPaginatedResult {
    entities?: DealLookupDto[] | undefined;
}

export class DealLookupDto implements IDealLookupDto {
    id?: string | undefined;
    purchaserOrderNo?: number;
    createdDateTimeUtc?: Date;
    selectedListingId?: number;
    unitSalePrice?: number;
    unitListingSalePrice?: number;
    state?: DealState;
    purchaserNames?: string[] | undefined;
    propertyName?: string | undefined;
    index?: number;
    unitNumber?: string | undefined;
    associatedSharedOpportunityId?: string | undefined;
    project?: NestedProjectDto | undefined;
    listing?: NestedListingDto | undefined;
    purchasers?: PurchaserDto[] | undefined;
    sellers?: SellerDto[] | undefined;
    expirationAtDateTimeUtc?: Date | undefined;
    vendorExpirationAtDateTimeUtc?: Date | undefined;
    lastPurchaserSignedDateTimeUtc?: Date | undefined;
    firmDateTimeUtc?: Date | undefined;
    declinedDateTimeUtc?: Date | undefined;
    cancelledDateTimeUtc?: Date | undefined;
    collapsedDateTimeUtc?: Date | undefined;
    savedDateTimeUtc?: Date | undefined;
    lastSelectionMadeDateTimeUtc?: Date | undefined;
    vendorSignedContractDateTimeUtc?: Date | undefined;
    realEstateType?: RealEstateType;
    depositDueDate?: Date | undefined;
    totalDeposit?: number;
    listingAddress?: AddressDto | undefined;

    constructor(data?: IDealLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.purchaserOrderNo = _data["purchaserOrderNo"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.selectedListingId = _data["selectedListingId"];
            this.unitSalePrice = _data["unitSalePrice"];
            this.unitListingSalePrice = _data["unitListingSalePrice"];
            this.state = _data["state"];
            if (Array.isArray(_data["purchaserNames"])) {
                this.purchaserNames = [] as any;
                for (let item of _data["purchaserNames"])
                    this.purchaserNames!.push(item);
            }
            this.propertyName = _data["propertyName"];
            this.index = _data["index"];
            this.unitNumber = _data["unitNumber"];
            this.associatedSharedOpportunityId = _data["associatedSharedOpportunityId"];
            this.project = _data["project"] ? NestedProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.listing = _data["listing"] ? NestedListingDto.fromJS(_data["listing"]) : <any>undefined;
            if (Array.isArray(_data["purchasers"])) {
                this.purchasers = [] as any;
                for (let item of _data["purchasers"])
                    this.purchasers!.push(PurchaserDto.fromJS(item));
            }
            if (Array.isArray(_data["sellers"])) {
                this.sellers = [] as any;
                for (let item of _data["sellers"])
                    this.sellers!.push(SellerDto.fromJS(item));
            }
            this.expirationAtDateTimeUtc = _data["expirationAtDateTimeUtc"] ? new Date(_data["expirationAtDateTimeUtc"].toString()) : <any>undefined;
            this.vendorExpirationAtDateTimeUtc = _data["vendorExpirationAtDateTimeUtc"] ? new Date(_data["vendorExpirationAtDateTimeUtc"].toString()) : <any>undefined;
            this.lastPurchaserSignedDateTimeUtc = _data["lastPurchaserSignedDateTimeUtc"] ? new Date(_data["lastPurchaserSignedDateTimeUtc"].toString()) : <any>undefined;
            this.firmDateTimeUtc = _data["firmDateTimeUtc"] ? new Date(_data["firmDateTimeUtc"].toString()) : <any>undefined;
            this.declinedDateTimeUtc = _data["declinedDateTimeUtc"] ? new Date(_data["declinedDateTimeUtc"].toString()) : <any>undefined;
            this.cancelledDateTimeUtc = _data["cancelledDateTimeUtc"] ? new Date(_data["cancelledDateTimeUtc"].toString()) : <any>undefined;
            this.collapsedDateTimeUtc = _data["collapsedDateTimeUtc"] ? new Date(_data["collapsedDateTimeUtc"].toString()) : <any>undefined;
            this.savedDateTimeUtc = _data["savedDateTimeUtc"] ? new Date(_data["savedDateTimeUtc"].toString()) : <any>undefined;
            this.lastSelectionMadeDateTimeUtc = _data["lastSelectionMadeDateTimeUtc"] ? new Date(_data["lastSelectionMadeDateTimeUtc"].toString()) : <any>undefined;
            this.vendorSignedContractDateTimeUtc = _data["vendorSignedContractDateTimeUtc"] ? new Date(_data["vendorSignedContractDateTimeUtc"].toString()) : <any>undefined;
            this.realEstateType = _data["realEstateType"];
            this.depositDueDate = _data["depositDueDate"] ? new Date(_data["depositDueDate"].toString()) : <any>undefined;
            this.totalDeposit = _data["totalDeposit"];
            this.listingAddress = _data["listingAddress"] ? AddressDto.fromJS(_data["listingAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DealLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaserOrderNo"] = this.purchaserOrderNo;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["selectedListingId"] = this.selectedListingId;
        data["unitSalePrice"] = this.unitSalePrice;
        data["unitListingSalePrice"] = this.unitListingSalePrice;
        data["state"] = this.state;
        if (Array.isArray(this.purchaserNames)) {
            data["purchaserNames"] = [];
            for (let item of this.purchaserNames)
                data["purchaserNames"].push(item);
        }
        data["propertyName"] = this.propertyName;
        data["index"] = this.index;
        data["unitNumber"] = this.unitNumber;
        data["associatedSharedOpportunityId"] = this.associatedSharedOpportunityId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        if (Array.isArray(this.purchasers)) {
            data["purchasers"] = [];
            for (let item of this.purchasers)
                data["purchasers"].push(item.toJSON());
        }
        if (Array.isArray(this.sellers)) {
            data["sellers"] = [];
            for (let item of this.sellers)
                data["sellers"].push(item.toJSON());
        }
        data["expirationAtDateTimeUtc"] = this.expirationAtDateTimeUtc ? this.expirationAtDateTimeUtc.toISOString() : <any>undefined;
        data["vendorExpirationAtDateTimeUtc"] = this.vendorExpirationAtDateTimeUtc ? this.vendorExpirationAtDateTimeUtc.toISOString() : <any>undefined;
        data["lastPurchaserSignedDateTimeUtc"] = this.lastPurchaserSignedDateTimeUtc ? this.lastPurchaserSignedDateTimeUtc.toISOString() : <any>undefined;
        data["firmDateTimeUtc"] = this.firmDateTimeUtc ? this.firmDateTimeUtc.toISOString() : <any>undefined;
        data["declinedDateTimeUtc"] = this.declinedDateTimeUtc ? this.declinedDateTimeUtc.toISOString() : <any>undefined;
        data["cancelledDateTimeUtc"] = this.cancelledDateTimeUtc ? this.cancelledDateTimeUtc.toISOString() : <any>undefined;
        data["collapsedDateTimeUtc"] = this.collapsedDateTimeUtc ? this.collapsedDateTimeUtc.toISOString() : <any>undefined;
        data["savedDateTimeUtc"] = this.savedDateTimeUtc ? this.savedDateTimeUtc.toISOString() : <any>undefined;
        data["lastSelectionMadeDateTimeUtc"] = this.lastSelectionMadeDateTimeUtc ? this.lastSelectionMadeDateTimeUtc.toISOString() : <any>undefined;
        data["vendorSignedContractDateTimeUtc"] = this.vendorSignedContractDateTimeUtc ? this.vendorSignedContractDateTimeUtc.toISOString() : <any>undefined;
        data["realEstateType"] = this.realEstateType;
        data["depositDueDate"] = this.depositDueDate ? this.depositDueDate.toISOString() : <any>undefined;
        data["totalDeposit"] = this.totalDeposit;
        data["listingAddress"] = this.listingAddress ? this.listingAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDealLookupDto {
    id?: string | undefined;
    purchaserOrderNo?: number;
    createdDateTimeUtc?: Date;
    selectedListingId?: number;
    unitSalePrice?: number;
    unitListingSalePrice?: number;
    state?: DealState;
    purchaserNames?: string[] | undefined;
    propertyName?: string | undefined;
    index?: number;
    unitNumber?: string | undefined;
    associatedSharedOpportunityId?: string | undefined;
    project?: NestedProjectDto | undefined;
    listing?: NestedListingDto | undefined;
    purchasers?: PurchaserDto[] | undefined;
    sellers?: SellerDto[] | undefined;
    expirationAtDateTimeUtc?: Date | undefined;
    vendorExpirationAtDateTimeUtc?: Date | undefined;
    lastPurchaserSignedDateTimeUtc?: Date | undefined;
    firmDateTimeUtc?: Date | undefined;
    declinedDateTimeUtc?: Date | undefined;
    cancelledDateTimeUtc?: Date | undefined;
    collapsedDateTimeUtc?: Date | undefined;
    savedDateTimeUtc?: Date | undefined;
    lastSelectionMadeDateTimeUtc?: Date | undefined;
    vendorSignedContractDateTimeUtc?: Date | undefined;
    realEstateType?: RealEstateType;
    depositDueDate?: Date | undefined;
    totalDeposit?: number;
    listingAddress?: AddressDto | undefined;
}

export enum DealState {
    PendingCompletion = 0,
    PendingBuyerSignature = 1,
    PendingBuyerSubmit = 2,
    PendingSellerSignature = 3,
    Accepted = 4,
    Cancelled = 5,
    AmendmentRequest = 6,
    Firm = 7,
    Declined = 8,
    Expired = 9,
}

export class PurchaserDto implements IPurchaserDto {
    id?: string | undefined;
    preferredName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    pronoun?: string | undefined;
    birthDate?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    residentAddress?: AddressDto | undefined;
    identityConsentDateUtc?: Date | undefined;
    employmentIndustry?: string | undefined;
    employerName?: string | undefined;
    jobTitle?: string | undefined;
    isFirstTimeHomeBuyer?: boolean;
    isPrincipalResidence?: boolean;
    hasPurchasedFromPrestiBefore?: boolean;
    relationshipWithOtherPurchaser?: PurchaserRelationship | undefined;
    nameVerifyStatus?: NameVerifyStatus | undefined;
    purchaserNo?: number;
    linkedUserId?: string | undefined;
    countryOfResidencyOrCitizenship?: string | undefined;

    constructor(data?: IPurchaserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preferredName = _data["preferredName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.pronoun = _data["pronoun"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.residentAddress = _data["residentAddress"] ? AddressDto.fromJS(_data["residentAddress"]) : <any>undefined;
            this.identityConsentDateUtc = _data["identityConsentDateUtc"] ? new Date(_data["identityConsentDateUtc"].toString()) : <any>undefined;
            this.employmentIndustry = _data["employmentIndustry"];
            this.employerName = _data["employerName"];
            this.jobTitle = _data["jobTitle"];
            this.isFirstTimeHomeBuyer = _data["isFirstTimeHomeBuyer"];
            this.isPrincipalResidence = _data["isPrincipalResidence"];
            this.hasPurchasedFromPrestiBefore = _data["hasPurchasedFromPrestiBefore"];
            this.relationshipWithOtherPurchaser = _data["relationshipWithOtherPurchaser"];
            this.nameVerifyStatus = _data["nameVerifyStatus"];
            this.purchaserNo = _data["purchaserNo"];
            this.linkedUserId = _data["linkedUserId"];
            this.countryOfResidencyOrCitizenship = _data["countryOfResidencyOrCitizenship"];
        }
    }

    static fromJS(data: any): PurchaserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preferredName"] = this.preferredName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["pronoun"] = this.pronoun;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["residentAddress"] = this.residentAddress ? this.residentAddress.toJSON() : <any>undefined;
        data["identityConsentDateUtc"] = this.identityConsentDateUtc ? this.identityConsentDateUtc.toISOString() : <any>undefined;
        data["employmentIndustry"] = this.employmentIndustry;
        data["employerName"] = this.employerName;
        data["jobTitle"] = this.jobTitle;
        data["isFirstTimeHomeBuyer"] = this.isFirstTimeHomeBuyer;
        data["isPrincipalResidence"] = this.isPrincipalResidence;
        data["hasPurchasedFromPrestiBefore"] = this.hasPurchasedFromPrestiBefore;
        data["relationshipWithOtherPurchaser"] = this.relationshipWithOtherPurchaser;
        data["nameVerifyStatus"] = this.nameVerifyStatus;
        data["purchaserNo"] = this.purchaserNo;
        data["linkedUserId"] = this.linkedUserId;
        data["countryOfResidencyOrCitizenship"] = this.countryOfResidencyOrCitizenship;
        return data;
    }
}

export interface IPurchaserDto {
    id?: string | undefined;
    preferredName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    pronoun?: string | undefined;
    birthDate?: Date | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    residentAddress?: AddressDto | undefined;
    identityConsentDateUtc?: Date | undefined;
    employmentIndustry?: string | undefined;
    employerName?: string | undefined;
    jobTitle?: string | undefined;
    isFirstTimeHomeBuyer?: boolean;
    isPrincipalResidence?: boolean;
    hasPurchasedFromPrestiBefore?: boolean;
    relationshipWithOtherPurchaser?: PurchaserRelationship | undefined;
    nameVerifyStatus?: NameVerifyStatus | undefined;
    purchaserNo?: number;
    linkedUserId?: string | undefined;
    countryOfResidencyOrCitizenship?: string | undefined;
}

export enum PurchaserRelationship {
    Family = 0,
    Relative = 1,
    Friend = 2,
    Partner = 3,
    BusinessPartner = 4,
}

export class SellerDto implements ISellerDto {
    id?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    isCompanyOwned?: boolean;
    companyName?: string | undefined;
    preferredName?: string | undefined;
    citizenship?: string | undefined;
    residence?: string | undefined;
    birthDate?: Date | undefined;
    agreeToValidateIdentity?: boolean;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    residentAddress?: AddressDto | undefined;
    driverLicenseUrl?: string | undefined;
    passportMediaUrl?: string | undefined;
    agreeToDeclaration?: boolean;
    agreeToTermsAndConditions?: boolean;
    linkedUserId?: string | undefined;
    confirmedDateTimeUtc?: Date | undefined;
    sellerNo?: number;
    hasASpouseOrPartner?: boolean | undefined;
    agreeToSpousalConsentRequired?: boolean;
    profileImage?: ImageMediaDto | undefined;
    originalSellerId?: string | undefined;

    constructor(data?: ISellerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.isCompanyOwned = _data["isCompanyOwned"];
            this.companyName = _data["companyName"];
            this.preferredName = _data["preferredName"];
            this.citizenship = _data["citizenship"];
            this.residence = _data["residence"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.agreeToValidateIdentity = _data["agreeToValidateIdentity"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.residentAddress = _data["residentAddress"] ? AddressDto.fromJS(_data["residentAddress"]) : <any>undefined;
            this.driverLicenseUrl = _data["driverLicenseUrl"];
            this.passportMediaUrl = _data["passportMediaUrl"];
            this.agreeToDeclaration = _data["agreeToDeclaration"];
            this.agreeToTermsAndConditions = _data["agreeToTermsAndConditions"];
            this.linkedUserId = _data["linkedUserId"];
            this.confirmedDateTimeUtc = _data["confirmedDateTimeUtc"] ? new Date(_data["confirmedDateTimeUtc"].toString()) : <any>undefined;
            this.sellerNo = _data["sellerNo"];
            this.hasASpouseOrPartner = _data["hasASpouseOrPartner"];
            this.agreeToSpousalConsentRequired = _data["agreeToSpousalConsentRequired"];
            this.profileImage = _data["profileImage"] ? ImageMediaDto.fromJS(_data["profileImage"]) : <any>undefined;
            this.originalSellerId = _data["originalSellerId"];
        }
    }

    static fromJS(data: any): SellerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["isCompanyOwned"] = this.isCompanyOwned;
        data["companyName"] = this.companyName;
        data["preferredName"] = this.preferredName;
        data["citizenship"] = this.citizenship;
        data["residence"] = this.residence;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["agreeToValidateIdentity"] = this.agreeToValidateIdentity;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["residentAddress"] = this.residentAddress ? this.residentAddress.toJSON() : <any>undefined;
        data["driverLicenseUrl"] = this.driverLicenseUrl;
        data["passportMediaUrl"] = this.passportMediaUrl;
        data["agreeToDeclaration"] = this.agreeToDeclaration;
        data["agreeToTermsAndConditions"] = this.agreeToTermsAndConditions;
        data["linkedUserId"] = this.linkedUserId;
        data["confirmedDateTimeUtc"] = this.confirmedDateTimeUtc ? this.confirmedDateTimeUtc.toISOString() : <any>undefined;
        data["sellerNo"] = this.sellerNo;
        data["hasASpouseOrPartner"] = this.hasASpouseOrPartner;
        data["agreeToSpousalConsentRequired"] = this.agreeToSpousalConsentRequired;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["originalSellerId"] = this.originalSellerId;
        return data;
    }
}

export interface ISellerDto {
    id?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    isCompanyOwned?: boolean;
    companyName?: string | undefined;
    preferredName?: string | undefined;
    citizenship?: string | undefined;
    residence?: string | undefined;
    birthDate?: Date | undefined;
    agreeToValidateIdentity?: boolean;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    residentAddress?: AddressDto | undefined;
    driverLicenseUrl?: string | undefined;
    passportMediaUrl?: string | undefined;
    agreeToDeclaration?: boolean;
    agreeToTermsAndConditions?: boolean;
    linkedUserId?: string | undefined;
    confirmedDateTimeUtc?: Date | undefined;
    sellerNo?: number;
    hasASpouseOrPartner?: boolean | undefined;
    agreeToSpousalConsentRequired?: boolean;
    profileImage?: ImageMediaDto | undefined;
    originalSellerId?: string | undefined;
}

export enum RealEstateType {
    Model = 0,
    Lot = 1,
    ModelAndLot = 2,
    Resale = 3,
}

export class PaginatedResultOfContactDto extends PaginatedResult implements IPaginatedResultOfContactDto {
    entities?: ContactDto[] | undefined;

    constructor(data?: IPaginatedResultOfContactDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ContactDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfContactDto extends IPaginatedResult {
    entities?: ContactDto[] | undefined;
}

export class ContactDto implements IContactDto {
    contactId?: string | undefined;
    entityInCommon?: string | undefined;
    entityInCommonId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberExtension?: string | undefined;
    contactRelationshipType?: ContactRelationshipType;
    subRelationship?: string | undefined;
    associatedProjects?: string[] | undefined;
    avatarImage?: ImageMediaDto | undefined;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.entityInCommon = _data["entityInCommon"];
            this.entityInCommonId = _data["entityInCommonId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.contactRelationshipType = _data["contactRelationshipType"];
            this.subRelationship = _data["subRelationship"];
            if (Array.isArray(_data["associatedProjects"])) {
                this.associatedProjects = [] as any;
                for (let item of _data["associatedProjects"])
                    this.associatedProjects!.push(item);
            }
            this.avatarImage = _data["avatarImage"] ? ImageMediaDto.fromJS(_data["avatarImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["entityInCommon"] = this.entityInCommon;
        data["entityInCommonId"] = this.entityInCommonId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["contactRelationshipType"] = this.contactRelationshipType;
        data["subRelationship"] = this.subRelationship;
        if (Array.isArray(this.associatedProjects)) {
            data["associatedProjects"] = [];
            for (let item of this.associatedProjects)
                data["associatedProjects"].push(item);
        }
        data["avatarImage"] = this.avatarImage ? this.avatarImage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactDto {
    contactId?: string | undefined;
    entityInCommon?: string | undefined;
    entityInCommonId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberExtension?: string | undefined;
    contactRelationshipType?: ContactRelationshipType;
    subRelationship?: string | undefined;
    associatedProjects?: string[] | undefined;
    avatarImage?: ImageMediaDto | undefined;
}

export enum ContactRelationshipType {
    CoPurchaser = 0,
    Broker = 1,
}

export class ConfigDto implements IConfigDto {
    environmentStage?: EnvironmentStage;
    adminApplication?: string | undefined;
    baseApplicationUrl?: string | undefined;

    constructor(data?: IConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environmentStage = _data["environmentStage"];
            this.adminApplication = _data["adminApplication"];
            this.baseApplicationUrl = _data["baseApplicationUrl"];
        }
    }

    static fromJS(data: any): ConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environmentStage"] = this.environmentStage;
        data["adminApplication"] = this.adminApplication;
        data["baseApplicationUrl"] = this.baseApplicationUrl;
        return data;
    }
}

export interface IConfigDto {
    environmentStage?: EnvironmentStage;
    adminApplication?: string | undefined;
    baseApplicationUrl?: string | undefined;
}

export enum EnvironmentStage {
    Local = 0,
    Development = 1,
    Test = 2,
    Demo = 3,
    Production = 4,
}

export class DealDto implements IDealDto {
    id?: string | undefined;
    selectedListingId?: number;
    totalDeposit?: number;
    depositPercent?: number | undefined;
    isDepositFixedAmount?: boolean;
    preferredLanguage?: LanguageType;
    paymentMethodType?: DealPaymentMethodType | undefined;
    unitSalePrice?: number;
    unitListingSalePrice?: number;
    upgradesSalePrice?: number;
    parkingSalePrice?: number;
    storageSalePrice?: number;
    salePrice?: number;
    reservationHold?: number | undefined;
    transactionFeePercentage?: number;
    transactionFee?: number;
    totalSalePrice?: number;
    isOnlineDepositPaid?: boolean;
    purchaserOrderNo?: number;
    confirmationNo?: number;
    canResetIdentityAndContract?: boolean;
    vendorExpirationAtDateTimeUtc?: Date | undefined;
    lastPurchaserSignedDateTimeUtc?: Date | undefined;
    possessionDate?: Date | undefined;
    closingDate?: Date | undefined;
    savedDateTimeUtc?: Date | undefined;
    lastSelectionMadeDateTimeUtc?: Date | undefined;
    isFinalizationStarted?: boolean;
    taxes?: DealTaxDto[] | undefined;
    purchasers?: PurchaserDto[] | undefined;
    selections?: any[] | undefined;
    documents?: DealDocumentLookupDto[] | undefined;
    firmDateTimeUtc?: Date | undefined;
    declinedDateTimeUtc?: Date | undefined;
    purchasersVerificationCode?: string | undefined;
    isIdentityProvidedByAllPurchasers?: boolean | undefined;
    isIdentityNameMatchingByAllPurchasers?: boolean | undefined;
    currentWorkflowSimpleStepGroup?: string | undefined;
    currentCompletedSimpleStep?: string | undefined;
    currentCompletedSimpleStepCount?: number;
    resetCount?: number;
    associatedSharedOpportunityId?: string | undefined;
    stripePaymentId?: string | undefined;
    finalizationExpiresAtDateTimeUtc?: Date | undefined;
    prospectAcceptanceExpiresAtDateTimeUtc?: Date | undefined;
    cancelledDateTimeUtc?: Date | undefined;
    collapsedDateTimeUtc?: Date | undefined;
    legalCancellationUntilDateTimeUtc?: Date | undefined;
    preApprovedPaymentMethodDetails?: PreApprovedPaymentMethodDetailsDto | undefined;
    lastCompletedStepDateTimeUtc?: Date | undefined;
    lastCompletedStep?: string | undefined;
    inclusions?: ListingContractItemDto[] | undefined;
    exclusions?: ListingContractItemDto[] | undefined;
    paymentError?: string | undefined;
    cashPaymentMethodDetails?: CashPaymentMethodDetailsDto | undefined;
    notPreApprovedPaymentDetails?: NotPreApprovedPaymentDetailsDto | undefined;
    parkingCount?: number;
    storageCount?: number;
    isUnitSoldToOtherDeal?: boolean;
    isUnitSoldToDeal?: boolean;
    isUnitReservedToOtherDeal?: boolean;
    isUnitReservedToDeal?: boolean;
    isContractGenerated?: boolean;
    isContractBeingGenerated?: boolean;
    isChangeRequestPending?: boolean;
    state?: DealState;
    listing?: NestedListingDto | undefined;
    depositDueDate?: Date;
    dueDiligenceDateUtc?: Date | undefined;
    financialDueDate?: Date | undefined;
    inspectionDueDate?: Date | undefined;
    saleOfHomeDueDate?: Date | undefined;
    ownershipDocsDueDate?: Date | undefined;
    acceptanceEmailSentDateTimeString?: string | undefined;
    skipPurchaseIdentityVerification?: boolean;
    skipContractGenerationAndSigning?: boolean;
    skipOnlineDeposit?: boolean;
    realEstateType?: RealEstateType;
    agreeToUseAndDisclosureOfCreditCard?: boolean;
    numberOfDaysForDueDiligence?: number;
    dueDiligenceExtended?: boolean | undefined;
    dueDiligenceExtendedReason?: string | undefined;
    numberOfDaysForDeposit?: number;
    numberOfDaysForFinancials?: number | undefined;
    numberOfDaysForInspection?: number | undefined;
    numberOfDaysForClosing?: number | undefined;
    numberOfDaysForTentativePossession?: number | undefined;
    additionalNotes?: string[] | undefined;
    rescissionPeriod?: number | undefined;
    rescissionDate?: Date | undefined;
    rescissionFeePercentage?: number | undefined;
    completionDateFormat?: CompletionDateFormat;
    fulfilmentConditions?: DealFulfilmentConditionsDto | undefined;
    dealCompany?: DealCompanyDto | undefined;
    depositStructures?: DepositStructureDto[] | undefined;

    constructor(data?: IDealDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selectedListingId = _data["selectedListingId"];
            this.totalDeposit = _data["totalDeposit"];
            this.depositPercent = _data["depositPercent"];
            this.isDepositFixedAmount = _data["isDepositFixedAmount"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.unitSalePrice = _data["unitSalePrice"];
            this.unitListingSalePrice = _data["unitListingSalePrice"];
            this.upgradesSalePrice = _data["upgradesSalePrice"];
            this.parkingSalePrice = _data["parkingSalePrice"];
            this.storageSalePrice = _data["storageSalePrice"];
            this.salePrice = _data["salePrice"];
            this.reservationHold = _data["reservationHold"];
            this.transactionFeePercentage = _data["transactionFeePercentage"];
            this.transactionFee = _data["transactionFee"];
            this.totalSalePrice = _data["totalSalePrice"];
            this.isOnlineDepositPaid = _data["isOnlineDepositPaid"];
            this.purchaserOrderNo = _data["purchaserOrderNo"];
            this.confirmationNo = _data["confirmationNo"];
            this.canResetIdentityAndContract = _data["canResetIdentityAndContract"];
            this.vendorExpirationAtDateTimeUtc = _data["vendorExpirationAtDateTimeUtc"] ? new Date(_data["vendorExpirationAtDateTimeUtc"].toString()) : <any>undefined;
            this.lastPurchaserSignedDateTimeUtc = _data["lastPurchaserSignedDateTimeUtc"] ? new Date(_data["lastPurchaserSignedDateTimeUtc"].toString()) : <any>undefined;
            this.possessionDate = _data["possessionDate"] ? new Date(_data["possessionDate"].toString()) : <any>undefined;
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.savedDateTimeUtc = _data["savedDateTimeUtc"] ? new Date(_data["savedDateTimeUtc"].toString()) : <any>undefined;
            this.lastSelectionMadeDateTimeUtc = _data["lastSelectionMadeDateTimeUtc"] ? new Date(_data["lastSelectionMadeDateTimeUtc"].toString()) : <any>undefined;
            this.isFinalizationStarted = _data["isFinalizationStarted"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(DealTaxDto.fromJS(item));
            }
            if (Array.isArray(_data["purchasers"])) {
                this.purchasers = [] as any;
                for (let item of _data["purchasers"])
                    this.purchasers!.push(PurchaserDto.fromJS(item));
            }
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections!.push(item);
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DealDocumentLookupDto.fromJS(item));
            }
            this.firmDateTimeUtc = _data["firmDateTimeUtc"] ? new Date(_data["firmDateTimeUtc"].toString()) : <any>undefined;
            this.declinedDateTimeUtc = _data["declinedDateTimeUtc"] ? new Date(_data["declinedDateTimeUtc"].toString()) : <any>undefined;
            this.purchasersVerificationCode = _data["purchasersVerificationCode"];
            this.isIdentityProvidedByAllPurchasers = _data["isIdentityProvidedByAllPurchasers"];
            this.isIdentityNameMatchingByAllPurchasers = _data["isIdentityNameMatchingByAllPurchasers"];
            this.currentWorkflowSimpleStepGroup = _data["currentWorkflowSimpleStepGroup"];
            this.currentCompletedSimpleStep = _data["currentCompletedSimpleStep"];
            this.currentCompletedSimpleStepCount = _data["currentCompletedSimpleStepCount"];
            this.resetCount = _data["resetCount"];
            this.associatedSharedOpportunityId = _data["associatedSharedOpportunityId"];
            this.stripePaymentId = _data["stripePaymentId"];
            this.finalizationExpiresAtDateTimeUtc = _data["finalizationExpiresAtDateTimeUtc"] ? new Date(_data["finalizationExpiresAtDateTimeUtc"].toString()) : <any>undefined;
            this.prospectAcceptanceExpiresAtDateTimeUtc = _data["prospectAcceptanceExpiresAtDateTimeUtc"] ? new Date(_data["prospectAcceptanceExpiresAtDateTimeUtc"].toString()) : <any>undefined;
            this.cancelledDateTimeUtc = _data["cancelledDateTimeUtc"] ? new Date(_data["cancelledDateTimeUtc"].toString()) : <any>undefined;
            this.collapsedDateTimeUtc = _data["collapsedDateTimeUtc"] ? new Date(_data["collapsedDateTimeUtc"].toString()) : <any>undefined;
            this.legalCancellationUntilDateTimeUtc = _data["legalCancellationUntilDateTimeUtc"] ? new Date(_data["legalCancellationUntilDateTimeUtc"].toString()) : <any>undefined;
            this.preApprovedPaymentMethodDetails = _data["preApprovedPaymentMethodDetails"] ? PreApprovedPaymentMethodDetailsDto.fromJS(_data["preApprovedPaymentMethodDetails"]) : <any>undefined;
            this.lastCompletedStepDateTimeUtc = _data["lastCompletedStepDateTimeUtc"] ? new Date(_data["lastCompletedStepDateTimeUtc"].toString()) : <any>undefined;
            this.lastCompletedStep = _data["lastCompletedStep"];
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions!.push(ListingContractItemDto.fromJS(item));
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions!.push(ListingContractItemDto.fromJS(item));
            }
            this.paymentError = _data["paymentError"];
            this.cashPaymentMethodDetails = _data["cashPaymentMethodDetails"] ? CashPaymentMethodDetailsDto.fromJS(_data["cashPaymentMethodDetails"]) : <any>undefined;
            this.notPreApprovedPaymentDetails = _data["notPreApprovedPaymentDetails"] ? NotPreApprovedPaymentDetailsDto.fromJS(_data["notPreApprovedPaymentDetails"]) : <any>undefined;
            this.parkingCount = _data["parkingCount"];
            this.storageCount = _data["storageCount"];
            this.isUnitSoldToOtherDeal = _data["isUnitSoldToOtherDeal"];
            this.isUnitSoldToDeal = _data["isUnitSoldToDeal"];
            this.isUnitReservedToOtherDeal = _data["isUnitReservedToOtherDeal"];
            this.isUnitReservedToDeal = _data["isUnitReservedToDeal"];
            this.isContractGenerated = _data["isContractGenerated"];
            this.isContractBeingGenerated = _data["isContractBeingGenerated"];
            this.isChangeRequestPending = _data["isChangeRequestPending"];
            this.state = _data["state"];
            this.listing = _data["listing"] ? NestedListingDto.fromJS(_data["listing"]) : <any>undefined;
            this.depositDueDate = _data["depositDueDate"] ? new Date(_data["depositDueDate"].toString()) : <any>undefined;
            this.dueDiligenceDateUtc = _data["dueDiligenceDateUtc"] ? new Date(_data["dueDiligenceDateUtc"].toString()) : <any>undefined;
            this.financialDueDate = _data["financialDueDate"] ? new Date(_data["financialDueDate"].toString()) : <any>undefined;
            this.inspectionDueDate = _data["inspectionDueDate"] ? new Date(_data["inspectionDueDate"].toString()) : <any>undefined;
            this.saleOfHomeDueDate = _data["saleOfHomeDueDate"] ? new Date(_data["saleOfHomeDueDate"].toString()) : <any>undefined;
            this.ownershipDocsDueDate = _data["ownershipDocsDueDate"] ? new Date(_data["ownershipDocsDueDate"].toString()) : <any>undefined;
            this.acceptanceEmailSentDateTimeString = _data["acceptanceEmailSentDateTimeString"];
            this.skipPurchaseIdentityVerification = _data["skipPurchaseIdentityVerification"];
            this.skipContractGenerationAndSigning = _data["skipContractGenerationAndSigning"];
            this.skipOnlineDeposit = _data["skipOnlineDeposit"];
            this.realEstateType = _data["realEstateType"];
            this.agreeToUseAndDisclosureOfCreditCard = _data["agreeToUseAndDisclosureOfCreditCard"];
            this.numberOfDaysForDueDiligence = _data["numberOfDaysForDueDiligence"];
            this.dueDiligenceExtended = _data["dueDiligenceExtended"];
            this.dueDiligenceExtendedReason = _data["dueDiligenceExtendedReason"];
            this.numberOfDaysForDeposit = _data["numberOfDaysForDeposit"];
            this.numberOfDaysForFinancials = _data["numberOfDaysForFinancials"];
            this.numberOfDaysForInspection = _data["numberOfDaysForInspection"];
            this.numberOfDaysForClosing = _data["numberOfDaysForClosing"];
            this.numberOfDaysForTentativePossession = _data["numberOfDaysForTentativePossession"];
            if (Array.isArray(_data["additionalNotes"])) {
                this.additionalNotes = [] as any;
                for (let item of _data["additionalNotes"])
                    this.additionalNotes!.push(item);
            }
            this.rescissionPeriod = _data["rescissionPeriod"];
            this.rescissionDate = _data["rescissionDate"] ? new Date(_data["rescissionDate"].toString()) : <any>undefined;
            this.rescissionFeePercentage = _data["rescissionFeePercentage"];
            this.completionDateFormat = _data["completionDateFormat"];
            this.fulfilmentConditions = _data["fulfilmentConditions"] ? DealFulfilmentConditionsDto.fromJS(_data["fulfilmentConditions"]) : <any>undefined;
            this.dealCompany = _data["dealCompany"] ? DealCompanyDto.fromJS(_data["dealCompany"]) : <any>undefined;
            if (Array.isArray(_data["depositStructures"])) {
                this.depositStructures = [] as any;
                for (let item of _data["depositStructures"])
                    this.depositStructures!.push(DepositStructureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selectedListingId"] = this.selectedListingId;
        data["totalDeposit"] = this.totalDeposit;
        data["depositPercent"] = this.depositPercent;
        data["isDepositFixedAmount"] = this.isDepositFixedAmount;
        data["preferredLanguage"] = this.preferredLanguage;
        data["paymentMethodType"] = this.paymentMethodType;
        data["unitSalePrice"] = this.unitSalePrice;
        data["unitListingSalePrice"] = this.unitListingSalePrice;
        data["upgradesSalePrice"] = this.upgradesSalePrice;
        data["parkingSalePrice"] = this.parkingSalePrice;
        data["storageSalePrice"] = this.storageSalePrice;
        data["salePrice"] = this.salePrice;
        data["reservationHold"] = this.reservationHold;
        data["transactionFeePercentage"] = this.transactionFeePercentage;
        data["transactionFee"] = this.transactionFee;
        data["totalSalePrice"] = this.totalSalePrice;
        data["isOnlineDepositPaid"] = this.isOnlineDepositPaid;
        data["purchaserOrderNo"] = this.purchaserOrderNo;
        data["confirmationNo"] = this.confirmationNo;
        data["canResetIdentityAndContract"] = this.canResetIdentityAndContract;
        data["vendorExpirationAtDateTimeUtc"] = this.vendorExpirationAtDateTimeUtc ? this.vendorExpirationAtDateTimeUtc.toISOString() : <any>undefined;
        data["lastPurchaserSignedDateTimeUtc"] = this.lastPurchaserSignedDateTimeUtc ? this.lastPurchaserSignedDateTimeUtc.toISOString() : <any>undefined;
        data["possessionDate"] = this.possessionDate ? this.possessionDate.toISOString() : <any>undefined;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["savedDateTimeUtc"] = this.savedDateTimeUtc ? this.savedDateTimeUtc.toISOString() : <any>undefined;
        data["lastSelectionMadeDateTimeUtc"] = this.lastSelectionMadeDateTimeUtc ? this.lastSelectionMadeDateTimeUtc.toISOString() : <any>undefined;
        data["isFinalizationStarted"] = this.isFinalizationStarted;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        if (Array.isArray(this.purchasers)) {
            data["purchasers"] = [];
            for (let item of this.purchasers)
                data["purchasers"].push(item.toJSON());
        }
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["firmDateTimeUtc"] = this.firmDateTimeUtc ? this.firmDateTimeUtc.toISOString() : <any>undefined;
        data["declinedDateTimeUtc"] = this.declinedDateTimeUtc ? this.declinedDateTimeUtc.toISOString() : <any>undefined;
        data["purchasersVerificationCode"] = this.purchasersVerificationCode;
        data["isIdentityProvidedByAllPurchasers"] = this.isIdentityProvidedByAllPurchasers;
        data["isIdentityNameMatchingByAllPurchasers"] = this.isIdentityNameMatchingByAllPurchasers;
        data["currentWorkflowSimpleStepGroup"] = this.currentWorkflowSimpleStepGroup;
        data["currentCompletedSimpleStep"] = this.currentCompletedSimpleStep;
        data["currentCompletedSimpleStepCount"] = this.currentCompletedSimpleStepCount;
        data["resetCount"] = this.resetCount;
        data["associatedSharedOpportunityId"] = this.associatedSharedOpportunityId;
        data["stripePaymentId"] = this.stripePaymentId;
        data["finalizationExpiresAtDateTimeUtc"] = this.finalizationExpiresAtDateTimeUtc ? this.finalizationExpiresAtDateTimeUtc.toISOString() : <any>undefined;
        data["prospectAcceptanceExpiresAtDateTimeUtc"] = this.prospectAcceptanceExpiresAtDateTimeUtc ? this.prospectAcceptanceExpiresAtDateTimeUtc.toISOString() : <any>undefined;
        data["cancelledDateTimeUtc"] = this.cancelledDateTimeUtc ? this.cancelledDateTimeUtc.toISOString() : <any>undefined;
        data["collapsedDateTimeUtc"] = this.collapsedDateTimeUtc ? this.collapsedDateTimeUtc.toISOString() : <any>undefined;
        data["legalCancellationUntilDateTimeUtc"] = this.legalCancellationUntilDateTimeUtc ? this.legalCancellationUntilDateTimeUtc.toISOString() : <any>undefined;
        data["preApprovedPaymentMethodDetails"] = this.preApprovedPaymentMethodDetails ? this.preApprovedPaymentMethodDetails.toJSON() : <any>undefined;
        data["lastCompletedStepDateTimeUtc"] = this.lastCompletedStepDateTimeUtc ? this.lastCompletedStepDateTimeUtc.toISOString() : <any>undefined;
        data["lastCompletedStep"] = this.lastCompletedStep;
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item.toJSON());
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item.toJSON());
        }
        data["paymentError"] = this.paymentError;
        data["cashPaymentMethodDetails"] = this.cashPaymentMethodDetails ? this.cashPaymentMethodDetails.toJSON() : <any>undefined;
        data["notPreApprovedPaymentDetails"] = this.notPreApprovedPaymentDetails ? this.notPreApprovedPaymentDetails.toJSON() : <any>undefined;
        data["parkingCount"] = this.parkingCount;
        data["storageCount"] = this.storageCount;
        data["isUnitSoldToOtherDeal"] = this.isUnitSoldToOtherDeal;
        data["isUnitSoldToDeal"] = this.isUnitSoldToDeal;
        data["isUnitReservedToOtherDeal"] = this.isUnitReservedToOtherDeal;
        data["isUnitReservedToDeal"] = this.isUnitReservedToDeal;
        data["isContractGenerated"] = this.isContractGenerated;
        data["isContractBeingGenerated"] = this.isContractBeingGenerated;
        data["isChangeRequestPending"] = this.isChangeRequestPending;
        data["state"] = this.state;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        data["depositDueDate"] = this.depositDueDate ? this.depositDueDate.toISOString() : <any>undefined;
        data["dueDiligenceDateUtc"] = this.dueDiligenceDateUtc ? this.dueDiligenceDateUtc.toISOString() : <any>undefined;
        data["financialDueDate"] = this.financialDueDate ? this.financialDueDate.toISOString() : <any>undefined;
        data["inspectionDueDate"] = this.inspectionDueDate ? this.inspectionDueDate.toISOString() : <any>undefined;
        data["saleOfHomeDueDate"] = this.saleOfHomeDueDate ? this.saleOfHomeDueDate.toISOString() : <any>undefined;
        data["ownershipDocsDueDate"] = this.ownershipDocsDueDate ? this.ownershipDocsDueDate.toISOString() : <any>undefined;
        data["acceptanceEmailSentDateTimeString"] = this.acceptanceEmailSentDateTimeString;
        data["skipPurchaseIdentityVerification"] = this.skipPurchaseIdentityVerification;
        data["skipContractGenerationAndSigning"] = this.skipContractGenerationAndSigning;
        data["skipOnlineDeposit"] = this.skipOnlineDeposit;
        data["realEstateType"] = this.realEstateType;
        data["agreeToUseAndDisclosureOfCreditCard"] = this.agreeToUseAndDisclosureOfCreditCard;
        data["numberOfDaysForDueDiligence"] = this.numberOfDaysForDueDiligence;
        data["dueDiligenceExtended"] = this.dueDiligenceExtended;
        data["dueDiligenceExtendedReason"] = this.dueDiligenceExtendedReason;
        data["numberOfDaysForDeposit"] = this.numberOfDaysForDeposit;
        data["numberOfDaysForFinancials"] = this.numberOfDaysForFinancials;
        data["numberOfDaysForInspection"] = this.numberOfDaysForInspection;
        data["numberOfDaysForClosing"] = this.numberOfDaysForClosing;
        data["numberOfDaysForTentativePossession"] = this.numberOfDaysForTentativePossession;
        if (Array.isArray(this.additionalNotes)) {
            data["additionalNotes"] = [];
            for (let item of this.additionalNotes)
                data["additionalNotes"].push(item);
        }
        data["rescissionPeriod"] = this.rescissionPeriod;
        data["rescissionDate"] = this.rescissionDate ? this.rescissionDate.toISOString() : <any>undefined;
        data["rescissionFeePercentage"] = this.rescissionFeePercentage;
        data["completionDateFormat"] = this.completionDateFormat;
        data["fulfilmentConditions"] = this.fulfilmentConditions ? this.fulfilmentConditions.toJSON() : <any>undefined;
        data["dealCompany"] = this.dealCompany ? this.dealCompany.toJSON() : <any>undefined;
        if (Array.isArray(this.depositStructures)) {
            data["depositStructures"] = [];
            for (let item of this.depositStructures)
                data["depositStructures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDealDto {
    id?: string | undefined;
    selectedListingId?: number;
    totalDeposit?: number;
    depositPercent?: number | undefined;
    isDepositFixedAmount?: boolean;
    preferredLanguage?: LanguageType;
    paymentMethodType?: DealPaymentMethodType | undefined;
    unitSalePrice?: number;
    unitListingSalePrice?: number;
    upgradesSalePrice?: number;
    parkingSalePrice?: number;
    storageSalePrice?: number;
    salePrice?: number;
    reservationHold?: number | undefined;
    transactionFeePercentage?: number;
    transactionFee?: number;
    totalSalePrice?: number;
    isOnlineDepositPaid?: boolean;
    purchaserOrderNo?: number;
    confirmationNo?: number;
    canResetIdentityAndContract?: boolean;
    vendorExpirationAtDateTimeUtc?: Date | undefined;
    lastPurchaserSignedDateTimeUtc?: Date | undefined;
    possessionDate?: Date | undefined;
    closingDate?: Date | undefined;
    savedDateTimeUtc?: Date | undefined;
    lastSelectionMadeDateTimeUtc?: Date | undefined;
    isFinalizationStarted?: boolean;
    taxes?: DealTaxDto[] | undefined;
    purchasers?: PurchaserDto[] | undefined;
    selections?: any[] | undefined;
    documents?: DealDocumentLookupDto[] | undefined;
    firmDateTimeUtc?: Date | undefined;
    declinedDateTimeUtc?: Date | undefined;
    purchasersVerificationCode?: string | undefined;
    isIdentityProvidedByAllPurchasers?: boolean | undefined;
    isIdentityNameMatchingByAllPurchasers?: boolean | undefined;
    currentWorkflowSimpleStepGroup?: string | undefined;
    currentCompletedSimpleStep?: string | undefined;
    currentCompletedSimpleStepCount?: number;
    resetCount?: number;
    associatedSharedOpportunityId?: string | undefined;
    stripePaymentId?: string | undefined;
    finalizationExpiresAtDateTimeUtc?: Date | undefined;
    prospectAcceptanceExpiresAtDateTimeUtc?: Date | undefined;
    cancelledDateTimeUtc?: Date | undefined;
    collapsedDateTimeUtc?: Date | undefined;
    legalCancellationUntilDateTimeUtc?: Date | undefined;
    preApprovedPaymentMethodDetails?: PreApprovedPaymentMethodDetailsDto | undefined;
    lastCompletedStepDateTimeUtc?: Date | undefined;
    lastCompletedStep?: string | undefined;
    inclusions?: ListingContractItemDto[] | undefined;
    exclusions?: ListingContractItemDto[] | undefined;
    paymentError?: string | undefined;
    cashPaymentMethodDetails?: CashPaymentMethodDetailsDto | undefined;
    notPreApprovedPaymentDetails?: NotPreApprovedPaymentDetailsDto | undefined;
    parkingCount?: number;
    storageCount?: number;
    isUnitSoldToOtherDeal?: boolean;
    isUnitSoldToDeal?: boolean;
    isUnitReservedToOtherDeal?: boolean;
    isUnitReservedToDeal?: boolean;
    isContractGenerated?: boolean;
    isContractBeingGenerated?: boolean;
    isChangeRequestPending?: boolean;
    state?: DealState;
    listing?: NestedListingDto | undefined;
    depositDueDate?: Date;
    dueDiligenceDateUtc?: Date | undefined;
    financialDueDate?: Date | undefined;
    inspectionDueDate?: Date | undefined;
    saleOfHomeDueDate?: Date | undefined;
    ownershipDocsDueDate?: Date | undefined;
    acceptanceEmailSentDateTimeString?: string | undefined;
    skipPurchaseIdentityVerification?: boolean;
    skipContractGenerationAndSigning?: boolean;
    skipOnlineDeposit?: boolean;
    realEstateType?: RealEstateType;
    agreeToUseAndDisclosureOfCreditCard?: boolean;
    numberOfDaysForDueDiligence?: number;
    dueDiligenceExtended?: boolean | undefined;
    dueDiligenceExtendedReason?: string | undefined;
    numberOfDaysForDeposit?: number;
    numberOfDaysForFinancials?: number | undefined;
    numberOfDaysForInspection?: number | undefined;
    numberOfDaysForClosing?: number | undefined;
    numberOfDaysForTentativePossession?: number | undefined;
    additionalNotes?: string[] | undefined;
    rescissionPeriod?: number | undefined;
    rescissionDate?: Date | undefined;
    rescissionFeePercentage?: number | undefined;
    completionDateFormat?: CompletionDateFormat;
    fulfilmentConditions?: DealFulfilmentConditionsDto | undefined;
    dealCompany?: DealCompanyDto | undefined;
    depositStructures?: DepositStructureDto[] | undefined;
}

export enum DealPaymentMethodType {
    PreApproved = 0,
    NotPreApproved = 1,
    Cash = 2,
}

export class DealTaxDto implements IDealTaxDto {
    no?: number;
    name?: string | undefined;
    percentage?: number;
    amount?: number;

    constructor(data?: IDealTaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.no = _data["no"];
            this.name = _data["name"];
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): DealTaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealTaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["name"] = this.name;
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IDealTaxDto {
    no?: number;
    name?: string | undefined;
    percentage?: number;
    amount?: number;
}

export class DealDocumentLookupDto implements IDealDocumentLookupDto {
    fileId?: string | undefined;
    category?: string | undefined;
    uploadedFileName?: string | undefined;

    constructor(data?: IDealDocumentLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.category = _data["category"];
            this.uploadedFileName = _data["uploadedFileName"];
        }
    }

    static fromJS(data: any): DealDocumentLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealDocumentLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["category"] = this.category;
        data["uploadedFileName"] = this.uploadedFileName;
        return data;
    }
}

export interface IDealDocumentLookupDto {
    fileId?: string | undefined;
    category?: string | undefined;
    uploadedFileName?: string | undefined;
}

export class PreApprovedPaymentMethodDetailsDto implements IPreApprovedPaymentMethodDetailsDto {
    financialInstitution?: string | undefined;
    approvalAmount?: number;
    preapprovalExpireDate?: Date | undefined;
    financingAdvisorName?: string | undefined;
    financingAdvisorEmail?: string | undefined;
    financingAdvisorContactPhoneNumber?: string | undefined;
    preApprovalLetterDocumentId?: string | undefined;

    constructor(data?: IPreApprovedPaymentMethodDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialInstitution = _data["financialInstitution"];
            this.approvalAmount = _data["approvalAmount"];
            this.preapprovalExpireDate = _data["preapprovalExpireDate"] ? new Date(_data["preapprovalExpireDate"].toString()) : <any>undefined;
            this.financingAdvisorName = _data["financingAdvisorName"];
            this.financingAdvisorEmail = _data["financingAdvisorEmail"];
            this.financingAdvisorContactPhoneNumber = _data["financingAdvisorContactPhoneNumber"];
            this.preApprovalLetterDocumentId = _data["preApprovalLetterDocumentId"];
        }
    }

    static fromJS(data: any): PreApprovedPaymentMethodDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreApprovedPaymentMethodDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialInstitution"] = this.financialInstitution;
        data["approvalAmount"] = this.approvalAmount;
        data["preapprovalExpireDate"] = this.preapprovalExpireDate ? this.preapprovalExpireDate.toISOString() : <any>undefined;
        data["financingAdvisorName"] = this.financingAdvisorName;
        data["financingAdvisorEmail"] = this.financingAdvisorEmail;
        data["financingAdvisorContactPhoneNumber"] = this.financingAdvisorContactPhoneNumber;
        data["preApprovalLetterDocumentId"] = this.preApprovalLetterDocumentId;
        return data;
    }
}

export interface IPreApprovedPaymentMethodDetailsDto {
    financialInstitution?: string | undefined;
    approvalAmount?: number;
    preapprovalExpireDate?: Date | undefined;
    financingAdvisorName?: string | undefined;
    financingAdvisorEmail?: string | undefined;
    financingAdvisorContactPhoneNumber?: string | undefined;
    preApprovalLetterDocumentId?: string | undefined;
}

export class ListingContractItemDto implements IListingContractItemDto {
    name?: string | undefined;
    location?: string | undefined;
    isSelected?: boolean;

    constructor(data?: IListingContractItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.location = _data["location"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ListingContractItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["location"] = this.location;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IListingContractItemDto {
    name?: string | undefined;
    location?: string | undefined;
    isSelected?: boolean;
}

export class CashPaymentMethodDetailsDto implements ICashPaymentMethodDetailsDto {
    financialInstitution?: string | undefined;
    approvalAmount?: number;
    dateOfLetter?: Date;
    financialInstitutionContact?: string | undefined;
    financialInstitutionEmail?: string | undefined;
    financialInstitutionContactPhoneNumber?: string | undefined;
    proofOfFundsLetterDocumentId?: string | undefined;
    financialInstitutionContactPhoneNumberExtension?: string | undefined;

    constructor(data?: ICashPaymentMethodDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialInstitution = _data["financialInstitution"];
            this.approvalAmount = _data["approvalAmount"];
            this.dateOfLetter = _data["dateOfLetter"] ? new Date(_data["dateOfLetter"].toString()) : <any>undefined;
            this.financialInstitutionContact = _data["financialInstitutionContact"];
            this.financialInstitutionEmail = _data["financialInstitutionEmail"];
            this.financialInstitutionContactPhoneNumber = _data["financialInstitutionContactPhoneNumber"];
            this.proofOfFundsLetterDocumentId = _data["proofOfFundsLetterDocumentId"];
            this.financialInstitutionContactPhoneNumberExtension = _data["financialInstitutionContactPhoneNumberExtension"];
        }
    }

    static fromJS(data: any): CashPaymentMethodDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashPaymentMethodDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialInstitution"] = this.financialInstitution;
        data["approvalAmount"] = this.approvalAmount;
        data["dateOfLetter"] = this.dateOfLetter ? this.dateOfLetter.toISOString() : <any>undefined;
        data["financialInstitutionContact"] = this.financialInstitutionContact;
        data["financialInstitutionEmail"] = this.financialInstitutionEmail;
        data["financialInstitutionContactPhoneNumber"] = this.financialInstitutionContactPhoneNumber;
        data["proofOfFundsLetterDocumentId"] = this.proofOfFundsLetterDocumentId;
        data["financialInstitutionContactPhoneNumberExtension"] = this.financialInstitutionContactPhoneNumberExtension;
        return data;
    }
}

export interface ICashPaymentMethodDetailsDto {
    financialInstitution?: string | undefined;
    approvalAmount?: number;
    dateOfLetter?: Date;
    financialInstitutionContact?: string | undefined;
    financialInstitutionEmail?: string | undefined;
    financialInstitutionContactPhoneNumber?: string | undefined;
    proofOfFundsLetterDocumentId?: string | undefined;
    financialInstitutionContactPhoneNumberExtension?: string | undefined;
}

export class NotPreApprovedPaymentDetailsDto implements INotPreApprovedPaymentDetailsDto {

    constructor(data?: INotPreApprovedPaymentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): NotPreApprovedPaymentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotPreApprovedPaymentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface INotPreApprovedPaymentDetailsDto {
}

export enum CompletionDateFormat {
    Period = 0,
    Date = 1,
}

export class DealFulfilmentConditionsDto implements IDealFulfilmentConditionsDto {
    financing?: boolean;
    inspection?: boolean;
    waterTests?: boolean;
    reviewOfCoOwnershipDocuments?: boolean;
    visitOfDwellingsAndReviewOfLeases?: boolean;
    saleOfBuyersProperty?: boolean;
    additionalConditions?: boolean[] | undefined;

    constructor(data?: IDealFulfilmentConditionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financing = _data["financing"];
            this.inspection = _data["inspection"];
            this.waterTests = _data["waterTests"];
            this.reviewOfCoOwnershipDocuments = _data["reviewOfCoOwnershipDocuments"];
            this.visitOfDwellingsAndReviewOfLeases = _data["visitOfDwellingsAndReviewOfLeases"];
            this.saleOfBuyersProperty = _data["saleOfBuyersProperty"];
            if (Array.isArray(_data["additionalConditions"])) {
                this.additionalConditions = [] as any;
                for (let item of _data["additionalConditions"])
                    this.additionalConditions!.push(item);
            }
        }
    }

    static fromJS(data: any): DealFulfilmentConditionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealFulfilmentConditionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financing"] = this.financing;
        data["inspection"] = this.inspection;
        data["waterTests"] = this.waterTests;
        data["reviewOfCoOwnershipDocuments"] = this.reviewOfCoOwnershipDocuments;
        data["visitOfDwellingsAndReviewOfLeases"] = this.visitOfDwellingsAndReviewOfLeases;
        data["saleOfBuyersProperty"] = this.saleOfBuyersProperty;
        if (Array.isArray(this.additionalConditions)) {
            data["additionalConditions"] = [];
            for (let item of this.additionalConditions)
                data["additionalConditions"].push(item);
        }
        return data;
    }
}

export interface IDealFulfilmentConditionsDto {
    financing?: boolean;
    inspection?: boolean;
    waterTests?: boolean;
    reviewOfCoOwnershipDocuments?: boolean;
    visitOfDwellingsAndReviewOfLeases?: boolean;
    saleOfBuyersProperty?: boolean;
    additionalConditions?: boolean[] | undefined;
}

export class DealCompanyDto implements IDealCompanyDto {
    companyName?: string | undefined;
    companyAddress?: AddressDto | undefined;

    constructor(data?: IDealCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.companyAddress = _data["companyAddress"] ? AddressDto.fromJS(_data["companyAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DealCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["companyAddress"] = this.companyAddress ? this.companyAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDealCompanyDto {
    companyName?: string | undefined;
    companyAddress?: AddressDto | undefined;
}

export class DepositStructureDto implements IDepositStructureDto {
    no?: number;
    depositPercentage?: number | undefined;
    depositAmount?: number | undefined;
    dueDateDuration?: number | undefined;
    dueDateDurationUnit?: DueDateDurationUnit | undefined;
    dueDate?: Date | undefined;
    paymentTypes?: string[] | undefined;
    isRefundable?: boolean | undefined;

    constructor(data?: IDepositStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.no = _data["no"];
            this.depositPercentage = _data["depositPercentage"];
            this.depositAmount = _data["depositAmount"];
            this.dueDateDuration = _data["dueDateDuration"];
            this.dueDateDurationUnit = _data["dueDateDurationUnit"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["paymentTypes"])) {
                this.paymentTypes = [] as any;
                for (let item of _data["paymentTypes"])
                    this.paymentTypes!.push(item);
            }
            this.isRefundable = _data["isRefundable"];
        }
    }

    static fromJS(data: any): DepositStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepositStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["depositPercentage"] = this.depositPercentage;
        data["depositAmount"] = this.depositAmount;
        data["dueDateDuration"] = this.dueDateDuration;
        data["dueDateDurationUnit"] = this.dueDateDurationUnit;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        if (Array.isArray(this.paymentTypes)) {
            data["paymentTypes"] = [];
            for (let item of this.paymentTypes)
                data["paymentTypes"].push(item);
        }
        data["isRefundable"] = this.isRefundable;
        return data;
    }
}

export interface IDepositStructureDto {
    no?: number;
    depositPercentage?: number | undefined;
    depositAmount?: number | undefined;
    dueDateDuration?: number | undefined;
    dueDateDurationUnit?: DueDateDurationUnit | undefined;
    dueDate?: Date | undefined;
    paymentTypes?: string[] | undefined;
    isRefundable?: boolean | undefined;
}

export enum DueDateDurationUnit {
    Days = 0,
    Weeks = 1,
    Months = 2,
    Years = 3,
}

export class DealCancellationDto implements IDealCancellationDto {
    conditionsForCancellation?: CancellationReason[] | undefined;
    detailedReason?: string | undefined;

    constructor(data?: IDealCancellationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditionsForCancellation"])) {
                this.conditionsForCancellation = [] as any;
                for (let item of _data["conditionsForCancellation"])
                    this.conditionsForCancellation!.push(item);
            }
            this.detailedReason = _data["detailedReason"];
        }
    }

    static fromJS(data: any): DealCancellationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealCancellationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditionsForCancellation)) {
            data["conditionsForCancellation"] = [];
            for (let item of this.conditionsForCancellation)
                data["conditionsForCancellation"].push(item);
        }
        data["detailedReason"] = this.detailedReason;
        return data;
    }
}

export interface IDealCancellationDto {
    conditionsForCancellation?: CancellationReason[] | undefined;
    detailedReason?: string | undefined;
}

export class UpdateDealCancellationCommand implements IUpdateDealCancellationCommand {
    conditionsForCancellation?: CancellationReason[] | undefined;
    detailedReason?: string | undefined;

    constructor(data?: IUpdateDealCancellationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditionsForCancellation"])) {
                this.conditionsForCancellation = [] as any;
                for (let item of _data["conditionsForCancellation"])
                    this.conditionsForCancellation!.push(item);
            }
            this.detailedReason = _data["detailedReason"];
        }
    }

    static fromJS(data: any): UpdateDealCancellationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDealCancellationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditionsForCancellation)) {
            data["conditionsForCancellation"] = [];
            for (let item of this.conditionsForCancellation)
                data["conditionsForCancellation"].push(item);
        }
        data["detailedReason"] = this.detailedReason;
        return data;
    }
}

export interface IUpdateDealCancellationCommand {
    conditionsForCancellation?: CancellationReason[] | undefined;
    detailedReason?: string | undefined;
}

export class StartDealCancellationCommand implements IStartDealCancellationCommand {

    constructor(data?: IStartDealCancellationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StartDealCancellationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StartDealCancellationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IStartDealCancellationCommand {
}

export class StartSigningDealCommand implements IStartSigningDealCommand {

    constructor(data?: IStartSigningDealCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StartSigningDealCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StartSigningDealCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IStartSigningDealCommand {
}

export class StartFulfillmentSigningCommand implements IStartFulfillmentSigningCommand {

    constructor(data?: IStartFulfillmentSigningCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StartFulfillmentSigningCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StartFulfillmentSigningCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IStartFulfillmentSigningCommand {
}

export class ResetDealToPendingBuyerSignatureCommand implements IResetDealToPendingBuyerSignatureCommand {

    constructor(data?: IResetDealToPendingBuyerSignatureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ResetDealToPendingBuyerSignatureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetDealToPendingBuyerSignatureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IResetDealToPendingBuyerSignatureCommand {
}

export class BaseDealCommand implements IBaseDealCommand {
    preferredLanguage?: LanguageType;

    constructor(data?: IBaseDealCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredLanguage = _data["preferredLanguage"];
        }
    }

    static fromJS(data: any): BaseDealCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BaseDealCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredLanguage"] = this.preferredLanguage;
        return data;
    }
}

export interface IBaseDealCommand {
    preferredLanguage?: LanguageType;
}

export class EditDealCommand extends BaseDealCommand implements IEditDealCommand {
    dealId?: string | undefined;
    purchaserEntryCompleted?: boolean;
    selectionsCompleted?: boolean;
    selectedListingId?: number | undefined;

    constructor(data?: IEditDealCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dealId = _data["dealId"];
            this.purchaserEntryCompleted = _data["purchaserEntryCompleted"];
            this.selectionsCompleted = _data["selectionsCompleted"];
            this.selectedListingId = _data["selectedListingId"];
        }
    }

    static fromJS(data: any): EditDealCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditDealCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["purchaserEntryCompleted"] = this.purchaserEntryCompleted;
        data["selectionsCompleted"] = this.selectionsCompleted;
        data["selectedListingId"] = this.selectedListingId;
        super.toJSON(data);
        return data;
    }
}

export interface IEditDealCommand extends IBaseDealCommand {
    dealId?: string | undefined;
    purchaserEntryCompleted?: boolean;
    selectionsCompleted?: boolean;
    selectedListingId?: number | undefined;
}

export class UpdateDealFulfilmentConditionsCommand implements IUpdateDealFulfilmentConditionsCommand {
    financing?: boolean;
    inspection?: boolean;
    waterTests?: boolean;
    reviewOfCoOwnershipDocuments?: boolean;
    visitOfDwellingsAndReviewOfLeases?: boolean;
    saleOfBuyersProperty?: boolean;
    additionalConditions?: boolean[] | undefined;

    constructor(data?: IUpdateDealFulfilmentConditionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financing = _data["financing"];
            this.inspection = _data["inspection"];
            this.waterTests = _data["waterTests"];
            this.reviewOfCoOwnershipDocuments = _data["reviewOfCoOwnershipDocuments"];
            this.visitOfDwellingsAndReviewOfLeases = _data["visitOfDwellingsAndReviewOfLeases"];
            this.saleOfBuyersProperty = _data["saleOfBuyersProperty"];
            if (Array.isArray(_data["additionalConditions"])) {
                this.additionalConditions = [] as any;
                for (let item of _data["additionalConditions"])
                    this.additionalConditions!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateDealFulfilmentConditionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDealFulfilmentConditionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financing"] = this.financing;
        data["inspection"] = this.inspection;
        data["waterTests"] = this.waterTests;
        data["reviewOfCoOwnershipDocuments"] = this.reviewOfCoOwnershipDocuments;
        data["visitOfDwellingsAndReviewOfLeases"] = this.visitOfDwellingsAndReviewOfLeases;
        data["saleOfBuyersProperty"] = this.saleOfBuyersProperty;
        if (Array.isArray(this.additionalConditions)) {
            data["additionalConditions"] = [];
            for (let item of this.additionalConditions)
                data["additionalConditions"].push(item);
        }
        return data;
    }
}

export interface IUpdateDealFulfilmentConditionsCommand {
    financing?: boolean;
    inspection?: boolean;
    waterTests?: boolean;
    reviewOfCoOwnershipDocuments?: boolean;
    visitOfDwellingsAndReviewOfLeases?: boolean;
    saleOfBuyersProperty?: boolean;
    additionalConditions?: boolean[] | undefined;
}

export class SetDealAsNotPreApprovedPaymentMethodCommand implements ISetDealAsNotPreApprovedPaymentMethodCommand {
    dealId?: string | undefined;

    constructor(data?: ISetDealAsNotPreApprovedPaymentMethodCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
        }
    }

    static fromJS(data: any): SetDealAsNotPreApprovedPaymentMethodCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDealAsNotPreApprovedPaymentMethodCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        return data;
    }
}

export interface ISetDealAsNotPreApprovedPaymentMethodCommand {
    dealId?: string | undefined;
}

export class SetDealAsCashPaymentMethodCommand implements ISetDealAsCashPaymentMethodCommand {
    dealId?: string | undefined;
    financialInstitution?: string | undefined;
    approvalAmount?: number;
    dateOfLetter?: Date;
    financialInstitutionContact?: string | undefined;
    financialInstitutionEmail?: string | undefined;
    financialInstitutionContactPhoneNumber?: string | undefined;
    financialInstitutionContactPhoneNumberExtension?: string | undefined;
    proofOfFundsLetterDocumentId?: string | undefined;

    constructor(data?: ISetDealAsCashPaymentMethodCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.financialInstitution = _data["financialInstitution"];
            this.approvalAmount = _data["approvalAmount"];
            this.dateOfLetter = _data["dateOfLetter"] ? new Date(_data["dateOfLetter"].toString()) : <any>undefined;
            this.financialInstitutionContact = _data["financialInstitutionContact"];
            this.financialInstitutionEmail = _data["financialInstitutionEmail"];
            this.financialInstitutionContactPhoneNumber = _data["financialInstitutionContactPhoneNumber"];
            this.financialInstitutionContactPhoneNumberExtension = _data["financialInstitutionContactPhoneNumberExtension"];
            this.proofOfFundsLetterDocumentId = _data["proofOfFundsLetterDocumentId"];
        }
    }

    static fromJS(data: any): SetDealAsCashPaymentMethodCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDealAsCashPaymentMethodCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["financialInstitution"] = this.financialInstitution;
        data["approvalAmount"] = this.approvalAmount;
        data["dateOfLetter"] = this.dateOfLetter ? this.dateOfLetter.toISOString() : <any>undefined;
        data["financialInstitutionContact"] = this.financialInstitutionContact;
        data["financialInstitutionEmail"] = this.financialInstitutionEmail;
        data["financialInstitutionContactPhoneNumber"] = this.financialInstitutionContactPhoneNumber;
        data["financialInstitutionContactPhoneNumberExtension"] = this.financialInstitutionContactPhoneNumberExtension;
        data["proofOfFundsLetterDocumentId"] = this.proofOfFundsLetterDocumentId;
        return data;
    }
}

export interface ISetDealAsCashPaymentMethodCommand {
    dealId?: string | undefined;
    financialInstitution?: string | undefined;
    approvalAmount?: number;
    dateOfLetter?: Date;
    financialInstitutionContact?: string | undefined;
    financialInstitutionEmail?: string | undefined;
    financialInstitutionContactPhoneNumber?: string | undefined;
    financialInstitutionContactPhoneNumberExtension?: string | undefined;
    proofOfFundsLetterDocumentId?: string | undefined;
}

export class SetDealAsPreApprovedPaymentMethodCommand implements ISetDealAsPreApprovedPaymentMethodCommand {
    preApprovalLetterDocumentId?: string | undefined;
    financialInstitution?: string | undefined;
    approvalAmount?: number;
    preapprovalExpireDate?: Date | undefined;
    financingAdvisorName?: string | undefined;
    financingAdvisorEmail?: string | undefined;
    financingAdvisorContactPhoneNumber?: string | undefined;
    dealId?: string | undefined;

    constructor(data?: ISetDealAsPreApprovedPaymentMethodCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preApprovalLetterDocumentId = _data["preApprovalLetterDocumentId"];
            this.financialInstitution = _data["financialInstitution"];
            this.approvalAmount = _data["approvalAmount"];
            this.preapprovalExpireDate = _data["preapprovalExpireDate"] ? new Date(_data["preapprovalExpireDate"].toString()) : <any>undefined;
            this.financingAdvisorName = _data["financingAdvisorName"];
            this.financingAdvisorEmail = _data["financingAdvisorEmail"];
            this.financingAdvisorContactPhoneNumber = _data["financingAdvisorContactPhoneNumber"];
            this.dealId = _data["dealId"];
        }
    }

    static fromJS(data: any): SetDealAsPreApprovedPaymentMethodCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDealAsPreApprovedPaymentMethodCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preApprovalLetterDocumentId"] = this.preApprovalLetterDocumentId;
        data["financialInstitution"] = this.financialInstitution;
        data["approvalAmount"] = this.approvalAmount;
        data["preapprovalExpireDate"] = this.preapprovalExpireDate ? this.preapprovalExpireDate.toISOString() : <any>undefined;
        data["financingAdvisorName"] = this.financingAdvisorName;
        data["financingAdvisorEmail"] = this.financingAdvisorEmail;
        data["financingAdvisorContactPhoneNumber"] = this.financingAdvisorContactPhoneNumber;
        data["dealId"] = this.dealId;
        return data;
    }
}

export interface ISetDealAsPreApprovedPaymentMethodCommand {
    preApprovalLetterDocumentId?: string | undefined;
    financialInstitution?: string | undefined;
    approvalAmount?: number;
    preapprovalExpireDate?: Date | undefined;
    financingAdvisorName?: string | undefined;
    financingAdvisorEmail?: string | undefined;
    financingAdvisorContactPhoneNumber?: string | undefined;
    dealId?: string | undefined;
}

export class InvitePurchaserCommand implements IInvitePurchaserCommand {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: LanguageType;

    constructor(data?: IInvitePurchaserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): InvitePurchaserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InvitePurchaserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["language"] = this.language;
        return data;
    }
}

export interface IInvitePurchaserCommand {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: LanguageType;
}

export class BaseDealPurchaserCommand implements IBaseDealPurchaserCommand {
    relationshipWithOtherPurchaser?: PurchaserRelationship | undefined;
    preferredName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    pronoun?: string | undefined;
    cellPhoneNumber?: string | undefined;
    phoneNumber?: string | undefined;
    birthDate?: Date;
    residentAddress?: AddressInput | undefined;
    employmentIndustry?: string | undefined;
    employerName?: string | undefined;
    jobTitle?: string | undefined;
    isFirstTimeHomeBuyer?: boolean;
    isPrincipalResidence?: boolean;
    hasPurchasedFromPrestiBefore?: boolean;
    countryOfResidencyOrCitizenship?: string | undefined;
    isPendingApproval?: boolean;
    isPurchasingAsCorporation?: boolean;
    companyName?: string | undefined;
    companyAddress?: AddressInput | undefined;

    constructor(data?: IBaseDealPurchaserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relationshipWithOtherPurchaser = _data["relationshipWithOtherPurchaser"];
            this.preferredName = _data["preferredName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.pronoun = _data["pronoun"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.residentAddress = _data["residentAddress"] ? AddressInput.fromJS(_data["residentAddress"]) : <any>undefined;
            this.employmentIndustry = _data["employmentIndustry"];
            this.employerName = _data["employerName"];
            this.jobTitle = _data["jobTitle"];
            this.isFirstTimeHomeBuyer = _data["isFirstTimeHomeBuyer"];
            this.isPrincipalResidence = _data["isPrincipalResidence"];
            this.hasPurchasedFromPrestiBefore = _data["hasPurchasedFromPrestiBefore"];
            this.countryOfResidencyOrCitizenship = _data["countryOfResidencyOrCitizenship"];
            this.isPendingApproval = _data["isPendingApproval"];
            this.isPurchasingAsCorporation = _data["isPurchasingAsCorporation"];
            this.companyName = _data["companyName"];
            this.companyAddress = _data["companyAddress"] ? AddressInput.fromJS(_data["companyAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseDealPurchaserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BaseDealPurchaserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relationshipWithOtherPurchaser"] = this.relationshipWithOtherPurchaser;
        data["preferredName"] = this.preferredName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["pronoun"] = this.pronoun;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["residentAddress"] = this.residentAddress ? this.residentAddress.toJSON() : <any>undefined;
        data["employmentIndustry"] = this.employmentIndustry;
        data["employerName"] = this.employerName;
        data["jobTitle"] = this.jobTitle;
        data["isFirstTimeHomeBuyer"] = this.isFirstTimeHomeBuyer;
        data["isPrincipalResidence"] = this.isPrincipalResidence;
        data["hasPurchasedFromPrestiBefore"] = this.hasPurchasedFromPrestiBefore;
        data["countryOfResidencyOrCitizenship"] = this.countryOfResidencyOrCitizenship;
        data["isPendingApproval"] = this.isPendingApproval;
        data["isPurchasingAsCorporation"] = this.isPurchasingAsCorporation;
        data["companyName"] = this.companyName;
        data["companyAddress"] = this.companyAddress ? this.companyAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseDealPurchaserCommand {
    relationshipWithOtherPurchaser?: PurchaserRelationship | undefined;
    preferredName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    pronoun?: string | undefined;
    cellPhoneNumber?: string | undefined;
    phoneNumber?: string | undefined;
    birthDate?: Date;
    residentAddress?: AddressInput | undefined;
    employmentIndustry?: string | undefined;
    employerName?: string | undefined;
    jobTitle?: string | undefined;
    isFirstTimeHomeBuyer?: boolean;
    isPrincipalResidence?: boolean;
    hasPurchasedFromPrestiBefore?: boolean;
    countryOfResidencyOrCitizenship?: string | undefined;
    isPendingApproval?: boolean;
    isPurchasingAsCorporation?: boolean;
    companyName?: string | undefined;
    companyAddress?: AddressInput | undefined;
}

export class CreateDealPurchaserCommand extends BaseDealPurchaserCommand implements ICreateDealPurchaserCommand {

    constructor(data?: ICreateDealPurchaserCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateDealPurchaserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDealPurchaserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDealPurchaserCommand extends IBaseDealPurchaserCommand {
}

export class UpdateDealCompletedStepCommand implements IUpdateDealCompletedStepCommand {
    lastCompletedStep?: string | undefined;

    constructor(data?: IUpdateDealCompletedStepCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastCompletedStep = _data["lastCompletedStep"];
        }
    }

    static fromJS(data: any): UpdateDealCompletedStepCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDealCompletedStepCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastCompletedStep"] = this.lastCompletedStep;
        return data;
    }
}

export interface IUpdateDealCompletedStepCommand {
    lastCompletedStep?: string | undefined;
}

export class AgreeToContractSectionCommand implements IAgreeToContractSectionCommand {
    contractSectionType?: ContractSectionType;

    constructor(data?: IAgreeToContractSectionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractSectionType = _data["contractSectionType"];
        }
    }

    static fromJS(data: any): AgreeToContractSectionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AgreeToContractSectionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractSectionType"] = this.contractSectionType;
        return data;
    }
}

export interface IAgreeToContractSectionCommand {
    contractSectionType?: ContractSectionType;
}

export enum ContractSectionType {
    SaleSummary = 0,
    SaleTermsAndConditions = 1,
    SalePropertyListing = 2,
    SaleSellersDeclaration = 3,
    SaleSignatures = 4,
    SaleWatermarkedContract = 5,
    SaleIdentityVerification = 6,
    SaleCombined = 7,
    CancellationMainDocument = 8,
    CancellationSignatures = 9,
    CancellationIdentityVerification = 10,
    CancellationCombined = 11,
    FulfillmentMainDocument = 12,
    FulfillmentSignatures = 13,
    FulfillmentIdentityVerification = 14,
    FulfillmentCombined = 15,
    AmendmentMainDocument = 16,
    AmendmentSignatures = 17,
    AmendmentIdentityVerification = 18,
    AmendmentCombined = 19,
    SaleAppendix = 20,
}

export class SendWatermarkedContractCommand implements ISendWatermarkedContractCommand {
    receiverFirstName?: string | undefined;
    receiverLastName?: string | undefined;
    receiverName?: string | undefined;
    receiverEmail?: string | undefined;
    contractType?: ContractType;

    constructor(data?: ISendWatermarkedContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiverFirstName = _data["receiverFirstName"];
            this.receiverLastName = _data["receiverLastName"];
            this.receiverName = _data["receiverName"];
            this.receiverEmail = _data["receiverEmail"];
            this.contractType = _data["contractType"];
        }
    }

    static fromJS(data: any): SendWatermarkedContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendWatermarkedContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverFirstName"] = this.receiverFirstName;
        data["receiverLastName"] = this.receiverLastName;
        data["receiverName"] = this.receiverName;
        data["receiverEmail"] = this.receiverEmail;
        data["contractType"] = this.contractType;
        return data;
    }
}

export interface ISendWatermarkedContractCommand {
    receiverFirstName?: string | undefined;
    receiverLastName?: string | undefined;
    receiverName?: string | undefined;
    receiverEmail?: string | undefined;
    contractType?: ContractType;
}

export class DepositResult implements IDepositResult {
    paymentIntent?: PaymentIntentOutput | undefined;

    constructor(data?: IDepositResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentIntent = _data["paymentIntent"] ? PaymentIntentOutput.fromJS(_data["paymentIntent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DepositResult {
        data = typeof data === 'object' ? data : {};
        let result = new DepositResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentIntent"] = this.paymentIntent ? this.paymentIntent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDepositResult {
    paymentIntent?: PaymentIntentOutput | undefined;
}

export class PaymentIntentOutput implements IPaymentIntentOutput {
    clientSecret?: string | undefined;
    id?: string | undefined;
    status?: StripePaymentIntentStatus;

    constructor(data?: IPaymentIntentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecret = _data["clientSecret"];
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PaymentIntentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentIntentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecret"] = this.clientSecret;
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IPaymentIntentOutput {
    clientSecret?: string | undefined;
    id?: string | undefined;
    status?: StripePaymentIntentStatus;
}

export enum StripePaymentIntentStatus {
    RequiresPaymentMethod = 0,
    RequiresConfirmation = 1,
    RequiresAction = 2,
    Processing = 3,
    RequiresCapture = 4,
    Canceled = 5,
    Succeeded = 6,
}

export class CreateDealDepositCommand implements ICreateDealDepositCommand {
    dealId?: string | undefined;
    agreeToUseAndDisclosureOfCreditCard?: boolean;
    culture?: string | undefined;

    constructor(data?: ICreateDealDepositCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.agreeToUseAndDisclosureOfCreditCard = _data["agreeToUseAndDisclosureOfCreditCard"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): CreateDealDepositCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDealDepositCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["agreeToUseAndDisclosureOfCreditCard"] = this.agreeToUseAndDisclosureOfCreditCard;
        data["culture"] = this.culture;
        return data;
    }
}

export interface ICreateDealDepositCommand {
    dealId?: string | undefined;
    agreeToUseAndDisclosureOfCreditCard?: boolean;
    culture?: string | undefined;
}

export class UpdateDealPaymentStatusResult implements IUpdateDealPaymentStatusResult {
    paymentIntentId?: string | undefined;
    status?: StripePaymentIntentStatus;
    statusString?: string | undefined;
    paymentSucceeded?: boolean;
    message?: string | undefined;

    constructor(data?: IUpdateDealPaymentStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentIntentId = _data["paymentIntentId"];
            this.status = _data["status"];
            this.statusString = _data["statusString"];
            this.paymentSucceeded = _data["paymentSucceeded"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UpdateDealPaymentStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDealPaymentStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentIntentId"] = this.paymentIntentId;
        data["status"] = this.status;
        data["statusString"] = this.statusString;
        data["paymentSucceeded"] = this.paymentSucceeded;
        data["message"] = this.message;
        return data;
    }
}

export interface IUpdateDealPaymentStatusResult {
    paymentIntentId?: string | undefined;
    status?: StripePaymentIntentStatus;
    statusString?: string | undefined;
    paymentSucceeded?: boolean;
    message?: string | undefined;
}

export class DealDocumentDto implements IDealDocumentDto {
    category?: string | undefined;
    file?: FileDto | undefined;

    constructor(data?: IDealDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DealDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDealDocumentDto {
    category?: string | undefined;
    file?: FileDto | undefined;
}

export class FileDto implements IFileDto {
    id?: string | undefined;
    uploadedFileName?: string | undefined;
    publicUrl?: string | undefined;
    temporaryAccessUrl?: string | undefined;
    accessType?: FileAccessType;
    creationDateTimeUtc?: Date | undefined;
    uploadedBy?: NestedUserDto | undefined;
    temporaryAccessUrlExpiresOnDateTimeUtc?: Date;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uploadedFileName = _data["uploadedFileName"];
            this.publicUrl = _data["publicUrl"];
            this.temporaryAccessUrl = _data["temporaryAccessUrl"];
            this.accessType = _data["accessType"];
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.uploadedBy = _data["uploadedBy"] ? NestedUserDto.fromJS(_data["uploadedBy"]) : <any>undefined;
            this.temporaryAccessUrlExpiresOnDateTimeUtc = _data["temporaryAccessUrlExpiresOnDateTimeUtc"] ? new Date(_data["temporaryAccessUrlExpiresOnDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uploadedFileName"] = this.uploadedFileName;
        data["publicUrl"] = this.publicUrl;
        data["temporaryAccessUrl"] = this.temporaryAccessUrl;
        data["accessType"] = this.accessType;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["uploadedBy"] = this.uploadedBy ? this.uploadedBy.toJSON() : <any>undefined;
        data["temporaryAccessUrlExpiresOnDateTimeUtc"] = this.temporaryAccessUrlExpiresOnDateTimeUtc ? this.temporaryAccessUrlExpiresOnDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFileDto {
    id?: string | undefined;
    uploadedFileName?: string | undefined;
    publicUrl?: string | undefined;
    temporaryAccessUrl?: string | undefined;
    accessType?: FileAccessType;
    creationDateTimeUtc?: Date | undefined;
    uploadedBy?: NestedUserDto | undefined;
    temporaryAccessUrlExpiresOnDateTimeUtc?: Date;
}

export enum FileAccessType {
    Public = 0,
    Confidential = 1,
}

export class CreateDealDocumentCommand implements ICreateDealDocumentCommand {
    dealId?: string | undefined;
    fileId?: string | undefined;
    category?: string | undefined;

    constructor(data?: ICreateDealDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.fileId = _data["fileId"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CreateDealDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDealDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["fileId"] = this.fileId;
        data["category"] = this.category;
        return data;
    }
}

export interface ICreateDealDocumentCommand {
    dealId?: string | undefined;
    fileId?: string | undefined;
    category?: string | undefined;
}

export class EditDealDocumentCommand implements IEditDealDocumentCommand {
    dealId?: string | undefined;
    fileId?: string | undefined;
    category?: string | undefined;

    constructor(data?: IEditDealDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.fileId = _data["fileId"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): EditDealDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditDealDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["fileId"] = this.fileId;
        data["category"] = this.category;
        return data;
    }
}

export interface IEditDealDocumentCommand {
    dealId?: string | undefined;
    fileId?: string | undefined;
    category?: string | undefined;
}

export class DeleteDealDocumentCommand implements IDeleteDealDocumentCommand {
    dealId?: string | undefined;
    fileId?: string | undefined;

    constructor(data?: IDeleteDealDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): DeleteDealDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDealDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IDeleteDealDocumentCommand {
    dealId?: string | undefined;
    fileId?: string | undefined;
}

export class DealPaymentDto implements IDealPaymentDto {
    paymentDueDate?: Date;
    amount?: number;

    constructor(data?: IDealPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDueDate = _data["paymentDueDate"] ? new Date(_data["paymentDueDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): DealPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IDealPaymentDto {
    paymentDueDate?: Date;
    amount?: number;
}

export class ContractSummaryDto implements IContractSummaryDto {
    id?: string | undefined;
    contractType?: ContractType;
    createdDateTimeUtc?: Date;
    executedDateTimeUtc?: Date | undefined;
    signatureCount?: number;
    requiredSignatures?: number;
    isFullySigned?: boolean;
    hasWatermarkedContract?: boolean;
    amendmentNumber?: number | undefined;
    signatures?: ContractSignatureSummaryDto[] | undefined;

    constructor(data?: IContractSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractType = _data["contractType"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.executedDateTimeUtc = _data["executedDateTimeUtc"] ? new Date(_data["executedDateTimeUtc"].toString()) : <any>undefined;
            this.signatureCount = _data["signatureCount"];
            this.requiredSignatures = _data["requiredSignatures"];
            this.isFullySigned = _data["isFullySigned"];
            this.hasWatermarkedContract = _data["hasWatermarkedContract"];
            this.amendmentNumber = _data["amendmentNumber"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(ContractSignatureSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractType"] = this.contractType;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["executedDateTimeUtc"] = this.executedDateTimeUtc ? this.executedDateTimeUtc.toISOString() : <any>undefined;
        data["signatureCount"] = this.signatureCount;
        data["requiredSignatures"] = this.requiredSignatures;
        data["isFullySigned"] = this.isFullySigned;
        data["hasWatermarkedContract"] = this.hasWatermarkedContract;
        data["amendmentNumber"] = this.amendmentNumber;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractSummaryDto {
    id?: string | undefined;
    contractType?: ContractType;
    createdDateTimeUtc?: Date;
    executedDateTimeUtc?: Date | undefined;
    signatureCount?: number;
    requiredSignatures?: number;
    isFullySigned?: boolean;
    hasWatermarkedContract?: boolean;
    amendmentNumber?: number | undefined;
    signatures?: ContractSignatureSummaryDto[] | undefined;
}

export class ContractSignatureSummaryDto implements IContractSignatureSummaryDto {
    id?: string | undefined;
    signedByName?: string | undefined;
    signerRole?: SignerRole;
    signedDateTimeUtc?: Date;

    constructor(data?: IContractSignatureSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.signedByName = _data["signedByName"];
            this.signerRole = _data["signerRole"];
            this.signedDateTimeUtc = _data["signedDateTimeUtc"] ? new Date(_data["signedDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractSignatureSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSignatureSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signedByName"] = this.signedByName;
        data["signerRole"] = this.signerRole;
        data["signedDateTimeUtc"] = this.signedDateTimeUtc ? this.signedDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IContractSignatureSummaryDto {
    id?: string | undefined;
    signedByName?: string | undefined;
    signerRole?: SignerRole;
    signedDateTimeUtc?: Date;
}

export enum SignerRole {
    Buyer = 0,
    Seller = 1,
}

export class EditDealPurchaserCommand extends BaseDealPurchaserCommand implements IEditDealPurchaserCommand {

    constructor(data?: IEditDealPurchaserCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EditDealPurchaserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditDealPurchaserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEditDealPurchaserCommand extends IBaseDealPurchaserCommand {
}

export class UpdatePurchaserNameToNameOnDocumentCommand implements IUpdatePurchaserNameToNameOnDocumentCommand {

    constructor(data?: IUpdatePurchaserNameToNameOnDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdatePurchaserNameToNameOnDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaserNameToNameOnDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdatePurchaserNameToNameOnDocumentCommand {
}

export class UseAnotherDocumentResult implements IUseAnotherDocumentResult {
    url?: string | undefined;
    sentEmailInstead?: boolean;

    constructor(data?: IUseAnotherDocumentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.sentEmailInstead = _data["sentEmailInstead"];
        }
    }

    static fromJS(data: any): UseAnotherDocumentResult {
        data = typeof data === 'object' ? data : {};
        let result = new UseAnotherDocumentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["sentEmailInstead"] = this.sentEmailInstead;
        return data;
    }
}

export interface IUseAnotherDocumentResult {
    url?: string | undefined;
    sentEmailInstead?: boolean;
}

export class UseAnotherDocumentCommand implements IUseAnotherDocumentCommand {
    baseUrl?: string | undefined;
    culture?: string | undefined;

    constructor(data?: IUseAnotherDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseUrl = _data["baseUrl"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): UseAnotherDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UseAnotherDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseUrl"] = this.baseUrl;
        data["culture"] = this.culture;
        return data;
    }
}

export interface IUseAnotherDocumentCommand {
    baseUrl?: string | undefined;
    culture?: string | undefined;
}

export class VerifyDealPurchaserCommand implements IVerifyDealPurchaserCommand {
    dealId?: string | undefined;
    purchaserId?: string | undefined;
    purchasersVerificationCode?: string | undefined;
    token?: string | undefined;

    constructor(data?: IVerifyDealPurchaserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.purchaserId = _data["purchaserId"];
            this.purchasersVerificationCode = _data["purchasersVerificationCode"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): VerifyDealPurchaserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyDealPurchaserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["purchaserId"] = this.purchaserId;
        data["purchasersVerificationCode"] = this.purchasersVerificationCode;
        data["token"] = this.token;
        return data;
    }
}

export interface IVerifyDealPurchaserCommand {
    dealId?: string | undefined;
    purchaserId?: string | undefined;
    purchasersVerificationCode?: string | undefined;
    token?: string | undefined;
}

export abstract class TranslatableOfDealStepTranslation implements ITranslatableOfDealStepTranslation {
    selectedTranslation?: DealStepTranslation | undefined;

    constructor(data?: ITranslatableOfDealStepTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedTranslation = _data["selectedTranslation"] ? DealStepTranslation.fromJS(_data["selectedTranslation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TranslatableOfDealStepTranslation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TranslatableOfDealStepTranslation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedTranslation"] = this.selectedTranslation ? this.selectedTranslation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITranslatableOfDealStepTranslation {
    selectedTranslation?: DealStepTranslation | undefined;
}

export abstract class TranslatableEntityOfDealStepTranslation extends TranslatableOfDealStepTranslation implements ITranslatableEntityOfDealStepTranslation {
    id?: string | undefined;

    constructor(data?: ITranslatableEntityOfDealStepTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TranslatableEntityOfDealStepTranslation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TranslatableEntityOfDealStepTranslation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslatableEntityOfDealStepTranslation extends ITranslatableOfDealStepTranslation {
    id?: string | undefined;
}

export class DealStepsDto extends TranslatableEntityOfDealStepTranslation implements IDealStepsDto {
    step?: number;
    translations?: DealStepTranslation[] | undefined;

    constructor(data?: IDealStepsDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.step = _data["step"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(DealStepTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealStepsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealStepsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDealStepsDto extends ITranslatableEntityOfDealStepTranslation {
    step?: number;
    translations?: DealStepTranslation[] | undefined;
}

export abstract class Translation implements ITranslation {
    culture?: string | undefined;

    constructor(data?: ITranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): Translation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Translation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        return data;
    }
}

export interface ITranslation {
    culture?: string | undefined;
}

export class DealStepTranslation extends Translation implements IDealStepTranslation {
    heading?: string | undefined;
    bodies?: string[] | undefined;
    description?: string | undefined;

    constructor(data?: IDealStepTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.heading = _data["heading"];
            if (Array.isArray(_data["bodies"])) {
                this.bodies = [] as any;
                for (let item of _data["bodies"])
                    this.bodies!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DealStepTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new DealStepTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        if (Array.isArray(this.bodies)) {
            data["bodies"] = [];
            for (let item of this.bodies)
                data["bodies"].push(item);
        }
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IDealStepTranslation extends ITranslation {
    heading?: string | undefined;
    bodies?: string[] | undefined;
    description?: string | undefined;
}

export class SkipContractGenerationCommand implements ISkipContractGenerationCommand {
    dealId?: string | undefined;

    constructor(data?: ISkipContractGenerationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
        }
    }

    static fromJS(data: any): SkipContractGenerationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SkipContractGenerationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        return data;
    }
}

export interface ISkipContractGenerationCommand {
    dealId?: string | undefined;
}

export class SubmitDealCommand implements ISubmitDealCommand {

    constructor(data?: ISubmitDealCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SubmitDealCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitDealCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISubmitDealCommand {
}

export class StripeCheckoutSessionOutput implements IStripeCheckoutSessionOutput {
    sessionId?: string | undefined;
    status?: StripeSubscriptionStatus | undefined;
    checkoutUrl?: string | undefined;

    constructor(data?: IStripeCheckoutSessionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.checkoutUrl = _data["checkoutUrl"];
        }
    }

    static fromJS(data: any): StripeCheckoutSessionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCheckoutSessionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["checkoutUrl"] = this.checkoutUrl;
        return data;
    }
}

export interface IStripeCheckoutSessionOutput {
    sessionId?: string | undefined;
    status?: StripeSubscriptionStatus | undefined;
    checkoutUrl?: string | undefined;
}

export enum StripeSubscriptionStatus {
    Incomplete = 0,
    IncompleteExpired = 1,
    Trialing = 2,
    Active = 3,
    PastDue = 4,
    Canceled = 5,
    Unpaid = 6,
}

export class CreateTransactionFeeCheckoutSessionCommand implements ICreateTransactionFeeCheckoutSessionCommand {
    successRedirectUrl?: string | undefined;

    constructor(data?: ICreateTransactionFeeCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successRedirectUrl = _data["successRedirectUrl"];
        }
    }

    static fromJS(data: any): CreateTransactionFeeCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransactionFeeCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successRedirectUrl"] = this.successRedirectUrl;
        return data;
    }
}

export interface ICreateTransactionFeeCheckoutSessionCommand {
    successRedirectUrl?: string | undefined;
}

export class OfferExtensionDto implements IOfferExtensionDto {
    id?: number;
    validUntilDateTimeUtc?: Date;
    extensionDurationInHours?: number;
    reason?: string | undefined;
    message?: string | undefined;
    offerId?: number;
    status?: OfferExtensionStatus;
    creationDateTimeUtc?: Date | undefined;
    version?: number;
    round?: number;
    createdByName?: string | undefined;

    constructor(data?: IOfferExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validUntilDateTimeUtc = _data["validUntilDateTimeUtc"] ? new Date(_data["validUntilDateTimeUtc"].toString()) : <any>undefined;
            this.extensionDurationInHours = _data["extensionDurationInHours"];
            this.reason = _data["reason"];
            this.message = _data["message"];
            this.offerId = _data["offerId"];
            this.status = _data["status"];
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.round = _data["round"];
            this.createdByName = _data["createdByName"];
        }
    }

    static fromJS(data: any): OfferExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validUntilDateTimeUtc"] = this.validUntilDateTimeUtc ? this.validUntilDateTimeUtc.toISOString() : <any>undefined;
        data["extensionDurationInHours"] = this.extensionDurationInHours;
        data["reason"] = this.reason;
        data["message"] = this.message;
        data["offerId"] = this.offerId;
        data["status"] = this.status;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["version"] = this.version;
        data["round"] = this.round;
        data["createdByName"] = this.createdByName;
        return data;
    }
}

export interface IOfferExtensionDto {
    id?: number;
    validUntilDateTimeUtc?: Date;
    extensionDurationInHours?: number;
    reason?: string | undefined;
    message?: string | undefined;
    offerId?: number;
    status?: OfferExtensionStatus;
    creationDateTimeUtc?: Date | undefined;
    version?: number;
    round?: number;
    createdByName?: string | undefined;
}

export enum OfferExtensionStatus {
    Sent = 0,
    Accepted = 1,
    Denied = 2,
    Expired = 3,
}

export class RequestOfferExtensionCommand implements IRequestOfferExtensionCommand {
    extensionDurationInHours?: number;
    reason?: string | undefined;
    message?: string | undefined;

    constructor(data?: IRequestOfferExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extensionDurationInHours = _data["extensionDurationInHours"];
            this.reason = _data["reason"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): RequestOfferExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestOfferExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionDurationInHours"] = this.extensionDurationInHours;
        data["reason"] = this.reason;
        data["message"] = this.message;
        return data;
    }
}

export interface IRequestOfferExtensionCommand {
    extensionDurationInHours?: number;
    reason?: string | undefined;
    message?: string | undefined;
}

export class AcceptOfferExtensionCommand implements IAcceptOfferExtensionCommand {

    constructor(data?: IAcceptOfferExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AcceptOfferExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptOfferExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAcceptOfferExtensionCommand {
}

export class DeclineOfferExtensionCommand implements IDeclineOfferExtensionCommand {

    constructor(data?: IDeclineOfferExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeclineOfferExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineOfferExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeclineOfferExtensionCommand {
}

export class SetOfferCommand implements ISetOfferCommand {
    newOfferPrice?: number | undefined;
    isOfferPriceNegotiable?: boolean | undefined;
    minimumOfferPrice?: number | undefined;
    depositMode?: DepositMode | undefined;
    offerType?: OfferType | undefined;
    financedAmount?: number | undefined;
    newDepositStructures?: DepositStructureInput[] | undefined;
    isDepositNegotiable?: boolean | undefined;
    minimumDepositPrice?: number | undefined;
    maximumDepositPrice?: number | undefined;
    newClosingPeriod?: number | undefined;
    newPossessionPeriod?: number | undefined;
    newPossessionDateTime?: Date | undefined;
    newDesiredClosingDateTime?: Date | undefined;
    completionDateFormat?: CompletionDateFormat;
    newInclusions?: PropertyContractItemInput[] | undefined;
    newExclusions?: PropertyContractItemInput[] | undefined;
    newNonConditionalOffer?: boolean | undefined;
    newConditionalFinancing?: boolean | undefined;
    isConditionalFinancingNegotiable?: boolean | undefined;
    newConditionalFinancingPeriod?: number | undefined;
    newConditionalFinancingDate?: Date | undefined;
    newConditionalInspection?: boolean | undefined;
    isConditionalInspectionNegotiable?: boolean | undefined;
    newConditionalInspectionPeriod?: number | undefined;
    newConditionalInspectionDate?: Date | undefined;
    newConditionalSaleOfHome?: boolean | undefined;
    newConditionalSaleOfHomePeriod?: number | undefined;
    newConditionalSaleOfHomeDate?: Date | undefined;
    newDueDiligenceExtended?: boolean | undefined;
    dueDiligenceExtended?: boolean | undefined;
    newDueDiligencePeriod?: number | undefined;
    newDueDiligenceDate?: Date | undefined;
    dueDiligenceExtendedReason?: string | undefined;
    newDueDiligenceExtendedReason?: string | undefined;
    newAdditionalNotes?: string[] | undefined;
    validUntilDateTime?: Date | undefined;
    isOwnershipDocsPeriodNegotiable?: boolean;
    newOwnershipDocsPeriod?: number | undefined;
    newOwnershipDocsDate?: Date | undefined;

    constructor(data?: ISetOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newOfferPrice = _data["newOfferPrice"];
            this.isOfferPriceNegotiable = _data["isOfferPriceNegotiable"];
            this.minimumOfferPrice = _data["minimumOfferPrice"];
            this.depositMode = _data["depositMode"];
            this.offerType = _data["offerType"];
            this.financedAmount = _data["financedAmount"];
            if (Array.isArray(_data["newDepositStructures"])) {
                this.newDepositStructures = [] as any;
                for (let item of _data["newDepositStructures"])
                    this.newDepositStructures!.push(DepositStructureInput.fromJS(item));
            }
            this.isDepositNegotiable = _data["isDepositNegotiable"];
            this.minimumDepositPrice = _data["minimumDepositPrice"];
            this.maximumDepositPrice = _data["maximumDepositPrice"];
            this.newClosingPeriod = _data["newClosingPeriod"];
            this.newPossessionPeriod = _data["newPossessionPeriod"];
            this.newPossessionDateTime = _data["newPossessionDateTime"] ? new Date(_data["newPossessionDateTime"].toString()) : <any>undefined;
            this.newDesiredClosingDateTime = _data["newDesiredClosingDateTime"] ? new Date(_data["newDesiredClosingDateTime"].toString()) : <any>undefined;
            this.completionDateFormat = _data["completionDateFormat"];
            if (Array.isArray(_data["newInclusions"])) {
                this.newInclusions = [] as any;
                for (let item of _data["newInclusions"])
                    this.newInclusions!.push(PropertyContractItemInput.fromJS(item));
            }
            if (Array.isArray(_data["newExclusions"])) {
                this.newExclusions = [] as any;
                for (let item of _data["newExclusions"])
                    this.newExclusions!.push(PropertyContractItemInput.fromJS(item));
            }
            this.newNonConditionalOffer = _data["newNonConditionalOffer"];
            this.newConditionalFinancing = _data["newConditionalFinancing"];
            this.isConditionalFinancingNegotiable = _data["isConditionalFinancingNegotiable"];
            this.newConditionalFinancingPeriod = _data["newConditionalFinancingPeriod"];
            this.newConditionalFinancingDate = _data["newConditionalFinancingDate"] ? new Date(_data["newConditionalFinancingDate"].toString()) : <any>undefined;
            this.newConditionalInspection = _data["newConditionalInspection"];
            this.isConditionalInspectionNegotiable = _data["isConditionalInspectionNegotiable"];
            this.newConditionalInspectionPeriod = _data["newConditionalInspectionPeriod"];
            this.newConditionalInspectionDate = _data["newConditionalInspectionDate"] ? new Date(_data["newConditionalInspectionDate"].toString()) : <any>undefined;
            this.newConditionalSaleOfHome = _data["newConditionalSaleOfHome"];
            this.newConditionalSaleOfHomePeriod = _data["newConditionalSaleOfHomePeriod"];
            this.newConditionalSaleOfHomeDate = _data["newConditionalSaleOfHomeDate"] ? new Date(_data["newConditionalSaleOfHomeDate"].toString()) : <any>undefined;
            this.newDueDiligenceExtended = _data["newDueDiligenceExtended"];
            this.dueDiligenceExtended = _data["dueDiligenceExtended"];
            this.newDueDiligencePeriod = _data["newDueDiligencePeriod"];
            this.newDueDiligenceDate = _data["newDueDiligenceDate"] ? new Date(_data["newDueDiligenceDate"].toString()) : <any>undefined;
            this.dueDiligenceExtendedReason = _data["dueDiligenceExtendedReason"];
            this.newDueDiligenceExtendedReason = _data["newDueDiligenceExtendedReason"];
            if (Array.isArray(_data["newAdditionalNotes"])) {
                this.newAdditionalNotes = [] as any;
                for (let item of _data["newAdditionalNotes"])
                    this.newAdditionalNotes!.push(item);
            }
            this.validUntilDateTime = _data["validUntilDateTime"] ? new Date(_data["validUntilDateTime"].toString()) : <any>undefined;
            this.isOwnershipDocsPeriodNegotiable = _data["isOwnershipDocsPeriodNegotiable"];
            this.newOwnershipDocsPeriod = _data["newOwnershipDocsPeriod"];
            this.newOwnershipDocsDate = _data["newOwnershipDocsDate"] ? new Date(_data["newOwnershipDocsDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SetOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newOfferPrice"] = this.newOfferPrice;
        data["isOfferPriceNegotiable"] = this.isOfferPriceNegotiable;
        data["minimumOfferPrice"] = this.minimumOfferPrice;
        data["depositMode"] = this.depositMode;
        data["offerType"] = this.offerType;
        data["financedAmount"] = this.financedAmount;
        if (Array.isArray(this.newDepositStructures)) {
            data["newDepositStructures"] = [];
            for (let item of this.newDepositStructures)
                data["newDepositStructures"].push(item.toJSON());
        }
        data["isDepositNegotiable"] = this.isDepositNegotiable;
        data["minimumDepositPrice"] = this.minimumDepositPrice;
        data["maximumDepositPrice"] = this.maximumDepositPrice;
        data["newClosingPeriod"] = this.newClosingPeriod;
        data["newPossessionPeriod"] = this.newPossessionPeriod;
        data["newPossessionDateTime"] = this.newPossessionDateTime ? this.newPossessionDateTime.toISOString() : <any>undefined;
        data["newDesiredClosingDateTime"] = this.newDesiredClosingDateTime ? this.newDesiredClosingDateTime.toISOString() : <any>undefined;
        data["completionDateFormat"] = this.completionDateFormat;
        if (Array.isArray(this.newInclusions)) {
            data["newInclusions"] = [];
            for (let item of this.newInclusions)
                data["newInclusions"].push(item.toJSON());
        }
        if (Array.isArray(this.newExclusions)) {
            data["newExclusions"] = [];
            for (let item of this.newExclusions)
                data["newExclusions"].push(item.toJSON());
        }
        data["newNonConditionalOffer"] = this.newNonConditionalOffer;
        data["newConditionalFinancing"] = this.newConditionalFinancing;
        data["isConditionalFinancingNegotiable"] = this.isConditionalFinancingNegotiable;
        data["newConditionalFinancingPeriod"] = this.newConditionalFinancingPeriod;
        data["newConditionalFinancingDate"] = this.newConditionalFinancingDate ? this.newConditionalFinancingDate.toISOString() : <any>undefined;
        data["newConditionalInspection"] = this.newConditionalInspection;
        data["isConditionalInspectionNegotiable"] = this.isConditionalInspectionNegotiable;
        data["newConditionalInspectionPeriod"] = this.newConditionalInspectionPeriod;
        data["newConditionalInspectionDate"] = this.newConditionalInspectionDate ? this.newConditionalInspectionDate.toISOString() : <any>undefined;
        data["newConditionalSaleOfHome"] = this.newConditionalSaleOfHome;
        data["newConditionalSaleOfHomePeriod"] = this.newConditionalSaleOfHomePeriod;
        data["newConditionalSaleOfHomeDate"] = this.newConditionalSaleOfHomeDate ? this.newConditionalSaleOfHomeDate.toISOString() : <any>undefined;
        data["newDueDiligenceExtended"] = this.newDueDiligenceExtended;
        data["dueDiligenceExtended"] = this.dueDiligenceExtended;
        data["newDueDiligencePeriod"] = this.newDueDiligencePeriod;
        data["newDueDiligenceDate"] = this.newDueDiligenceDate ? this.newDueDiligenceDate.toISOString() : <any>undefined;
        data["dueDiligenceExtendedReason"] = this.dueDiligenceExtendedReason;
        data["newDueDiligenceExtendedReason"] = this.newDueDiligenceExtendedReason;
        if (Array.isArray(this.newAdditionalNotes)) {
            data["newAdditionalNotes"] = [];
            for (let item of this.newAdditionalNotes)
                data["newAdditionalNotes"].push(item);
        }
        data["validUntilDateTime"] = this.validUntilDateTime ? this.validUntilDateTime.toISOString() : <any>undefined;
        data["isOwnershipDocsPeriodNegotiable"] = this.isOwnershipDocsPeriodNegotiable;
        data["newOwnershipDocsPeriod"] = this.newOwnershipDocsPeriod;
        data["newOwnershipDocsDate"] = this.newOwnershipDocsDate ? this.newOwnershipDocsDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISetOfferCommand {
    newOfferPrice?: number | undefined;
    isOfferPriceNegotiable?: boolean | undefined;
    minimumOfferPrice?: number | undefined;
    depositMode?: DepositMode | undefined;
    offerType?: OfferType | undefined;
    financedAmount?: number | undefined;
    newDepositStructures?: DepositStructureInput[] | undefined;
    isDepositNegotiable?: boolean | undefined;
    minimumDepositPrice?: number | undefined;
    maximumDepositPrice?: number | undefined;
    newClosingPeriod?: number | undefined;
    newPossessionPeriod?: number | undefined;
    newPossessionDateTime?: Date | undefined;
    newDesiredClosingDateTime?: Date | undefined;
    completionDateFormat?: CompletionDateFormat;
    newInclusions?: PropertyContractItemInput[] | undefined;
    newExclusions?: PropertyContractItemInput[] | undefined;
    newNonConditionalOffer?: boolean | undefined;
    newConditionalFinancing?: boolean | undefined;
    isConditionalFinancingNegotiable?: boolean | undefined;
    newConditionalFinancingPeriod?: number | undefined;
    newConditionalFinancingDate?: Date | undefined;
    newConditionalInspection?: boolean | undefined;
    isConditionalInspectionNegotiable?: boolean | undefined;
    newConditionalInspectionPeriod?: number | undefined;
    newConditionalInspectionDate?: Date | undefined;
    newConditionalSaleOfHome?: boolean | undefined;
    newConditionalSaleOfHomePeriod?: number | undefined;
    newConditionalSaleOfHomeDate?: Date | undefined;
    newDueDiligenceExtended?: boolean | undefined;
    dueDiligenceExtended?: boolean | undefined;
    newDueDiligencePeriod?: number | undefined;
    newDueDiligenceDate?: Date | undefined;
    dueDiligenceExtendedReason?: string | undefined;
    newDueDiligenceExtendedReason?: string | undefined;
    newAdditionalNotes?: string[] | undefined;
    validUntilDateTime?: Date | undefined;
    isOwnershipDocsPeriodNegotiable?: boolean;
    newOwnershipDocsPeriod?: number | undefined;
    newOwnershipDocsDate?: Date | undefined;
}

export enum DepositMode {
    Percentage = 0,
    FixedAmount = 1,
}

export enum OfferType {
    Cash = 0,
    Financing = 1,
}

export class DepositStructureInput implements IDepositStructureInput {
    depositPercentage?: number | undefined;
    depositAmount?: number | undefined;
    dueDateDuration?: number | undefined;
    dueDateDurationUnit?: DueDateDurationUnit | undefined;
    dueDate?: Date | undefined;
    paymentTypes?: string[] | undefined;
    isRefundable?: boolean;

    constructor(data?: IDepositStructureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depositPercentage = _data["depositPercentage"];
            this.depositAmount = _data["depositAmount"];
            this.dueDateDuration = _data["dueDateDuration"];
            this.dueDateDurationUnit = _data["dueDateDurationUnit"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["paymentTypes"])) {
                this.paymentTypes = [] as any;
                for (let item of _data["paymentTypes"])
                    this.paymentTypes!.push(item);
            }
            this.isRefundable = _data["isRefundable"];
        }
    }

    static fromJS(data: any): DepositStructureInput {
        data = typeof data === 'object' ? data : {};
        let result = new DepositStructureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depositPercentage"] = this.depositPercentage;
        data["depositAmount"] = this.depositAmount;
        data["dueDateDuration"] = this.dueDateDuration;
        data["dueDateDurationUnit"] = this.dueDateDurationUnit;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        if (Array.isArray(this.paymentTypes)) {
            data["paymentTypes"] = [];
            for (let item of this.paymentTypes)
                data["paymentTypes"].push(item);
        }
        data["isRefundable"] = this.isRefundable;
        return data;
    }
}

export interface IDepositStructureInput {
    depositPercentage?: number | undefined;
    depositAmount?: number | undefined;
    dueDateDuration?: number | undefined;
    dueDateDurationUnit?: DueDateDurationUnit | undefined;
    dueDate?: Date | undefined;
    paymentTypes?: string[] | undefined;
    isRefundable?: boolean;
}

export class PropertyContractItemInput implements IPropertyContractItemInput {
    name?: string | undefined;
    location?: string | undefined;
    isSelected?: boolean;

    constructor(data?: IPropertyContractItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.location = _data["location"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): PropertyContractItemInput {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyContractItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["location"] = this.location;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IPropertyContractItemInput {
    name?: string | undefined;
    location?: string | undefined;
    isSelected?: boolean;
}

export class AcceptOfferCommand implements IAcceptOfferCommand {
    verificationId?: string | undefined;
    verificationCode?: string | undefined;

    constructor(data?: IAcceptOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationId = _data["verificationId"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): AcceptOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationId"] = this.verificationId;
        data["verificationCode"] = this.verificationCode;
        return data;
    }
}

export interface IAcceptOfferCommand {
    verificationId?: string | undefined;
    verificationCode?: string | undefined;
}

export class DeclineOfferCommand implements IDeclineOfferCommand {
    verificationId?: string | undefined;
    verificationCode?: string | undefined;

    constructor(data?: IDeclineOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationId = _data["verificationId"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): DeclineOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationId"] = this.verificationId;
        data["verificationCode"] = this.verificationCode;
        return data;
    }
}

export interface IDeclineOfferCommand {
    verificationId?: string | undefined;
    verificationCode?: string | undefined;
}

export class CancelOfferCommand implements ICancelOfferCommand {

    constructor(data?: ICancelOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CancelOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICancelOfferCommand {
}

export class SendOfferCommand implements ISendOfferCommand {
    verificationId?: string | undefined;
    verificationCode?: string | undefined;

    constructor(data?: ISendOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationId = _data["verificationId"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): SendOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationId"] = this.verificationId;
        data["verificationCode"] = this.verificationCode;
        return data;
    }
}

export interface ISendOfferCommand {
    verificationId?: string | undefined;
    verificationCode?: string | undefined;
}

export class OfferDto implements IOfferDto {
    version?: number;
    round?: number;
    offerPrice?: number;
    newOfferPrice?: number | undefined;
    isOfferPriceNegotiable?: boolean | undefined;
    minimumOfferPrice?: number | undefined;
    creator?: OfferCreator;
    creationDateTimeUtc?: Date | undefined;
    status?: OfferStatus;
    finalStatusUpdateDateTimeUtc?: Date | undefined;
    sentDateTimeUtc?: Date | undefined;
    offerType?: OfferType | undefined;
    financedAmount?: number | undefined;
    extensions?: OfferExtensionDto[] | undefined;
    depositStructures?: DepositStructureDto[] | undefined;
    newDepositStructures?: DepositStructureDto[] | undefined;
    isDepositNegotiable?: boolean | undefined;
    minimumDepositPrice?: number | undefined;
    maximumDepositPrice?: number | undefined;
    closingPeriod?: number;
    newClosingPeriod?: number | undefined;
    possessionPeriod?: number | undefined;
    newPossessionPeriod?: number | undefined;
    possessionDateTime?: Date | undefined;
    newPossessionDateTime?: Date | undefined;
    isPossessionDateNegotiable?: boolean | undefined;
    closingDateTime?: Date | undefined;
    newClosingDateTime?: Date | undefined;
    completionDateFormat?: CompletionDateFormat;
    ownershipDocsPeriod?: number;
    newOwnershipDocsPeriod?: number | undefined;
    ownershipDocsDate?: Date | undefined;
    newOwnershipDocsDate?: Date | undefined;
    isOwnershipDocsPeriodNegotiable?: boolean;
    inclusions?: ListingContractItemDto[] | undefined;
    newInclusions?: ListingContractItemDto[] | undefined;
    exclusions?: ListingContractItemDto[] | undefined;
    newExclusions?: ListingContractItemDto[] | undefined;
    nonConditionalOffer?: boolean;
    newNonConditionalOffer?: boolean;
    conditionalFinancing?: boolean;
    isConditionalFinancingNegotiable?: boolean | undefined;
    newConditionalFinancing?: boolean | undefined;
    conditionalFinancingPeriod?: number | undefined;
    newConditionalFinancingPeriod?: number | undefined;
    conditionalFinancingDate?: Date | undefined;
    newConditionalFinancingDate?: Date | undefined;
    conditionalInspection?: boolean;
    isConditionalInspectionNegotiable?: boolean | undefined;
    newConditionalInspection?: boolean | undefined;
    conditionalInspectionPeriod?: number | undefined;
    newConditionalInspectionPeriod?: number | undefined;
    conditionalInspectionDate?: Date | undefined;
    newConditionalInspectionDate?: Date | undefined;
    conditionalSaleOfHome?: boolean;
    newConditionalSaleOfHome?: boolean | undefined;
    conditionalSaleOfHomePeriod?: number | undefined;
    newConditionalSaleOfHomePeriod?: number | undefined;
    conditionalSaleOfHomeDate?: Date | undefined;
    newConditionalSaleOfHomeDate?: Date | undefined;
    dueDiligenceExtended?: boolean | undefined;
    newDueDiligenceExtended?: boolean | undefined;
    additionalNotes?: string[] | undefined;
    newAdditionalNotes?: string[] | undefined;
    dueDiligencePeriod?: number;
    newDueDiligencePeriod?: number | undefined;
    dueDiligenceDate?: Date | undefined;
    newDueDiligenceDate?: Date | undefined;
    dueDiligenceExtendedReason?: string | undefined;
    newDueDiligenceExtendedReason?: string | undefined;
    depositMode?: DepositMode;
    validUntilDateTimeUtc?: Date | undefined;

    constructor(data?: IOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.round = _data["round"];
            this.offerPrice = _data["offerPrice"];
            this.newOfferPrice = _data["newOfferPrice"];
            this.isOfferPriceNegotiable = _data["isOfferPriceNegotiable"];
            this.minimumOfferPrice = _data["minimumOfferPrice"];
            this.creator = _data["creator"];
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.finalStatusUpdateDateTimeUtc = _data["finalStatusUpdateDateTimeUtc"] ? new Date(_data["finalStatusUpdateDateTimeUtc"].toString()) : <any>undefined;
            this.sentDateTimeUtc = _data["sentDateTimeUtc"] ? new Date(_data["sentDateTimeUtc"].toString()) : <any>undefined;
            this.offerType = _data["offerType"];
            this.financedAmount = _data["financedAmount"];
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(OfferExtensionDto.fromJS(item));
            }
            if (Array.isArray(_data["depositStructures"])) {
                this.depositStructures = [] as any;
                for (let item of _data["depositStructures"])
                    this.depositStructures!.push(DepositStructureDto.fromJS(item));
            }
            if (Array.isArray(_data["newDepositStructures"])) {
                this.newDepositStructures = [] as any;
                for (let item of _data["newDepositStructures"])
                    this.newDepositStructures!.push(DepositStructureDto.fromJS(item));
            }
            this.isDepositNegotiable = _data["isDepositNegotiable"];
            this.minimumDepositPrice = _data["minimumDepositPrice"];
            this.maximumDepositPrice = _data["maximumDepositPrice"];
            this.closingPeriod = _data["closingPeriod"];
            this.newClosingPeriod = _data["newClosingPeriod"];
            this.possessionPeriod = _data["possessionPeriod"];
            this.newPossessionPeriod = _data["newPossessionPeriod"];
            this.possessionDateTime = _data["possessionDateTime"] ? new Date(_data["possessionDateTime"].toString()) : <any>undefined;
            this.newPossessionDateTime = _data["newPossessionDateTime"] ? new Date(_data["newPossessionDateTime"].toString()) : <any>undefined;
            this.isPossessionDateNegotiable = _data["isPossessionDateNegotiable"];
            this.closingDateTime = _data["closingDateTime"] ? new Date(_data["closingDateTime"].toString()) : <any>undefined;
            this.newClosingDateTime = _data["newClosingDateTime"] ? new Date(_data["newClosingDateTime"].toString()) : <any>undefined;
            this.completionDateFormat = _data["completionDateFormat"];
            this.ownershipDocsPeriod = _data["ownershipDocsPeriod"];
            this.newOwnershipDocsPeriod = _data["newOwnershipDocsPeriod"];
            this.ownershipDocsDate = _data["ownershipDocsDate"] ? new Date(_data["ownershipDocsDate"].toString()) : <any>undefined;
            this.newOwnershipDocsDate = _data["newOwnershipDocsDate"] ? new Date(_data["newOwnershipDocsDate"].toString()) : <any>undefined;
            this.isOwnershipDocsPeriodNegotiable = _data["isOwnershipDocsPeriodNegotiable"];
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions!.push(ListingContractItemDto.fromJS(item));
            }
            if (Array.isArray(_data["newInclusions"])) {
                this.newInclusions = [] as any;
                for (let item of _data["newInclusions"])
                    this.newInclusions!.push(ListingContractItemDto.fromJS(item));
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions!.push(ListingContractItemDto.fromJS(item));
            }
            if (Array.isArray(_data["newExclusions"])) {
                this.newExclusions = [] as any;
                for (let item of _data["newExclusions"])
                    this.newExclusions!.push(ListingContractItemDto.fromJS(item));
            }
            this.nonConditionalOffer = _data["nonConditionalOffer"];
            this.newNonConditionalOffer = _data["newNonConditionalOffer"];
            this.conditionalFinancing = _data["conditionalFinancing"];
            this.isConditionalFinancingNegotiable = _data["isConditionalFinancingNegotiable"];
            this.newConditionalFinancing = _data["newConditionalFinancing"];
            this.conditionalFinancingPeriod = _data["conditionalFinancingPeriod"];
            this.newConditionalFinancingPeriod = _data["newConditionalFinancingPeriod"];
            this.conditionalFinancingDate = _data["conditionalFinancingDate"] ? new Date(_data["conditionalFinancingDate"].toString()) : <any>undefined;
            this.newConditionalFinancingDate = _data["newConditionalFinancingDate"] ? new Date(_data["newConditionalFinancingDate"].toString()) : <any>undefined;
            this.conditionalInspection = _data["conditionalInspection"];
            this.isConditionalInspectionNegotiable = _data["isConditionalInspectionNegotiable"];
            this.newConditionalInspection = _data["newConditionalInspection"];
            this.conditionalInspectionPeriod = _data["conditionalInspectionPeriod"];
            this.newConditionalInspectionPeriod = _data["newConditionalInspectionPeriod"];
            this.conditionalInspectionDate = _data["conditionalInspectionDate"] ? new Date(_data["conditionalInspectionDate"].toString()) : <any>undefined;
            this.newConditionalInspectionDate = _data["newConditionalInspectionDate"] ? new Date(_data["newConditionalInspectionDate"].toString()) : <any>undefined;
            this.conditionalSaleOfHome = _data["conditionalSaleOfHome"];
            this.newConditionalSaleOfHome = _data["newConditionalSaleOfHome"];
            this.conditionalSaleOfHomePeriod = _data["conditionalSaleOfHomePeriod"];
            this.newConditionalSaleOfHomePeriod = _data["newConditionalSaleOfHomePeriod"];
            this.conditionalSaleOfHomeDate = _data["conditionalSaleOfHomeDate"] ? new Date(_data["conditionalSaleOfHomeDate"].toString()) : <any>undefined;
            this.newConditionalSaleOfHomeDate = _data["newConditionalSaleOfHomeDate"] ? new Date(_data["newConditionalSaleOfHomeDate"].toString()) : <any>undefined;
            this.dueDiligenceExtended = _data["dueDiligenceExtended"];
            this.newDueDiligenceExtended = _data["newDueDiligenceExtended"];
            if (Array.isArray(_data["additionalNotes"])) {
                this.additionalNotes = [] as any;
                for (let item of _data["additionalNotes"])
                    this.additionalNotes!.push(item);
            }
            if (Array.isArray(_data["newAdditionalNotes"])) {
                this.newAdditionalNotes = [] as any;
                for (let item of _data["newAdditionalNotes"])
                    this.newAdditionalNotes!.push(item);
            }
            this.dueDiligencePeriod = _data["dueDiligencePeriod"];
            this.newDueDiligencePeriod = _data["newDueDiligencePeriod"];
            this.dueDiligenceDate = _data["dueDiligenceDate"] ? new Date(_data["dueDiligenceDate"].toString()) : <any>undefined;
            this.newDueDiligenceDate = _data["newDueDiligenceDate"] ? new Date(_data["newDueDiligenceDate"].toString()) : <any>undefined;
            this.dueDiligenceExtendedReason = _data["dueDiligenceExtendedReason"];
            this.newDueDiligenceExtendedReason = _data["newDueDiligenceExtendedReason"];
            this.depositMode = _data["depositMode"];
            this.validUntilDateTimeUtc = _data["validUntilDateTimeUtc"] ? new Date(_data["validUntilDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["round"] = this.round;
        data["offerPrice"] = this.offerPrice;
        data["newOfferPrice"] = this.newOfferPrice;
        data["isOfferPriceNegotiable"] = this.isOfferPriceNegotiable;
        data["minimumOfferPrice"] = this.minimumOfferPrice;
        data["creator"] = this.creator;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["finalStatusUpdateDateTimeUtc"] = this.finalStatusUpdateDateTimeUtc ? this.finalStatusUpdateDateTimeUtc.toISOString() : <any>undefined;
        data["sentDateTimeUtc"] = this.sentDateTimeUtc ? this.sentDateTimeUtc.toISOString() : <any>undefined;
        data["offerType"] = this.offerType;
        data["financedAmount"] = this.financedAmount;
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item.toJSON());
        }
        if (Array.isArray(this.depositStructures)) {
            data["depositStructures"] = [];
            for (let item of this.depositStructures)
                data["depositStructures"].push(item.toJSON());
        }
        if (Array.isArray(this.newDepositStructures)) {
            data["newDepositStructures"] = [];
            for (let item of this.newDepositStructures)
                data["newDepositStructures"].push(item.toJSON());
        }
        data["isDepositNegotiable"] = this.isDepositNegotiable;
        data["minimumDepositPrice"] = this.minimumDepositPrice;
        data["maximumDepositPrice"] = this.maximumDepositPrice;
        data["closingPeriod"] = this.closingPeriod;
        data["newClosingPeriod"] = this.newClosingPeriod;
        data["possessionPeriod"] = this.possessionPeriod;
        data["newPossessionPeriod"] = this.newPossessionPeriod;
        data["possessionDateTime"] = this.possessionDateTime ? this.possessionDateTime.toISOString() : <any>undefined;
        data["newPossessionDateTime"] = this.newPossessionDateTime ? this.newPossessionDateTime.toISOString() : <any>undefined;
        data["isPossessionDateNegotiable"] = this.isPossessionDateNegotiable;
        data["closingDateTime"] = this.closingDateTime ? this.closingDateTime.toISOString() : <any>undefined;
        data["newClosingDateTime"] = this.newClosingDateTime ? this.newClosingDateTime.toISOString() : <any>undefined;
        data["completionDateFormat"] = this.completionDateFormat;
        data["ownershipDocsPeriod"] = this.ownershipDocsPeriod;
        data["newOwnershipDocsPeriod"] = this.newOwnershipDocsPeriod;
        data["ownershipDocsDate"] = this.ownershipDocsDate ? this.ownershipDocsDate.toISOString() : <any>undefined;
        data["newOwnershipDocsDate"] = this.newOwnershipDocsDate ? this.newOwnershipDocsDate.toISOString() : <any>undefined;
        data["isOwnershipDocsPeriodNegotiable"] = this.isOwnershipDocsPeriodNegotiable;
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item.toJSON());
        }
        if (Array.isArray(this.newInclusions)) {
            data["newInclusions"] = [];
            for (let item of this.newInclusions)
                data["newInclusions"].push(item.toJSON());
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item.toJSON());
        }
        if (Array.isArray(this.newExclusions)) {
            data["newExclusions"] = [];
            for (let item of this.newExclusions)
                data["newExclusions"].push(item.toJSON());
        }
        data["nonConditionalOffer"] = this.nonConditionalOffer;
        data["newNonConditionalOffer"] = this.newNonConditionalOffer;
        data["conditionalFinancing"] = this.conditionalFinancing;
        data["isConditionalFinancingNegotiable"] = this.isConditionalFinancingNegotiable;
        data["newConditionalFinancing"] = this.newConditionalFinancing;
        data["conditionalFinancingPeriod"] = this.conditionalFinancingPeriod;
        data["newConditionalFinancingPeriod"] = this.newConditionalFinancingPeriod;
        data["conditionalFinancingDate"] = this.conditionalFinancingDate ? this.conditionalFinancingDate.toISOString() : <any>undefined;
        data["newConditionalFinancingDate"] = this.newConditionalFinancingDate ? this.newConditionalFinancingDate.toISOString() : <any>undefined;
        data["conditionalInspection"] = this.conditionalInspection;
        data["isConditionalInspectionNegotiable"] = this.isConditionalInspectionNegotiable;
        data["newConditionalInspection"] = this.newConditionalInspection;
        data["conditionalInspectionPeriod"] = this.conditionalInspectionPeriod;
        data["newConditionalInspectionPeriod"] = this.newConditionalInspectionPeriod;
        data["conditionalInspectionDate"] = this.conditionalInspectionDate ? this.conditionalInspectionDate.toISOString() : <any>undefined;
        data["newConditionalInspectionDate"] = this.newConditionalInspectionDate ? this.newConditionalInspectionDate.toISOString() : <any>undefined;
        data["conditionalSaleOfHome"] = this.conditionalSaleOfHome;
        data["newConditionalSaleOfHome"] = this.newConditionalSaleOfHome;
        data["conditionalSaleOfHomePeriod"] = this.conditionalSaleOfHomePeriod;
        data["newConditionalSaleOfHomePeriod"] = this.newConditionalSaleOfHomePeriod;
        data["conditionalSaleOfHomeDate"] = this.conditionalSaleOfHomeDate ? this.conditionalSaleOfHomeDate.toISOString() : <any>undefined;
        data["newConditionalSaleOfHomeDate"] = this.newConditionalSaleOfHomeDate ? this.newConditionalSaleOfHomeDate.toISOString() : <any>undefined;
        data["dueDiligenceExtended"] = this.dueDiligenceExtended;
        data["newDueDiligenceExtended"] = this.newDueDiligenceExtended;
        if (Array.isArray(this.additionalNotes)) {
            data["additionalNotes"] = [];
            for (let item of this.additionalNotes)
                data["additionalNotes"].push(item);
        }
        if (Array.isArray(this.newAdditionalNotes)) {
            data["newAdditionalNotes"] = [];
            for (let item of this.newAdditionalNotes)
                data["newAdditionalNotes"].push(item);
        }
        data["dueDiligencePeriod"] = this.dueDiligencePeriod;
        data["newDueDiligencePeriod"] = this.newDueDiligencePeriod;
        data["dueDiligenceDate"] = this.dueDiligenceDate ? this.dueDiligenceDate.toISOString() : <any>undefined;
        data["newDueDiligenceDate"] = this.newDueDiligenceDate ? this.newDueDiligenceDate.toISOString() : <any>undefined;
        data["dueDiligenceExtendedReason"] = this.dueDiligenceExtendedReason;
        data["newDueDiligenceExtendedReason"] = this.newDueDiligenceExtendedReason;
        data["depositMode"] = this.depositMode;
        data["validUntilDateTimeUtc"] = this.validUntilDateTimeUtc ? this.validUntilDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOfferDto {
    version?: number;
    round?: number;
    offerPrice?: number;
    newOfferPrice?: number | undefined;
    isOfferPriceNegotiable?: boolean | undefined;
    minimumOfferPrice?: number | undefined;
    creator?: OfferCreator;
    creationDateTimeUtc?: Date | undefined;
    status?: OfferStatus;
    finalStatusUpdateDateTimeUtc?: Date | undefined;
    sentDateTimeUtc?: Date | undefined;
    offerType?: OfferType | undefined;
    financedAmount?: number | undefined;
    extensions?: OfferExtensionDto[] | undefined;
    depositStructures?: DepositStructureDto[] | undefined;
    newDepositStructures?: DepositStructureDto[] | undefined;
    isDepositNegotiable?: boolean | undefined;
    minimumDepositPrice?: number | undefined;
    maximumDepositPrice?: number | undefined;
    closingPeriod?: number;
    newClosingPeriod?: number | undefined;
    possessionPeriod?: number | undefined;
    newPossessionPeriod?: number | undefined;
    possessionDateTime?: Date | undefined;
    newPossessionDateTime?: Date | undefined;
    isPossessionDateNegotiable?: boolean | undefined;
    closingDateTime?: Date | undefined;
    newClosingDateTime?: Date | undefined;
    completionDateFormat?: CompletionDateFormat;
    ownershipDocsPeriod?: number;
    newOwnershipDocsPeriod?: number | undefined;
    ownershipDocsDate?: Date | undefined;
    newOwnershipDocsDate?: Date | undefined;
    isOwnershipDocsPeriodNegotiable?: boolean;
    inclusions?: ListingContractItemDto[] | undefined;
    newInclusions?: ListingContractItemDto[] | undefined;
    exclusions?: ListingContractItemDto[] | undefined;
    newExclusions?: ListingContractItemDto[] | undefined;
    nonConditionalOffer?: boolean;
    newNonConditionalOffer?: boolean;
    conditionalFinancing?: boolean;
    isConditionalFinancingNegotiable?: boolean | undefined;
    newConditionalFinancing?: boolean | undefined;
    conditionalFinancingPeriod?: number | undefined;
    newConditionalFinancingPeriod?: number | undefined;
    conditionalFinancingDate?: Date | undefined;
    newConditionalFinancingDate?: Date | undefined;
    conditionalInspection?: boolean;
    isConditionalInspectionNegotiable?: boolean | undefined;
    newConditionalInspection?: boolean | undefined;
    conditionalInspectionPeriod?: number | undefined;
    newConditionalInspectionPeriod?: number | undefined;
    conditionalInspectionDate?: Date | undefined;
    newConditionalInspectionDate?: Date | undefined;
    conditionalSaleOfHome?: boolean;
    newConditionalSaleOfHome?: boolean | undefined;
    conditionalSaleOfHomePeriod?: number | undefined;
    newConditionalSaleOfHomePeriod?: number | undefined;
    conditionalSaleOfHomeDate?: Date | undefined;
    newConditionalSaleOfHomeDate?: Date | undefined;
    dueDiligenceExtended?: boolean | undefined;
    newDueDiligenceExtended?: boolean | undefined;
    additionalNotes?: string[] | undefined;
    newAdditionalNotes?: string[] | undefined;
    dueDiligencePeriod?: number;
    newDueDiligencePeriod?: number | undefined;
    dueDiligenceDate?: Date | undefined;
    newDueDiligenceDate?: Date | undefined;
    dueDiligenceExtendedReason?: string | undefined;
    newDueDiligenceExtendedReason?: string | undefined;
    depositMode?: DepositMode;
    validUntilDateTimeUtc?: Date | undefined;
}

export enum OfferCreator {
    Seller = 0,
    Buyer = 1,
}

export enum OfferStatus {
    Draft = 0,
    Sent = 1,
    Accepted = 2,
    Declined = 3,
    Expired = 4,
    Countered = 5,
    Cancelled = 6,
    DealFellThrough = 7,
}

export class GetOfferHistoryResponseDto implements IGetOfferHistoryResponseDto {
    events?: OfferHistoryEventDto[] | undefined;

    constructor(data?: IGetOfferHistoryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(OfferHistoryEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOfferHistoryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferHistoryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOfferHistoryResponseDto {
    events?: OfferHistoryEventDto[] | undefined;
}

export class OfferHistoryEventDto implements IOfferHistoryEventDto {
    type?: OfferHistoryEventType;
    createdDateTimeUtc?: Date;
    fromUserName?: string | undefined;
    toUserNames?: string[] | undefined;
    offerId?: string | undefined;
    offerStatus?: OfferStatus | undefined;
    offerPrice?: number | undefined;
    extensionId?: number | undefined;
    extensionStatus?: OfferExtensionStatus | undefined;
    extensionDurationInHours?: number | undefined;
    newValidUntilDateTimeUtc?: Date | undefined;
    reason?: string | undefined;

    constructor(data?: IOfferHistoryEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.fromUserName = _data["fromUserName"];
            if (Array.isArray(_data["toUserNames"])) {
                this.toUserNames = [] as any;
                for (let item of _data["toUserNames"])
                    this.toUserNames!.push(item);
            }
            this.offerId = _data["offerId"];
            this.offerStatus = _data["offerStatus"];
            this.offerPrice = _data["offerPrice"];
            this.extensionId = _data["extensionId"];
            this.extensionStatus = _data["extensionStatus"];
            this.extensionDurationInHours = _data["extensionDurationInHours"];
            this.newValidUntilDateTimeUtc = _data["newValidUntilDateTimeUtc"] ? new Date(_data["newValidUntilDateTimeUtc"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): OfferHistoryEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferHistoryEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["fromUserName"] = this.fromUserName;
        if (Array.isArray(this.toUserNames)) {
            data["toUserNames"] = [];
            for (let item of this.toUserNames)
                data["toUserNames"].push(item);
        }
        data["offerId"] = this.offerId;
        data["offerStatus"] = this.offerStatus;
        data["offerPrice"] = this.offerPrice;
        data["extensionId"] = this.extensionId;
        data["extensionStatus"] = this.extensionStatus;
        data["extensionDurationInHours"] = this.extensionDurationInHours;
        data["newValidUntilDateTimeUtc"] = this.newValidUntilDateTimeUtc ? this.newValidUntilDateTimeUtc.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IOfferHistoryEventDto {
    type?: OfferHistoryEventType;
    createdDateTimeUtc?: Date;
    fromUserName?: string | undefined;
    toUserNames?: string[] | undefined;
    offerId?: string | undefined;
    offerStatus?: OfferStatus | undefined;
    offerPrice?: number | undefined;
    extensionId?: number | undefined;
    extensionStatus?: OfferExtensionStatus | undefined;
    extensionDurationInHours?: number | undefined;
    newValidUntilDateTimeUtc?: Date | undefined;
    reason?: string | undefined;
}

export enum OfferHistoryEventType {
    Offer = 0,
    Extension = 1,
    AmendmentRequest = 2,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class RequestDealExtensionCommand implements IRequestDealExtensionCommand {
    extensionDurationInHours?: number;
    reason?: string | undefined;
    message?: string | undefined;
    verificationId?: string | undefined;
    verificationCode?: string | undefined;

    constructor(data?: IRequestDealExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extensionDurationInHours = _data["extensionDurationInHours"];
            this.reason = _data["reason"];
            this.message = _data["message"];
            this.verificationId = _data["verificationId"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): RequestDealExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDealExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionDurationInHours"] = this.extensionDurationInHours;
        data["reason"] = this.reason;
        data["message"] = this.message;
        data["verificationId"] = this.verificationId;
        data["verificationCode"] = this.verificationCode;
        return data;
    }
}

export interface IRequestDealExtensionCommand {
    extensionDurationInHours?: number;
    reason?: string | undefined;
    message?: string | undefined;
    verificationId?: string | undefined;
    verificationCode?: string | undefined;
}

export class AcceptDealExtensionCommand implements IAcceptDealExtensionCommand {

    constructor(data?: IAcceptDealExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AcceptDealExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptDealExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAcceptDealExtensionCommand {
}

export class DeclineDealExtensionCommand implements IDeclineDealExtensionCommand {

    constructor(data?: IDeclineDealExtensionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeclineDealExtensionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineDealExtensionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeclineDealExtensionCommand {
}

export class DealExtensionsDto implements IDealExtensionsDto {
    id?: number;
    validUntilDateTimeUtc?: Date;
    extensionDurationInHours?: number;
    reason?: string | undefined;
    message?: string | undefined;
    status?: DealExtensionStatus;
    sendbirdMessageId?: number | undefined;
    creationDateTimeUtc?: Date | undefined;
    createdByName?: string | undefined;
    createdById?: string | undefined;

    constructor(data?: IDealExtensionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validUntilDateTimeUtc = _data["validUntilDateTimeUtc"] ? new Date(_data["validUntilDateTimeUtc"].toString()) : <any>undefined;
            this.extensionDurationInHours = _data["extensionDurationInHours"];
            this.reason = _data["reason"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.sendbirdMessageId = _data["sendbirdMessageId"];
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.createdByName = _data["createdByName"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): DealExtensionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealExtensionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validUntilDateTimeUtc"] = this.validUntilDateTimeUtc ? this.validUntilDateTimeUtc.toISOString() : <any>undefined;
        data["extensionDurationInHours"] = this.extensionDurationInHours;
        data["reason"] = this.reason;
        data["message"] = this.message;
        data["status"] = this.status;
        data["sendbirdMessageId"] = this.sendbirdMessageId;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["createdByName"] = this.createdByName;
        data["createdById"] = this.createdById;
        return data;
    }
}

export interface IDealExtensionsDto {
    id?: number;
    validUntilDateTimeUtc?: Date;
    extensionDurationInHours?: number;
    reason?: string | undefined;
    message?: string | undefined;
    status?: DealExtensionStatus;
    sendbirdMessageId?: number | undefined;
    creationDateTimeUtc?: Date | undefined;
    createdByName?: string | undefined;
    createdById?: string | undefined;
}

export enum DealExtensionStatus {
    Sent = 0,
    Accepted = 1,
    Denied = 2,
    Expired = 3,
}

export class ContractDto implements IContractDto {
    id?: string | undefined;
    contractType?: ContractType;
    createdDateTimeUtc?: Date;
    executedDateTimeUtc?: Date | undefined;
    signedByAllSellersDateTimeUtc?: Date | undefined;
    signedByAllBuyersDateTimeUtc?: Date | undefined;
    isSignedByAllBuyers?: boolean;
    isSignedByAllSellers?: boolean;
    amendmentNumber?: number | undefined;
    contractSections?: ContractSectionDto[] | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractType = _data["contractType"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.executedDateTimeUtc = _data["executedDateTimeUtc"] ? new Date(_data["executedDateTimeUtc"].toString()) : <any>undefined;
            this.signedByAllSellersDateTimeUtc = _data["signedByAllSellersDateTimeUtc"] ? new Date(_data["signedByAllSellersDateTimeUtc"].toString()) : <any>undefined;
            this.signedByAllBuyersDateTimeUtc = _data["signedByAllBuyersDateTimeUtc"] ? new Date(_data["signedByAllBuyersDateTimeUtc"].toString()) : <any>undefined;
            this.isSignedByAllBuyers = _data["isSignedByAllBuyers"];
            this.isSignedByAllSellers = _data["isSignedByAllSellers"];
            this.amendmentNumber = _data["amendmentNumber"];
            if (Array.isArray(_data["contractSections"])) {
                this.contractSections = [] as any;
                for (let item of _data["contractSections"])
                    this.contractSections!.push(ContractSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractType"] = this.contractType;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["executedDateTimeUtc"] = this.executedDateTimeUtc ? this.executedDateTimeUtc.toISOString() : <any>undefined;
        data["signedByAllSellersDateTimeUtc"] = this.signedByAllSellersDateTimeUtc ? this.signedByAllSellersDateTimeUtc.toISOString() : <any>undefined;
        data["signedByAllBuyersDateTimeUtc"] = this.signedByAllBuyersDateTimeUtc ? this.signedByAllBuyersDateTimeUtc.toISOString() : <any>undefined;
        data["isSignedByAllBuyers"] = this.isSignedByAllBuyers;
        data["isSignedByAllSellers"] = this.isSignedByAllSellers;
        data["amendmentNumber"] = this.amendmentNumber;
        if (Array.isArray(this.contractSections)) {
            data["contractSections"] = [];
            for (let item of this.contractSections)
                data["contractSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractDto {
    id?: string | undefined;
    contractType?: ContractType;
    createdDateTimeUtc?: Date;
    executedDateTimeUtc?: Date | undefined;
    signedByAllSellersDateTimeUtc?: Date | undefined;
    signedByAllBuyersDateTimeUtc?: Date | undefined;
    isSignedByAllBuyers?: boolean;
    isSignedByAllSellers?: boolean;
    amendmentNumber?: number | undefined;
    contractSections?: ContractSectionDto[] | undefined;
}

export class ContractSectionDto implements IContractSectionDto {
    downloadUrl?: string | undefined;
    downloadExpiryDate?: Date;
    section?: ContractSectionType;
    agreedToSection?: boolean;
    filePath?: string | undefined;

    constructor(data?: IContractSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadUrl = _data["downloadUrl"];
            this.downloadExpiryDate = _data["downloadExpiryDate"] ? new Date(_data["downloadExpiryDate"].toString()) : <any>undefined;
            this.section = _data["section"];
            this.agreedToSection = _data["agreedToSection"];
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): ContractSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadUrl"] = this.downloadUrl;
        data["downloadExpiryDate"] = this.downloadExpiryDate ? this.downloadExpiryDate.toISOString() : <any>undefined;
        data["section"] = this.section;
        data["agreedToSection"] = this.agreedToSection;
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IContractSectionDto {
    downloadUrl?: string | undefined;
    downloadExpiryDate?: Date;
    section?: ContractSectionType;
    agreedToSection?: boolean;
    filePath?: string | undefined;
}

export enum ContractDownloadOptions {
    Split = 0,
    Contract = 1,
    Watermarked = 2,
}

export class SignContractCommand implements ISignContractCommand {
    signatureBase64?: string | undefined;
    completedVerificationId?: string | undefined;

    constructor(data?: ISignContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signatureBase64 = _data["signatureBase64"];
            this.completedVerificationId = _data["completedVerificationId"];
        }
    }

    static fromJS(data: any): SignContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SignContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signatureBase64"] = this.signatureBase64;
        data["completedVerificationId"] = this.completedVerificationId;
        return data;
    }
}

export interface ISignContractCommand {
    signatureBase64?: string | undefined;
    completedVerificationId?: string | undefined;
}

export class ContractSignatureDto implements IContractSignatureDto {
    id?: string | undefined;
    signedById?: string | undefined;
    signedByName?: string | undefined;
    signerRole?: SignerRole;
    signedDateTimeUtc?: Date;
    signatureImageUrl?: string | undefined;

    constructor(data?: IContractSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.signedById = _data["signedById"];
            this.signedByName = _data["signedByName"];
            this.signerRole = _data["signerRole"];
            this.signedDateTimeUtc = _data["signedDateTimeUtc"] ? new Date(_data["signedDateTimeUtc"].toString()) : <any>undefined;
            this.signatureImageUrl = _data["signatureImageUrl"];
        }
    }

    static fromJS(data: any): ContractSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signedById"] = this.signedById;
        data["signedByName"] = this.signedByName;
        data["signerRole"] = this.signerRole;
        data["signedDateTimeUtc"] = this.signedDateTimeUtc ? this.signedDateTimeUtc.toISOString() : <any>undefined;
        data["signatureImageUrl"] = this.signatureImageUrl;
        return data;
    }
}

export interface IContractSignatureDto {
    id?: string | undefined;
    signedById?: string | undefined;
    signedByName?: string | undefined;
    signerRole?: SignerRole;
    signedDateTimeUtc?: Date;
    signatureImageUrl?: string | undefined;
}

export class CreateClientLeadSelfRegisterCommand implements ICreateClientLeadSelfRegisterCommand {
    waitList?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    dialCode?: string | undefined;
    phoneNumber?: string | undefined;
    isFromContactForm?: boolean;
    contactMessage?: string | undefined;
    phoneNumberExtension?: string | undefined;
    languageType?: LanguageType;
    prefersLakeAccess?: boolean;
    isAnAgent?: boolean;
    referrerId?: number | undefined;
    listingNumber?: number | undefined;
    projectId?: number | undefined;
    sendNotification?: boolean;
    isLandingPageRegister?: boolean;
    registeredFrom?: string | undefined;
    projectName?: string | undefined;
    budget?: string | undefined;
    unitSize?: string | undefined;

    constructor(data?: ICreateClientLeadSelfRegisterCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waitList = _data["waitList"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.dialCode = _data["dialCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.isFromContactForm = _data["isFromContactForm"];
            this.contactMessage = _data["contactMessage"];
            this.phoneNumberExtension = _data["phoneNumberExtension"];
            this.languageType = _data["languageType"];
            this.prefersLakeAccess = _data["prefersLakeAccess"];
            this.isAnAgent = _data["isAnAgent"];
            this.referrerId = _data["referrerId"];
            this.listingNumber = _data["listingNumber"];
            this.projectId = _data["projectId"];
            this.sendNotification = _data["sendNotification"];
            this.isLandingPageRegister = _data["isLandingPageRegister"];
            this.registeredFrom = _data["registeredFrom"];
            this.projectName = _data["projectName"];
            this.budget = _data["budget"];
            this.unitSize = _data["unitSize"];
        }
    }

    static fromJS(data: any): CreateClientLeadSelfRegisterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientLeadSelfRegisterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitList"] = this.waitList;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["dialCode"] = this.dialCode;
        data["phoneNumber"] = this.phoneNumber;
        data["isFromContactForm"] = this.isFromContactForm;
        data["contactMessage"] = this.contactMessage;
        data["phoneNumberExtension"] = this.phoneNumberExtension;
        data["languageType"] = this.languageType;
        data["prefersLakeAccess"] = this.prefersLakeAccess;
        data["isAnAgent"] = this.isAnAgent;
        data["referrerId"] = this.referrerId;
        data["listingNumber"] = this.listingNumber;
        data["projectId"] = this.projectId;
        data["sendNotification"] = this.sendNotification;
        data["isLandingPageRegister"] = this.isLandingPageRegister;
        data["registeredFrom"] = this.registeredFrom;
        data["projectName"] = this.projectName;
        data["budget"] = this.budget;
        data["unitSize"] = this.unitSize;
        return data;
    }
}

export interface ICreateClientLeadSelfRegisterCommand {
    waitList?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    dialCode?: string | undefined;
    phoneNumber?: string | undefined;
    isFromContactForm?: boolean;
    contactMessage?: string | undefined;
    phoneNumberExtension?: string | undefined;
    languageType?: LanguageType;
    prefersLakeAccess?: boolean;
    isAnAgent?: boolean;
    referrerId?: number | undefined;
    listingNumber?: number | undefined;
    projectId?: number | undefined;
    sendNotification?: boolean;
    isLandingPageRegister?: boolean;
    registeredFrom?: string | undefined;
    projectName?: string | undefined;
    budget?: string | undefined;
    unitSize?: string | undefined;
}

export class SubscriptionCodeDto implements ISubscriptionCodeDto {
    code?: string | undefined;
    redeemedOnDateTimeUtc?: Date | undefined;
    creationDateTimeUtc?: Date | undefined;
    numberOfMonths?: number;

    constructor(data?: ISubscriptionCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.redeemedOnDateTimeUtc = _data["redeemedOnDateTimeUtc"] ? new Date(_data["redeemedOnDateTimeUtc"].toString()) : <any>undefined;
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.numberOfMonths = _data["numberOfMonths"];
        }
    }

    static fromJS(data: any): SubscriptionCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["redeemedOnDateTimeUtc"] = this.redeemedOnDateTimeUtc ? this.redeemedOnDateTimeUtc.toISOString() : <any>undefined;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["numberOfMonths"] = this.numberOfMonths;
        return data;
    }
}

export interface ISubscriptionCodeDto {
    code?: string | undefined;
    redeemedOnDateTimeUtc?: Date | undefined;
    creationDateTimeUtc?: Date | undefined;
    numberOfMonths?: number;
}

export class GenerateSubscriptionCodeCommand implements IGenerateSubscriptionCodeCommand {
    numberOfMonths?: number;
    numberOfCodes?: number;

    constructor(data?: IGenerateSubscriptionCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfMonths = _data["numberOfMonths"];
            this.numberOfCodes = _data["numberOfCodes"];
        }
    }

    static fromJS(data: any): GenerateSubscriptionCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateSubscriptionCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfMonths"] = this.numberOfMonths;
        data["numberOfCodes"] = this.numberOfCodes;
        return data;
    }
}

export interface IGenerateSubscriptionCodeCommand {
    numberOfMonths?: number;
    numberOfCodes?: number;
}

export class PaginatedResultOfListingLookupDto extends PaginatedResult implements IPaginatedResultOfListingLookupDto {
    entities?: ListingLookupDto[] | undefined;

    constructor(data?: IPaginatedResultOfListingLookupDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ListingLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfListingLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfListingLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfListingLookupDto extends IPaginatedResult {
    entities?: ListingLookupDto[] | undefined;
}

export class ListingLookupDto implements IListingLookupDto {
    id?: number;
    lotNumber?: string | undefined;
    lotName?: string | undefined;
    name?: string | undefined;
    floor?: string | undefined;
    projectName?: string | undefined;
    index?: number;
    builderName?: string | undefined;
    hasPropertyTemplate?: boolean;
    projectId?: number | undefined;
    displayImage?: ImageMediaDto | undefined;
    buildingId?: string | undefined;
    buildingName?: string | undefined;
    phaseId?: string | undefined;
    outdoorSquareFeet?: number | undefined;
    indoorSquareFeet?: number | undefined;
    totalListingAreaInSqMeters?: number | undefined;
    price?: number | undefined;
    soldPrice?: number | undefined;
    buyUrl?: string | undefined;
    shareUrl?: string | undefined;
    propertyDirections?: string[] | undefined;
    unitNumber?: string | undefined;
    realEstateType?: RealEstateType | undefined;
    projectLogo?: ImageMediaDto | undefined;
    builderId?: number | undefined;
    building?: NestedBuildingDto | undefined;
    ownedByUserId?: string | undefined;
    address?: AddressDto | undefined;
    propertyType?: ListingType | undefined;
    creationDateTimeUtc?: Date | undefined;
    state?: ListingState | undefined;
    activeDateTimeUtc?: Date | undefined;
    cancelledDateTimeUtc?: Date | undefined;
    soldDateTimeUtc?: Date | undefined;
    archivedDateTimeUtc?: Date | undefined;
    lastSavedDateTimeUtc?: Date | undefined;
    submittedDateTimeUtc?: Date | undefined;
    lastListingStateChangeDateTimeUtc?: Date | undefined;
    lastReviewedDateTimeUtc?: Date | undefined;
    approvedOrDeniedListingDateTimeUtc?: Date | undefined;
    publicListingUrl?: string | undefined;
    lastCompletedListingStep?: string | undefined;
    archived?: boolean;
    reviewers?: string[] | undefined;
    numberOfReviewGroupSections?: number | undefined;
    numberOfReviewedGroupSections?: number | undefined;
    constructionType?: ConstructionType | undefined;
    otherConstructionType?: string | undefined;
    draftStatus?: DraftStatus;
    draftStatusDate?: Date | undefined;
    parentListingId?: number | undefined;
    bedroomQuantity?: number | undefined;
    bathroomQuantity?: number | undefined;
    powderRoomQuantity?: number | undefined;
    marketingDescription?: string | undefined;
    marketingName?: string | undefined;
    tier?: ListingTier;
    subscriptionExpiryDateTimeUtc?: Date | undefined;
    subscriptionRenewalDateTimeUtc?: Date | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    ownerEmail?: string | undefined;
    externalSourceName?: string | undefined;
    externalSourceLogoImage?: ImageMediaDto | undefined;
    isAvailableForSale?: boolean;
    isAvailableForRent?: boolean;
    monthlyRent?: number | undefined;

    constructor(data?: IListingLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lotNumber = _data["lotNumber"];
            this.lotName = _data["lotName"];
            this.name = _data["name"];
            this.floor = _data["floor"];
            this.projectName = _data["projectName"];
            this.index = _data["index"];
            this.builderName = _data["builderName"];
            this.hasPropertyTemplate = _data["hasPropertyTemplate"];
            this.projectId = _data["projectId"];
            this.displayImage = _data["displayImage"] ? ImageMediaDto.fromJS(_data["displayImage"]) : <any>undefined;
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.phaseId = _data["phaseId"];
            this.outdoorSquareFeet = _data["outdoorSquareFeet"];
            this.indoorSquareFeet = _data["indoorSquareFeet"];
            this.totalListingAreaInSqMeters = _data["totalListingAreaInSqMeters"];
            this.price = _data["price"];
            this.soldPrice = _data["soldPrice"];
            this.buyUrl = _data["buyUrl"];
            this.shareUrl = _data["shareUrl"];
            if (Array.isArray(_data["propertyDirections"])) {
                this.propertyDirections = [] as any;
                for (let item of _data["propertyDirections"])
                    this.propertyDirections!.push(item);
            }
            this.unitNumber = _data["unitNumber"];
            this.realEstateType = _data["realEstateType"];
            this.projectLogo = _data["projectLogo"] ? ImageMediaDto.fromJS(_data["projectLogo"]) : <any>undefined;
            this.builderId = _data["builderId"];
            this.building = _data["building"] ? NestedBuildingDto.fromJS(_data["building"]) : <any>undefined;
            this.ownedByUserId = _data["ownedByUserId"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.propertyType = _data["propertyType"];
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.activeDateTimeUtc = _data["activeDateTimeUtc"] ? new Date(_data["activeDateTimeUtc"].toString()) : <any>undefined;
            this.cancelledDateTimeUtc = _data["cancelledDateTimeUtc"] ? new Date(_data["cancelledDateTimeUtc"].toString()) : <any>undefined;
            this.soldDateTimeUtc = _data["soldDateTimeUtc"] ? new Date(_data["soldDateTimeUtc"].toString()) : <any>undefined;
            this.archivedDateTimeUtc = _data["archivedDateTimeUtc"] ? new Date(_data["archivedDateTimeUtc"].toString()) : <any>undefined;
            this.lastSavedDateTimeUtc = _data["lastSavedDateTimeUtc"] ? new Date(_data["lastSavedDateTimeUtc"].toString()) : <any>undefined;
            this.submittedDateTimeUtc = _data["submittedDateTimeUtc"] ? new Date(_data["submittedDateTimeUtc"].toString()) : <any>undefined;
            this.lastListingStateChangeDateTimeUtc = _data["lastListingStateChangeDateTimeUtc"] ? new Date(_data["lastListingStateChangeDateTimeUtc"].toString()) : <any>undefined;
            this.lastReviewedDateTimeUtc = _data["lastReviewedDateTimeUtc"] ? new Date(_data["lastReviewedDateTimeUtc"].toString()) : <any>undefined;
            this.approvedOrDeniedListingDateTimeUtc = _data["approvedOrDeniedListingDateTimeUtc"] ? new Date(_data["approvedOrDeniedListingDateTimeUtc"].toString()) : <any>undefined;
            this.publicListingUrl = _data["publicListingUrl"];
            this.lastCompletedListingStep = _data["lastCompletedListingStep"];
            this.archived = _data["archived"];
            if (Array.isArray(_data["reviewers"])) {
                this.reviewers = [] as any;
                for (let item of _data["reviewers"])
                    this.reviewers!.push(item);
            }
            this.numberOfReviewGroupSections = _data["numberOfReviewGroupSections"];
            this.numberOfReviewedGroupSections = _data["numberOfReviewedGroupSections"];
            this.constructionType = _data["constructionType"];
            this.otherConstructionType = _data["otherConstructionType"];
            this.draftStatus = _data["draftStatus"];
            this.draftStatusDate = _data["draftStatusDate"] ? new Date(_data["draftStatusDate"].toString()) : <any>undefined;
            this.parentListingId = _data["parentListingId"];
            this.bedroomQuantity = _data["bedroomQuantity"];
            this.bathroomQuantity = _data["bathroomQuantity"];
            this.powderRoomQuantity = _data["powderRoomQuantity"];
            this.marketingDescription = _data["marketingDescription"];
            this.marketingName = _data["marketingName"];
            this.tier = _data["tier"];
            this.subscriptionExpiryDateTimeUtc = _data["subscriptionExpiryDateTimeUtc"] ? new Date(_data["subscriptionExpiryDateTimeUtc"].toString()) : <any>undefined;
            this.subscriptionRenewalDateTimeUtc = _data["subscriptionRenewalDateTimeUtc"] ? new Date(_data["subscriptionRenewalDateTimeUtc"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.ownerEmail = _data["ownerEmail"];
            this.externalSourceName = _data["externalSourceName"];
            this.externalSourceLogoImage = _data["externalSourceLogoImage"] ? ImageMediaDto.fromJS(_data["externalSourceLogoImage"]) : <any>undefined;
            this.isAvailableForSale = _data["isAvailableForSale"];
            this.isAvailableForRent = _data["isAvailableForRent"];
            this.monthlyRent = _data["monthlyRent"];
        }
    }

    static fromJS(data: any): ListingLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lotNumber"] = this.lotNumber;
        data["lotName"] = this.lotName;
        data["name"] = this.name;
        data["floor"] = this.floor;
        data["projectName"] = this.projectName;
        data["index"] = this.index;
        data["builderName"] = this.builderName;
        data["hasPropertyTemplate"] = this.hasPropertyTemplate;
        data["projectId"] = this.projectId;
        data["displayImage"] = this.displayImage ? this.displayImage.toJSON() : <any>undefined;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["phaseId"] = this.phaseId;
        data["outdoorSquareFeet"] = this.outdoorSquareFeet;
        data["indoorSquareFeet"] = this.indoorSquareFeet;
        data["totalListingAreaInSqMeters"] = this.totalListingAreaInSqMeters;
        data["price"] = this.price;
        data["soldPrice"] = this.soldPrice;
        data["buyUrl"] = this.buyUrl;
        data["shareUrl"] = this.shareUrl;
        if (Array.isArray(this.propertyDirections)) {
            data["propertyDirections"] = [];
            for (let item of this.propertyDirections)
                data["propertyDirections"].push(item);
        }
        data["unitNumber"] = this.unitNumber;
        data["realEstateType"] = this.realEstateType;
        data["projectLogo"] = this.projectLogo ? this.projectLogo.toJSON() : <any>undefined;
        data["builderId"] = this.builderId;
        data["building"] = this.building ? this.building.toJSON() : <any>undefined;
        data["ownedByUserId"] = this.ownedByUserId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["propertyType"] = this.propertyType;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["activeDateTimeUtc"] = this.activeDateTimeUtc ? this.activeDateTimeUtc.toISOString() : <any>undefined;
        data["cancelledDateTimeUtc"] = this.cancelledDateTimeUtc ? this.cancelledDateTimeUtc.toISOString() : <any>undefined;
        data["soldDateTimeUtc"] = this.soldDateTimeUtc ? this.soldDateTimeUtc.toISOString() : <any>undefined;
        data["archivedDateTimeUtc"] = this.archivedDateTimeUtc ? this.archivedDateTimeUtc.toISOString() : <any>undefined;
        data["lastSavedDateTimeUtc"] = this.lastSavedDateTimeUtc ? this.lastSavedDateTimeUtc.toISOString() : <any>undefined;
        data["submittedDateTimeUtc"] = this.submittedDateTimeUtc ? this.submittedDateTimeUtc.toISOString() : <any>undefined;
        data["lastListingStateChangeDateTimeUtc"] = this.lastListingStateChangeDateTimeUtc ? this.lastListingStateChangeDateTimeUtc.toISOString() : <any>undefined;
        data["lastReviewedDateTimeUtc"] = this.lastReviewedDateTimeUtc ? this.lastReviewedDateTimeUtc.toISOString() : <any>undefined;
        data["approvedOrDeniedListingDateTimeUtc"] = this.approvedOrDeniedListingDateTimeUtc ? this.approvedOrDeniedListingDateTimeUtc.toISOString() : <any>undefined;
        data["publicListingUrl"] = this.publicListingUrl;
        data["lastCompletedListingStep"] = this.lastCompletedListingStep;
        data["archived"] = this.archived;
        if (Array.isArray(this.reviewers)) {
            data["reviewers"] = [];
            for (let item of this.reviewers)
                data["reviewers"].push(item);
        }
        data["numberOfReviewGroupSections"] = this.numberOfReviewGroupSections;
        data["numberOfReviewedGroupSections"] = this.numberOfReviewedGroupSections;
        data["constructionType"] = this.constructionType;
        data["otherConstructionType"] = this.otherConstructionType;
        data["draftStatus"] = this.draftStatus;
        data["draftStatusDate"] = this.draftStatusDate ? this.draftStatusDate.toISOString() : <any>undefined;
        data["parentListingId"] = this.parentListingId;
        data["bedroomQuantity"] = this.bedroomQuantity;
        data["bathroomQuantity"] = this.bathroomQuantity;
        data["powderRoomQuantity"] = this.powderRoomQuantity;
        data["marketingDescription"] = this.marketingDescription;
        data["marketingName"] = this.marketingName;
        data["tier"] = this.tier;
        data["subscriptionExpiryDateTimeUtc"] = this.subscriptionExpiryDateTimeUtc ? this.subscriptionExpiryDateTimeUtc.toISOString() : <any>undefined;
        data["subscriptionRenewalDateTimeUtc"] = this.subscriptionRenewalDateTimeUtc ? this.subscriptionRenewalDateTimeUtc.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["ownerEmail"] = this.ownerEmail;
        data["externalSourceName"] = this.externalSourceName;
        data["externalSourceLogoImage"] = this.externalSourceLogoImage ? this.externalSourceLogoImage.toJSON() : <any>undefined;
        data["isAvailableForSale"] = this.isAvailableForSale;
        data["isAvailableForRent"] = this.isAvailableForRent;
        data["monthlyRent"] = this.monthlyRent;
        return data;
    }
}

export interface IListingLookupDto {
    id?: number;
    lotNumber?: string | undefined;
    lotName?: string | undefined;
    name?: string | undefined;
    floor?: string | undefined;
    projectName?: string | undefined;
    index?: number;
    builderName?: string | undefined;
    hasPropertyTemplate?: boolean;
    projectId?: number | undefined;
    displayImage?: ImageMediaDto | undefined;
    buildingId?: string | undefined;
    buildingName?: string | undefined;
    phaseId?: string | undefined;
    outdoorSquareFeet?: number | undefined;
    indoorSquareFeet?: number | undefined;
    totalListingAreaInSqMeters?: number | undefined;
    price?: number | undefined;
    soldPrice?: number | undefined;
    buyUrl?: string | undefined;
    shareUrl?: string | undefined;
    propertyDirections?: string[] | undefined;
    unitNumber?: string | undefined;
    realEstateType?: RealEstateType | undefined;
    projectLogo?: ImageMediaDto | undefined;
    builderId?: number | undefined;
    building?: NestedBuildingDto | undefined;
    ownedByUserId?: string | undefined;
    address?: AddressDto | undefined;
    propertyType?: ListingType | undefined;
    creationDateTimeUtc?: Date | undefined;
    state?: ListingState | undefined;
    activeDateTimeUtc?: Date | undefined;
    cancelledDateTimeUtc?: Date | undefined;
    soldDateTimeUtc?: Date | undefined;
    archivedDateTimeUtc?: Date | undefined;
    lastSavedDateTimeUtc?: Date | undefined;
    submittedDateTimeUtc?: Date | undefined;
    lastListingStateChangeDateTimeUtc?: Date | undefined;
    lastReviewedDateTimeUtc?: Date | undefined;
    approvedOrDeniedListingDateTimeUtc?: Date | undefined;
    publicListingUrl?: string | undefined;
    lastCompletedListingStep?: string | undefined;
    archived?: boolean;
    reviewers?: string[] | undefined;
    numberOfReviewGroupSections?: number | undefined;
    numberOfReviewedGroupSections?: number | undefined;
    constructionType?: ConstructionType | undefined;
    otherConstructionType?: string | undefined;
    draftStatus?: DraftStatus;
    draftStatusDate?: Date | undefined;
    parentListingId?: number | undefined;
    bedroomQuantity?: number | undefined;
    bathroomQuantity?: number | undefined;
    powderRoomQuantity?: number | undefined;
    marketingDescription?: string | undefined;
    marketingName?: string | undefined;
    tier?: ListingTier;
    subscriptionExpiryDateTimeUtc?: Date | undefined;
    subscriptionRenewalDateTimeUtc?: Date | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    ownerEmail?: string | undefined;
    externalSourceName?: string | undefined;
    externalSourceLogoImage?: ImageMediaDto | undefined;
    isAvailableForSale?: boolean;
    isAvailableForRent?: boolean;
    monthlyRent?: number | undefined;
}

export class NestedBuildingDto implements INestedBuildingDto {
    id?: string;
    name?: string;
    description?: string;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;

    constructor(data?: INestedBuildingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.modifiedDateTimeUtc = _data["modifiedDateTimeUtc"] ? new Date(_data["modifiedDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NestedBuildingDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedBuildingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["modifiedDateTimeUtc"] = this.modifiedDateTimeUtc ? this.modifiedDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface INestedBuildingDto {
    id?: string;
    name?: string;
    description?: string;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;
}

export enum ListingType {
    Condo = 0,
    Apartment = 1,
    TownHome = 2,
    SingleFamilyHome = 3,
    Duplex = 4,
    Land = 5,
    MultiFamilyBuilding = 6,
}

export enum ConstructionType {
    WoodFrame = 0,
    Concrete = 1,
    Masonry = 2,
    SteelFrameConstruction = 3,
    Other = 4,
}

export enum DraftStatus {
    None = 0,
    DraftInProgress = 1,
    PendingReview = 2,
    DraftDeclined = 3,
    LastUpdated = 4,
}

export enum ListingTier {
    Standard = 0,
    Free = 1,
    Curveball = 2,
}

export class ListingImageDto implements IListingImageDto {
    id?: string | undefined;
    caption?: string | undefined;
    sortOrder?: number;
    propertyCategoryId?: string | undefined;
    originalImageId?: string | undefined;
    imageMedia?: NestedImageMediaDto | undefined;
    isVideo?: boolean;

    constructor(data?: IListingImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caption = _data["caption"];
            this.sortOrder = _data["sortOrder"];
            this.propertyCategoryId = _data["propertyCategoryId"];
            this.originalImageId = _data["originalImageId"];
            this.imageMedia = _data["imageMedia"] ? NestedImageMediaDto.fromJS(_data["imageMedia"]) : <any>undefined;
            this.isVideo = _data["isVideo"];
        }
    }

    static fromJS(data: any): ListingImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caption"] = this.caption;
        data["sortOrder"] = this.sortOrder;
        data["propertyCategoryId"] = this.propertyCategoryId;
        data["originalImageId"] = this.originalImageId;
        data["imageMedia"] = this.imageMedia ? this.imageMedia.toJSON() : <any>undefined;
        data["isVideo"] = this.isVideo;
        return data;
    }
}

export interface IListingImageDto {
    id?: string | undefined;
    caption?: string | undefined;
    sortOrder?: number;
    propertyCategoryId?: string | undefined;
    originalImageId?: string | undefined;
    imageMedia?: NestedImageMediaDto | undefined;
    isVideo?: boolean;
}

export class NestedImageMediaDto implements INestedImageMediaDto {
    id?: string | undefined;
    fileName?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    sizeInBytes?: number;
    width?: number | undefined;
    height?: number | undefined;
    uploadedFileName?: string | undefined;

    constructor(data?: INestedImageMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.uploadedFileName = _data["uploadedFileName"];
        }
    }

    static fromJS(data: any): NestedImageMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedImageMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["description"] = this.description;
        data["sizeInBytes"] = this.sizeInBytes;
        data["width"] = this.width;
        data["height"] = this.height;
        data["uploadedFileName"] = this.uploadedFileName;
        return data;
    }
}

export interface INestedImageMediaDto {
    id?: string | undefined;
    fileName?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    sizeInBytes?: number;
    width?: number | undefined;
    height?: number | undefined;
    uploadedFileName?: string | undefined;
}

export class CancelListingCommand implements ICancelListingCommand {

    constructor(data?: ICancelListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CancelListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICancelListingCommand {
}

export class PauseListingCommand implements IPauseListingCommand {
    daysToPause?: number | undefined;
    pauseIndefinitely?: boolean;

    constructor(data?: IPauseListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daysToPause = _data["daysToPause"];
            this.pauseIndefinitely = _data["pauseIndefinitely"];
        }
    }

    static fromJS(data: any): PauseListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PauseListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daysToPause"] = this.daysToPause;
        data["pauseIndefinitely"] = this.pauseIndefinitely;
        return data;
    }
}

export interface IPauseListingCommand {
    daysToPause?: number | undefined;
    pauseIndefinitely?: boolean;
}

export class ResubmitListingCommand implements IResubmitListingCommand {

    constructor(data?: IResubmitListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ResubmitListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResubmitListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IResubmitListingCommand {
}

export class RejectFreeListingCommand implements IRejectFreeListingCommand {
    listingId?: number;
    rejectionReason?: string | undefined;

    constructor(data?: IRejectFreeListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingId = _data["listingId"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): RejectFreeListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejectFreeListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IRejectFreeListingCommand {
    listingId?: number;
    rejectionReason?: string | undefined;
}

export class SubmitListingDraftForApprovalResult implements ISubmitListingDraftForApprovalResult {
    success?: boolean;
    updateType?: DraftSubmissionUpdateType;
    sectionsRequiringApproval?: string[] | undefined;
    sectionsUpdatedImmediately?: string[] | undefined;
    allChangedSections?: string[] | undefined;
    fieldChanges?: FieldChangeInfo[] | undefined;
    draftListingId?: number | undefined;
    message?: string | undefined;

    constructor(data?: ISubmitListingDraftForApprovalResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.updateType = _data["updateType"];
            if (Array.isArray(_data["sectionsRequiringApproval"])) {
                this.sectionsRequiringApproval = [] as any;
                for (let item of _data["sectionsRequiringApproval"])
                    this.sectionsRequiringApproval!.push(item);
            }
            if (Array.isArray(_data["sectionsUpdatedImmediately"])) {
                this.sectionsUpdatedImmediately = [] as any;
                for (let item of _data["sectionsUpdatedImmediately"])
                    this.sectionsUpdatedImmediately!.push(item);
            }
            if (Array.isArray(_data["allChangedSections"])) {
                this.allChangedSections = [] as any;
                for (let item of _data["allChangedSections"])
                    this.allChangedSections!.push(item);
            }
            if (Array.isArray(_data["fieldChanges"])) {
                this.fieldChanges = [] as any;
                for (let item of _data["fieldChanges"])
                    this.fieldChanges!.push(FieldChangeInfo.fromJS(item));
            }
            this.draftListingId = _data["draftListingId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SubmitListingDraftForApprovalResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitListingDraftForApprovalResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["updateType"] = this.updateType;
        if (Array.isArray(this.sectionsRequiringApproval)) {
            data["sectionsRequiringApproval"] = [];
            for (let item of this.sectionsRequiringApproval)
                data["sectionsRequiringApproval"].push(item);
        }
        if (Array.isArray(this.sectionsUpdatedImmediately)) {
            data["sectionsUpdatedImmediately"] = [];
            for (let item of this.sectionsUpdatedImmediately)
                data["sectionsUpdatedImmediately"].push(item);
        }
        if (Array.isArray(this.allChangedSections)) {
            data["allChangedSections"] = [];
            for (let item of this.allChangedSections)
                data["allChangedSections"].push(item);
        }
        if (Array.isArray(this.fieldChanges)) {
            data["fieldChanges"] = [];
            for (let item of this.fieldChanges)
                data["fieldChanges"].push(item.toJSON());
        }
        data["draftListingId"] = this.draftListingId;
        data["message"] = this.message;
        return data;
    }
}

export interface ISubmitListingDraftForApprovalResult {
    success?: boolean;
    updateType?: DraftSubmissionUpdateType;
    sectionsRequiringApproval?: string[] | undefined;
    sectionsUpdatedImmediately?: string[] | undefined;
    allChangedSections?: string[] | undefined;
    fieldChanges?: FieldChangeInfo[] | undefined;
    draftListingId?: number | undefined;
    message?: string | undefined;
}

export enum DraftSubmissionUpdateType {
    NoChanges = 0,
    ImmediateUpdate = 1,
    ApprovalRequired = 2,
    Error = 3,
}

export class FieldChangeInfo implements IFieldChangeInfo {
    fieldName?: string | undefined;
    section?: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;
    requiresApproval?: boolean;

    constructor(data?: IFieldChangeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.section = _data["section"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.requiresApproval = _data["requiresApproval"];
        }
    }

    static fromJS(data: any): FieldChangeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldChangeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["section"] = this.section;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["requiresApproval"] = this.requiresApproval;
        return data;
    }
}

export interface IFieldChangeInfo {
    fieldName?: string | undefined;
    section?: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;
    requiresApproval?: boolean;
}

export class ListingAuditHistoryDto implements IListingAuditHistoryDto {
    listingId?: number;
    auditEntries?: ListingAuditEntryDto[] | undefined;

    constructor(data?: IListingAuditHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingId = _data["listingId"];
            if (Array.isArray(_data["auditEntries"])) {
                this.auditEntries = [] as any;
                for (let item of _data["auditEntries"])
                    this.auditEntries!.push(ListingAuditEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingAuditHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingAuditHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        if (Array.isArray(this.auditEntries)) {
            data["auditEntries"] = [];
            for (let item of this.auditEntries)
                data["auditEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingAuditHistoryDto {
    listingId?: number;
    auditEntries?: ListingAuditEntryDto[] | undefined;
}

export class ListingAuditEntryDto implements IListingAuditEntryDto {
    auditType?: string | undefined;
    timestamp?: Date;
    userId?: string | undefined;
    userName?: string | undefined;
    action?: string | undefined;
    updateType?: string | undefined;
    sectionsAffected?: string[] | undefined;
    sectionsApproved?: string[] | undefined;
    sectionsDeclined?: string[] | undefined;
    fieldChanges?: FieldChangeDetailDto[] | undefined;
    reviewNotes?: string | undefined;
    draftListingId?: number | undefined;

    constructor(data?: IListingAuditEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditType = _data["auditType"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.action = _data["action"];
            this.updateType = _data["updateType"];
            if (Array.isArray(_data["sectionsAffected"])) {
                this.sectionsAffected = [] as any;
                for (let item of _data["sectionsAffected"])
                    this.sectionsAffected!.push(item);
            }
            if (Array.isArray(_data["sectionsApproved"])) {
                this.sectionsApproved = [] as any;
                for (let item of _data["sectionsApproved"])
                    this.sectionsApproved!.push(item);
            }
            if (Array.isArray(_data["sectionsDeclined"])) {
                this.sectionsDeclined = [] as any;
                for (let item of _data["sectionsDeclined"])
                    this.sectionsDeclined!.push(item);
            }
            if (Array.isArray(_data["fieldChanges"])) {
                this.fieldChanges = [] as any;
                for (let item of _data["fieldChanges"])
                    this.fieldChanges!.push(FieldChangeDetailDto.fromJS(item));
            }
            this.reviewNotes = _data["reviewNotes"];
            this.draftListingId = _data["draftListingId"];
        }
    }

    static fromJS(data: any): ListingAuditEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingAuditEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditType"] = this.auditType;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["action"] = this.action;
        data["updateType"] = this.updateType;
        if (Array.isArray(this.sectionsAffected)) {
            data["sectionsAffected"] = [];
            for (let item of this.sectionsAffected)
                data["sectionsAffected"].push(item);
        }
        if (Array.isArray(this.sectionsApproved)) {
            data["sectionsApproved"] = [];
            for (let item of this.sectionsApproved)
                data["sectionsApproved"].push(item);
        }
        if (Array.isArray(this.sectionsDeclined)) {
            data["sectionsDeclined"] = [];
            for (let item of this.sectionsDeclined)
                data["sectionsDeclined"].push(item);
        }
        if (Array.isArray(this.fieldChanges)) {
            data["fieldChanges"] = [];
            for (let item of this.fieldChanges)
                data["fieldChanges"].push(item.toJSON());
        }
        data["reviewNotes"] = this.reviewNotes;
        data["draftListingId"] = this.draftListingId;
        return data;
    }
}

export interface IListingAuditEntryDto {
    auditType?: string | undefined;
    timestamp?: Date;
    userId?: string | undefined;
    userName?: string | undefined;
    action?: string | undefined;
    updateType?: string | undefined;
    sectionsAffected?: string[] | undefined;
    sectionsApproved?: string[] | undefined;
    sectionsDeclined?: string[] | undefined;
    fieldChanges?: FieldChangeDetailDto[] | undefined;
    reviewNotes?: string | undefined;
    draftListingId?: number | undefined;
}

export class FieldChangeDetailDto implements IFieldChangeDetailDto {
    fieldName?: string | undefined;
    section?: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;
    requiresApproval?: boolean;

    constructor(data?: IFieldChangeDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.section = _data["section"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.requiresApproval = _data["requiresApproval"];
        }
    }

    static fromJS(data: any): FieldChangeDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldChangeDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["section"] = this.section;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["requiresApproval"] = this.requiresApproval;
        return data;
    }
}

export interface IFieldChangeDetailDto {
    fieldName?: string | undefined;
    section?: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;
    requiresApproval?: boolean;
}

export class ProcessSectionApprovalRequest implements IProcessSectionApprovalRequest {
    sectionName?: ListingSectionName;
    approvalStatus?: ListingReviewSectionStatus;
    reasonForDecline?: string | undefined;

    constructor(data?: IProcessSectionApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionName = _data["sectionName"];
            this.approvalStatus = _data["approvalStatus"];
            this.reasonForDecline = _data["reasonForDecline"];
        }
    }

    static fromJS(data: any): ProcessSectionApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessSectionApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionName"] = this.sectionName;
        data["approvalStatus"] = this.approvalStatus;
        data["reasonForDecline"] = this.reasonForDecline;
        return data;
    }
}

export interface IProcessSectionApprovalRequest {
    sectionName?: ListingSectionName;
    approvalStatus?: ListingReviewSectionStatus;
    reasonForDecline?: string | undefined;
}

export enum ListingSectionName {
    ListingType = 0,
    CoOwnership = 1,
    Listing = 2,
    ListingOverview = 3,
    ListingDimensions = 4,
    LotAndLandDimensions = 5,
    Parking = 6,
    Storage = 7,
    ListingFeaturesIncluded = 8,
    ViewAndOrientation = 9,
    OpenHouse = 10,
    ScheduleAViewing = 11,
    ListingContact = 12,
    ListingPrice = 13,
    Taxes = 14,
    ReservationHold = 15,
    Deposit = 16,
    AdditionalCostDetails = 17,
    Images = 18,
    Seller = 19,
    Documents = 20,
    Contract = 21,
    GeneralInformation = 22,
    LandAndBuildingBasement = 23,
    Roof = 24,
    WaterInfiltration = 25,
    IndoorAirQuality = 26,
    Electricity = 27,
    PlumbingAndDrainage = 28,
    HeatingAndAirConditioning = 29,
    Miscellaneous = 30,
    RenovationsAndConstruction = 31,
    SupplementaryDocuments = 32,
    OwnerContact = 33,
    PreEmptiveRightDelay = 34,
    SpousalDeclaration = 35,
}

export enum ListingReviewSectionStatus {
    None = 0,
    Approved = 1,
    Declined = 2,
    AwaitingForResponse = 3,
}

export class ApproveListingUpdatesResult implements IApproveListingUpdatesResult {
    approvedSections?: ListingSectionName[] | undefined;
    declinedSections?: ListingSectionName[] | undefined;
    status?: string | undefined;

    constructor(data?: IApproveListingUpdatesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["approvedSections"])) {
                this.approvedSections = [] as any;
                for (let item of _data["approvedSections"])
                    this.approvedSections!.push(item);
            }
            if (Array.isArray(_data["declinedSections"])) {
                this.declinedSections = [] as any;
                for (let item of _data["declinedSections"])
                    this.declinedSections!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ApproveListingUpdatesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveListingUpdatesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.approvedSections)) {
            data["approvedSections"] = [];
            for (let item of this.approvedSections)
                data["approvedSections"].push(item);
        }
        if (Array.isArray(this.declinedSections)) {
            data["declinedSections"] = [];
            for (let item of this.declinedSections)
                data["declinedSections"].push(item);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IApproveListingUpdatesResult {
    approvedSections?: ListingSectionName[] | undefined;
    declinedSections?: ListingSectionName[] | undefined;
    status?: string | undefined;
}

export class UpdateListingStateCommand implements IUpdateListingStateCommand {
    listingState?: ListingState;

    constructor(data?: IUpdateListingStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingState = _data["listingState"];
        }
    }

    static fromJS(data: any): UpdateListingStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListingStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingState"] = this.listingState;
        return data;
    }
}

export interface IUpdateListingStateCommand {
    listingState?: ListingState;
}

export class UpdateListingCompletedStepCommand implements IUpdateListingCompletedStepCommand {
    lastCompletedStep?: string | undefined;

    constructor(data?: IUpdateListingCompletedStepCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastCompletedStep = _data["lastCompletedStep"];
        }
    }

    static fromJS(data: any): UpdateListingCompletedStepCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListingCompletedStepCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastCompletedStep"] = this.lastCompletedStep;
        return data;
    }
}

export interface IUpdateListingCompletedStepCommand {
    lastCompletedStep?: string | undefined;
}

export class ConfirmListingContractCommand implements IConfirmListingContractCommand {

    constructor(data?: IConfirmListingContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ConfirmListingContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmListingContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IConfirmListingContractCommand {
}

export class EditListingImageCommand implements IEditListingImageCommand {
    caption?: string | undefined;

    constructor(data?: IEditListingImageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caption = _data["caption"];
        }
    }

    static fromJS(data: any): EditListingImageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditListingImageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption;
        return data;
    }
}

export interface IEditListingImageCommand {
    caption?: string | undefined;
}

export class ListingDocumentDto implements IListingDocumentDto {
    documentId?: string | undefined;
    document?: DocumentMediaDto | undefined;
    originalDocumentId?: string | undefined;
    supplementaryDocumentName?: string | undefined;

    constructor(data?: IListingDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? DocumentMediaDto.fromJS(_data["document"]) : <any>undefined;
            this.originalDocumentId = _data["originalDocumentId"];
            this.supplementaryDocumentName = _data["supplementaryDocumentName"];
        }
    }

    static fromJS(data: any): ListingDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["originalDocumentId"] = this.originalDocumentId;
        data["supplementaryDocumentName"] = this.supplementaryDocumentName;
        return data;
    }
}

export interface IListingDocumentDto {
    documentId?: string | undefined;
    document?: DocumentMediaDto | undefined;
    originalDocumentId?: string | undefined;
    supplementaryDocumentName?: string | undefined;
}

export class ListingPriceChangeDto implements IListingPriceChangeDto {
    listingId?: number;
    price?: number;
    event?: PropertyPriceChangeEvent;
    priceChangeDate?: Date;

    constructor(data?: IListingPriceChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingId = _data["listingId"];
            this.price = _data["price"];
            this.event = _data["event"];
            this.priceChangeDate = _data["priceChangeDate"] ? new Date(_data["priceChangeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ListingPriceChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingPriceChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        data["price"] = this.price;
        data["event"] = this.event;
        data["priceChangeDate"] = this.priceChangeDate ? this.priceChangeDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IListingPriceChangeDto {
    listingId?: number;
    price?: number;
    event?: PropertyPriceChangeEvent;
    priceChangeDate?: Date;
}

export enum PropertyPriceChangeEvent {
    PriceChange = 0,
    ListedForSale = 1,
}

export abstract class TranslatableDtoOfListingTranslation implements ITranslatableDtoOfListingTranslation {
    defaultLanguageCode?: string | undefined;
    translations?: ListingTranslation[] | undefined;

    constructor(data?: ITranslatableDtoOfListingTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageCode = _data["defaultLanguageCode"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(ListingTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslatableDtoOfListingTranslation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TranslatableDtoOfListingTranslation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageCode"] = this.defaultLanguageCode;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranslatableDtoOfListingTranslation {
    defaultLanguageCode?: string | undefined;
    translations?: ListingTranslation[] | undefined;
}

export class ListingDto extends TranslatableDtoOfListingTranslation implements IListingDto {
    id?: number;
    name?: string | undefined;
    companyName?: string | undefined;
    lotName?: string | undefined;
    isWaterfront?: boolean | undefined;
    outdoorSquareFeet?: number | undefined;
    tier?: ListingTier;
    subscriptionExpiryDateTimeUtc?: Date | undefined;
    subscriptionRenewalDateTimeUtc?: Date | undefined;
    buyUrl?: string | undefined;
    indoorSquareFeet?: number | undefined;
    directions?: string[] | undefined;
    marketingDescription?: string | undefined;
    notes?: string | undefined;
    listingType?: ListingType | undefined;
    constructionType?: ConstructionType | undefined;
    otherConstructionType?: string | undefined;
    foundationType?: ListingFoundationType | undefined;
    otherFoundationType?: string | undefined;
    yearBuilt?: number | undefined;
    buildStatus?: ListingBuildStatus | undefined;
    lotType?: LotType;
    contracts?: ListingContractDto[] | undefined;
    displayImage?: ImageMediaDto | undefined;
    lotNumber?: string | undefined;
    hasParking?: boolean | undefined;
    hasStorage?: boolean | undefined;
    landRegistry?: string | undefined;
    landRegistryType?: LandRegistryType | undefined;
    address?: AddressDto | undefined;
    project?: NestedProjectDto | undefined;
    projectId?: number | undefined;
    price?: number | undefined;
    negotiablePrice?: boolean | undefined;
    minimumNegotiablePrice?: number | undefined;
    acceptsConditionalOffers?: boolean | undefined;
    lotLayoutImage?: ImageMediaDto | undefined;
    lotLocationInPlanImage?: ImageMediaDto | undefined;
    lotLayoutDocument?: DocumentMediaDto | undefined;
    translations?: ListingTranslation[] | undefined;
    building?: NestedBuildingDto | undefined;
    phase?: NestedPhaseDto | undefined;
    realEstateType?: RealEstateType | undefined;
    completionDate?: Date | undefined;
    contractType?: ListingContractType | undefined;
    builder?: ListingBuilderDto | undefined;
    shareUrl?: string | undefined;
    onlineVisitCount?: number;
    saveCount?: number;
    creationDateTimeUtc?: Date | undefined;
    confirmedContractDateTimeUtc?: Date | undefined;
    listingRepresentative?: ListingRepresentativeDto | undefined;
    state?: ListingState | undefined;
    activeDateTimeUtc?: Date | undefined;
    cancelledDateTimeUtc?: Date | undefined;
    soldDateTimeUtc?: Date | undefined;
    archivedDateTimeUtc?: Date | undefined;
    lastSavedDateTimeUtc?: Date | undefined;
    approvedOrDeniedListingDateTimeUtc?: Date | undefined;
    declinedDateTimeUtc?: Date | undefined;
    submittedDateTimeUtc?: Date | undefined;
    declinedBySellerName?: string | undefined;
    archived?: boolean;
    publicListingUrl?: string | undefined;
    soldPrice?: number | undefined;
    lastCompletedListingStep?: string | undefined;
    lastCompletedListingStepDateTimeUtc?: Date | undefined;
    coOwnership?: ListingCoOwnershipDto | undefined;
    overview?: ListingOverviewDto | undefined;
    lotDimensions?: ListingLotDimensionsDto | undefined;
    interior?: ListingInteriorDto | undefined;
    pauseUntilDateTime?: Date | undefined;
    levels?: ListingLevelDimensionsDto[] | undefined;
    parkingSpots?: ListingParkingDto[] | undefined;
    additionalParkingNotes?: string | undefined;
    storageUnits?: ListingStorageDto[] | undefined;
    additionalStorageNotes?: string | undefined;
    taxDetails?: ListingTaxDetailsDto | undefined;
    features?: string[] | undefined;
    scheduleAViewLink?: string | undefined;
    contactPhoneNumber?: string | undefined;
    additionalCostDetails?: ListingAdditionalCostsDto | undefined;
    publishDateTimeUtc?: Date | undefined;
    numberOfReviewGroupSections?: number | undefined;
    numberOfReviewedGroupSections?: number | undefined;
    lastListingStateChangeDateTimeUtc?: Date | undefined;
    lastReviewedDateTimeUtc?: Date | undefined;
    deposit?: ListingDepositDto | undefined;
    contractDates?: ListingContractDatesDto | undefined;
    ownershipDocuments?: ListingOwnershipDocumentsDto | undefined;
    contractInclusions?: ListingContractInclusionsDto | undefined;
    contractExclusions?: ListingContractExclusionsDto | undefined;
    contractAdditionalTerms?: ListingContractAdditionalTermsDto | undefined;
    preEmptiveRightDelay?: ListingPreEmptiveRightDelayDto | undefined;
    isAvailableForSale?: boolean;
    isAvailableForRent?: boolean;
    rentDetails?: ListingRentDetailsDto | undefined;
    draftStatus?: DraftStatus;
    draftStatusDate?: Date | undefined;
    parentListingId?: number | undefined;
    externalSourceName?: string | undefined;
    externalSourceUrl?: string | undefined;
    externalSourceLogoImage?: ImageMediaDto | undefined;

    constructor(data?: IListingDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.lotName = _data["lotName"];
            this.isWaterfront = _data["isWaterfront"];
            this.outdoorSquareFeet = _data["outdoorSquareFeet"];
            this.tier = _data["tier"];
            this.subscriptionExpiryDateTimeUtc = _data["subscriptionExpiryDateTimeUtc"] ? new Date(_data["subscriptionExpiryDateTimeUtc"].toString()) : <any>undefined;
            this.subscriptionRenewalDateTimeUtc = _data["subscriptionRenewalDateTimeUtc"] ? new Date(_data["subscriptionRenewalDateTimeUtc"].toString()) : <any>undefined;
            this.buyUrl = _data["buyUrl"];
            this.indoorSquareFeet = _data["indoorSquareFeet"];
            if (Array.isArray(_data["directions"])) {
                this.directions = [] as any;
                for (let item of _data["directions"])
                    this.directions!.push(item);
            }
            this.marketingDescription = _data["marketingDescription"];
            this.notes = _data["notes"];
            this.listingType = _data["listingType"];
            this.constructionType = _data["constructionType"];
            this.otherConstructionType = _data["otherConstructionType"];
            this.foundationType = _data["foundationType"];
            this.otherFoundationType = _data["otherFoundationType"];
            this.yearBuilt = _data["yearBuilt"];
            this.buildStatus = _data["buildStatus"];
            this.lotType = _data["lotType"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ListingContractDto.fromJS(item));
            }
            this.displayImage = _data["displayImage"] ? ImageMediaDto.fromJS(_data["displayImage"]) : <any>undefined;
            this.lotNumber = _data["lotNumber"];
            this.hasParking = _data["hasParking"];
            this.hasStorage = _data["hasStorage"];
            this.landRegistry = _data["landRegistry"];
            this.landRegistryType = _data["landRegistryType"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.project = _data["project"] ? NestedProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.price = _data["price"];
            this.negotiablePrice = _data["negotiablePrice"];
            this.minimumNegotiablePrice = _data["minimumNegotiablePrice"];
            this.acceptsConditionalOffers = _data["acceptsConditionalOffers"];
            this.lotLayoutImage = _data["lotLayoutImage"] ? ImageMediaDto.fromJS(_data["lotLayoutImage"]) : <any>undefined;
            this.lotLocationInPlanImage = _data["lotLocationInPlanImage"] ? ImageMediaDto.fromJS(_data["lotLocationInPlanImage"]) : <any>undefined;
            this.lotLayoutDocument = _data["lotLayoutDocument"] ? DocumentMediaDto.fromJS(_data["lotLayoutDocument"]) : <any>undefined;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(ListingTranslation.fromJS(item));
            }
            this.building = _data["building"] ? NestedBuildingDto.fromJS(_data["building"]) : <any>undefined;
            this.phase = _data["phase"] ? NestedPhaseDto.fromJS(_data["phase"]) : <any>undefined;
            this.realEstateType = _data["realEstateType"];
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
            this.contractType = _data["contractType"];
            this.builder = _data["builder"] ? ListingBuilderDto.fromJS(_data["builder"]) : <any>undefined;
            this.shareUrl = _data["shareUrl"];
            this.onlineVisitCount = _data["onlineVisitCount"];
            this.saveCount = _data["saveCount"];
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.confirmedContractDateTimeUtc = _data["confirmedContractDateTimeUtc"] ? new Date(_data["confirmedContractDateTimeUtc"].toString()) : <any>undefined;
            this.listingRepresentative = _data["listingRepresentative"] ? ListingRepresentativeDto.fromJS(_data["listingRepresentative"]) : <any>undefined;
            this.state = _data["state"];
            this.activeDateTimeUtc = _data["activeDateTimeUtc"] ? new Date(_data["activeDateTimeUtc"].toString()) : <any>undefined;
            this.cancelledDateTimeUtc = _data["cancelledDateTimeUtc"] ? new Date(_data["cancelledDateTimeUtc"].toString()) : <any>undefined;
            this.soldDateTimeUtc = _data["soldDateTimeUtc"] ? new Date(_data["soldDateTimeUtc"].toString()) : <any>undefined;
            this.archivedDateTimeUtc = _data["archivedDateTimeUtc"] ? new Date(_data["archivedDateTimeUtc"].toString()) : <any>undefined;
            this.lastSavedDateTimeUtc = _data["lastSavedDateTimeUtc"] ? new Date(_data["lastSavedDateTimeUtc"].toString()) : <any>undefined;
            this.approvedOrDeniedListingDateTimeUtc = _data["approvedOrDeniedListingDateTimeUtc"] ? new Date(_data["approvedOrDeniedListingDateTimeUtc"].toString()) : <any>undefined;
            this.declinedDateTimeUtc = _data["declinedDateTimeUtc"] ? new Date(_data["declinedDateTimeUtc"].toString()) : <any>undefined;
            this.submittedDateTimeUtc = _data["submittedDateTimeUtc"] ? new Date(_data["submittedDateTimeUtc"].toString()) : <any>undefined;
            this.declinedBySellerName = _data["declinedBySellerName"];
            this.archived = _data["archived"];
            this.publicListingUrl = _data["publicListingUrl"];
            this.soldPrice = _data["soldPrice"];
            this.lastCompletedListingStep = _data["lastCompletedListingStep"];
            this.lastCompletedListingStepDateTimeUtc = _data["lastCompletedListingStepDateTimeUtc"] ? new Date(_data["lastCompletedListingStepDateTimeUtc"].toString()) : <any>undefined;
            this.coOwnership = _data["coOwnership"] ? ListingCoOwnershipDto.fromJS(_data["coOwnership"]) : <any>undefined;
            this.overview = _data["overview"] ? ListingOverviewDto.fromJS(_data["overview"]) : <any>undefined;
            this.lotDimensions = _data["lotDimensions"] ? ListingLotDimensionsDto.fromJS(_data["lotDimensions"]) : <any>undefined;
            this.interior = _data["interior"] ? ListingInteriorDto.fromJS(_data["interior"]) : <any>undefined;
            this.pauseUntilDateTime = _data["pauseUntilDateTime"] ? new Date(_data["pauseUntilDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(ListingLevelDimensionsDto.fromJS(item));
            }
            if (Array.isArray(_data["parkingSpots"])) {
                this.parkingSpots = [] as any;
                for (let item of _data["parkingSpots"])
                    this.parkingSpots!.push(ListingParkingDto.fromJS(item));
            }
            this.additionalParkingNotes = _data["additionalParkingNotes"];
            if (Array.isArray(_data["storageUnits"])) {
                this.storageUnits = [] as any;
                for (let item of _data["storageUnits"])
                    this.storageUnits!.push(ListingStorageDto.fromJS(item));
            }
            this.additionalStorageNotes = _data["additionalStorageNotes"];
            this.taxDetails = _data["taxDetails"] ? ListingTaxDetailsDto.fromJS(_data["taxDetails"]) : <any>undefined;
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
            this.scheduleAViewLink = _data["scheduleAViewLink"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.additionalCostDetails = _data["additionalCostDetails"] ? ListingAdditionalCostsDto.fromJS(_data["additionalCostDetails"]) : <any>undefined;
            this.publishDateTimeUtc = _data["publishDateTimeUtc"] ? new Date(_data["publishDateTimeUtc"].toString()) : <any>undefined;
            this.numberOfReviewGroupSections = _data["numberOfReviewGroupSections"];
            this.numberOfReviewedGroupSections = _data["numberOfReviewedGroupSections"];
            this.lastListingStateChangeDateTimeUtc = _data["lastListingStateChangeDateTimeUtc"] ? new Date(_data["lastListingStateChangeDateTimeUtc"].toString()) : <any>undefined;
            this.lastReviewedDateTimeUtc = _data["lastReviewedDateTimeUtc"] ? new Date(_data["lastReviewedDateTimeUtc"].toString()) : <any>undefined;
            this.deposit = _data["deposit"] ? ListingDepositDto.fromJS(_data["deposit"]) : <any>undefined;
            this.contractDates = _data["contractDates"] ? ListingContractDatesDto.fromJS(_data["contractDates"]) : <any>undefined;
            this.ownershipDocuments = _data["ownershipDocuments"] ? ListingOwnershipDocumentsDto.fromJS(_data["ownershipDocuments"]) : <any>undefined;
            this.contractInclusions = _data["contractInclusions"] ? ListingContractInclusionsDto.fromJS(_data["contractInclusions"]) : <any>undefined;
            this.contractExclusions = _data["contractExclusions"] ? ListingContractExclusionsDto.fromJS(_data["contractExclusions"]) : <any>undefined;
            this.contractAdditionalTerms = _data["contractAdditionalTerms"] ? ListingContractAdditionalTermsDto.fromJS(_data["contractAdditionalTerms"]) : <any>undefined;
            this.preEmptiveRightDelay = _data["preEmptiveRightDelay"] ? ListingPreEmptiveRightDelayDto.fromJS(_data["preEmptiveRightDelay"]) : <any>undefined;
            this.isAvailableForSale = _data["isAvailableForSale"];
            this.isAvailableForRent = _data["isAvailableForRent"];
            this.rentDetails = _data["rentDetails"] ? ListingRentDetailsDto.fromJS(_data["rentDetails"]) : <any>undefined;
            this.draftStatus = _data["draftStatus"];
            this.draftStatusDate = _data["draftStatusDate"] ? new Date(_data["draftStatusDate"].toString()) : <any>undefined;
            this.parentListingId = _data["parentListingId"];
            this.externalSourceName = _data["externalSourceName"];
            this.externalSourceUrl = _data["externalSourceUrl"];
            this.externalSourceLogoImage = _data["externalSourceLogoImage"] ? ImageMediaDto.fromJS(_data["externalSourceLogoImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["lotName"] = this.lotName;
        data["isWaterfront"] = this.isWaterfront;
        data["outdoorSquareFeet"] = this.outdoorSquareFeet;
        data["tier"] = this.tier;
        data["subscriptionExpiryDateTimeUtc"] = this.subscriptionExpiryDateTimeUtc ? this.subscriptionExpiryDateTimeUtc.toISOString() : <any>undefined;
        data["subscriptionRenewalDateTimeUtc"] = this.subscriptionRenewalDateTimeUtc ? this.subscriptionRenewalDateTimeUtc.toISOString() : <any>undefined;
        data["buyUrl"] = this.buyUrl;
        data["indoorSquareFeet"] = this.indoorSquareFeet;
        if (Array.isArray(this.directions)) {
            data["directions"] = [];
            for (let item of this.directions)
                data["directions"].push(item);
        }
        data["marketingDescription"] = this.marketingDescription;
        data["notes"] = this.notes;
        data["listingType"] = this.listingType;
        data["constructionType"] = this.constructionType;
        data["otherConstructionType"] = this.otherConstructionType;
        data["foundationType"] = this.foundationType;
        data["otherFoundationType"] = this.otherFoundationType;
        data["yearBuilt"] = this.yearBuilt;
        data["buildStatus"] = this.buildStatus;
        data["lotType"] = this.lotType;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        data["displayImage"] = this.displayImage ? this.displayImage.toJSON() : <any>undefined;
        data["lotNumber"] = this.lotNumber;
        data["hasParking"] = this.hasParking;
        data["hasStorage"] = this.hasStorage;
        data["landRegistry"] = this.landRegistry;
        data["landRegistryType"] = this.landRegistryType;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["price"] = this.price;
        data["negotiablePrice"] = this.negotiablePrice;
        data["minimumNegotiablePrice"] = this.minimumNegotiablePrice;
        data["acceptsConditionalOffers"] = this.acceptsConditionalOffers;
        data["lotLayoutImage"] = this.lotLayoutImage ? this.lotLayoutImage.toJSON() : <any>undefined;
        data["lotLocationInPlanImage"] = this.lotLocationInPlanImage ? this.lotLocationInPlanImage.toJSON() : <any>undefined;
        data["lotLayoutDocument"] = this.lotLayoutDocument ? this.lotLayoutDocument.toJSON() : <any>undefined;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["building"] = this.building ? this.building.toJSON() : <any>undefined;
        data["phase"] = this.phase ? this.phase.toJSON() : <any>undefined;
        data["realEstateType"] = this.realEstateType;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["contractType"] = this.contractType;
        data["builder"] = this.builder ? this.builder.toJSON() : <any>undefined;
        data["shareUrl"] = this.shareUrl;
        data["onlineVisitCount"] = this.onlineVisitCount;
        data["saveCount"] = this.saveCount;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["confirmedContractDateTimeUtc"] = this.confirmedContractDateTimeUtc ? this.confirmedContractDateTimeUtc.toISOString() : <any>undefined;
        data["listingRepresentative"] = this.listingRepresentative ? this.listingRepresentative.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["activeDateTimeUtc"] = this.activeDateTimeUtc ? this.activeDateTimeUtc.toISOString() : <any>undefined;
        data["cancelledDateTimeUtc"] = this.cancelledDateTimeUtc ? this.cancelledDateTimeUtc.toISOString() : <any>undefined;
        data["soldDateTimeUtc"] = this.soldDateTimeUtc ? this.soldDateTimeUtc.toISOString() : <any>undefined;
        data["archivedDateTimeUtc"] = this.archivedDateTimeUtc ? this.archivedDateTimeUtc.toISOString() : <any>undefined;
        data["lastSavedDateTimeUtc"] = this.lastSavedDateTimeUtc ? this.lastSavedDateTimeUtc.toISOString() : <any>undefined;
        data["approvedOrDeniedListingDateTimeUtc"] = this.approvedOrDeniedListingDateTimeUtc ? this.approvedOrDeniedListingDateTimeUtc.toISOString() : <any>undefined;
        data["declinedDateTimeUtc"] = this.declinedDateTimeUtc ? this.declinedDateTimeUtc.toISOString() : <any>undefined;
        data["submittedDateTimeUtc"] = this.submittedDateTimeUtc ? this.submittedDateTimeUtc.toISOString() : <any>undefined;
        data["declinedBySellerName"] = this.declinedBySellerName;
        data["archived"] = this.archived;
        data["publicListingUrl"] = this.publicListingUrl;
        data["soldPrice"] = this.soldPrice;
        data["lastCompletedListingStep"] = this.lastCompletedListingStep;
        data["lastCompletedListingStepDateTimeUtc"] = this.lastCompletedListingStepDateTimeUtc ? this.lastCompletedListingStepDateTimeUtc.toISOString() : <any>undefined;
        data["coOwnership"] = this.coOwnership ? this.coOwnership.toJSON() : <any>undefined;
        data["overview"] = this.overview ? this.overview.toJSON() : <any>undefined;
        data["lotDimensions"] = this.lotDimensions ? this.lotDimensions.toJSON() : <any>undefined;
        data["interior"] = this.interior ? this.interior.toJSON() : <any>undefined;
        data["pauseUntilDateTime"] = this.pauseUntilDateTime ? this.pauseUntilDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        if (Array.isArray(this.parkingSpots)) {
            data["parkingSpots"] = [];
            for (let item of this.parkingSpots)
                data["parkingSpots"].push(item.toJSON());
        }
        data["additionalParkingNotes"] = this.additionalParkingNotes;
        if (Array.isArray(this.storageUnits)) {
            data["storageUnits"] = [];
            for (let item of this.storageUnits)
                data["storageUnits"].push(item.toJSON());
        }
        data["additionalStorageNotes"] = this.additionalStorageNotes;
        data["taxDetails"] = this.taxDetails ? this.taxDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        data["scheduleAViewLink"] = this.scheduleAViewLink;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["additionalCostDetails"] = this.additionalCostDetails ? this.additionalCostDetails.toJSON() : <any>undefined;
        data["publishDateTimeUtc"] = this.publishDateTimeUtc ? this.publishDateTimeUtc.toISOString() : <any>undefined;
        data["numberOfReviewGroupSections"] = this.numberOfReviewGroupSections;
        data["numberOfReviewedGroupSections"] = this.numberOfReviewedGroupSections;
        data["lastListingStateChangeDateTimeUtc"] = this.lastListingStateChangeDateTimeUtc ? this.lastListingStateChangeDateTimeUtc.toISOString() : <any>undefined;
        data["lastReviewedDateTimeUtc"] = this.lastReviewedDateTimeUtc ? this.lastReviewedDateTimeUtc.toISOString() : <any>undefined;
        data["deposit"] = this.deposit ? this.deposit.toJSON() : <any>undefined;
        data["contractDates"] = this.contractDates ? this.contractDates.toJSON() : <any>undefined;
        data["ownershipDocuments"] = this.ownershipDocuments ? this.ownershipDocuments.toJSON() : <any>undefined;
        data["contractInclusions"] = this.contractInclusions ? this.contractInclusions.toJSON() : <any>undefined;
        data["contractExclusions"] = this.contractExclusions ? this.contractExclusions.toJSON() : <any>undefined;
        data["contractAdditionalTerms"] = this.contractAdditionalTerms ? this.contractAdditionalTerms.toJSON() : <any>undefined;
        data["preEmptiveRightDelay"] = this.preEmptiveRightDelay ? this.preEmptiveRightDelay.toJSON() : <any>undefined;
        data["isAvailableForSale"] = this.isAvailableForSale;
        data["isAvailableForRent"] = this.isAvailableForRent;
        data["rentDetails"] = this.rentDetails ? this.rentDetails.toJSON() : <any>undefined;
        data["draftStatus"] = this.draftStatus;
        data["draftStatusDate"] = this.draftStatusDate ? this.draftStatusDate.toISOString() : <any>undefined;
        data["parentListingId"] = this.parentListingId;
        data["externalSourceName"] = this.externalSourceName;
        data["externalSourceUrl"] = this.externalSourceUrl;
        data["externalSourceLogoImage"] = this.externalSourceLogoImage ? this.externalSourceLogoImage.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IListingDto extends ITranslatableDtoOfListingTranslation {
    id?: number;
    name?: string | undefined;
    companyName?: string | undefined;
    lotName?: string | undefined;
    isWaterfront?: boolean | undefined;
    outdoorSquareFeet?: number | undefined;
    tier?: ListingTier;
    subscriptionExpiryDateTimeUtc?: Date | undefined;
    subscriptionRenewalDateTimeUtc?: Date | undefined;
    buyUrl?: string | undefined;
    indoorSquareFeet?: number | undefined;
    directions?: string[] | undefined;
    marketingDescription?: string | undefined;
    notes?: string | undefined;
    listingType?: ListingType | undefined;
    constructionType?: ConstructionType | undefined;
    otherConstructionType?: string | undefined;
    foundationType?: ListingFoundationType | undefined;
    otherFoundationType?: string | undefined;
    yearBuilt?: number | undefined;
    buildStatus?: ListingBuildStatus | undefined;
    lotType?: LotType;
    contracts?: ListingContractDto[] | undefined;
    displayImage?: ImageMediaDto | undefined;
    lotNumber?: string | undefined;
    hasParking?: boolean | undefined;
    hasStorage?: boolean | undefined;
    landRegistry?: string | undefined;
    landRegistryType?: LandRegistryType | undefined;
    address?: AddressDto | undefined;
    project?: NestedProjectDto | undefined;
    projectId?: number | undefined;
    price?: number | undefined;
    negotiablePrice?: boolean | undefined;
    minimumNegotiablePrice?: number | undefined;
    acceptsConditionalOffers?: boolean | undefined;
    lotLayoutImage?: ImageMediaDto | undefined;
    lotLocationInPlanImage?: ImageMediaDto | undefined;
    lotLayoutDocument?: DocumentMediaDto | undefined;
    translations?: ListingTranslation[] | undefined;
    building?: NestedBuildingDto | undefined;
    phase?: NestedPhaseDto | undefined;
    realEstateType?: RealEstateType | undefined;
    completionDate?: Date | undefined;
    contractType?: ListingContractType | undefined;
    builder?: ListingBuilderDto | undefined;
    shareUrl?: string | undefined;
    onlineVisitCount?: number;
    saveCount?: number;
    creationDateTimeUtc?: Date | undefined;
    confirmedContractDateTimeUtc?: Date | undefined;
    listingRepresentative?: ListingRepresentativeDto | undefined;
    state?: ListingState | undefined;
    activeDateTimeUtc?: Date | undefined;
    cancelledDateTimeUtc?: Date | undefined;
    soldDateTimeUtc?: Date | undefined;
    archivedDateTimeUtc?: Date | undefined;
    lastSavedDateTimeUtc?: Date | undefined;
    approvedOrDeniedListingDateTimeUtc?: Date | undefined;
    declinedDateTimeUtc?: Date | undefined;
    submittedDateTimeUtc?: Date | undefined;
    declinedBySellerName?: string | undefined;
    archived?: boolean;
    publicListingUrl?: string | undefined;
    soldPrice?: number | undefined;
    lastCompletedListingStep?: string | undefined;
    lastCompletedListingStepDateTimeUtc?: Date | undefined;
    coOwnership?: ListingCoOwnershipDto | undefined;
    overview?: ListingOverviewDto | undefined;
    lotDimensions?: ListingLotDimensionsDto | undefined;
    interior?: ListingInteriorDto | undefined;
    pauseUntilDateTime?: Date | undefined;
    levels?: ListingLevelDimensionsDto[] | undefined;
    parkingSpots?: ListingParkingDto[] | undefined;
    additionalParkingNotes?: string | undefined;
    storageUnits?: ListingStorageDto[] | undefined;
    additionalStorageNotes?: string | undefined;
    taxDetails?: ListingTaxDetailsDto | undefined;
    features?: string[] | undefined;
    scheduleAViewLink?: string | undefined;
    contactPhoneNumber?: string | undefined;
    additionalCostDetails?: ListingAdditionalCostsDto | undefined;
    publishDateTimeUtc?: Date | undefined;
    numberOfReviewGroupSections?: number | undefined;
    numberOfReviewedGroupSections?: number | undefined;
    lastListingStateChangeDateTimeUtc?: Date | undefined;
    lastReviewedDateTimeUtc?: Date | undefined;
    deposit?: ListingDepositDto | undefined;
    contractDates?: ListingContractDatesDto | undefined;
    ownershipDocuments?: ListingOwnershipDocumentsDto | undefined;
    contractInclusions?: ListingContractInclusionsDto | undefined;
    contractExclusions?: ListingContractExclusionsDto | undefined;
    contractAdditionalTerms?: ListingContractAdditionalTermsDto | undefined;
    preEmptiveRightDelay?: ListingPreEmptiveRightDelayDto | undefined;
    isAvailableForSale?: boolean;
    isAvailableForRent?: boolean;
    rentDetails?: ListingRentDetailsDto | undefined;
    draftStatus?: DraftStatus;
    draftStatusDate?: Date | undefined;
    parentListingId?: number | undefined;
    externalSourceName?: string | undefined;
    externalSourceUrl?: string | undefined;
    externalSourceLogoImage?: ImageMediaDto | undefined;
}

export enum ListingFoundationType {
    WoodFrame = 0,
    Concrete = 1,
    SlabFoundation = 2,
    IDontKnow = 3,
    Other = 4,
}

export enum ListingBuildStatus {
    PreConstruction = 0,
    NewConstruction = 1,
    Resale = 2,
}

export enum LotType {
    OwnedByBuyer = 0,
    OwnedByBuilder = 1,
}

export class ListingContractDto implements IListingContractDto {
    id?: number;
    contractName?: string | undefined;
    contractStatus?: string | undefined;
    lastUpdatedDateTime?: Date | undefined;
    createdDateTime?: Date;

    constructor(data?: IListingContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractName = _data["contractName"];
            this.contractStatus = _data["contractStatus"];
            this.lastUpdatedDateTime = _data["lastUpdatedDateTime"] ? new Date(_data["lastUpdatedDateTime"].toString()) : <any>undefined;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ListingContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractName"] = this.contractName;
        data["contractStatus"] = this.contractStatus;
        data["lastUpdatedDateTime"] = this.lastUpdatedDateTime ? this.lastUpdatedDateTime.toISOString() : <any>undefined;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IListingContractDto {
    id?: number;
    contractName?: string | undefined;
    contractStatus?: string | undefined;
    lastUpdatedDateTime?: Date | undefined;
    createdDateTime?: Date;
}

export enum LandRegistryType {
    Cadastral = 0,
    Strata = 1,
    LandRegistery = 2,
    ParcelIdentifier = 3,
}

export abstract class TranslationEntity extends Translation implements ITranslationEntity {
    id?: string | undefined;

    constructor(data?: ITranslationEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TranslationEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TranslationEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationEntity extends ITranslation {
    id?: string | undefined;
}

export class ListingTranslation extends TranslationEntity implements IListingTranslation {
    listingId?: number;
    marketingName?: string | undefined;
    marketingDescription?: string | undefined;
    marketingPropertyUrl?: string | undefined;

    constructor(data?: IListingTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.listingId = _data["listingId"];
            this.marketingName = _data["marketingName"];
            this.marketingDescription = _data["marketingDescription"];
            this.marketingPropertyUrl = _data["marketingPropertyUrl"];
        }
    }

    static fromJS(data: any): ListingTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ListingTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        data["marketingName"] = this.marketingName;
        data["marketingDescription"] = this.marketingDescription;
        data["marketingPropertyUrl"] = this.marketingPropertyUrl;
        super.toJSON(data);
        return data;
    }
}

export interface IListingTranslation extends ITranslationEntity {
    listingId?: number;
    marketingName?: string | undefined;
    marketingDescription?: string | undefined;
    marketingPropertyUrl?: string | undefined;
}

export class NestedPhaseDto implements INestedPhaseDto {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;

    constructor(data?: INestedPhaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.modifiedDateTimeUtc = _data["modifiedDateTimeUtc"] ? new Date(_data["modifiedDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NestedPhaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedPhaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["modifiedDateTimeUtc"] = this.modifiedDateTimeUtc ? this.modifiedDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface INestedPhaseDto {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;
}

export enum ListingContractType {
    QuebecListingContract = 0,
}

export class ListingBuilderDto implements IListingBuilderDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    logoImage?: ImageMediaDto | undefined;

    constructor(data?: IListingBuilderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.logoImage = _data["logoImage"] ? ImageMediaDto.fromJS(_data["logoImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListingBuilderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingBuilderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["logoImage"] = this.logoImage ? this.logoImage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListingBuilderDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    logoImage?: ImageMediaDto | undefined;
}

export class ListingRepresentativeDto implements IListingRepresentativeDto {
    name?: string | undefined;
    profileImage?: ImageMediaDto | undefined;
    email?: string | undefined;

    constructor(data?: IListingRepresentativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.profileImage = _data["profileImage"] ? ImageMediaDto.fromJS(_data["profileImage"]) : <any>undefined;
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ListingRepresentativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingRepresentativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["email"] = this.email;
        return data;
    }
}

export interface IListingRepresentativeDto {
    name?: string | undefined;
    profileImage?: ImageMediaDto | undefined;
    email?: string | undefined;
}

export class ListingCoOwnershipDto implements IListingCoOwnershipDto {
    hasCoOwnership?: boolean;
    coOwnershipType?: CoOwnershipType | undefined;
    ownershipPercentage?: number | undefined;

    constructor(data?: IListingCoOwnershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasCoOwnership = _data["hasCoOwnership"];
            this.coOwnershipType = _data["coOwnershipType"];
            this.ownershipPercentage = _data["ownershipPercentage"];
        }
    }

    static fromJS(data: any): ListingCoOwnershipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingCoOwnershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasCoOwnership"] = this.hasCoOwnership;
        data["coOwnershipType"] = this.coOwnershipType;
        data["ownershipPercentage"] = this.ownershipPercentage;
        return data;
    }
}

export interface IListingCoOwnershipDto {
    hasCoOwnership?: boolean;
    coOwnershipType?: CoOwnershipType | undefined;
    ownershipPercentage?: number | undefined;
}

export enum CoOwnershipType {
    DividedCoOwnership = 0,
    UndividedCoOwnership = 1,
}

export class ListingOverviewDto implements IListingOverviewDto {
    hasElevatorAccess?: boolean | undefined;
    roomsAndAmenities?: string[] | undefined;
    external?: string[] | undefined;
    bedroomQuantity?: number | undefined;
    bathroomQuantity?: number | undefined;
    powderRoomQuantity?: number | undefined;

    constructor(data?: IListingOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasElevatorAccess = _data["hasElevatorAccess"];
            if (Array.isArray(_data["roomsAndAmenities"])) {
                this.roomsAndAmenities = [] as any;
                for (let item of _data["roomsAndAmenities"])
                    this.roomsAndAmenities!.push(item);
            }
            if (Array.isArray(_data["external"])) {
                this.external = [] as any;
                for (let item of _data["external"])
                    this.external!.push(item);
            }
            this.bedroomQuantity = _data["bedroomQuantity"];
            this.bathroomQuantity = _data["bathroomQuantity"];
            this.powderRoomQuantity = _data["powderRoomQuantity"];
        }
    }

    static fromJS(data: any): ListingOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasElevatorAccess"] = this.hasElevatorAccess;
        if (Array.isArray(this.roomsAndAmenities)) {
            data["roomsAndAmenities"] = [];
            for (let item of this.roomsAndAmenities)
                data["roomsAndAmenities"].push(item);
        }
        if (Array.isArray(this.external)) {
            data["external"] = [];
            for (let item of this.external)
                data["external"].push(item);
        }
        data["bedroomQuantity"] = this.bedroomQuantity;
        data["bathroomQuantity"] = this.bathroomQuantity;
        data["powderRoomQuantity"] = this.powderRoomQuantity;
        return data;
    }
}

export interface IListingOverviewDto {
    hasElevatorAccess?: boolean | undefined;
    roomsAndAmenities?: string[] | undefined;
    external?: string[] | undefined;
    bedroomQuantity?: number | undefined;
    bathroomQuantity?: number | undefined;
    powderRoomQuantity?: number | undefined;
}

export class BaseListingDimensionsDto implements IBaseListingDimensionsDto {
    lengthInMeters?: number | undefined;
    widthInMeters?: number | undefined;
    heightInMeters?: number | undefined;
    totalListingAreaInSqMeters?: number | undefined;

    constructor(data?: IBaseListingDimensionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lengthInMeters = _data["lengthInMeters"];
            this.widthInMeters = _data["widthInMeters"];
            this.heightInMeters = _data["heightInMeters"];
            this.totalListingAreaInSqMeters = _data["totalListingAreaInSqMeters"];
        }
    }

    static fromJS(data: any): BaseListingDimensionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseListingDimensionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lengthInMeters"] = this.lengthInMeters;
        data["widthInMeters"] = this.widthInMeters;
        data["heightInMeters"] = this.heightInMeters;
        data["totalListingAreaInSqMeters"] = this.totalListingAreaInSqMeters;
        return data;
    }
}

export interface IBaseListingDimensionsDto {
    lengthInMeters?: number | undefined;
    widthInMeters?: number | undefined;
    heightInMeters?: number | undefined;
    totalListingAreaInSqMeters?: number | undefined;
}

export class ListingLotDimensionsDto extends BaseListingDimensionsDto implements IListingLotDimensionsDto {
    unitPreferences?: MeasurementSystem;

    constructor(data?: IListingLotDimensionsDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unitPreferences = _data["unitPreferences"];
        }
    }

    static fromJS(data: any): ListingLotDimensionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingLotDimensionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPreferences"] = this.unitPreferences;
        super.toJSON(data);
        return data;
    }
}

export interface IListingLotDimensionsDto extends IBaseListingDimensionsDto {
    unitPreferences?: MeasurementSystem;
}

export enum MeasurementSystem {
    Imperial = 0,
    Metric = 1,
}

export class ListingInteriorDto implements IListingInteriorDto {
    isMultiLevel?: boolean | undefined;
    unitPreferences?: MeasurementSystem;
    totalIndoorAreaInMeters?: number | undefined;
    hasOutdoorSpace?: boolean | undefined;
    outdoorLengthInMeters?: number | undefined;
    outdoorWidthInMeters?: number | undefined;
    totalOutdoorAreaInMeters?: number | undefined;
    totalIndoorOutdoorAreaInMeters?: number | undefined;

    constructor(data?: IListingInteriorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMultiLevel = _data["isMultiLevel"];
            this.unitPreferences = _data["unitPreferences"];
            this.totalIndoorAreaInMeters = _data["totalIndoorAreaInMeters"];
            this.hasOutdoorSpace = _data["hasOutdoorSpace"];
            this.outdoorLengthInMeters = _data["outdoorLengthInMeters"];
            this.outdoorWidthInMeters = _data["outdoorWidthInMeters"];
            this.totalOutdoorAreaInMeters = _data["totalOutdoorAreaInMeters"];
            this.totalIndoorOutdoorAreaInMeters = _data["totalIndoorOutdoorAreaInMeters"];
        }
    }

    static fromJS(data: any): ListingInteriorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingInteriorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMultiLevel"] = this.isMultiLevel;
        data["unitPreferences"] = this.unitPreferences;
        data["totalIndoorAreaInMeters"] = this.totalIndoorAreaInMeters;
        data["hasOutdoorSpace"] = this.hasOutdoorSpace;
        data["outdoorLengthInMeters"] = this.outdoorLengthInMeters;
        data["outdoorWidthInMeters"] = this.outdoorWidthInMeters;
        data["totalOutdoorAreaInMeters"] = this.totalOutdoorAreaInMeters;
        data["totalIndoorOutdoorAreaInMeters"] = this.totalIndoorOutdoorAreaInMeters;
        return data;
    }
}

export interface IListingInteriorDto {
    isMultiLevel?: boolean | undefined;
    unitPreferences?: MeasurementSystem;
    totalIndoorAreaInMeters?: number | undefined;
    hasOutdoorSpace?: boolean | undefined;
    outdoorLengthInMeters?: number | undefined;
    outdoorWidthInMeters?: number | undefined;
    totalOutdoorAreaInMeters?: number | undefined;
    totalIndoorOutdoorAreaInMeters?: number | undefined;
}

export class ListingLevelDimensionsDto extends BaseListingDimensionsDto implements IListingLevelDimensionsDto {
    id?: string | undefined;
    no?: number;
    customName?: string | undefined;
    originalLevelId?: string | undefined;
    isBasement?: boolean | undefined;

    constructor(data?: IListingLevelDimensionsDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.no = _data["no"];
            this.customName = _data["customName"];
            this.originalLevelId = _data["originalLevelId"];
            this.isBasement = _data["isBasement"];
        }
    }

    static fromJS(data: any): ListingLevelDimensionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingLevelDimensionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["customName"] = this.customName;
        data["originalLevelId"] = this.originalLevelId;
        data["isBasement"] = this.isBasement;
        super.toJSON(data);
        return data;
    }
}

export interface IListingLevelDimensionsDto extends IBaseListingDimensionsDto {
    id?: string | undefined;
    no?: number;
    customName?: string | undefined;
    originalLevelId?: string | undefined;
    isBasement?: boolean | undefined;
}

export class ListingParkingDto implements IListingParkingDto {
    id?: string | undefined;
    no?: number;
    type?: ParkingType | undefined;
    location?: ParkingLocationType | undefined;
    otherLocation?: string | undefined;
    exposure?: ParkingExposureType | undefined;
    numberOfStalls?: number;
    stalls?: ParkingStallDto[] | undefined;
    additionalNotes?: string | undefined;
    originalParkingId?: string | undefined;

    constructor(data?: IListingParkingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.no = _data["no"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.otherLocation = _data["otherLocation"];
            this.exposure = _data["exposure"];
            this.numberOfStalls = _data["numberOfStalls"];
            if (Array.isArray(_data["stalls"])) {
                this.stalls = [] as any;
                for (let item of _data["stalls"])
                    this.stalls!.push(ParkingStallDto.fromJS(item));
            }
            this.additionalNotes = _data["additionalNotes"];
            this.originalParkingId = _data["originalParkingId"];
        }
    }

    static fromJS(data: any): ListingParkingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingParkingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["type"] = this.type;
        data["location"] = this.location;
        data["otherLocation"] = this.otherLocation;
        data["exposure"] = this.exposure;
        data["numberOfStalls"] = this.numberOfStalls;
        if (Array.isArray(this.stalls)) {
            data["stalls"] = [];
            for (let item of this.stalls)
                data["stalls"].push(item.toJSON());
        }
        data["additionalNotes"] = this.additionalNotes;
        data["originalParkingId"] = this.originalParkingId;
        return data;
    }
}

export interface IListingParkingDto {
    id?: string | undefined;
    no?: number;
    type?: ParkingType | undefined;
    location?: ParkingLocationType | undefined;
    otherLocation?: string | undefined;
    exposure?: ParkingExposureType | undefined;
    numberOfStalls?: number;
    stalls?: ParkingStallDto[] | undefined;
    additionalNotes?: string | undefined;
    originalParkingId?: string | undefined;
}

export enum ParkingType {
    Single = 0,
    SideBySide = 1,
    Tandem = 2,
    NoParking = 3,
}

export enum ParkingLocationType {
    GarageAttached = 0,
    GarageDetached = 1,
    GroundLevelGated = 2,
    GroundLevel = 3,
    UndergroundGated = 4,
    Underground = 5,
    Driveway = 6,
    Other = 7,
}

export enum ParkingExposureType {
    Interior = 0,
    Exterior = 1,
}

export class ParkingStallDto implements IParkingStallDto {
    id?: string | undefined;
    stallSize?: ParkingStallSize | undefined;
    assignedStallNo?: string | undefined;
    hasEvCharging?: boolean;
    hasCarLift?: boolean;
    originalStallId?: string | undefined;

    constructor(data?: IParkingStallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stallSize = _data["stallSize"];
            this.assignedStallNo = _data["assignedStallNo"];
            this.hasEvCharging = _data["hasEvCharging"];
            this.hasCarLift = _data["hasCarLift"];
            this.originalStallId = _data["originalStallId"];
        }
    }

    static fromJS(data: any): ParkingStallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingStallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stallSize"] = this.stallSize;
        data["assignedStallNo"] = this.assignedStallNo;
        data["hasEvCharging"] = this.hasEvCharging;
        data["hasCarLift"] = this.hasCarLift;
        data["originalStallId"] = this.originalStallId;
        return data;
    }
}

export interface IParkingStallDto {
    id?: string | undefined;
    stallSize?: ParkingStallSize | undefined;
    assignedStallNo?: string | undefined;
    hasEvCharging?: boolean;
    hasCarLift?: boolean;
    originalStallId?: string | undefined;
}

export enum ParkingStallSize {
    StandardSize = 0,
    SmallSize = 1,
    LargeSize = 2,
    ExtraLargeSize = 3,
}

export class ListingStorageDto implements IListingStorageDto {
    id?: string | undefined;
    no?: number;
    type?: StorageType | undefined;
    access?: Access | undefined;
    otherAccess?: string | undefined;
    assignedStorageUnitNo?: string | undefined;
    accessType?: AccessType | undefined;
    storageSizeShape?: StorageSizeShape | undefined;
    lengthInMeters?: number | undefined;
    widthInMeters?: number | undefined;
    heightInMeters?: number | undefined;
    originalStorageId?: string | undefined;
    additionalNotes?: string | undefined;
    unitPreference?: MeasurementSystem;

    constructor(data?: IListingStorageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.no = _data["no"];
            this.type = _data["type"];
            this.access = _data["access"];
            this.otherAccess = _data["otherAccess"];
            this.assignedStorageUnitNo = _data["assignedStorageUnitNo"];
            this.accessType = _data["accessType"];
            this.storageSizeShape = _data["storageSizeShape"];
            this.lengthInMeters = _data["lengthInMeters"];
            this.widthInMeters = _data["widthInMeters"];
            this.heightInMeters = _data["heightInMeters"];
            this.originalStorageId = _data["originalStorageId"];
            this.additionalNotes = _data["additionalNotes"];
            this.unitPreference = _data["unitPreference"];
        }
    }

    static fromJS(data: any): ListingStorageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingStorageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["type"] = this.type;
        data["access"] = this.access;
        data["otherAccess"] = this.otherAccess;
        data["assignedStorageUnitNo"] = this.assignedStorageUnitNo;
        data["accessType"] = this.accessType;
        data["storageSizeShape"] = this.storageSizeShape;
        data["lengthInMeters"] = this.lengthInMeters;
        data["widthInMeters"] = this.widthInMeters;
        data["heightInMeters"] = this.heightInMeters;
        data["originalStorageId"] = this.originalStorageId;
        data["additionalNotes"] = this.additionalNotes;
        data["unitPreference"] = this.unitPreference;
        return data;
    }
}

export interface IListingStorageDto {
    id?: string | undefined;
    no?: number;
    type?: StorageType | undefined;
    access?: Access | undefined;
    otherAccess?: string | undefined;
    assignedStorageUnitNo?: string | undefined;
    accessType?: AccessType | undefined;
    storageSizeShape?: StorageSizeShape | undefined;
    lengthInMeters?: number | undefined;
    widthInMeters?: number | undefined;
    heightInMeters?: number | undefined;
    originalStorageId?: string | undefined;
    additionalNotes?: string | undefined;
    unitPreference?: MeasurementSystem;
}

export enum StorageType {
    StorageUnitStandard = 0,
    InSuiteStorageRoomInsideTheUnit = 1,
    Shed = 2,
    DetachedStorageUnit = 3,
    NoStorage = 4,
    NoStorageRentalsAvailable = 5,
    StorageLocker = 6,
}

export enum Access {
    GroundLevel = 0,
    LevelP1 = 1,
    LevelP2 = 2,
    LevelP3 = 3,
    LevelP4 = 4,
    LevelP5 = 5,
    LevelP6 = 6,
    Level1 = 7,
    Level2 = 8,
    Level3 = 9,
    Level4 = 10,
    Level5 = 11,
    Level6 = 12,
    Garage = 13,
    InsideUnit = 14,
    Basement = 15,
    NotApplicable = 16,
    Outdoor = 17,
    Other = 18,
    BehindTheProperty = 19,
    ToTheSideOfTheProperty = 20,
}

export enum AccessType {
    KeyFob = 0,
    Passcode = 1,
    PersonalKey = 2,
    LocksAndKeys = 3,
    CombinationOfAFewTypes = 4,
    Outdoor = 5,
    NotApplicable = 6,
}

export enum StorageSizeShape {
    Square = 0,
    Rectangular = 1,
    Narrow = 2,
    SpecialShape = 3,
}

export class ListingTaxDetailsDto implements IListingTaxDetailsDto {
    areTaxesApplicable?: boolean | undefined;
    currency?: string | undefined;
    taxes?: ListingTaxDto[] | undefined;

    constructor(data?: IListingTaxDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areTaxesApplicable = _data["areTaxesApplicable"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(ListingTaxDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingTaxDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingTaxDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areTaxesApplicable"] = this.areTaxesApplicable;
        data["currency"] = this.currency;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingTaxDetailsDto {
    areTaxesApplicable?: boolean | undefined;
    currency?: string | undefined;
    taxes?: ListingTaxDto[] | undefined;
}

export class ListingTaxDto implements IListingTaxDto {
    no?: number;
    name?: string | undefined;
    percentage?: number;
    creditName?: string | undefined;
    creditPercentage?: number | undefined;

    constructor(data?: IListingTaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.no = _data["no"];
            this.name = _data["name"];
            this.percentage = _data["percentage"];
            this.creditName = _data["creditName"];
            this.creditPercentage = _data["creditPercentage"];
        }
    }

    static fromJS(data: any): ListingTaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingTaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["name"] = this.name;
        data["percentage"] = this.percentage;
        data["creditName"] = this.creditName;
        data["creditPercentage"] = this.creditPercentage;
        return data;
    }
}

export interface IListingTaxDto {
    no?: number;
    name?: string | undefined;
    percentage?: number;
    creditName?: string | undefined;
    creditPercentage?: number | undefined;
}

export class ListingAdditionalCostsDto implements IListingAdditionalCostsDto {
    monthlyHomeOwnerAssociationFee?: number | undefined;
    monthlyHydroAndElectricityFee?: number | undefined;
    monthlyGasFee?: number | undefined;
    previousPropertyTaxAmount?: number | undefined;
    additionalCosts?: ListingAdditionalCostDetailDto[] | undefined;

    constructor(data?: IListingAdditionalCostsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyHomeOwnerAssociationFee = _data["monthlyHomeOwnerAssociationFee"];
            this.monthlyHydroAndElectricityFee = _data["monthlyHydroAndElectricityFee"];
            this.monthlyGasFee = _data["monthlyGasFee"];
            this.previousPropertyTaxAmount = _data["previousPropertyTaxAmount"];
            if (Array.isArray(_data["additionalCosts"])) {
                this.additionalCosts = [] as any;
                for (let item of _data["additionalCosts"])
                    this.additionalCosts!.push(ListingAdditionalCostDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingAdditionalCostsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingAdditionalCostsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyHomeOwnerAssociationFee"] = this.monthlyHomeOwnerAssociationFee;
        data["monthlyHydroAndElectricityFee"] = this.monthlyHydroAndElectricityFee;
        data["monthlyGasFee"] = this.monthlyGasFee;
        data["previousPropertyTaxAmount"] = this.previousPropertyTaxAmount;
        if (Array.isArray(this.additionalCosts)) {
            data["additionalCosts"] = [];
            for (let item of this.additionalCosts)
                data["additionalCosts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingAdditionalCostsDto {
    monthlyHomeOwnerAssociationFee?: number | undefined;
    monthlyHydroAndElectricityFee?: number | undefined;
    monthlyGasFee?: number | undefined;
    previousPropertyTaxAmount?: number | undefined;
    additionalCosts?: ListingAdditionalCostDetailDto[] | undefined;
}

export class ListingAdditionalCostDetailDto implements IListingAdditionalCostDetailDto {
    no?: number;
    name?: string | undefined;
    cost?: number;

    constructor(data?: IListingAdditionalCostDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.no = _data["no"];
            this.name = _data["name"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): ListingAdditionalCostDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingAdditionalCostDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["name"] = this.name;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IListingAdditionalCostDetailDto {
    no?: number;
    name?: string | undefined;
    cost?: number;
}

export class ListingDepositDto implements IListingDepositDto {
    isDepositRequired?: boolean | undefined;
    depositMode?: DepositMode;
    negotiable?: boolean | undefined;
    minimumDeposit?: number | undefined;
    maximumDeposit?: number | undefined;
    depositStructures?: DepositStructureDto[] | undefined;

    constructor(data?: IListingDepositDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDepositRequired = _data["isDepositRequired"];
            this.depositMode = _data["depositMode"];
            this.negotiable = _data["negotiable"];
            this.minimumDeposit = _data["minimumDeposit"];
            this.maximumDeposit = _data["maximumDeposit"];
            if (Array.isArray(_data["depositStructures"])) {
                this.depositStructures = [] as any;
                for (let item of _data["depositStructures"])
                    this.depositStructures!.push(DepositStructureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingDepositDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingDepositDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDepositRequired"] = this.isDepositRequired;
        data["depositMode"] = this.depositMode;
        data["negotiable"] = this.negotiable;
        data["minimumDeposit"] = this.minimumDeposit;
        data["maximumDeposit"] = this.maximumDeposit;
        if (Array.isArray(this.depositStructures)) {
            data["depositStructures"] = [];
            for (let item of this.depositStructures)
                data["depositStructures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingDepositDto {
    isDepositRequired?: boolean | undefined;
    depositMode?: DepositMode;
    negotiable?: boolean | undefined;
    minimumDeposit?: number | undefined;
    maximumDeposit?: number | undefined;
    depositStructures?: DepositStructureDto[] | undefined;
}

export class ListingContractDatesDto implements IListingContractDatesDto {
    rescissionPeriodInDays?: number | undefined;
    rescissionFeePercentage?: number | undefined;
    rescissionPeriodIsBusinessDays?: boolean | undefined;
    rescissionPeriodStartsAtSigning?: boolean | undefined;
    availableDate?: Date | undefined;
    isAvailableDateNegotiable?: boolean | undefined;

    constructor(data?: IListingContractDatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rescissionPeriodInDays = _data["rescissionPeriodInDays"];
            this.rescissionFeePercentage = _data["rescissionFeePercentage"];
            this.rescissionPeriodIsBusinessDays = _data["rescissionPeriodIsBusinessDays"];
            this.rescissionPeriodStartsAtSigning = _data["rescissionPeriodStartsAtSigning"];
            this.availableDate = _data["availableDate"] ? new Date(_data["availableDate"].toString()) : <any>undefined;
            this.isAvailableDateNegotiable = _data["isAvailableDateNegotiable"];
        }
    }

    static fromJS(data: any): ListingContractDatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractDatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rescissionPeriodInDays"] = this.rescissionPeriodInDays;
        data["rescissionFeePercentage"] = this.rescissionFeePercentage;
        data["rescissionPeriodIsBusinessDays"] = this.rescissionPeriodIsBusinessDays;
        data["rescissionPeriodStartsAtSigning"] = this.rescissionPeriodStartsAtSigning;
        data["availableDate"] = this.availableDate ? this.availableDate.toISOString() : <any>undefined;
        data["isAvailableDateNegotiable"] = this.isAvailableDateNegotiable;
        return data;
    }
}

export interface IListingContractDatesDto {
    rescissionPeriodInDays?: number | undefined;
    rescissionFeePercentage?: number | undefined;
    rescissionPeriodIsBusinessDays?: boolean | undefined;
    rescissionPeriodStartsAtSigning?: boolean | undefined;
    availableDate?: Date | undefined;
    isAvailableDateNegotiable?: boolean | undefined;
}

export class ListingOwnershipDocumentsDto implements IListingOwnershipDocumentsDto {
    amountOfTimeToProvideDocumentsInDays?: number | undefined;
    isAmountOfTimeToProvideDocumentsNegotiable?: boolean | undefined;
    minAmountOfTimeToProvideDocumentsInDays?: number | undefined;
    maxAmountOfTimeToProvideDocumentsInDays?: number | undefined;
    comments?: string | undefined;

    constructor(data?: IListingOwnershipDocumentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountOfTimeToProvideDocumentsInDays = _data["amountOfTimeToProvideDocumentsInDays"];
            this.isAmountOfTimeToProvideDocumentsNegotiable = _data["isAmountOfTimeToProvideDocumentsNegotiable"];
            this.minAmountOfTimeToProvideDocumentsInDays = _data["minAmountOfTimeToProvideDocumentsInDays"];
            this.maxAmountOfTimeToProvideDocumentsInDays = _data["maxAmountOfTimeToProvideDocumentsInDays"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ListingOwnershipDocumentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingOwnershipDocumentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountOfTimeToProvideDocumentsInDays"] = this.amountOfTimeToProvideDocumentsInDays;
        data["isAmountOfTimeToProvideDocumentsNegotiable"] = this.isAmountOfTimeToProvideDocumentsNegotiable;
        data["minAmountOfTimeToProvideDocumentsInDays"] = this.minAmountOfTimeToProvideDocumentsInDays;
        data["maxAmountOfTimeToProvideDocumentsInDays"] = this.maxAmountOfTimeToProvideDocumentsInDays;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IListingOwnershipDocumentsDto {
    amountOfTimeToProvideDocumentsInDays?: number | undefined;
    isAmountOfTimeToProvideDocumentsNegotiable?: boolean | undefined;
    minAmountOfTimeToProvideDocumentsInDays?: number | undefined;
    maxAmountOfTimeToProvideDocumentsInDays?: number | undefined;
    comments?: string | undefined;
}

export class ListingContractInclusionsDto implements IListingContractInclusionsDto {
    inclusions?: ListingContractItemDto[] | undefined;

    constructor(data?: IListingContractInclusionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions!.push(ListingContractItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingContractInclusionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractInclusionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingContractInclusionsDto {
    inclusions?: ListingContractItemDto[] | undefined;
}

export class ListingContractExclusionsDto implements IListingContractExclusionsDto {
    exclusions?: ListingContractItemDto[] | undefined;

    constructor(data?: IListingContractExclusionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions!.push(ListingContractItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingContractExclusionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractExclusionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingContractExclusionsDto {
    exclusions?: ListingContractItemDto[] | undefined;
}

export class ListingContractAdditionalTermsDto implements IListingContractAdditionalTermsDto {
    additionalConditions?: string[] | undefined;

    constructor(data?: IListingContractAdditionalTermsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["additionalConditions"])) {
                this.additionalConditions = [] as any;
                for (let item of _data["additionalConditions"])
                    this.additionalConditions!.push(item);
            }
        }
    }

    static fromJS(data: any): ListingContractAdditionalTermsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractAdditionalTermsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.additionalConditions)) {
            data["additionalConditions"] = [];
            for (let item of this.additionalConditions)
                data["additionalConditions"].push(item);
        }
        return data;
    }
}

export interface IListingContractAdditionalTermsDto {
    additionalConditions?: string[] | undefined;
}

export class ListingPreEmptiveRightDelayDto implements IListingPreEmptiveRightDelayDto {
    isPreEmptiveRightDelay?: boolean | undefined;
    preEmptiveRightDelayInDays?: number | undefined;

    constructor(data?: IListingPreEmptiveRightDelayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPreEmptiveRightDelay = _data["isPreEmptiveRightDelay"];
            this.preEmptiveRightDelayInDays = _data["preEmptiveRightDelayInDays"];
        }
    }

    static fromJS(data: any): ListingPreEmptiveRightDelayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingPreEmptiveRightDelayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPreEmptiveRightDelay"] = this.isPreEmptiveRightDelay;
        data["preEmptiveRightDelayInDays"] = this.preEmptiveRightDelayInDays;
        return data;
    }
}

export interface IListingPreEmptiveRightDelayDto {
    isPreEmptiveRightDelay?: boolean | undefined;
    preEmptiveRightDelayInDays?: number | undefined;
}

export class ListingRentDetailsDto implements IListingRentDetailsDto {
    monthlyRent?: number | undefined;
    availableFromDate?: Date | undefined;
    minLeaseTermMonths?: number;
    utilitiesIncluded?: ListingUtilitiesIncludedDto | undefined;
    inclusions?: ListingContractItemDto[] | undefined;
    exclusions?: ListingContractItemDto[] | undefined;

    constructor(data?: IListingRentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyRent = _data["monthlyRent"];
            this.availableFromDate = _data["availableFromDate"] ? new Date(_data["availableFromDate"].toString()) : <any>undefined;
            this.minLeaseTermMonths = _data["minLeaseTermMonths"];
            this.utilitiesIncluded = _data["utilitiesIncluded"] ? ListingUtilitiesIncludedDto.fromJS(_data["utilitiesIncluded"]) : <any>undefined;
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions!.push(ListingContractItemDto.fromJS(item));
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions!.push(ListingContractItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingRentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingRentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyRent"] = this.monthlyRent;
        data["availableFromDate"] = this.availableFromDate ? this.availableFromDate.toISOString() : <any>undefined;
        data["minLeaseTermMonths"] = this.minLeaseTermMonths;
        data["utilitiesIncluded"] = this.utilitiesIncluded ? this.utilitiesIncluded.toJSON() : <any>undefined;
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item.toJSON());
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingRentDetailsDto {
    monthlyRent?: number | undefined;
    availableFromDate?: Date | undefined;
    minLeaseTermMonths?: number;
    utilitiesIncluded?: ListingUtilitiesIncludedDto | undefined;
    inclusions?: ListingContractItemDto[] | undefined;
    exclusions?: ListingContractItemDto[] | undefined;
}

export class ListingUtilitiesIncludedDto implements IListingUtilitiesIncludedDto {
    hydro?: boolean | undefined;
    water?: boolean | undefined;
    heat?: boolean | undefined;
    gas?: boolean | undefined;
    internet?: boolean | undefined;
    cable?: boolean | undefined;

    constructor(data?: IListingUtilitiesIncludedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hydro = _data["hydro"];
            this.water = _data["water"];
            this.heat = _data["heat"];
            this.gas = _data["gas"];
            this.internet = _data["internet"];
            this.cable = _data["cable"];
        }
    }

    static fromJS(data: any): ListingUtilitiesIncludedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingUtilitiesIncludedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hydro"] = this.hydro;
        data["water"] = this.water;
        data["heat"] = this.heat;
        data["gas"] = this.gas;
        data["internet"] = this.internet;
        data["cable"] = this.cable;
        return data;
    }
}

export interface IListingUtilitiesIncludedDto {
    hydro?: boolean | undefined;
    water?: boolean | undefined;
    heat?: boolean | undefined;
    gas?: boolean | undefined;
    internet?: boolean | undefined;
    cable?: boolean | undefined;
}

export class ListingContractDocumentDto implements IListingContractDocumentDto {
    contractType?: ListingContractType;
    documentUrl?: string | undefined;

    constructor(data?: IListingContractDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractType = _data["contractType"];
            this.documentUrl = _data["documentUrl"];
        }
    }

    static fromJS(data: any): ListingContractDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractType"] = this.contractType;
        data["documentUrl"] = this.documentUrl;
        return data;
    }
}

export interface IListingContractDocumentDto {
    contractType?: ListingContractType;
    documentUrl?: string | undefined;
}

export class EditListingPriceCommand implements IEditListingPriceCommand {
    price?: number;

    constructor(data?: IEditListingPriceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): EditListingPriceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditListingPriceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        return data;
    }
}

export interface IEditListingPriceCommand {
    price?: number;
}

export class RegisterListingVisitCommand implements IRegisterListingVisitCommand {

    constructor(data?: IRegisterListingVisitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RegisterListingVisitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterListingVisitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRegisterListingVisitCommand {
}

export class CreateOrEditListingCommand implements ICreateOrEditListingCommand {
    address?: ListingAddressInput | undefined;
    priceInfo?: ListingPriceInput | undefined;
    listingTypeInfo?: ListingTypeInput | undefined;
    coOwnership?: ListingCoOwnershipInput | undefined;
    overview?: ListingOverviewInput | undefined;
    contractType?: ListingContractType | undefined;
    interior?: ListingInteriorInputs | undefined;
    levels?: ListingLevelDimensionsInput[] | undefined;
    lotDimensions?: ListingLotDimensionsInput | undefined;
    parking?: ListingParkingDetailInput | undefined;
    storage?: ListingStorageDetailInput | undefined;
    taxDetails?: ListingTaxDetailsInput | undefined;
    features?: string[] | undefined;
    viewAndOrientation?: ListingViewAndOrientationInput | undefined;
    contactInformation?: ListingContactInformationInput | undefined;
    scheduleView?: ListingScheduleViewInput | undefined;
    deposit?: ListingDepositInput | undefined;
    ownershipDocuments?: ListingOwnershipDocumentsInput | undefined;
    additionalCostDetails?: ListingAdditionalCostsInput | undefined;
    sellersDeclaration?: SellersDeclarationInput | undefined;
    contractDates?: ListingContractDatesInput | undefined;
    preEmptiveRightDelay?: ListingPreEmptiveRightDelayInput | undefined;
    contractInclusions?: ListingContractInclusionsInput | undefined;
    contractExclusions?: ListingContractExclusionsInput | undefined;
    contractAdditionalTerms?: ListingContractAdditionalTermsInput | undefined;
    isAvailableForSale?: boolean | undefined;
    isAvailableForRent?: boolean | undefined;
    rentDetails?: ListingRentDetailsInput | undefined;

    constructor(data?: ICreateOrEditListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? ListingAddressInput.fromJS(_data["address"]) : <any>undefined;
            this.priceInfo = _data["priceInfo"] ? ListingPriceInput.fromJS(_data["priceInfo"]) : <any>undefined;
            this.listingTypeInfo = _data["listingTypeInfo"] ? ListingTypeInput.fromJS(_data["listingTypeInfo"]) : <any>undefined;
            this.coOwnership = _data["coOwnership"] ? ListingCoOwnershipInput.fromJS(_data["coOwnership"]) : <any>undefined;
            this.overview = _data["overview"] ? ListingOverviewInput.fromJS(_data["overview"]) : <any>undefined;
            this.contractType = _data["contractType"];
            this.interior = _data["interior"] ? ListingInteriorInputs.fromJS(_data["interior"]) : <any>undefined;
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(ListingLevelDimensionsInput.fromJS(item));
            }
            this.lotDimensions = _data["lotDimensions"] ? ListingLotDimensionsInput.fromJS(_data["lotDimensions"]) : <any>undefined;
            this.parking = _data["parking"] ? ListingParkingDetailInput.fromJS(_data["parking"]) : <any>undefined;
            this.storage = _data["storage"] ? ListingStorageDetailInput.fromJS(_data["storage"]) : <any>undefined;
            this.taxDetails = _data["taxDetails"] ? ListingTaxDetailsInput.fromJS(_data["taxDetails"]) : <any>undefined;
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
            this.viewAndOrientation = _data["viewAndOrientation"] ? ListingViewAndOrientationInput.fromJS(_data["viewAndOrientation"]) : <any>undefined;
            this.contactInformation = _data["contactInformation"] ? ListingContactInformationInput.fromJS(_data["contactInformation"]) : <any>undefined;
            this.scheduleView = _data["scheduleView"] ? ListingScheduleViewInput.fromJS(_data["scheduleView"]) : <any>undefined;
            this.deposit = _data["deposit"] ? ListingDepositInput.fromJS(_data["deposit"]) : <any>undefined;
            this.ownershipDocuments = _data["ownershipDocuments"] ? ListingOwnershipDocumentsInput.fromJS(_data["ownershipDocuments"]) : <any>undefined;
            this.additionalCostDetails = _data["additionalCostDetails"] ? ListingAdditionalCostsInput.fromJS(_data["additionalCostDetails"]) : <any>undefined;
            this.sellersDeclaration = _data["sellersDeclaration"] ? SellersDeclarationInput.fromJS(_data["sellersDeclaration"]) : <any>undefined;
            this.contractDates = _data["contractDates"] ? ListingContractDatesInput.fromJS(_data["contractDates"]) : <any>undefined;
            this.preEmptiveRightDelay = _data["preEmptiveRightDelay"] ? ListingPreEmptiveRightDelayInput.fromJS(_data["preEmptiveRightDelay"]) : <any>undefined;
            this.contractInclusions = _data["contractInclusions"] ? ListingContractInclusionsInput.fromJS(_data["contractInclusions"]) : <any>undefined;
            this.contractExclusions = _data["contractExclusions"] ? ListingContractExclusionsInput.fromJS(_data["contractExclusions"]) : <any>undefined;
            this.contractAdditionalTerms = _data["contractAdditionalTerms"] ? ListingContractAdditionalTermsInput.fromJS(_data["contractAdditionalTerms"]) : <any>undefined;
            this.isAvailableForSale = _data["isAvailableForSale"];
            this.isAvailableForRent = _data["isAvailableForRent"];
            this.rentDetails = _data["rentDetails"] ? ListingRentDetailsInput.fromJS(_data["rentDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>undefined;
        data["listingTypeInfo"] = this.listingTypeInfo ? this.listingTypeInfo.toJSON() : <any>undefined;
        data["coOwnership"] = this.coOwnership ? this.coOwnership.toJSON() : <any>undefined;
        data["overview"] = this.overview ? this.overview.toJSON() : <any>undefined;
        data["contractType"] = this.contractType;
        data["interior"] = this.interior ? this.interior.toJSON() : <any>undefined;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        data["lotDimensions"] = this.lotDimensions ? this.lotDimensions.toJSON() : <any>undefined;
        data["parking"] = this.parking ? this.parking.toJSON() : <any>undefined;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["taxDetails"] = this.taxDetails ? this.taxDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        data["viewAndOrientation"] = this.viewAndOrientation ? this.viewAndOrientation.toJSON() : <any>undefined;
        data["contactInformation"] = this.contactInformation ? this.contactInformation.toJSON() : <any>undefined;
        data["scheduleView"] = this.scheduleView ? this.scheduleView.toJSON() : <any>undefined;
        data["deposit"] = this.deposit ? this.deposit.toJSON() : <any>undefined;
        data["ownershipDocuments"] = this.ownershipDocuments ? this.ownershipDocuments.toJSON() : <any>undefined;
        data["additionalCostDetails"] = this.additionalCostDetails ? this.additionalCostDetails.toJSON() : <any>undefined;
        data["sellersDeclaration"] = this.sellersDeclaration ? this.sellersDeclaration.toJSON() : <any>undefined;
        data["contractDates"] = this.contractDates ? this.contractDates.toJSON() : <any>undefined;
        data["preEmptiveRightDelay"] = this.preEmptiveRightDelay ? this.preEmptiveRightDelay.toJSON() : <any>undefined;
        data["contractInclusions"] = this.contractInclusions ? this.contractInclusions.toJSON() : <any>undefined;
        data["contractExclusions"] = this.contractExclusions ? this.contractExclusions.toJSON() : <any>undefined;
        data["contractAdditionalTerms"] = this.contractAdditionalTerms ? this.contractAdditionalTerms.toJSON() : <any>undefined;
        data["isAvailableForSale"] = this.isAvailableForSale;
        data["isAvailableForRent"] = this.isAvailableForRent;
        data["rentDetails"] = this.rentDetails ? this.rentDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrEditListingCommand {
    address?: ListingAddressInput | undefined;
    priceInfo?: ListingPriceInput | undefined;
    listingTypeInfo?: ListingTypeInput | undefined;
    coOwnership?: ListingCoOwnershipInput | undefined;
    overview?: ListingOverviewInput | undefined;
    contractType?: ListingContractType | undefined;
    interior?: ListingInteriorInputs | undefined;
    levels?: ListingLevelDimensionsInput[] | undefined;
    lotDimensions?: ListingLotDimensionsInput | undefined;
    parking?: ListingParkingDetailInput | undefined;
    storage?: ListingStorageDetailInput | undefined;
    taxDetails?: ListingTaxDetailsInput | undefined;
    features?: string[] | undefined;
    viewAndOrientation?: ListingViewAndOrientationInput | undefined;
    contactInformation?: ListingContactInformationInput | undefined;
    scheduleView?: ListingScheduleViewInput | undefined;
    deposit?: ListingDepositInput | undefined;
    ownershipDocuments?: ListingOwnershipDocumentsInput | undefined;
    additionalCostDetails?: ListingAdditionalCostsInput | undefined;
    sellersDeclaration?: SellersDeclarationInput | undefined;
    contractDates?: ListingContractDatesInput | undefined;
    preEmptiveRightDelay?: ListingPreEmptiveRightDelayInput | undefined;
    contractInclusions?: ListingContractInclusionsInput | undefined;
    contractExclusions?: ListingContractExclusionsInput | undefined;
    contractAdditionalTerms?: ListingContractAdditionalTermsInput | undefined;
    isAvailableForSale?: boolean | undefined;
    isAvailableForRent?: boolean | undefined;
    rentDetails?: ListingRentDetailsInput | undefined;
}

export class ListingAddressInput extends AddressInput implements IListingAddressInput {
    landRegistry?: string | undefined;
    landRegistryType?: LandRegistryType | undefined;

    constructor(data?: IListingAddressInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.landRegistry = _data["landRegistry"];
            this.landRegistryType = _data["landRegistryType"];
        }
    }

    static fromJS(data: any): ListingAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["landRegistry"] = this.landRegistry;
        data["landRegistryType"] = this.landRegistryType;
        super.toJSON(data);
        return data;
    }
}

export interface IListingAddressInput extends IAddressInput {
    landRegistry?: string | undefined;
    landRegistryType?: LandRegistryType | undefined;
}

export class ListingPriceInput implements IListingPriceInput {
    price?: number | undefined;
    negotiablePrice?: boolean | undefined;
    minimumNegotiablePrice?: number | undefined;
    acceptsConditionalOffers?: boolean | undefined;

    constructor(data?: IListingPriceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.negotiablePrice = _data["negotiablePrice"];
            this.minimumNegotiablePrice = _data["minimumNegotiablePrice"];
            this.acceptsConditionalOffers = _data["acceptsConditionalOffers"];
        }
    }

    static fromJS(data: any): ListingPriceInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingPriceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["negotiablePrice"] = this.negotiablePrice;
        data["minimumNegotiablePrice"] = this.minimumNegotiablePrice;
        data["acceptsConditionalOffers"] = this.acceptsConditionalOffers;
        return data;
    }
}

export interface IListingPriceInput {
    price?: number | undefined;
    negotiablePrice?: boolean | undefined;
    minimumNegotiablePrice?: number | undefined;
    acceptsConditionalOffers?: boolean | undefined;
}

export class ListingTypeInput implements IListingTypeInput {
    listingType?: ListingType | undefined;
    foundationType?: ListingFoundationType | undefined;
    otherFoundationType?: string | undefined;
    constructionType?: ConstructionType | undefined;
    otherConstructionType?: string | undefined;
    yearBuilt?: number | undefined;
    buildStatus?: ListingBuildStatus | undefined;

    constructor(data?: IListingTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingType = _data["listingType"];
            this.foundationType = _data["foundationType"];
            this.otherFoundationType = _data["otherFoundationType"];
            this.constructionType = _data["constructionType"];
            this.otherConstructionType = _data["otherConstructionType"];
            this.yearBuilt = _data["yearBuilt"];
            this.buildStatus = _data["buildStatus"];
        }
    }

    static fromJS(data: any): ListingTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingType"] = this.listingType;
        data["foundationType"] = this.foundationType;
        data["otherFoundationType"] = this.otherFoundationType;
        data["constructionType"] = this.constructionType;
        data["otherConstructionType"] = this.otherConstructionType;
        data["yearBuilt"] = this.yearBuilt;
        data["buildStatus"] = this.buildStatus;
        return data;
    }
}

export interface IListingTypeInput {
    listingType?: ListingType | undefined;
    foundationType?: ListingFoundationType | undefined;
    otherFoundationType?: string | undefined;
    constructionType?: ConstructionType | undefined;
    otherConstructionType?: string | undefined;
    yearBuilt?: number | undefined;
    buildStatus?: ListingBuildStatus | undefined;
}

export class ListingCoOwnershipInput implements IListingCoOwnershipInput {
    hasCoOwnership?: boolean | undefined;
    coOwnershipType?: CoOwnershipType | undefined;
    ownershipPercentage?: number | undefined;

    constructor(data?: IListingCoOwnershipInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasCoOwnership = _data["hasCoOwnership"];
            this.coOwnershipType = _data["coOwnershipType"];
            this.ownershipPercentage = _data["ownershipPercentage"];
        }
    }

    static fromJS(data: any): ListingCoOwnershipInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingCoOwnershipInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasCoOwnership"] = this.hasCoOwnership;
        data["coOwnershipType"] = this.coOwnershipType;
        data["ownershipPercentage"] = this.ownershipPercentage;
        return data;
    }
}

export interface IListingCoOwnershipInput {
    hasCoOwnership?: boolean | undefined;
    coOwnershipType?: CoOwnershipType | undefined;
    ownershipPercentage?: number | undefined;
}

export class ListingOverviewInput implements IListingOverviewInput {
    bedroomQuantity?: number | undefined;
    bathroomQuantity?: number | undefined;
    powderRoomQuantity?: number | undefined;
    hasElevatorAccess?: boolean | undefined;
    roomsAndAmenities?: string[] | undefined;
    external?: string[] | undefined;

    constructor(data?: IListingOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bedroomQuantity = _data["bedroomQuantity"];
            this.bathroomQuantity = _data["bathroomQuantity"];
            this.powderRoomQuantity = _data["powderRoomQuantity"];
            this.hasElevatorAccess = _data["hasElevatorAccess"];
            if (Array.isArray(_data["roomsAndAmenities"])) {
                this.roomsAndAmenities = [] as any;
                for (let item of _data["roomsAndAmenities"])
                    this.roomsAndAmenities!.push(item);
            }
            if (Array.isArray(_data["external"])) {
                this.external = [] as any;
                for (let item of _data["external"])
                    this.external!.push(item);
            }
        }
    }

    static fromJS(data: any): ListingOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bedroomQuantity"] = this.bedroomQuantity;
        data["bathroomQuantity"] = this.bathroomQuantity;
        data["powderRoomQuantity"] = this.powderRoomQuantity;
        data["hasElevatorAccess"] = this.hasElevatorAccess;
        if (Array.isArray(this.roomsAndAmenities)) {
            data["roomsAndAmenities"] = [];
            for (let item of this.roomsAndAmenities)
                data["roomsAndAmenities"].push(item);
        }
        if (Array.isArray(this.external)) {
            data["external"] = [];
            for (let item of this.external)
                data["external"].push(item);
        }
        return data;
    }
}

export interface IListingOverviewInput {
    bedroomQuantity?: number | undefined;
    bathroomQuantity?: number | undefined;
    powderRoomQuantity?: number | undefined;
    hasElevatorAccess?: boolean | undefined;
    roomsAndAmenities?: string[] | undefined;
    external?: string[] | undefined;
}

export class ListingInteriorInputs implements IListingInteriorInputs {
    isMultiLevel?: boolean | undefined;
    unitPreferences?: MeasurementSystem;
    totalIndoorAreaInMeters?: number | undefined;
    hasOutdoorSpace?: boolean | undefined;
    outdoorLengthInMeters?: number | undefined;
    outdoorWidthInMeters?: number | undefined;
    totalOutdoorAreaInMeters?: number | undefined;
    totalIndoorOutdoorAreaInMeters?: number | undefined;

    constructor(data?: IListingInteriorInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMultiLevel = _data["isMultiLevel"];
            this.unitPreferences = _data["unitPreferences"];
            this.totalIndoorAreaInMeters = _data["totalIndoorAreaInMeters"];
            this.hasOutdoorSpace = _data["hasOutdoorSpace"];
            this.outdoorLengthInMeters = _data["outdoorLengthInMeters"];
            this.outdoorWidthInMeters = _data["outdoorWidthInMeters"];
            this.totalOutdoorAreaInMeters = _data["totalOutdoorAreaInMeters"];
            this.totalIndoorOutdoorAreaInMeters = _data["totalIndoorOutdoorAreaInMeters"];
        }
    }

    static fromJS(data: any): ListingInteriorInputs {
        data = typeof data === 'object' ? data : {};
        let result = new ListingInteriorInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMultiLevel"] = this.isMultiLevel;
        data["unitPreferences"] = this.unitPreferences;
        data["totalIndoorAreaInMeters"] = this.totalIndoorAreaInMeters;
        data["hasOutdoorSpace"] = this.hasOutdoorSpace;
        data["outdoorLengthInMeters"] = this.outdoorLengthInMeters;
        data["outdoorWidthInMeters"] = this.outdoorWidthInMeters;
        data["totalOutdoorAreaInMeters"] = this.totalOutdoorAreaInMeters;
        data["totalIndoorOutdoorAreaInMeters"] = this.totalIndoorOutdoorAreaInMeters;
        return data;
    }
}

export interface IListingInteriorInputs {
    isMultiLevel?: boolean | undefined;
    unitPreferences?: MeasurementSystem;
    totalIndoorAreaInMeters?: number | undefined;
    hasOutdoorSpace?: boolean | undefined;
    outdoorLengthInMeters?: number | undefined;
    outdoorWidthInMeters?: number | undefined;
    totalOutdoorAreaInMeters?: number | undefined;
    totalIndoorOutdoorAreaInMeters?: number | undefined;
}

export abstract class BaseDimensionsInput implements IBaseDimensionsInput {
    lengthInMeters?: number | undefined;
    widthInMeters?: number | undefined;
    heightInMeters?: number | undefined;
    totalPropertyAreaInSqMeters?: number | undefined;

    constructor(data?: IBaseDimensionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lengthInMeters = _data["lengthInMeters"];
            this.widthInMeters = _data["widthInMeters"];
            this.heightInMeters = _data["heightInMeters"];
            this.totalPropertyAreaInSqMeters = _data["totalPropertyAreaInSqMeters"];
        }
    }

    static fromJS(data: any): BaseDimensionsInput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseDimensionsInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lengthInMeters"] = this.lengthInMeters;
        data["widthInMeters"] = this.widthInMeters;
        data["heightInMeters"] = this.heightInMeters;
        data["totalPropertyAreaInSqMeters"] = this.totalPropertyAreaInSqMeters;
        return data;
    }
}

export interface IBaseDimensionsInput {
    lengthInMeters?: number | undefined;
    widthInMeters?: number | undefined;
    heightInMeters?: number | undefined;
    totalPropertyAreaInSqMeters?: number | undefined;
}

export class ListingLevelDimensionsInput extends BaseDimensionsInput implements IListingLevelDimensionsInput {
    id?: string | undefined;
    customName?: string | undefined;
    isBasement?: boolean | undefined;

    constructor(data?: IListingLevelDimensionsInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.customName = _data["customName"];
            this.isBasement = _data["isBasement"];
        }
    }

    static fromJS(data: any): ListingLevelDimensionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingLevelDimensionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customName"] = this.customName;
        data["isBasement"] = this.isBasement;
        super.toJSON(data);
        return data;
    }
}

export interface IListingLevelDimensionsInput extends IBaseDimensionsInput {
    id?: string | undefined;
    customName?: string | undefined;
    isBasement?: boolean | undefined;
}

export class ListingLotDimensionsInput extends BaseDimensionsInput implements IListingLotDimensionsInput {
    unitPreferences?: MeasurementSystem;

    constructor(data?: IListingLotDimensionsInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unitPreferences = _data["unitPreferences"];
        }
    }

    static fromJS(data: any): ListingLotDimensionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingLotDimensionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPreferences"] = this.unitPreferences;
        super.toJSON(data);
        return data;
    }
}

export interface IListingLotDimensionsInput extends IBaseDimensionsInput {
    unitPreferences?: MeasurementSystem;
}

export class ListingParkingDetailInput implements IListingParkingDetailInput {
    hasParking?: boolean;
    additionalNotes?: string | undefined;
    spots?: ListingParkingInput[] | undefined;

    constructor(data?: IListingParkingDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasParking = _data["hasParking"];
            this.additionalNotes = _data["additionalNotes"];
            if (Array.isArray(_data["spots"])) {
                this.spots = [] as any;
                for (let item of _data["spots"])
                    this.spots!.push(ListingParkingInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingParkingDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingParkingDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasParking"] = this.hasParking;
        data["additionalNotes"] = this.additionalNotes;
        if (Array.isArray(this.spots)) {
            data["spots"] = [];
            for (let item of this.spots)
                data["spots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingParkingDetailInput {
    hasParking?: boolean;
    additionalNotes?: string | undefined;
    spots?: ListingParkingInput[] | undefined;
}

export class ListingParkingInput implements IListingParkingInput {
    id?: string | undefined;
    type?: ParkingType | undefined;
    location?: ParkingLocationType | undefined;
    otherLocation?: string | undefined;
    exposure?: ParkingExposureType | undefined;
    numberOfStalls?: number;
    stalls?: ParkingStallInput[] | undefined;
    additionalNotes?: string | undefined;

    constructor(data?: IListingParkingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.otherLocation = _data["otherLocation"];
            this.exposure = _data["exposure"];
            this.numberOfStalls = _data["numberOfStalls"];
            if (Array.isArray(_data["stalls"])) {
                this.stalls = [] as any;
                for (let item of _data["stalls"])
                    this.stalls!.push(ParkingStallInput.fromJS(item));
            }
            this.additionalNotes = _data["additionalNotes"];
        }
    }

    static fromJS(data: any): ListingParkingInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingParkingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["location"] = this.location;
        data["otherLocation"] = this.otherLocation;
        data["exposure"] = this.exposure;
        data["numberOfStalls"] = this.numberOfStalls;
        if (Array.isArray(this.stalls)) {
            data["stalls"] = [];
            for (let item of this.stalls)
                data["stalls"].push(item.toJSON());
        }
        data["additionalNotes"] = this.additionalNotes;
        return data;
    }
}

export interface IListingParkingInput {
    id?: string | undefined;
    type?: ParkingType | undefined;
    location?: ParkingLocationType | undefined;
    otherLocation?: string | undefined;
    exposure?: ParkingExposureType | undefined;
    numberOfStalls?: number;
    stalls?: ParkingStallInput[] | undefined;
    additionalNotes?: string | undefined;
}

export class ParkingStallInput implements IParkingStallInput {
    id?: string | undefined;
    stallSize?: ParkingStallSize | undefined;
    assignedStallNo?: string | undefined;
    hasEvCharging?: boolean;
    hasCarLift?: boolean;

    constructor(data?: IParkingStallInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stallSize = _data["stallSize"];
            this.assignedStallNo = _data["assignedStallNo"];
            this.hasEvCharging = _data["hasEvCharging"];
            this.hasCarLift = _data["hasCarLift"];
        }
    }

    static fromJS(data: any): ParkingStallInput {
        data = typeof data === 'object' ? data : {};
        let result = new ParkingStallInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stallSize"] = this.stallSize;
        data["assignedStallNo"] = this.assignedStallNo;
        data["hasEvCharging"] = this.hasEvCharging;
        data["hasCarLift"] = this.hasCarLift;
        return data;
    }
}

export interface IParkingStallInput {
    id?: string | undefined;
    stallSize?: ParkingStallSize | undefined;
    assignedStallNo?: string | undefined;
    hasEvCharging?: boolean;
    hasCarLift?: boolean;
}

export class ListingStorageDetailInput implements IListingStorageDetailInput {
    hasStorage?: boolean;
    additionalNotes?: string | undefined;
    unitPreference?: MeasurementSystem;
    units?: ListingStorageInput[] | undefined;

    constructor(data?: IListingStorageDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasStorage = _data["hasStorage"];
            this.additionalNotes = _data["additionalNotes"];
            this.unitPreference = _data["unitPreference"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(ListingStorageInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingStorageDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingStorageDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasStorage"] = this.hasStorage;
        data["additionalNotes"] = this.additionalNotes;
        data["unitPreference"] = this.unitPreference;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingStorageDetailInput {
    hasStorage?: boolean;
    additionalNotes?: string | undefined;
    unitPreference?: MeasurementSystem;
    units?: ListingStorageInput[] | undefined;
}

export class ListingStorageInput implements IListingStorageInput {
    id?: string | undefined;
    type?: StorageType | undefined;
    access?: Access | undefined;
    accessType?: AccessType | undefined;
    otherAccess?: string | undefined;
    storageSizeShape?: StorageSizeShape | undefined;
    assignedStorageUnitNo?: string | undefined;
    lengthInMeters?: number | undefined;
    widthInMeters?: number | undefined;
    heightInMeters?: number | undefined;
    additionalNotes?: string | undefined;
    unitPreference?: MeasurementSystem;

    constructor(data?: IListingStorageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.access = _data["access"];
            this.accessType = _data["accessType"];
            this.otherAccess = _data["otherAccess"];
            this.storageSizeShape = _data["storageSizeShape"];
            this.assignedStorageUnitNo = _data["assignedStorageUnitNo"];
            this.lengthInMeters = _data["lengthInMeters"];
            this.widthInMeters = _data["widthInMeters"];
            this.heightInMeters = _data["heightInMeters"];
            this.additionalNotes = _data["additionalNotes"];
            this.unitPreference = _data["unitPreference"];
        }
    }

    static fromJS(data: any): ListingStorageInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingStorageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["access"] = this.access;
        data["accessType"] = this.accessType;
        data["otherAccess"] = this.otherAccess;
        data["storageSizeShape"] = this.storageSizeShape;
        data["assignedStorageUnitNo"] = this.assignedStorageUnitNo;
        data["lengthInMeters"] = this.lengthInMeters;
        data["widthInMeters"] = this.widthInMeters;
        data["heightInMeters"] = this.heightInMeters;
        data["additionalNotes"] = this.additionalNotes;
        data["unitPreference"] = this.unitPreference;
        return data;
    }
}

export interface IListingStorageInput {
    id?: string | undefined;
    type?: StorageType | undefined;
    access?: Access | undefined;
    accessType?: AccessType | undefined;
    otherAccess?: string | undefined;
    storageSizeShape?: StorageSizeShape | undefined;
    assignedStorageUnitNo?: string | undefined;
    lengthInMeters?: number | undefined;
    widthInMeters?: number | undefined;
    heightInMeters?: number | undefined;
    additionalNotes?: string | undefined;
    unitPreference?: MeasurementSystem;
}

export class ListingTaxDetailsInput implements IListingTaxDetailsInput {
    areTaxesApplicable?: boolean | undefined;
    currency?: string | undefined;
    taxes?: ListingTaxInput[] | undefined;

    constructor(data?: IListingTaxDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areTaxesApplicable = _data["areTaxesApplicable"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(ListingTaxInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingTaxDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingTaxDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areTaxesApplicable"] = this.areTaxesApplicable;
        data["currency"] = this.currency;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingTaxDetailsInput {
    areTaxesApplicable?: boolean | undefined;
    currency?: string | undefined;
    taxes?: ListingTaxInput[] | undefined;
}

export class ListingTaxInput implements IListingTaxInput {
    no?: number;
    name?: string | undefined;
    percentage?: number;
    creditName?: string | undefined;
    creditPercentage?: number | undefined;

    constructor(data?: IListingTaxInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.no = _data["no"];
            this.name = _data["name"];
            this.percentage = _data["percentage"];
            this.creditName = _data["creditName"];
            this.creditPercentage = _data["creditPercentage"];
        }
    }

    static fromJS(data: any): ListingTaxInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingTaxInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["name"] = this.name;
        data["percentage"] = this.percentage;
        data["creditName"] = this.creditName;
        data["creditPercentage"] = this.creditPercentage;
        return data;
    }
}

export interface IListingTaxInput {
    no?: number;
    name?: string | undefined;
    percentage?: number;
    creditName?: string | undefined;
    creditPercentage?: number | undefined;
}

export class ListingViewAndOrientationInput implements IListingViewAndOrientationInput {
    orientation?: string[] | undefined;
    marketingDescription?: string | undefined;

    constructor(data?: IListingViewAndOrientationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orientation"])) {
                this.orientation = [] as any;
                for (let item of _data["orientation"])
                    this.orientation!.push(item);
            }
            this.marketingDescription = _data["marketingDescription"];
        }
    }

    static fromJS(data: any): ListingViewAndOrientationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingViewAndOrientationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orientation)) {
            data["orientation"] = [];
            for (let item of this.orientation)
                data["orientation"].push(item);
        }
        data["marketingDescription"] = this.marketingDescription;
        return data;
    }
}

export interface IListingViewAndOrientationInput {
    orientation?: string[] | undefined;
    marketingDescription?: string | undefined;
}

export class ListingContactInformationInput implements IListingContactInformationInput {
    phoneNumber?: string | undefined;

    constructor(data?: IListingContactInformationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): ListingContactInformationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContactInformationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IListingContactInformationInput {
    phoneNumber?: string | undefined;
}

export class ListingScheduleViewInput implements IListingScheduleViewInput {
    scheduleAViewLink?: string | undefined;

    constructor(data?: IListingScheduleViewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleAViewLink = _data["scheduleAViewLink"];
        }
    }

    static fromJS(data: any): ListingScheduleViewInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingScheduleViewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleAViewLink"] = this.scheduleAViewLink;
        return data;
    }
}

export interface IListingScheduleViewInput {
    scheduleAViewLink?: string | undefined;
}

export class ListingDepositInput implements IListingDepositInput {
    isDepositRequired?: boolean | undefined;
    depositMode?: DepositMode;
    negotiable?: boolean | undefined;
    isDepositRefundable?: boolean | undefined;
    minimumDeposit?: number | undefined;
    maximumDeposit?: number | undefined;
    depositStructures?: DepositStructureDto[] | undefined;

    constructor(data?: IListingDepositInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDepositRequired = _data["isDepositRequired"];
            this.depositMode = _data["depositMode"];
            this.negotiable = _data["negotiable"];
            this.isDepositRefundable = _data["isDepositRefundable"];
            this.minimumDeposit = _data["minimumDeposit"];
            this.maximumDeposit = _data["maximumDeposit"];
            if (Array.isArray(_data["depositStructures"])) {
                this.depositStructures = [] as any;
                for (let item of _data["depositStructures"])
                    this.depositStructures!.push(DepositStructureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingDepositInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingDepositInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDepositRequired"] = this.isDepositRequired;
        data["depositMode"] = this.depositMode;
        data["negotiable"] = this.negotiable;
        data["isDepositRefundable"] = this.isDepositRefundable;
        data["minimumDeposit"] = this.minimumDeposit;
        data["maximumDeposit"] = this.maximumDeposit;
        if (Array.isArray(this.depositStructures)) {
            data["depositStructures"] = [];
            for (let item of this.depositStructures)
                data["depositStructures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingDepositInput {
    isDepositRequired?: boolean | undefined;
    depositMode?: DepositMode;
    negotiable?: boolean | undefined;
    isDepositRefundable?: boolean | undefined;
    minimumDeposit?: number | undefined;
    maximumDeposit?: number | undefined;
    depositStructures?: DepositStructureDto[] | undefined;
}

export class ListingOwnershipDocumentsInput implements IListingOwnershipDocumentsInput {
    amountOfTimeToProvideDocumentsInDays?: number | undefined;
    isAmountOfTimeToProvideDocumentsNegotiable?: boolean | undefined;
    minAmountOfTimeToProvideDocumentsInDays?: number | undefined;
    maxAmountOfTimeToProvideDocumentsInDays?: number | undefined;
    comments?: string | undefined;

    constructor(data?: IListingOwnershipDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountOfTimeToProvideDocumentsInDays = _data["amountOfTimeToProvideDocumentsInDays"];
            this.isAmountOfTimeToProvideDocumentsNegotiable = _data["isAmountOfTimeToProvideDocumentsNegotiable"];
            this.minAmountOfTimeToProvideDocumentsInDays = _data["minAmountOfTimeToProvideDocumentsInDays"];
            this.maxAmountOfTimeToProvideDocumentsInDays = _data["maxAmountOfTimeToProvideDocumentsInDays"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ListingOwnershipDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingOwnershipDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountOfTimeToProvideDocumentsInDays"] = this.amountOfTimeToProvideDocumentsInDays;
        data["isAmountOfTimeToProvideDocumentsNegotiable"] = this.isAmountOfTimeToProvideDocumentsNegotiable;
        data["minAmountOfTimeToProvideDocumentsInDays"] = this.minAmountOfTimeToProvideDocumentsInDays;
        data["maxAmountOfTimeToProvideDocumentsInDays"] = this.maxAmountOfTimeToProvideDocumentsInDays;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IListingOwnershipDocumentsInput {
    amountOfTimeToProvideDocumentsInDays?: number | undefined;
    isAmountOfTimeToProvideDocumentsNegotiable?: boolean | undefined;
    minAmountOfTimeToProvideDocumentsInDays?: number | undefined;
    maxAmountOfTimeToProvideDocumentsInDays?: number | undefined;
    comments?: string | undefined;
}

export class ListingAdditionalCostsInput implements IListingAdditionalCostsInput {
    monthlyHomeOwnerAssociationFee?: number | undefined;
    monthlyHydroAndElectricityFee?: number | undefined;
    monthlyGasFee?: number | undefined;
    previousPropertyTaxAmount?: number | undefined;
    additionalCosts?: PropertyAdditionalCostDetailInput[] | undefined;

    constructor(data?: IListingAdditionalCostsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyHomeOwnerAssociationFee = _data["monthlyHomeOwnerAssociationFee"];
            this.monthlyHydroAndElectricityFee = _data["monthlyHydroAndElectricityFee"];
            this.monthlyGasFee = _data["monthlyGasFee"];
            this.previousPropertyTaxAmount = _data["previousPropertyTaxAmount"];
            if (Array.isArray(_data["additionalCosts"])) {
                this.additionalCosts = [] as any;
                for (let item of _data["additionalCosts"])
                    this.additionalCosts!.push(PropertyAdditionalCostDetailInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingAdditionalCostsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingAdditionalCostsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyHomeOwnerAssociationFee"] = this.monthlyHomeOwnerAssociationFee;
        data["monthlyHydroAndElectricityFee"] = this.monthlyHydroAndElectricityFee;
        data["monthlyGasFee"] = this.monthlyGasFee;
        data["previousPropertyTaxAmount"] = this.previousPropertyTaxAmount;
        if (Array.isArray(this.additionalCosts)) {
            data["additionalCosts"] = [];
            for (let item of this.additionalCosts)
                data["additionalCosts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingAdditionalCostsInput {
    monthlyHomeOwnerAssociationFee?: number | undefined;
    monthlyHydroAndElectricityFee?: number | undefined;
    monthlyGasFee?: number | undefined;
    previousPropertyTaxAmount?: number | undefined;
    additionalCosts?: PropertyAdditionalCostDetailInput[] | undefined;
}

export class PropertyAdditionalCostDetailInput implements IPropertyAdditionalCostDetailInput {
    no?: number;
    name?: string | undefined;
    cost?: number;

    constructor(data?: IPropertyAdditionalCostDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.no = _data["no"];
            this.name = _data["name"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): PropertyAdditionalCostDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAdditionalCostDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["name"] = this.name;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IPropertyAdditionalCostDetailInput {
    no?: number;
    name?: string | undefined;
    cost?: number;
}

export class SellersDeclarationInput implements ISellersDeclarationInput {
    declarationGeneralInformation?: DeclarationGeneralInformationInput | undefined;
    declarationLandAndBuildingBasement?: DeclarationLandAndBuildingBasementInput | undefined;
    declarationRoof?: DeclarationRoofInput | undefined;
    declarationWaterInfiltration?: DeclarationWaterInfiltrationInput | undefined;
    declarationIndoorAirQuality?: DeclarationIndoorAirQualityInput | undefined;
    declarationElectricity?: DeclarationElectricityInput | undefined;
    declarationPlumbingAndDrainage?: DeclarationPlumbingAndDrainageInput | undefined;
    declarationHeatingAndAirConditioning?: DeclarationHeatingAndAirConditioningInput | undefined;
    declarationMiscellaneous?: DeclarationMiscellaneousInput | undefined;
    declarationRenovationsAndConstruction?: DeclarationRenovationsAndConstructionInput | undefined;

    constructor(data?: ISellersDeclarationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.declarationGeneralInformation = _data["declarationGeneralInformation"] ? DeclarationGeneralInformationInput.fromJS(_data["declarationGeneralInformation"]) : <any>undefined;
            this.declarationLandAndBuildingBasement = _data["declarationLandAndBuildingBasement"] ? DeclarationLandAndBuildingBasementInput.fromJS(_data["declarationLandAndBuildingBasement"]) : <any>undefined;
            this.declarationRoof = _data["declarationRoof"] ? DeclarationRoofInput.fromJS(_data["declarationRoof"]) : <any>undefined;
            this.declarationWaterInfiltration = _data["declarationWaterInfiltration"] ? DeclarationWaterInfiltrationInput.fromJS(_data["declarationWaterInfiltration"]) : <any>undefined;
            this.declarationIndoorAirQuality = _data["declarationIndoorAirQuality"] ? DeclarationIndoorAirQualityInput.fromJS(_data["declarationIndoorAirQuality"]) : <any>undefined;
            this.declarationElectricity = _data["declarationElectricity"] ? DeclarationElectricityInput.fromJS(_data["declarationElectricity"]) : <any>undefined;
            this.declarationPlumbingAndDrainage = _data["declarationPlumbingAndDrainage"] ? DeclarationPlumbingAndDrainageInput.fromJS(_data["declarationPlumbingAndDrainage"]) : <any>undefined;
            this.declarationHeatingAndAirConditioning = _data["declarationHeatingAndAirConditioning"] ? DeclarationHeatingAndAirConditioningInput.fromJS(_data["declarationHeatingAndAirConditioning"]) : <any>undefined;
            this.declarationMiscellaneous = _data["declarationMiscellaneous"] ? DeclarationMiscellaneousInput.fromJS(_data["declarationMiscellaneous"]) : <any>undefined;
            this.declarationRenovationsAndConstruction = _data["declarationRenovationsAndConstruction"] ? DeclarationRenovationsAndConstructionInput.fromJS(_data["declarationRenovationsAndConstruction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SellersDeclarationInput {
        data = typeof data === 'object' ? data : {};
        let result = new SellersDeclarationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["declarationGeneralInformation"] = this.declarationGeneralInformation ? this.declarationGeneralInformation.toJSON() : <any>undefined;
        data["declarationLandAndBuildingBasement"] = this.declarationLandAndBuildingBasement ? this.declarationLandAndBuildingBasement.toJSON() : <any>undefined;
        data["declarationRoof"] = this.declarationRoof ? this.declarationRoof.toJSON() : <any>undefined;
        data["declarationWaterInfiltration"] = this.declarationWaterInfiltration ? this.declarationWaterInfiltration.toJSON() : <any>undefined;
        data["declarationIndoorAirQuality"] = this.declarationIndoorAirQuality ? this.declarationIndoorAirQuality.toJSON() : <any>undefined;
        data["declarationElectricity"] = this.declarationElectricity ? this.declarationElectricity.toJSON() : <any>undefined;
        data["declarationPlumbingAndDrainage"] = this.declarationPlumbingAndDrainage ? this.declarationPlumbingAndDrainage.toJSON() : <any>undefined;
        data["declarationHeatingAndAirConditioning"] = this.declarationHeatingAndAirConditioning ? this.declarationHeatingAndAirConditioning.toJSON() : <any>undefined;
        data["declarationMiscellaneous"] = this.declarationMiscellaneous ? this.declarationMiscellaneous.toJSON() : <any>undefined;
        data["declarationRenovationsAndConstruction"] = this.declarationRenovationsAndConstruction ? this.declarationRenovationsAndConstruction.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISellersDeclarationInput {
    declarationGeneralInformation?: DeclarationGeneralInformationInput | undefined;
    declarationLandAndBuildingBasement?: DeclarationLandAndBuildingBasementInput | undefined;
    declarationRoof?: DeclarationRoofInput | undefined;
    declarationWaterInfiltration?: DeclarationWaterInfiltrationInput | undefined;
    declarationIndoorAirQuality?: DeclarationIndoorAirQualityInput | undefined;
    declarationElectricity?: DeclarationElectricityInput | undefined;
    declarationPlumbingAndDrainage?: DeclarationPlumbingAndDrainageInput | undefined;
    declarationHeatingAndAirConditioning?: DeclarationHeatingAndAirConditioningInput | undefined;
    declarationMiscellaneous?: DeclarationMiscellaneousInput | undefined;
    declarationRenovationsAndConstruction?: DeclarationRenovationsAndConstructionInput | undefined;
}

export class DeclarationGeneralInformationInput implements IDeclarationGeneralInformationInput {
    purchaseYear?: number | undefined;
    occupyProperty?: YesNoDontKnow | undefined;
    occupyPropertySince?: number | undefined;
    propertyLeased?: YesNoDontKnow | undefined;
    rentalPeriods?: string | undefined;
    yearOfConstruction?: number | undefined;
    dontKnowYearOfConstruction?: boolean | undefined;
    coveredByNewHomeWarranty?: YesNoDontKnow | undefined;

    constructor(data?: IDeclarationGeneralInformationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseYear = _data["purchaseYear"];
            this.occupyProperty = _data["occupyProperty"];
            this.occupyPropertySince = _data["occupyPropertySince"];
            this.propertyLeased = _data["propertyLeased"];
            this.rentalPeriods = _data["rentalPeriods"];
            this.yearOfConstruction = _data["yearOfConstruction"];
            this.dontKnowYearOfConstruction = _data["dontKnowYearOfConstruction"];
            this.coveredByNewHomeWarranty = _data["coveredByNewHomeWarranty"];
        }
    }

    static fromJS(data: any): DeclarationGeneralInformationInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationGeneralInformationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseYear"] = this.purchaseYear;
        data["occupyProperty"] = this.occupyProperty;
        data["occupyPropertySince"] = this.occupyPropertySince;
        data["propertyLeased"] = this.propertyLeased;
        data["rentalPeriods"] = this.rentalPeriods;
        data["yearOfConstruction"] = this.yearOfConstruction;
        data["dontKnowYearOfConstruction"] = this.dontKnowYearOfConstruction;
        data["coveredByNewHomeWarranty"] = this.coveredByNewHomeWarranty;
        return data;
    }
}

export interface IDeclarationGeneralInformationInput {
    purchaseYear?: number | undefined;
    occupyProperty?: YesNoDontKnow | undefined;
    occupyPropertySince?: number | undefined;
    propertyLeased?: YesNoDontKnow | undefined;
    rentalPeriods?: string | undefined;
    yearOfConstruction?: number | undefined;
    dontKnowYearOfConstruction?: boolean | undefined;
    coveredByNewHomeWarranty?: YesNoDontKnow | undefined;
}

export enum YesNoDontKnow {
    Yes = 0,
    No = 1,
    DontKnow = 2,
}

export class DeclarationLandAndBuildingBasementInput implements IDeclarationLandAndBuildingBasementInput {
    problemsWithSoil?: YesNoDontKnow | undefined;
    problemsWithSoilDetails?: string | undefined;
    foundationStabilizationWork?: YesNoDontKnow | undefined;
    foundationStabilizationWorkDetails?: string | undefined;
    soilContamination?: YesNoDontKnow | undefined;
    soilContaminationDetails?: string | undefined;
    soilWork?: YesNoDontKnow | undefined;
    soilWorkDetails?: string | undefined;
    recurringWaterAccumulation?: YesNoDontKnow | undefined;
    recurringWaterAccumulationDetails?: string | undefined;
    ironOchreInSoil?: YesNoDontKnow | undefined;
    ironOchreInSoilDetails?: string | undefined;
    liquidSpillsInBasement?: YesNoDontKnow | undefined;
    liquidSpillsInBasementDetails?: string | undefined;
    foundationCracksOrRot?: YesNoDontKnow | undefined;
    foundationCracksOrRotDetails?: string | undefined;

    constructor(data?: IDeclarationLandAndBuildingBasementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.problemsWithSoil = _data["problemsWithSoil"];
            this.problemsWithSoilDetails = _data["problemsWithSoilDetails"];
            this.foundationStabilizationWork = _data["foundationStabilizationWork"];
            this.foundationStabilizationWorkDetails = _data["foundationStabilizationWorkDetails"];
            this.soilContamination = _data["soilContamination"];
            this.soilContaminationDetails = _data["soilContaminationDetails"];
            this.soilWork = _data["soilWork"];
            this.soilWorkDetails = _data["soilWorkDetails"];
            this.recurringWaterAccumulation = _data["recurringWaterAccumulation"];
            this.recurringWaterAccumulationDetails = _data["recurringWaterAccumulationDetails"];
            this.ironOchreInSoil = _data["ironOchreInSoil"];
            this.ironOchreInSoilDetails = _data["ironOchreInSoilDetails"];
            this.liquidSpillsInBasement = _data["liquidSpillsInBasement"];
            this.liquidSpillsInBasementDetails = _data["liquidSpillsInBasementDetails"];
            this.foundationCracksOrRot = _data["foundationCracksOrRot"];
            this.foundationCracksOrRotDetails = _data["foundationCracksOrRotDetails"];
        }
    }

    static fromJS(data: any): DeclarationLandAndBuildingBasementInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationLandAndBuildingBasementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["problemsWithSoil"] = this.problemsWithSoil;
        data["problemsWithSoilDetails"] = this.problemsWithSoilDetails;
        data["foundationStabilizationWork"] = this.foundationStabilizationWork;
        data["foundationStabilizationWorkDetails"] = this.foundationStabilizationWorkDetails;
        data["soilContamination"] = this.soilContamination;
        data["soilContaminationDetails"] = this.soilContaminationDetails;
        data["soilWork"] = this.soilWork;
        data["soilWorkDetails"] = this.soilWorkDetails;
        data["recurringWaterAccumulation"] = this.recurringWaterAccumulation;
        data["recurringWaterAccumulationDetails"] = this.recurringWaterAccumulationDetails;
        data["ironOchreInSoil"] = this.ironOchreInSoil;
        data["ironOchreInSoilDetails"] = this.ironOchreInSoilDetails;
        data["liquidSpillsInBasement"] = this.liquidSpillsInBasement;
        data["liquidSpillsInBasementDetails"] = this.liquidSpillsInBasementDetails;
        data["foundationCracksOrRot"] = this.foundationCracksOrRot;
        data["foundationCracksOrRotDetails"] = this.foundationCracksOrRotDetails;
        return data;
    }
}

export interface IDeclarationLandAndBuildingBasementInput {
    problemsWithSoil?: YesNoDontKnow | undefined;
    problemsWithSoilDetails?: string | undefined;
    foundationStabilizationWork?: YesNoDontKnow | undefined;
    foundationStabilizationWorkDetails?: string | undefined;
    soilContamination?: YesNoDontKnow | undefined;
    soilContaminationDetails?: string | undefined;
    soilWork?: YesNoDontKnow | undefined;
    soilWorkDetails?: string | undefined;
    recurringWaterAccumulation?: YesNoDontKnow | undefined;
    recurringWaterAccumulationDetails?: string | undefined;
    ironOchreInSoil?: YesNoDontKnow | undefined;
    ironOchreInSoilDetails?: string | undefined;
    liquidSpillsInBasement?: YesNoDontKnow | undefined;
    liquidSpillsInBasementDetails?: string | undefined;
    foundationCracksOrRot?: YesNoDontKnow | undefined;
    foundationCracksOrRotDetails?: string | undefined;
}

export class DeclarationRoofInput implements IDeclarationRoofInput {
    roofCoveringYear?: number | undefined;
    dontKnowRoofCoveringYear?: boolean | undefined;
    roofMaintenanceDocuments?: YesNoDontKnow | undefined;
    iceAccumulationOrIcicles?: YesNoDontKnow | undefined;

    constructor(data?: IDeclarationRoofInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roofCoveringYear = _data["roofCoveringYear"];
            this.dontKnowRoofCoveringYear = _data["dontKnowRoofCoveringYear"];
            this.roofMaintenanceDocuments = _data["roofMaintenanceDocuments"];
            this.iceAccumulationOrIcicles = _data["iceAccumulationOrIcicles"];
        }
    }

    static fromJS(data: any): DeclarationRoofInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationRoofInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roofCoveringYear"] = this.roofCoveringYear;
        data["dontKnowRoofCoveringYear"] = this.dontKnowRoofCoveringYear;
        data["roofMaintenanceDocuments"] = this.roofMaintenanceDocuments;
        data["iceAccumulationOrIcicles"] = this.iceAccumulationOrIcicles;
        return data;
    }
}

export interface IDeclarationRoofInput {
    roofCoveringYear?: number | undefined;
    dontKnowRoofCoveringYear?: boolean | undefined;
    roofMaintenanceDocuments?: YesNoDontKnow | undefined;
    iceAccumulationOrIcicles?: YesNoDontKnow | undefined;
}

export class DeclarationWaterInfiltrationInput implements IDeclarationWaterInfiltrationInput {
    waterInfiltrationThroughRoofOrOther?: YesNoDontKnow | undefined;
    waterInfiltrationDetails?: string | undefined;
    waterInfiltrationInBasement?: YesNoDontKnow | undefined;
    waterInfiltrationCauses?: string[] | undefined;

    constructor(data?: IDeclarationWaterInfiltrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waterInfiltrationThroughRoofOrOther = _data["waterInfiltrationThroughRoofOrOther"];
            this.waterInfiltrationDetails = _data["waterInfiltrationDetails"];
            this.waterInfiltrationInBasement = _data["waterInfiltrationInBasement"];
            if (Array.isArray(_data["waterInfiltrationCauses"])) {
                this.waterInfiltrationCauses = [] as any;
                for (let item of _data["waterInfiltrationCauses"])
                    this.waterInfiltrationCauses!.push(item);
            }
        }
    }

    static fromJS(data: any): DeclarationWaterInfiltrationInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationWaterInfiltrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waterInfiltrationThroughRoofOrOther"] = this.waterInfiltrationThroughRoofOrOther;
        data["waterInfiltrationDetails"] = this.waterInfiltrationDetails;
        data["waterInfiltrationInBasement"] = this.waterInfiltrationInBasement;
        if (Array.isArray(this.waterInfiltrationCauses)) {
            data["waterInfiltrationCauses"] = [];
            for (let item of this.waterInfiltrationCauses)
                data["waterInfiltrationCauses"].push(item);
        }
        return data;
    }
}

export interface IDeclarationWaterInfiltrationInput {
    waterInfiltrationThroughRoofOrOther?: YesNoDontKnow | undefined;
    waterInfiltrationDetails?: string | undefined;
    waterInfiltrationInBasement?: YesNoDontKnow | undefined;
    waterInfiltrationCauses?: string[] | undefined;
}

export class DeclarationIndoorAirQualityInput implements IDeclarationIndoorAirQualityInput {
    insulationProductWithAsbestos?: YesNoDontKnow | undefined;
    insulationProductDetails?: string | undefined;
    condensation?: YesNoDontKnow | undefined;
    condensationDetails?: string | undefined;
    odours?: YesNoDontKnow | undefined;
    odoursDetails?: string | undefined;
    evidenceOfMouldOrRot?: YesNoDontKnow | undefined;
    evidenceOfMouldOrRotDetails?: string | undefined;

    constructor(data?: IDeclarationIndoorAirQualityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insulationProductWithAsbestos = _data["insulationProductWithAsbestos"];
            this.insulationProductDetails = _data["insulationProductDetails"];
            this.condensation = _data["condensation"];
            this.condensationDetails = _data["condensationDetails"];
            this.odours = _data["odours"];
            this.odoursDetails = _data["odoursDetails"];
            this.evidenceOfMouldOrRot = _data["evidenceOfMouldOrRot"];
            this.evidenceOfMouldOrRotDetails = _data["evidenceOfMouldOrRotDetails"];
        }
    }

    static fromJS(data: any): DeclarationIndoorAirQualityInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationIndoorAirQualityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insulationProductWithAsbestos"] = this.insulationProductWithAsbestos;
        data["insulationProductDetails"] = this.insulationProductDetails;
        data["condensation"] = this.condensation;
        data["condensationDetails"] = this.condensationDetails;
        data["odours"] = this.odours;
        data["odoursDetails"] = this.odoursDetails;
        data["evidenceOfMouldOrRot"] = this.evidenceOfMouldOrRot;
        data["evidenceOfMouldOrRotDetails"] = this.evidenceOfMouldOrRotDetails;
        return data;
    }
}

export interface IDeclarationIndoorAirQualityInput {
    insulationProductWithAsbestos?: YesNoDontKnow | undefined;
    insulationProductDetails?: string | undefined;
    condensation?: YesNoDontKnow | undefined;
    condensationDetails?: string | undefined;
    odours?: YesNoDontKnow | undefined;
    odoursDetails?: string | undefined;
    evidenceOfMouldOrRot?: YesNoDontKnow | undefined;
    evidenceOfMouldOrRotDetails?: string | undefined;
}

export class DeclarationElectricityInput implements IDeclarationElectricityInput {
    electricalProblems?: YesNoDontKnow | undefined;
    electricalProblemsDetails?: string | undefined;

    constructor(data?: IDeclarationElectricityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.electricalProblems = _data["electricalProblems"];
            this.electricalProblemsDetails = _data["electricalProblemsDetails"];
        }
    }

    static fromJS(data: any): DeclarationElectricityInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationElectricityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["electricalProblems"] = this.electricalProblems;
        data["electricalProblemsDetails"] = this.electricalProblemsDetails;
        return data;
    }
}

export interface IDeclarationElectricityInput {
    electricalProblems?: YesNoDontKnow | undefined;
    electricalProblemsDetails?: string | undefined;
}

export class DeclarationPlumbingAndDrainageInput implements IDeclarationPlumbingAndDrainageInput {
    significantWaterPressureVariation?: YesNoDontKnow | undefined;
    freezingPipes?: YesNoDontKnow | undefined;
    waterLeaks?: YesNoDontKnow | undefined;
    rustyWater?: YesNoDontKnow | undefined;
    odours?: YesNoDontKnow | undefined;
    plumbingDrainageOrBackup?: YesNoDontKnow | undefined;
    plumbingDrainageDetails?: string | undefined;
    sumpPump?: YesNoDontKnow | undefined;
    sumpPumpDetails?: string | undefined;
    plumbingModifications?: YesNoDontKnow | undefined;
    waterHeaterYear?: number | undefined;
    dontKnowWaterHeaterYear?: boolean | undefined;
    wellsOnProperty?: YesNoDontKnow | undefined;
    waterSupplySource?: string | undefined;
    drinkingWaterSupply?: YesNoDontKnow | undefined;
    waterSupplyQualityIssues?: YesNoDontKnow | undefined;
    septicTanksAndWeepingFieldOnProperty?: YesNoDontKnow | undefined;
    installationYear?: number | undefined;
    dontKnowInstallationYear?: boolean | undefined;
    complianceCertificate?: YesNoDontKnow | undefined;
    nonComplianceNotice?: YesNoDontKnow | undefined;
    nonComplianceNoticeDetails?: string | undefined;
    systemLastEmptiedYear?: number | undefined;
    dontKnowSystemLastEmptiedYear?: boolean | undefined;
    systemProblems?: YesNoDontKnow | undefined;
    systemProblemsDetails?: string | undefined;

    constructor(data?: IDeclarationPlumbingAndDrainageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.significantWaterPressureVariation = _data["significantWaterPressureVariation"];
            this.freezingPipes = _data["freezingPipes"];
            this.waterLeaks = _data["waterLeaks"];
            this.rustyWater = _data["rustyWater"];
            this.odours = _data["odours"];
            this.plumbingDrainageOrBackup = _data["plumbingDrainageOrBackup"];
            this.plumbingDrainageDetails = _data["plumbingDrainageDetails"];
            this.sumpPump = _data["sumpPump"];
            this.sumpPumpDetails = _data["sumpPumpDetails"];
            this.plumbingModifications = _data["plumbingModifications"];
            this.waterHeaterYear = _data["waterHeaterYear"];
            this.dontKnowWaterHeaterYear = _data["dontKnowWaterHeaterYear"];
            this.wellsOnProperty = _data["wellsOnProperty"];
            this.waterSupplySource = _data["waterSupplySource"];
            this.drinkingWaterSupply = _data["drinkingWaterSupply"];
            this.waterSupplyQualityIssues = _data["waterSupplyQualityIssues"];
            this.septicTanksAndWeepingFieldOnProperty = _data["septicTanksAndWeepingFieldOnProperty"];
            this.installationYear = _data["installationYear"];
            this.dontKnowInstallationYear = _data["dontKnowInstallationYear"];
            this.complianceCertificate = _data["complianceCertificate"];
            this.nonComplianceNotice = _data["nonComplianceNotice"];
            this.nonComplianceNoticeDetails = _data["nonComplianceNoticeDetails"];
            this.systemLastEmptiedYear = _data["systemLastEmptiedYear"];
            this.dontKnowSystemLastEmptiedYear = _data["dontKnowSystemLastEmptiedYear"];
            this.systemProblems = _data["systemProblems"];
            this.systemProblemsDetails = _data["systemProblemsDetails"];
        }
    }

    static fromJS(data: any): DeclarationPlumbingAndDrainageInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationPlumbingAndDrainageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["significantWaterPressureVariation"] = this.significantWaterPressureVariation;
        data["freezingPipes"] = this.freezingPipes;
        data["waterLeaks"] = this.waterLeaks;
        data["rustyWater"] = this.rustyWater;
        data["odours"] = this.odours;
        data["plumbingDrainageOrBackup"] = this.plumbingDrainageOrBackup;
        data["plumbingDrainageDetails"] = this.plumbingDrainageDetails;
        data["sumpPump"] = this.sumpPump;
        data["sumpPumpDetails"] = this.sumpPumpDetails;
        data["plumbingModifications"] = this.plumbingModifications;
        data["waterHeaterYear"] = this.waterHeaterYear;
        data["dontKnowWaterHeaterYear"] = this.dontKnowWaterHeaterYear;
        data["wellsOnProperty"] = this.wellsOnProperty;
        data["waterSupplySource"] = this.waterSupplySource;
        data["drinkingWaterSupply"] = this.drinkingWaterSupply;
        data["waterSupplyQualityIssues"] = this.waterSupplyQualityIssues;
        data["septicTanksAndWeepingFieldOnProperty"] = this.septicTanksAndWeepingFieldOnProperty;
        data["installationYear"] = this.installationYear;
        data["dontKnowInstallationYear"] = this.dontKnowInstallationYear;
        data["complianceCertificate"] = this.complianceCertificate;
        data["nonComplianceNotice"] = this.nonComplianceNotice;
        data["nonComplianceNoticeDetails"] = this.nonComplianceNoticeDetails;
        data["systemLastEmptiedYear"] = this.systemLastEmptiedYear;
        data["dontKnowSystemLastEmptiedYear"] = this.dontKnowSystemLastEmptiedYear;
        data["systemProblems"] = this.systemProblems;
        data["systemProblemsDetails"] = this.systemProblemsDetails;
        return data;
    }
}

export interface IDeclarationPlumbingAndDrainageInput {
    significantWaterPressureVariation?: YesNoDontKnow | undefined;
    freezingPipes?: YesNoDontKnow | undefined;
    waterLeaks?: YesNoDontKnow | undefined;
    rustyWater?: YesNoDontKnow | undefined;
    odours?: YesNoDontKnow | undefined;
    plumbingDrainageOrBackup?: YesNoDontKnow | undefined;
    plumbingDrainageDetails?: string | undefined;
    sumpPump?: YesNoDontKnow | undefined;
    sumpPumpDetails?: string | undefined;
    plumbingModifications?: YesNoDontKnow | undefined;
    waterHeaterYear?: number | undefined;
    dontKnowWaterHeaterYear?: boolean | undefined;
    wellsOnProperty?: YesNoDontKnow | undefined;
    waterSupplySource?: string | undefined;
    drinkingWaterSupply?: YesNoDontKnow | undefined;
    waterSupplyQualityIssues?: YesNoDontKnow | undefined;
    septicTanksAndWeepingFieldOnProperty?: YesNoDontKnow | undefined;
    installationYear?: number | undefined;
    dontKnowInstallationYear?: boolean | undefined;
    complianceCertificate?: YesNoDontKnow | undefined;
    nonComplianceNotice?: YesNoDontKnow | undefined;
    nonComplianceNoticeDetails?: string | undefined;
    systemLastEmptiedYear?: number | undefined;
    dontKnowSystemLastEmptiedYear?: boolean | undefined;
    systemProblems?: YesNoDontKnow | undefined;
    systemProblemsDetails?: string | undefined;
}

export class DeclarationHeatingAndAirConditioningInput implements IDeclarationHeatingAndAirConditioningInput {
    mainHeatingSystemProblems?: YesNoDontKnow | undefined;
    mainHeatingSystemProblemsDetails?: string | undefined;
    mainHeatingSystemWorkEfficiently?: YesNoDontKnow | undefined;
    mainHeatingSystemInstallationYear?: number | undefined;
    mainHeatingSystemDontKnowInstallationYear?: boolean | undefined;
    mainHeatingSystemMaintenanceContract?: YesNoDontKnow | undefined;
    mainHeatingSystemUndergroundOilTank?: YesNoDontKnow | undefined;
    mainHeatingSystemUndergroundOilTankInspectedRecently?: YesNoDontKnow | undefined;
    mainHeatingSystemOilLastInspectionYear?: number | undefined;
    heatPumpHasHeatPump?: YesNoDontKnow | undefined;
    heatPumpProblems?: YesNoDontKnow | undefined;
    heatPumpProblemsDetails?: string | undefined;
    heatPumpInstallationYear?: number | undefined;
    heatPumpDontKnowInstallationYear?: boolean | undefined;
    heatPumpMaintenanceContract?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemHasSystem?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemProblems?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemProblemsDetails?: string | undefined;
    permanentAirConditioningSystemInstallationYear?: number | undefined;
    permanentAirConditioningSystemDontKnowInstallationYear?: boolean | undefined;
    permanentAirConditioningSystemMaintenanceContract?: YesNoDontKnow | undefined;
    fireplaceHasFireplace?: YesNoDontKnow | undefined;
    fireplaceWorksWell?: YesNoDontKnow | undefined;
    fireplaceProblems?: YesNoDontKnow | undefined;
    fireplaceNonComplianceNotice?: YesNoDontKnow | undefined;
    fireplaceProblemsDetails?: string | undefined;
    fireplaceNonComplianceNoticeDetails?: string | undefined;
    fireplaceInstallationYear?: number | undefined;
    fireplaceDontKnowInstallationYear?: boolean | undefined;
    fireplaceUsageFrequency?: string | undefined;
    fireplaceDontKnowUsageFrequency?: boolean | undefined;
    fireplaceChimneySweptFrequency?: string | undefined;
    fireplaceDontKnowChimneySweptFrequency?: boolean | undefined;
    fireplaceLastChimneySweptYear?: number | undefined;
    fireplaceDontKnowLastChimneySweptYear?: boolean | undefined;

    constructor(data?: IDeclarationHeatingAndAirConditioningInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainHeatingSystemProblems = _data["mainHeatingSystemProblems"];
            this.mainHeatingSystemProblemsDetails = _data["mainHeatingSystemProblemsDetails"];
            this.mainHeatingSystemWorkEfficiently = _data["mainHeatingSystemWorkEfficiently"];
            this.mainHeatingSystemInstallationYear = _data["mainHeatingSystemInstallationYear"];
            this.mainHeatingSystemDontKnowInstallationYear = _data["mainHeatingSystemDontKnowInstallationYear"];
            this.mainHeatingSystemMaintenanceContract = _data["mainHeatingSystemMaintenanceContract"];
            this.mainHeatingSystemUndergroundOilTank = _data["mainHeatingSystemUndergroundOilTank"];
            this.mainHeatingSystemUndergroundOilTankInspectedRecently = _data["mainHeatingSystemUndergroundOilTankInspectedRecently"];
            this.mainHeatingSystemOilLastInspectionYear = _data["mainHeatingSystemOilLastInspectionYear"];
            this.heatPumpHasHeatPump = _data["heatPumpHasHeatPump"];
            this.heatPumpProblems = _data["heatPumpProblems"];
            this.heatPumpProblemsDetails = _data["heatPumpProblemsDetails"];
            this.heatPumpInstallationYear = _data["heatPumpInstallationYear"];
            this.heatPumpDontKnowInstallationYear = _data["heatPumpDontKnowInstallationYear"];
            this.heatPumpMaintenanceContract = _data["heatPumpMaintenanceContract"];
            this.permanentAirConditioningSystemHasSystem = _data["permanentAirConditioningSystemHasSystem"];
            this.permanentAirConditioningSystemProblems = _data["permanentAirConditioningSystemProblems"];
            this.permanentAirConditioningSystemProblemsDetails = _data["permanentAirConditioningSystemProblemsDetails"];
            this.permanentAirConditioningSystemInstallationYear = _data["permanentAirConditioningSystemInstallationYear"];
            this.permanentAirConditioningSystemDontKnowInstallationYear = _data["permanentAirConditioningSystemDontKnowInstallationYear"];
            this.permanentAirConditioningSystemMaintenanceContract = _data["permanentAirConditioningSystemMaintenanceContract"];
            this.fireplaceHasFireplace = _data["fireplaceHasFireplace"];
            this.fireplaceWorksWell = _data["fireplaceWorksWell"];
            this.fireplaceProblems = _data["fireplaceProblems"];
            this.fireplaceNonComplianceNotice = _data["fireplaceNonComplianceNotice"];
            this.fireplaceProblemsDetails = _data["fireplaceProblemsDetails"];
            this.fireplaceNonComplianceNoticeDetails = _data["fireplaceNonComplianceNoticeDetails"];
            this.fireplaceInstallationYear = _data["fireplaceInstallationYear"];
            this.fireplaceDontKnowInstallationYear = _data["fireplaceDontKnowInstallationYear"];
            this.fireplaceUsageFrequency = _data["fireplaceUsageFrequency"];
            this.fireplaceDontKnowUsageFrequency = _data["fireplaceDontKnowUsageFrequency"];
            this.fireplaceChimneySweptFrequency = _data["fireplaceChimneySweptFrequency"];
            this.fireplaceDontKnowChimneySweptFrequency = _data["fireplaceDontKnowChimneySweptFrequency"];
            this.fireplaceLastChimneySweptYear = _data["fireplaceLastChimneySweptYear"];
            this.fireplaceDontKnowLastChimneySweptYear = _data["fireplaceDontKnowLastChimneySweptYear"];
        }
    }

    static fromJS(data: any): DeclarationHeatingAndAirConditioningInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationHeatingAndAirConditioningInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainHeatingSystemProblems"] = this.mainHeatingSystemProblems;
        data["mainHeatingSystemProblemsDetails"] = this.mainHeatingSystemProblemsDetails;
        data["mainHeatingSystemWorkEfficiently"] = this.mainHeatingSystemWorkEfficiently;
        data["mainHeatingSystemInstallationYear"] = this.mainHeatingSystemInstallationYear;
        data["mainHeatingSystemDontKnowInstallationYear"] = this.mainHeatingSystemDontKnowInstallationYear;
        data["mainHeatingSystemMaintenanceContract"] = this.mainHeatingSystemMaintenanceContract;
        data["mainHeatingSystemUndergroundOilTank"] = this.mainHeatingSystemUndergroundOilTank;
        data["mainHeatingSystemUndergroundOilTankInspectedRecently"] = this.mainHeatingSystemUndergroundOilTankInspectedRecently;
        data["mainHeatingSystemOilLastInspectionYear"] = this.mainHeatingSystemOilLastInspectionYear;
        data["heatPumpHasHeatPump"] = this.heatPumpHasHeatPump;
        data["heatPumpProblems"] = this.heatPumpProblems;
        data["heatPumpProblemsDetails"] = this.heatPumpProblemsDetails;
        data["heatPumpInstallationYear"] = this.heatPumpInstallationYear;
        data["heatPumpDontKnowInstallationYear"] = this.heatPumpDontKnowInstallationYear;
        data["heatPumpMaintenanceContract"] = this.heatPumpMaintenanceContract;
        data["permanentAirConditioningSystemHasSystem"] = this.permanentAirConditioningSystemHasSystem;
        data["permanentAirConditioningSystemProblems"] = this.permanentAirConditioningSystemProblems;
        data["permanentAirConditioningSystemProblemsDetails"] = this.permanentAirConditioningSystemProblemsDetails;
        data["permanentAirConditioningSystemInstallationYear"] = this.permanentAirConditioningSystemInstallationYear;
        data["permanentAirConditioningSystemDontKnowInstallationYear"] = this.permanentAirConditioningSystemDontKnowInstallationYear;
        data["permanentAirConditioningSystemMaintenanceContract"] = this.permanentAirConditioningSystemMaintenanceContract;
        data["fireplaceHasFireplace"] = this.fireplaceHasFireplace;
        data["fireplaceWorksWell"] = this.fireplaceWorksWell;
        data["fireplaceProblems"] = this.fireplaceProblems;
        data["fireplaceNonComplianceNotice"] = this.fireplaceNonComplianceNotice;
        data["fireplaceProblemsDetails"] = this.fireplaceProblemsDetails;
        data["fireplaceNonComplianceNoticeDetails"] = this.fireplaceNonComplianceNoticeDetails;
        data["fireplaceInstallationYear"] = this.fireplaceInstallationYear;
        data["fireplaceDontKnowInstallationYear"] = this.fireplaceDontKnowInstallationYear;
        data["fireplaceUsageFrequency"] = this.fireplaceUsageFrequency;
        data["fireplaceDontKnowUsageFrequency"] = this.fireplaceDontKnowUsageFrequency;
        data["fireplaceChimneySweptFrequency"] = this.fireplaceChimneySweptFrequency;
        data["fireplaceDontKnowChimneySweptFrequency"] = this.fireplaceDontKnowChimneySweptFrequency;
        data["fireplaceLastChimneySweptYear"] = this.fireplaceLastChimneySweptYear;
        data["fireplaceDontKnowLastChimneySweptYear"] = this.fireplaceDontKnowLastChimneySweptYear;
        return data;
    }
}

export interface IDeclarationHeatingAndAirConditioningInput {
    mainHeatingSystemProblems?: YesNoDontKnow | undefined;
    mainHeatingSystemProblemsDetails?: string | undefined;
    mainHeatingSystemWorkEfficiently?: YesNoDontKnow | undefined;
    mainHeatingSystemInstallationYear?: number | undefined;
    mainHeatingSystemDontKnowInstallationYear?: boolean | undefined;
    mainHeatingSystemMaintenanceContract?: YesNoDontKnow | undefined;
    mainHeatingSystemUndergroundOilTank?: YesNoDontKnow | undefined;
    mainHeatingSystemUndergroundOilTankInspectedRecently?: YesNoDontKnow | undefined;
    mainHeatingSystemOilLastInspectionYear?: number | undefined;
    heatPumpHasHeatPump?: YesNoDontKnow | undefined;
    heatPumpProblems?: YesNoDontKnow | undefined;
    heatPumpProblemsDetails?: string | undefined;
    heatPumpInstallationYear?: number | undefined;
    heatPumpDontKnowInstallationYear?: boolean | undefined;
    heatPumpMaintenanceContract?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemHasSystem?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemProblems?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemProblemsDetails?: string | undefined;
    permanentAirConditioningSystemInstallationYear?: number | undefined;
    permanentAirConditioningSystemDontKnowInstallationYear?: boolean | undefined;
    permanentAirConditioningSystemMaintenanceContract?: YesNoDontKnow | undefined;
    fireplaceHasFireplace?: YesNoDontKnow | undefined;
    fireplaceWorksWell?: YesNoDontKnow | undefined;
    fireplaceProblems?: YesNoDontKnow | undefined;
    fireplaceNonComplianceNotice?: YesNoDontKnow | undefined;
    fireplaceProblemsDetails?: string | undefined;
    fireplaceNonComplianceNoticeDetails?: string | undefined;
    fireplaceInstallationYear?: number | undefined;
    fireplaceDontKnowInstallationYear?: boolean | undefined;
    fireplaceUsageFrequency?: string | undefined;
    fireplaceDontKnowUsageFrequency?: boolean | undefined;
    fireplaceChimneySweptFrequency?: string | undefined;
    fireplaceDontKnowChimneySweptFrequency?: boolean | undefined;
    fireplaceLastChimneySweptYear?: number | undefined;
    fireplaceDontKnowLastChimneySweptYear?: boolean | undefined;
}

export class DeclarationMiscellaneousInput implements IDeclarationMiscellaneousInput {
    inspectionReports?: YesNoDontKnow | undefined;
    reportsAvailable?: YesNoDontKnow | undefined;
    insectOrPestProblems?: YesNoDontKnow | undefined;
    pestProblemsYear?: number | undefined;
    pestSpecies?: string | undefined;
    pestControlMeasures?: string | undefined;
    propertyDamage?: YesNoDontKnow | undefined;
    damageYear?: number | undefined;
    damageNature?: string | undefined;
    damageRepairs?: string | undefined;
    violenceOrSuicideProblems?: YesNoDontKnow | undefined;
    usedToProduceControversialMaterials?: YesNoDontKnow | undefined;
    otherProblems?: YesNoDontKnow | undefined;
    otherProblemsDetails?: string | undefined;

    constructor(data?: IDeclarationMiscellaneousInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionReports = _data["inspectionReports"];
            this.reportsAvailable = _data["reportsAvailable"];
            this.insectOrPestProblems = _data["insectOrPestProblems"];
            this.pestProblemsYear = _data["pestProblemsYear"];
            this.pestSpecies = _data["pestSpecies"];
            this.pestControlMeasures = _data["pestControlMeasures"];
            this.propertyDamage = _data["propertyDamage"];
            this.damageYear = _data["damageYear"];
            this.damageNature = _data["damageNature"];
            this.damageRepairs = _data["damageRepairs"];
            this.violenceOrSuicideProblems = _data["violenceOrSuicideProblems"];
            this.usedToProduceControversialMaterials = _data["usedToProduceControversialMaterials"];
            this.otherProblems = _data["otherProblems"];
            this.otherProblemsDetails = _data["otherProblemsDetails"];
        }
    }

    static fromJS(data: any): DeclarationMiscellaneousInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationMiscellaneousInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionReports"] = this.inspectionReports;
        data["reportsAvailable"] = this.reportsAvailable;
        data["insectOrPestProblems"] = this.insectOrPestProblems;
        data["pestProblemsYear"] = this.pestProblemsYear;
        data["pestSpecies"] = this.pestSpecies;
        data["pestControlMeasures"] = this.pestControlMeasures;
        data["propertyDamage"] = this.propertyDamage;
        data["damageYear"] = this.damageYear;
        data["damageNature"] = this.damageNature;
        data["damageRepairs"] = this.damageRepairs;
        data["violenceOrSuicideProblems"] = this.violenceOrSuicideProblems;
        data["usedToProduceControversialMaterials"] = this.usedToProduceControversialMaterials;
        data["otherProblems"] = this.otherProblems;
        data["otherProblemsDetails"] = this.otherProblemsDetails;
        return data;
    }
}

export interface IDeclarationMiscellaneousInput {
    inspectionReports?: YesNoDontKnow | undefined;
    reportsAvailable?: YesNoDontKnow | undefined;
    insectOrPestProblems?: YesNoDontKnow | undefined;
    pestProblemsYear?: number | undefined;
    pestSpecies?: string | undefined;
    pestControlMeasures?: string | undefined;
    propertyDamage?: YesNoDontKnow | undefined;
    damageYear?: number | undefined;
    damageNature?: string | undefined;
    damageRepairs?: string | undefined;
    violenceOrSuicideProblems?: YesNoDontKnow | undefined;
    usedToProduceControversialMaterials?: YesNoDontKnow | undefined;
    otherProblems?: YesNoDontKnow | undefined;
    otherProblemsDetails?: string | undefined;
}

export class DeclarationRenovationsAndConstructionInput implements IDeclarationRenovationsAndConstructionInput {
    significantWorkDone?: YesNoDontKnow | undefined;
    workDetails?: string | undefined;

    constructor(data?: IDeclarationRenovationsAndConstructionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.significantWorkDone = _data["significantWorkDone"];
            this.workDetails = _data["workDetails"];
        }
    }

    static fromJS(data: any): DeclarationRenovationsAndConstructionInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationRenovationsAndConstructionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["significantWorkDone"] = this.significantWorkDone;
        data["workDetails"] = this.workDetails;
        return data;
    }
}

export interface IDeclarationRenovationsAndConstructionInput {
    significantWorkDone?: YesNoDontKnow | undefined;
    workDetails?: string | undefined;
}

export class ListingContractDatesInput implements IListingContractDatesInput {
    availableDate?: Date | undefined;
    isAvailableDateNegotiable?: boolean | undefined;

    constructor(data?: IListingContractDatesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availableDate = _data["availableDate"] ? new Date(_data["availableDate"].toString()) : <any>undefined;
            this.isAvailableDateNegotiable = _data["isAvailableDateNegotiable"];
        }
    }

    static fromJS(data: any): ListingContractDatesInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractDatesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availableDate"] = this.availableDate ? this.availableDate.toISOString() : <any>undefined;
        data["isAvailableDateNegotiable"] = this.isAvailableDateNegotiable;
        return data;
    }
}

export interface IListingContractDatesInput {
    availableDate?: Date | undefined;
    isAvailableDateNegotiable?: boolean | undefined;
}

export class ListingPreEmptiveRightDelayInput implements IListingPreEmptiveRightDelayInput {
    isPreEmptiveRightDelay?: boolean | undefined;
    preEmptiveRightDelayInDays?: number | undefined;

    constructor(data?: IListingPreEmptiveRightDelayInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPreEmptiveRightDelay = _data["isPreEmptiveRightDelay"];
            this.preEmptiveRightDelayInDays = _data["preEmptiveRightDelayInDays"];
        }
    }

    static fromJS(data: any): ListingPreEmptiveRightDelayInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingPreEmptiveRightDelayInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPreEmptiveRightDelay"] = this.isPreEmptiveRightDelay;
        data["preEmptiveRightDelayInDays"] = this.preEmptiveRightDelayInDays;
        return data;
    }
}

export interface IListingPreEmptiveRightDelayInput {
    isPreEmptiveRightDelay?: boolean | undefined;
    preEmptiveRightDelayInDays?: number | undefined;
}

export class ListingContractInclusionsInput implements IListingContractInclusionsInput {
    inclusions?: ListingContractItemInput[] | undefined;

    constructor(data?: IListingContractInclusionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions!.push(ListingContractItemInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingContractInclusionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractInclusionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingContractInclusionsInput {
    inclusions?: ListingContractItemInput[] | undefined;
}

export class ListingContractItemInput implements IListingContractItemInput {
    name?: string | undefined;
    location?: string | undefined;

    constructor(data?: IListingContractItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): ListingContractItemInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["location"] = this.location;
        return data;
    }
}

export interface IListingContractItemInput {
    name?: string | undefined;
    location?: string | undefined;
}

export class ListingContractExclusionsInput implements IListingContractExclusionsInput {
    exclusions?: ListingContractItemInput[] | undefined;

    constructor(data?: IListingContractExclusionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions!.push(ListingContractItemInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingContractExclusionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractExclusionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingContractExclusionsInput {
    exclusions?: ListingContractItemInput[] | undefined;
}

export class ListingContractAdditionalTermsInput implements IListingContractAdditionalTermsInput {
    additionalConditions?: string[] | undefined;

    constructor(data?: IListingContractAdditionalTermsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["additionalConditions"])) {
                this.additionalConditions = [] as any;
                for (let item of _data["additionalConditions"])
                    this.additionalConditions!.push(item);
            }
        }
    }

    static fromJS(data: any): ListingContractAdditionalTermsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingContractAdditionalTermsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.additionalConditions)) {
            data["additionalConditions"] = [];
            for (let item of this.additionalConditions)
                data["additionalConditions"].push(item);
        }
        return data;
    }
}

export interface IListingContractAdditionalTermsInput {
    additionalConditions?: string[] | undefined;
}

export class ListingRentDetailsInput implements IListingRentDetailsInput {
    monthlyRent?: number | undefined;
    availableFromDate?: Date | undefined;
    minLeaseTermMonths?: number | undefined;
    utilitiesIncluded?: ListingUtilitiesIncludedInput | undefined;
    inclusions?: ListingContractItemInput[] | undefined;
    exclusions?: ListingContractItemInput[] | undefined;

    constructor(data?: IListingRentDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyRent = _data["monthlyRent"];
            this.availableFromDate = _data["availableFromDate"] ? new Date(_data["availableFromDate"].toString()) : <any>undefined;
            this.minLeaseTermMonths = _data["minLeaseTermMonths"];
            this.utilitiesIncluded = _data["utilitiesIncluded"] ? ListingUtilitiesIncludedInput.fromJS(_data["utilitiesIncluded"]) : <any>undefined;
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions!.push(ListingContractItemInput.fromJS(item));
            }
            if (Array.isArray(_data["exclusions"])) {
                this.exclusions = [] as any;
                for (let item of _data["exclusions"])
                    this.exclusions!.push(ListingContractItemInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingRentDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingRentDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyRent"] = this.monthlyRent;
        data["availableFromDate"] = this.availableFromDate ? this.availableFromDate.toISOString() : <any>undefined;
        data["minLeaseTermMonths"] = this.minLeaseTermMonths;
        data["utilitiesIncluded"] = this.utilitiesIncluded ? this.utilitiesIncluded.toJSON() : <any>undefined;
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item.toJSON());
        }
        if (Array.isArray(this.exclusions)) {
            data["exclusions"] = [];
            for (let item of this.exclusions)
                data["exclusions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingRentDetailsInput {
    monthlyRent?: number | undefined;
    availableFromDate?: Date | undefined;
    minLeaseTermMonths?: number | undefined;
    utilitiesIncluded?: ListingUtilitiesIncludedInput | undefined;
    inclusions?: ListingContractItemInput[] | undefined;
    exclusions?: ListingContractItemInput[] | undefined;
}

export class ListingUtilitiesIncludedInput implements IListingUtilitiesIncludedInput {
    hydro?: boolean | undefined;
    water?: boolean | undefined;
    heat?: boolean | undefined;
    gas?: boolean | undefined;
    internet?: boolean | undefined;
    cable?: boolean | undefined;

    constructor(data?: IListingUtilitiesIncludedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hydro = _data["hydro"];
            this.water = _data["water"];
            this.heat = _data["heat"];
            this.gas = _data["gas"];
            this.internet = _data["internet"];
            this.cable = _data["cable"];
        }
    }

    static fromJS(data: any): ListingUtilitiesIncludedInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingUtilitiesIncludedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hydro"] = this.hydro;
        data["water"] = this.water;
        data["heat"] = this.heat;
        data["gas"] = this.gas;
        data["internet"] = this.internet;
        data["cable"] = this.cable;
        return data;
    }
}

export interface IListingUtilitiesIncludedInput {
    hydro?: boolean | undefined;
    water?: boolean | undefined;
    heat?: boolean | undefined;
    gas?: boolean | undefined;
    internet?: boolean | undefined;
    cable?: boolean | undefined;
}

export class DeleteListingCommand implements IDeleteListingCommand {

    constructor(data?: IDeleteListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteListingCommand {
}

export class ListingCategoryDto implements IListingCategoryDto {
    id?: string | undefined;
    name?: string | undefined;
    isDefault?: boolean;
    identifier?: string | undefined;
    originalCategoryId?: string | undefined;
    displayImage?: ImageMediaDto | undefined;

    constructor(data?: IListingCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.identifier = _data["identifier"];
            this.originalCategoryId = _data["originalCategoryId"];
            this.displayImage = _data["displayImage"] ? ImageMediaDto.fromJS(_data["displayImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListingCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["identifier"] = this.identifier;
        data["originalCategoryId"] = this.originalCategoryId;
        data["displayImage"] = this.displayImage ? this.displayImage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListingCategoryDto {
    id?: string | undefined;
    name?: string | undefined;
    isDefault?: boolean;
    identifier?: string | undefined;
    originalCategoryId?: string | undefined;
    displayImage?: ImageMediaDto | undefined;
}

export class CreateOrEditListingCategoryCommand implements ICreateOrEditListingCategoryCommand {
    name?: string | undefined;

    constructor(data?: ICreateOrEditListingCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateOrEditListingCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditListingCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateOrEditListingCategoryCommand {
    name?: string | undefined;
}

export class ReorderListingCategoryImagesCommand implements IReorderListingCategoryImagesCommand {
    listingImageIds?: string[] | undefined;

    constructor(data?: IReorderListingCategoryImagesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["listingImageIds"])) {
                this.listingImageIds = [] as any;
                for (let item of _data["listingImageIds"])
                    this.listingImageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderListingCategoryImagesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderListingCategoryImagesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.listingImageIds)) {
            data["listingImageIds"] = [];
            for (let item of this.listingImageIds)
                data["listingImageIds"].push(item);
        }
        return data;
    }
}

export interface IReorderListingCategoryImagesCommand {
    listingImageIds?: string[] | undefined;
}

export class DeleteListingDocumentCommand implements IDeleteListingDocumentCommand {

    constructor(data?: IDeleteListingDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteListingDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteListingDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteListingDocumentCommand {
}

export class DeleteListingImageCommand implements IDeleteListingImageCommand {

    constructor(data?: IDeleteListingImageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteListingImageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteListingImageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteListingImageCommand {
}

export class DeleteSpecificListingFileCommand implements IDeleteSpecificListingFileCommand {
    listingFileType?: ListingFileType;

    constructor(data?: IDeleteSpecificListingFileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingFileType = _data["listingFileType"];
        }
    }

    static fromJS(data: any): DeleteSpecificListingFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSpecificListingFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingFileType"] = this.listingFileType;
        return data;
    }
}

export interface IDeleteSpecificListingFileCommand {
    listingFileType?: ListingFileType;
}

export enum ListingFileType {
    LotLayout = 0,
    LotLocationInPlanImage = 1,
    LotLayoutDocument = 2,
    DisplayImage = 3,
    PropertyDocument = 4,
    PropertyPicture = 5,
    PropertyPrivateDocument = 6,
}

export class SellersDeclarationDto implements ISellersDeclarationDto {
    declarationGeneralInformation?: DeclarationGeneralInformationDto | undefined;
    declarationLandAndBuildingBasement?: DeclarationLandAndBuildingBasementDto | undefined;
    declarationRoof?: DeclarationRoofDto | undefined;
    declarationWaterInfiltration?: DeclarationWaterInfiltrationDto | undefined;
    declarationIndoorAirQuality?: DeclarationIndoorAirQualityDto | undefined;
    declarationElectricity?: DeclarationElectricityDto | undefined;
    declarationPlumbingAndDrainage?: DeclarationPlumbingAndDrainageDto | undefined;
    declarationHeatingAndAirConditioning?: DeclarationHeatingAndAirConditioningDto | undefined;
    declarationMiscellaneous?: DeclarationMiscellaneousDto | undefined;
    declarationRenovationsAndConstruction?: DeclarationRenovationsAndConstructionDto | undefined;

    constructor(data?: ISellersDeclarationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.declarationGeneralInformation = _data["declarationGeneralInformation"] ? DeclarationGeneralInformationDto.fromJS(_data["declarationGeneralInformation"]) : <any>undefined;
            this.declarationLandAndBuildingBasement = _data["declarationLandAndBuildingBasement"] ? DeclarationLandAndBuildingBasementDto.fromJS(_data["declarationLandAndBuildingBasement"]) : <any>undefined;
            this.declarationRoof = _data["declarationRoof"] ? DeclarationRoofDto.fromJS(_data["declarationRoof"]) : <any>undefined;
            this.declarationWaterInfiltration = _data["declarationWaterInfiltration"] ? DeclarationWaterInfiltrationDto.fromJS(_data["declarationWaterInfiltration"]) : <any>undefined;
            this.declarationIndoorAirQuality = _data["declarationIndoorAirQuality"] ? DeclarationIndoorAirQualityDto.fromJS(_data["declarationIndoorAirQuality"]) : <any>undefined;
            this.declarationElectricity = _data["declarationElectricity"] ? DeclarationElectricityDto.fromJS(_data["declarationElectricity"]) : <any>undefined;
            this.declarationPlumbingAndDrainage = _data["declarationPlumbingAndDrainage"] ? DeclarationPlumbingAndDrainageDto.fromJS(_data["declarationPlumbingAndDrainage"]) : <any>undefined;
            this.declarationHeatingAndAirConditioning = _data["declarationHeatingAndAirConditioning"] ? DeclarationHeatingAndAirConditioningDto.fromJS(_data["declarationHeatingAndAirConditioning"]) : <any>undefined;
            this.declarationMiscellaneous = _data["declarationMiscellaneous"] ? DeclarationMiscellaneousDto.fromJS(_data["declarationMiscellaneous"]) : <any>undefined;
            this.declarationRenovationsAndConstruction = _data["declarationRenovationsAndConstruction"] ? DeclarationRenovationsAndConstructionDto.fromJS(_data["declarationRenovationsAndConstruction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SellersDeclarationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellersDeclarationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["declarationGeneralInformation"] = this.declarationGeneralInformation ? this.declarationGeneralInformation.toJSON() : <any>undefined;
        data["declarationLandAndBuildingBasement"] = this.declarationLandAndBuildingBasement ? this.declarationLandAndBuildingBasement.toJSON() : <any>undefined;
        data["declarationRoof"] = this.declarationRoof ? this.declarationRoof.toJSON() : <any>undefined;
        data["declarationWaterInfiltration"] = this.declarationWaterInfiltration ? this.declarationWaterInfiltration.toJSON() : <any>undefined;
        data["declarationIndoorAirQuality"] = this.declarationIndoorAirQuality ? this.declarationIndoorAirQuality.toJSON() : <any>undefined;
        data["declarationElectricity"] = this.declarationElectricity ? this.declarationElectricity.toJSON() : <any>undefined;
        data["declarationPlumbingAndDrainage"] = this.declarationPlumbingAndDrainage ? this.declarationPlumbingAndDrainage.toJSON() : <any>undefined;
        data["declarationHeatingAndAirConditioning"] = this.declarationHeatingAndAirConditioning ? this.declarationHeatingAndAirConditioning.toJSON() : <any>undefined;
        data["declarationMiscellaneous"] = this.declarationMiscellaneous ? this.declarationMiscellaneous.toJSON() : <any>undefined;
        data["declarationRenovationsAndConstruction"] = this.declarationRenovationsAndConstruction ? this.declarationRenovationsAndConstruction.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISellersDeclarationDto {
    declarationGeneralInformation?: DeclarationGeneralInformationDto | undefined;
    declarationLandAndBuildingBasement?: DeclarationLandAndBuildingBasementDto | undefined;
    declarationRoof?: DeclarationRoofDto | undefined;
    declarationWaterInfiltration?: DeclarationWaterInfiltrationDto | undefined;
    declarationIndoorAirQuality?: DeclarationIndoorAirQualityDto | undefined;
    declarationElectricity?: DeclarationElectricityDto | undefined;
    declarationPlumbingAndDrainage?: DeclarationPlumbingAndDrainageDto | undefined;
    declarationHeatingAndAirConditioning?: DeclarationHeatingAndAirConditioningDto | undefined;
    declarationMiscellaneous?: DeclarationMiscellaneousDto | undefined;
    declarationRenovationsAndConstruction?: DeclarationRenovationsAndConstructionDto | undefined;
}

export class DeclarationGeneralInformationDto implements IDeclarationGeneralInformationDto {
    purchaseYear?: number | undefined;
    occupyProperty?: YesNoDontKnow | undefined;
    occupyPropertySince?: number | undefined;
    propertyLeased?: YesNoDontKnow | undefined;
    rentalPeriods?: string | undefined;
    yearOfConstruction?: number | undefined;
    dontKnowYearOfConstruction?: boolean | undefined;
    coveredByNewHomeWarranty?: YesNoDontKnow | undefined;

    constructor(data?: IDeclarationGeneralInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseYear = _data["purchaseYear"];
            this.occupyProperty = _data["occupyProperty"];
            this.occupyPropertySince = _data["occupyPropertySince"];
            this.propertyLeased = _data["propertyLeased"];
            this.rentalPeriods = _data["rentalPeriods"];
            this.yearOfConstruction = _data["yearOfConstruction"];
            this.dontKnowYearOfConstruction = _data["dontKnowYearOfConstruction"];
            this.coveredByNewHomeWarranty = _data["coveredByNewHomeWarranty"];
        }
    }

    static fromJS(data: any): DeclarationGeneralInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationGeneralInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseYear"] = this.purchaseYear;
        data["occupyProperty"] = this.occupyProperty;
        data["occupyPropertySince"] = this.occupyPropertySince;
        data["propertyLeased"] = this.propertyLeased;
        data["rentalPeriods"] = this.rentalPeriods;
        data["yearOfConstruction"] = this.yearOfConstruction;
        data["dontKnowYearOfConstruction"] = this.dontKnowYearOfConstruction;
        data["coveredByNewHomeWarranty"] = this.coveredByNewHomeWarranty;
        return data;
    }
}

export interface IDeclarationGeneralInformationDto {
    purchaseYear?: number | undefined;
    occupyProperty?: YesNoDontKnow | undefined;
    occupyPropertySince?: number | undefined;
    propertyLeased?: YesNoDontKnow | undefined;
    rentalPeriods?: string | undefined;
    yearOfConstruction?: number | undefined;
    dontKnowYearOfConstruction?: boolean | undefined;
    coveredByNewHomeWarranty?: YesNoDontKnow | undefined;
}

export class DeclarationLandAndBuildingBasementDto implements IDeclarationLandAndBuildingBasementDto {
    problemsWithSoil?: YesNoDontKnow | undefined;
    problemsWithSoilDetails?: string | undefined;
    foundationStabilizationWork?: YesNoDontKnow | undefined;
    foundationStabilizationWorkDetails?: string | undefined;
    soilContamination?: YesNoDontKnow | undefined;
    soilContaminationDetails?: string | undefined;
    soilWork?: YesNoDontKnow | undefined;
    soilWorkDetails?: string | undefined;
    recurringWaterAccumulation?: YesNoDontKnow | undefined;
    recurringWaterAccumulationDetails?: string | undefined;
    ironOchreInSoil?: YesNoDontKnow | undefined;
    ironOchreInSoilDetails?: string | undefined;
    liquidSpillsInBasement?: YesNoDontKnow | undefined;
    liquidSpillsInBasementDetails?: string | undefined;
    foundationCracksOrRot?: YesNoDontKnow | undefined;
    foundationCracksOrRotDetails?: string | undefined;

    constructor(data?: IDeclarationLandAndBuildingBasementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.problemsWithSoil = _data["problemsWithSoil"];
            this.problemsWithSoilDetails = _data["problemsWithSoilDetails"];
            this.foundationStabilizationWork = _data["foundationStabilizationWork"];
            this.foundationStabilizationWorkDetails = _data["foundationStabilizationWorkDetails"];
            this.soilContamination = _data["soilContamination"];
            this.soilContaminationDetails = _data["soilContaminationDetails"];
            this.soilWork = _data["soilWork"];
            this.soilWorkDetails = _data["soilWorkDetails"];
            this.recurringWaterAccumulation = _data["recurringWaterAccumulation"];
            this.recurringWaterAccumulationDetails = _data["recurringWaterAccumulationDetails"];
            this.ironOchreInSoil = _data["ironOchreInSoil"];
            this.ironOchreInSoilDetails = _data["ironOchreInSoilDetails"];
            this.liquidSpillsInBasement = _data["liquidSpillsInBasement"];
            this.liquidSpillsInBasementDetails = _data["liquidSpillsInBasementDetails"];
            this.foundationCracksOrRot = _data["foundationCracksOrRot"];
            this.foundationCracksOrRotDetails = _data["foundationCracksOrRotDetails"];
        }
    }

    static fromJS(data: any): DeclarationLandAndBuildingBasementDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationLandAndBuildingBasementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["problemsWithSoil"] = this.problemsWithSoil;
        data["problemsWithSoilDetails"] = this.problemsWithSoilDetails;
        data["foundationStabilizationWork"] = this.foundationStabilizationWork;
        data["foundationStabilizationWorkDetails"] = this.foundationStabilizationWorkDetails;
        data["soilContamination"] = this.soilContamination;
        data["soilContaminationDetails"] = this.soilContaminationDetails;
        data["soilWork"] = this.soilWork;
        data["soilWorkDetails"] = this.soilWorkDetails;
        data["recurringWaterAccumulation"] = this.recurringWaterAccumulation;
        data["recurringWaterAccumulationDetails"] = this.recurringWaterAccumulationDetails;
        data["ironOchreInSoil"] = this.ironOchreInSoil;
        data["ironOchreInSoilDetails"] = this.ironOchreInSoilDetails;
        data["liquidSpillsInBasement"] = this.liquidSpillsInBasement;
        data["liquidSpillsInBasementDetails"] = this.liquidSpillsInBasementDetails;
        data["foundationCracksOrRot"] = this.foundationCracksOrRot;
        data["foundationCracksOrRotDetails"] = this.foundationCracksOrRotDetails;
        return data;
    }
}

export interface IDeclarationLandAndBuildingBasementDto {
    problemsWithSoil?: YesNoDontKnow | undefined;
    problemsWithSoilDetails?: string | undefined;
    foundationStabilizationWork?: YesNoDontKnow | undefined;
    foundationStabilizationWorkDetails?: string | undefined;
    soilContamination?: YesNoDontKnow | undefined;
    soilContaminationDetails?: string | undefined;
    soilWork?: YesNoDontKnow | undefined;
    soilWorkDetails?: string | undefined;
    recurringWaterAccumulation?: YesNoDontKnow | undefined;
    recurringWaterAccumulationDetails?: string | undefined;
    ironOchreInSoil?: YesNoDontKnow | undefined;
    ironOchreInSoilDetails?: string | undefined;
    liquidSpillsInBasement?: YesNoDontKnow | undefined;
    liquidSpillsInBasementDetails?: string | undefined;
    foundationCracksOrRot?: YesNoDontKnow | undefined;
    foundationCracksOrRotDetails?: string | undefined;
}

export class DeclarationRoofDto implements IDeclarationRoofDto {
    roofCoveringYear?: number | undefined;
    dontKnowRoofCoveringYear?: boolean | undefined;
    roofMaintenanceDocuments?: YesNoDontKnow | undefined;
    iceAccumulationOrIcicles?: YesNoDontKnow | undefined;

    constructor(data?: IDeclarationRoofDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roofCoveringYear = _data["roofCoveringYear"];
            this.dontKnowRoofCoveringYear = _data["dontKnowRoofCoveringYear"];
            this.roofMaintenanceDocuments = _data["roofMaintenanceDocuments"];
            this.iceAccumulationOrIcicles = _data["iceAccumulationOrIcicles"];
        }
    }

    static fromJS(data: any): DeclarationRoofDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationRoofDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roofCoveringYear"] = this.roofCoveringYear;
        data["dontKnowRoofCoveringYear"] = this.dontKnowRoofCoveringYear;
        data["roofMaintenanceDocuments"] = this.roofMaintenanceDocuments;
        data["iceAccumulationOrIcicles"] = this.iceAccumulationOrIcicles;
        return data;
    }
}

export interface IDeclarationRoofDto {
    roofCoveringYear?: number | undefined;
    dontKnowRoofCoveringYear?: boolean | undefined;
    roofMaintenanceDocuments?: YesNoDontKnow | undefined;
    iceAccumulationOrIcicles?: YesNoDontKnow | undefined;
}

export class DeclarationWaterInfiltrationDto implements IDeclarationWaterInfiltrationDto {
    waterInfiltrationThroughRoofOrOther?: YesNoDontKnow | undefined;
    waterInfiltrationDetails?: string | undefined;
    waterInfiltrationInBasement?: YesNoDontKnow | undefined;
    waterInfiltrationCauses?: string[] | undefined;

    constructor(data?: IDeclarationWaterInfiltrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waterInfiltrationThroughRoofOrOther = _data["waterInfiltrationThroughRoofOrOther"];
            this.waterInfiltrationDetails = _data["waterInfiltrationDetails"];
            this.waterInfiltrationInBasement = _data["waterInfiltrationInBasement"];
            if (Array.isArray(_data["waterInfiltrationCauses"])) {
                this.waterInfiltrationCauses = [] as any;
                for (let item of _data["waterInfiltrationCauses"])
                    this.waterInfiltrationCauses!.push(item);
            }
        }
    }

    static fromJS(data: any): DeclarationWaterInfiltrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationWaterInfiltrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waterInfiltrationThroughRoofOrOther"] = this.waterInfiltrationThroughRoofOrOther;
        data["waterInfiltrationDetails"] = this.waterInfiltrationDetails;
        data["waterInfiltrationInBasement"] = this.waterInfiltrationInBasement;
        if (Array.isArray(this.waterInfiltrationCauses)) {
            data["waterInfiltrationCauses"] = [];
            for (let item of this.waterInfiltrationCauses)
                data["waterInfiltrationCauses"].push(item);
        }
        return data;
    }
}

export interface IDeclarationWaterInfiltrationDto {
    waterInfiltrationThroughRoofOrOther?: YesNoDontKnow | undefined;
    waterInfiltrationDetails?: string | undefined;
    waterInfiltrationInBasement?: YesNoDontKnow | undefined;
    waterInfiltrationCauses?: string[] | undefined;
}

export class DeclarationIndoorAirQualityDto implements IDeclarationIndoorAirQualityDto {
    insulationProductWithAsbestos?: YesNoDontKnow | undefined;
    insulationProductDetails?: string | undefined;
    condensation?: YesNoDontKnow | undefined;
    condensationDetails?: string | undefined;
    odours?: YesNoDontKnow | undefined;
    odoursDetails?: string | undefined;
    evidenceOfMouldOrRot?: YesNoDontKnow | undefined;
    evidenceOfMouldOrRotDetails?: string | undefined;

    constructor(data?: IDeclarationIndoorAirQualityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insulationProductWithAsbestos = _data["insulationProductWithAsbestos"];
            this.insulationProductDetails = _data["insulationProductDetails"];
            this.condensation = _data["condensation"];
            this.condensationDetails = _data["condensationDetails"];
            this.odours = _data["odours"];
            this.odoursDetails = _data["odoursDetails"];
            this.evidenceOfMouldOrRot = _data["evidenceOfMouldOrRot"];
            this.evidenceOfMouldOrRotDetails = _data["evidenceOfMouldOrRotDetails"];
        }
    }

    static fromJS(data: any): DeclarationIndoorAirQualityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationIndoorAirQualityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insulationProductWithAsbestos"] = this.insulationProductWithAsbestos;
        data["insulationProductDetails"] = this.insulationProductDetails;
        data["condensation"] = this.condensation;
        data["condensationDetails"] = this.condensationDetails;
        data["odours"] = this.odours;
        data["odoursDetails"] = this.odoursDetails;
        data["evidenceOfMouldOrRot"] = this.evidenceOfMouldOrRot;
        data["evidenceOfMouldOrRotDetails"] = this.evidenceOfMouldOrRotDetails;
        return data;
    }
}

export interface IDeclarationIndoorAirQualityDto {
    insulationProductWithAsbestos?: YesNoDontKnow | undefined;
    insulationProductDetails?: string | undefined;
    condensation?: YesNoDontKnow | undefined;
    condensationDetails?: string | undefined;
    odours?: YesNoDontKnow | undefined;
    odoursDetails?: string | undefined;
    evidenceOfMouldOrRot?: YesNoDontKnow | undefined;
    evidenceOfMouldOrRotDetails?: string | undefined;
}

export class DeclarationElectricityDto implements IDeclarationElectricityDto {
    electricalProblems?: YesNoDontKnow | undefined;
    electricalProblemsDetails?: string | undefined;

    constructor(data?: IDeclarationElectricityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.electricalProblems = _data["electricalProblems"];
            this.electricalProblemsDetails = _data["electricalProblemsDetails"];
        }
    }

    static fromJS(data: any): DeclarationElectricityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationElectricityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["electricalProblems"] = this.electricalProblems;
        data["electricalProblemsDetails"] = this.electricalProblemsDetails;
        return data;
    }
}

export interface IDeclarationElectricityDto {
    electricalProblems?: YesNoDontKnow | undefined;
    electricalProblemsDetails?: string | undefined;
}

export class DeclarationPlumbingAndDrainageDto implements IDeclarationPlumbingAndDrainageDto {
    significantWaterPressureVariation?: YesNoDontKnow | undefined;
    freezingPipes?: YesNoDontKnow | undefined;
    waterLeaks?: YesNoDontKnow | undefined;
    rustyWater?: YesNoDontKnow | undefined;
    odours?: YesNoDontKnow | undefined;
    plumbingDrainageOrBackup?: YesNoDontKnow | undefined;
    plumbingDrainageDetails?: string | undefined;
    sumpPump?: YesNoDontKnow | undefined;
    sumpPumpDetails?: string | undefined;
    plumbingModifications?: YesNoDontKnow | undefined;
    waterHeaterYear?: number | undefined;
    dontKnowWaterHeaterYear?: boolean | undefined;
    wellsOnProperty?: YesNoDontKnow | undefined;
    waterSupplySource?: string | undefined;
    drinkingWaterSupply?: YesNoDontKnow | undefined;
    waterSupplyQualityIssues?: YesNoDontKnow | undefined;
    septicTanksAndWeepingFieldOnProperty?: YesNoDontKnow | undefined;
    installationYear?: number | undefined;
    dontKnowInstallationYear?: boolean | undefined;
    complianceCertificate?: YesNoDontKnow | undefined;
    nonComplianceNotice?: YesNoDontKnow | undefined;
    nonComplianceNoticeDetails?: string | undefined;
    systemLastEmptiedYear?: number | undefined;
    dontKnowSystemLastEmptiedYear?: boolean | undefined;
    systemProblems?: YesNoDontKnow | undefined;
    systemProblemsDetails?: string | undefined;

    constructor(data?: IDeclarationPlumbingAndDrainageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.significantWaterPressureVariation = _data["significantWaterPressureVariation"];
            this.freezingPipes = _data["freezingPipes"];
            this.waterLeaks = _data["waterLeaks"];
            this.rustyWater = _data["rustyWater"];
            this.odours = _data["odours"];
            this.plumbingDrainageOrBackup = _data["plumbingDrainageOrBackup"];
            this.plumbingDrainageDetails = _data["plumbingDrainageDetails"];
            this.sumpPump = _data["sumpPump"];
            this.sumpPumpDetails = _data["sumpPumpDetails"];
            this.plumbingModifications = _data["plumbingModifications"];
            this.waterHeaterYear = _data["waterHeaterYear"];
            this.dontKnowWaterHeaterYear = _data["dontKnowWaterHeaterYear"];
            this.wellsOnProperty = _data["wellsOnProperty"];
            this.waterSupplySource = _data["waterSupplySource"];
            this.drinkingWaterSupply = _data["drinkingWaterSupply"];
            this.waterSupplyQualityIssues = _data["waterSupplyQualityIssues"];
            this.septicTanksAndWeepingFieldOnProperty = _data["septicTanksAndWeepingFieldOnProperty"];
            this.installationYear = _data["installationYear"];
            this.dontKnowInstallationYear = _data["dontKnowInstallationYear"];
            this.complianceCertificate = _data["complianceCertificate"];
            this.nonComplianceNotice = _data["nonComplianceNotice"];
            this.nonComplianceNoticeDetails = _data["nonComplianceNoticeDetails"];
            this.systemLastEmptiedYear = _data["systemLastEmptiedYear"];
            this.dontKnowSystemLastEmptiedYear = _data["dontKnowSystemLastEmptiedYear"];
            this.systemProblems = _data["systemProblems"];
            this.systemProblemsDetails = _data["systemProblemsDetails"];
        }
    }

    static fromJS(data: any): DeclarationPlumbingAndDrainageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationPlumbingAndDrainageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["significantWaterPressureVariation"] = this.significantWaterPressureVariation;
        data["freezingPipes"] = this.freezingPipes;
        data["waterLeaks"] = this.waterLeaks;
        data["rustyWater"] = this.rustyWater;
        data["odours"] = this.odours;
        data["plumbingDrainageOrBackup"] = this.plumbingDrainageOrBackup;
        data["plumbingDrainageDetails"] = this.plumbingDrainageDetails;
        data["sumpPump"] = this.sumpPump;
        data["sumpPumpDetails"] = this.sumpPumpDetails;
        data["plumbingModifications"] = this.plumbingModifications;
        data["waterHeaterYear"] = this.waterHeaterYear;
        data["dontKnowWaterHeaterYear"] = this.dontKnowWaterHeaterYear;
        data["wellsOnProperty"] = this.wellsOnProperty;
        data["waterSupplySource"] = this.waterSupplySource;
        data["drinkingWaterSupply"] = this.drinkingWaterSupply;
        data["waterSupplyQualityIssues"] = this.waterSupplyQualityIssues;
        data["septicTanksAndWeepingFieldOnProperty"] = this.septicTanksAndWeepingFieldOnProperty;
        data["installationYear"] = this.installationYear;
        data["dontKnowInstallationYear"] = this.dontKnowInstallationYear;
        data["complianceCertificate"] = this.complianceCertificate;
        data["nonComplianceNotice"] = this.nonComplianceNotice;
        data["nonComplianceNoticeDetails"] = this.nonComplianceNoticeDetails;
        data["systemLastEmptiedYear"] = this.systemLastEmptiedYear;
        data["dontKnowSystemLastEmptiedYear"] = this.dontKnowSystemLastEmptiedYear;
        data["systemProblems"] = this.systemProblems;
        data["systemProblemsDetails"] = this.systemProblemsDetails;
        return data;
    }
}

export interface IDeclarationPlumbingAndDrainageDto {
    significantWaterPressureVariation?: YesNoDontKnow | undefined;
    freezingPipes?: YesNoDontKnow | undefined;
    waterLeaks?: YesNoDontKnow | undefined;
    rustyWater?: YesNoDontKnow | undefined;
    odours?: YesNoDontKnow | undefined;
    plumbingDrainageOrBackup?: YesNoDontKnow | undefined;
    plumbingDrainageDetails?: string | undefined;
    sumpPump?: YesNoDontKnow | undefined;
    sumpPumpDetails?: string | undefined;
    plumbingModifications?: YesNoDontKnow | undefined;
    waterHeaterYear?: number | undefined;
    dontKnowWaterHeaterYear?: boolean | undefined;
    wellsOnProperty?: YesNoDontKnow | undefined;
    waterSupplySource?: string | undefined;
    drinkingWaterSupply?: YesNoDontKnow | undefined;
    waterSupplyQualityIssues?: YesNoDontKnow | undefined;
    septicTanksAndWeepingFieldOnProperty?: YesNoDontKnow | undefined;
    installationYear?: number | undefined;
    dontKnowInstallationYear?: boolean | undefined;
    complianceCertificate?: YesNoDontKnow | undefined;
    nonComplianceNotice?: YesNoDontKnow | undefined;
    nonComplianceNoticeDetails?: string | undefined;
    systemLastEmptiedYear?: number | undefined;
    dontKnowSystemLastEmptiedYear?: boolean | undefined;
    systemProblems?: YesNoDontKnow | undefined;
    systemProblemsDetails?: string | undefined;
}

export class DeclarationHeatingAndAirConditioningDto implements IDeclarationHeatingAndAirConditioningDto {
    mainHeatingSystemProblems?: YesNoDontKnow | undefined;
    mainHeatingSystemProblemsDetails?: string | undefined;
    mainHeatingSystemWorkEfficiently?: YesNoDontKnow | undefined;
    mainHeatingSystemInstallationYear?: number | undefined;
    mainHeatingSystemDontKnowInstallationYear?: boolean | undefined;
    mainHeatingSystemMaintenanceContract?: YesNoDontKnow | undefined;
    mainHeatingSystemUndergroundOilTank?: YesNoDontKnow | undefined;
    mainHeatingSystemUndergroundOilTankInspectedRecently?: YesNoDontKnow | undefined;
    mainHeatingSystemOilLastInspectionYear?: number | undefined;
    heatPumpHasHeatPump?: YesNoDontKnow | undefined;
    heatPumpProblems?: YesNoDontKnow | undefined;
    heatPumpProblemsDetails?: string | undefined;
    heatPumpInstallationYear?: number | undefined;
    heatPumpDontKnowInstallationYear?: boolean | undefined;
    heatPumpMaintenanceContract?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemHasSystem?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemProblems?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemProblemsDetails?: string | undefined;
    permanentAirConditioningSystemInstallationYear?: number | undefined;
    permanentAirConditioningSystemDontKnowInstallationYear?: boolean | undefined;
    permanentAirConditioningSystemMaintenanceContract?: YesNoDontKnow | undefined;
    fireplaceHasFireplace?: YesNoDontKnow | undefined;
    fireplaceWorksWell?: YesNoDontKnow | undefined;
    fireplaceProblems?: YesNoDontKnow | undefined;
    fireplaceNonComplianceNotice?: YesNoDontKnow | undefined;
    fireplaceProblemsDetails?: string | undefined;
    fireplaceNonComplianceNoticeDetails?: string | undefined;
    fireplaceInstallationYear?: number | undefined;
    fireplaceDontKnowInstallationYear?: boolean | undefined;
    fireplaceUsageFrequency?: string | undefined;
    fireplaceDontKnowUsageFrequency?: boolean | undefined;
    fireplaceChimneySweptFrequency?: string | undefined;
    fireplaceDontKnowChimneySweptFrequency?: boolean | undefined;
    fireplaceLastChimneySweptYear?: number | undefined;
    fireplaceDontKnowLastChimneySweptYear?: boolean | undefined;

    constructor(data?: IDeclarationHeatingAndAirConditioningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainHeatingSystemProblems = _data["mainHeatingSystemProblems"];
            this.mainHeatingSystemProblemsDetails = _data["mainHeatingSystemProblemsDetails"];
            this.mainHeatingSystemWorkEfficiently = _data["mainHeatingSystemWorkEfficiently"];
            this.mainHeatingSystemInstallationYear = _data["mainHeatingSystemInstallationYear"];
            this.mainHeatingSystemDontKnowInstallationYear = _data["mainHeatingSystemDontKnowInstallationYear"];
            this.mainHeatingSystemMaintenanceContract = _data["mainHeatingSystemMaintenanceContract"];
            this.mainHeatingSystemUndergroundOilTank = _data["mainHeatingSystemUndergroundOilTank"];
            this.mainHeatingSystemUndergroundOilTankInspectedRecently = _data["mainHeatingSystemUndergroundOilTankInspectedRecently"];
            this.mainHeatingSystemOilLastInspectionYear = _data["mainHeatingSystemOilLastInspectionYear"];
            this.heatPumpHasHeatPump = _data["heatPumpHasHeatPump"];
            this.heatPumpProblems = _data["heatPumpProblems"];
            this.heatPumpProblemsDetails = _data["heatPumpProblemsDetails"];
            this.heatPumpInstallationYear = _data["heatPumpInstallationYear"];
            this.heatPumpDontKnowInstallationYear = _data["heatPumpDontKnowInstallationYear"];
            this.heatPumpMaintenanceContract = _data["heatPumpMaintenanceContract"];
            this.permanentAirConditioningSystemHasSystem = _data["permanentAirConditioningSystemHasSystem"];
            this.permanentAirConditioningSystemProblems = _data["permanentAirConditioningSystemProblems"];
            this.permanentAirConditioningSystemProblemsDetails = _data["permanentAirConditioningSystemProblemsDetails"];
            this.permanentAirConditioningSystemInstallationYear = _data["permanentAirConditioningSystemInstallationYear"];
            this.permanentAirConditioningSystemDontKnowInstallationYear = _data["permanentAirConditioningSystemDontKnowInstallationYear"];
            this.permanentAirConditioningSystemMaintenanceContract = _data["permanentAirConditioningSystemMaintenanceContract"];
            this.fireplaceHasFireplace = _data["fireplaceHasFireplace"];
            this.fireplaceWorksWell = _data["fireplaceWorksWell"];
            this.fireplaceProblems = _data["fireplaceProblems"];
            this.fireplaceNonComplianceNotice = _data["fireplaceNonComplianceNotice"];
            this.fireplaceProblemsDetails = _data["fireplaceProblemsDetails"];
            this.fireplaceNonComplianceNoticeDetails = _data["fireplaceNonComplianceNoticeDetails"];
            this.fireplaceInstallationYear = _data["fireplaceInstallationYear"];
            this.fireplaceDontKnowInstallationYear = _data["fireplaceDontKnowInstallationYear"];
            this.fireplaceUsageFrequency = _data["fireplaceUsageFrequency"];
            this.fireplaceDontKnowUsageFrequency = _data["fireplaceDontKnowUsageFrequency"];
            this.fireplaceChimneySweptFrequency = _data["fireplaceChimneySweptFrequency"];
            this.fireplaceDontKnowChimneySweptFrequency = _data["fireplaceDontKnowChimneySweptFrequency"];
            this.fireplaceLastChimneySweptYear = _data["fireplaceLastChimneySweptYear"];
            this.fireplaceDontKnowLastChimneySweptYear = _data["fireplaceDontKnowLastChimneySweptYear"];
        }
    }

    static fromJS(data: any): DeclarationHeatingAndAirConditioningDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationHeatingAndAirConditioningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainHeatingSystemProblems"] = this.mainHeatingSystemProblems;
        data["mainHeatingSystemProblemsDetails"] = this.mainHeatingSystemProblemsDetails;
        data["mainHeatingSystemWorkEfficiently"] = this.mainHeatingSystemWorkEfficiently;
        data["mainHeatingSystemInstallationYear"] = this.mainHeatingSystemInstallationYear;
        data["mainHeatingSystemDontKnowInstallationYear"] = this.mainHeatingSystemDontKnowInstallationYear;
        data["mainHeatingSystemMaintenanceContract"] = this.mainHeatingSystemMaintenanceContract;
        data["mainHeatingSystemUndergroundOilTank"] = this.mainHeatingSystemUndergroundOilTank;
        data["mainHeatingSystemUndergroundOilTankInspectedRecently"] = this.mainHeatingSystemUndergroundOilTankInspectedRecently;
        data["mainHeatingSystemOilLastInspectionYear"] = this.mainHeatingSystemOilLastInspectionYear;
        data["heatPumpHasHeatPump"] = this.heatPumpHasHeatPump;
        data["heatPumpProblems"] = this.heatPumpProblems;
        data["heatPumpProblemsDetails"] = this.heatPumpProblemsDetails;
        data["heatPumpInstallationYear"] = this.heatPumpInstallationYear;
        data["heatPumpDontKnowInstallationYear"] = this.heatPumpDontKnowInstallationYear;
        data["heatPumpMaintenanceContract"] = this.heatPumpMaintenanceContract;
        data["permanentAirConditioningSystemHasSystem"] = this.permanentAirConditioningSystemHasSystem;
        data["permanentAirConditioningSystemProblems"] = this.permanentAirConditioningSystemProblems;
        data["permanentAirConditioningSystemProblemsDetails"] = this.permanentAirConditioningSystemProblemsDetails;
        data["permanentAirConditioningSystemInstallationYear"] = this.permanentAirConditioningSystemInstallationYear;
        data["permanentAirConditioningSystemDontKnowInstallationYear"] = this.permanentAirConditioningSystemDontKnowInstallationYear;
        data["permanentAirConditioningSystemMaintenanceContract"] = this.permanentAirConditioningSystemMaintenanceContract;
        data["fireplaceHasFireplace"] = this.fireplaceHasFireplace;
        data["fireplaceWorksWell"] = this.fireplaceWorksWell;
        data["fireplaceProblems"] = this.fireplaceProblems;
        data["fireplaceNonComplianceNotice"] = this.fireplaceNonComplianceNotice;
        data["fireplaceProblemsDetails"] = this.fireplaceProblemsDetails;
        data["fireplaceNonComplianceNoticeDetails"] = this.fireplaceNonComplianceNoticeDetails;
        data["fireplaceInstallationYear"] = this.fireplaceInstallationYear;
        data["fireplaceDontKnowInstallationYear"] = this.fireplaceDontKnowInstallationYear;
        data["fireplaceUsageFrequency"] = this.fireplaceUsageFrequency;
        data["fireplaceDontKnowUsageFrequency"] = this.fireplaceDontKnowUsageFrequency;
        data["fireplaceChimneySweptFrequency"] = this.fireplaceChimneySweptFrequency;
        data["fireplaceDontKnowChimneySweptFrequency"] = this.fireplaceDontKnowChimneySweptFrequency;
        data["fireplaceLastChimneySweptYear"] = this.fireplaceLastChimneySweptYear;
        data["fireplaceDontKnowLastChimneySweptYear"] = this.fireplaceDontKnowLastChimneySweptYear;
        return data;
    }
}

export interface IDeclarationHeatingAndAirConditioningDto {
    mainHeatingSystemProblems?: YesNoDontKnow | undefined;
    mainHeatingSystemProblemsDetails?: string | undefined;
    mainHeatingSystemWorkEfficiently?: YesNoDontKnow | undefined;
    mainHeatingSystemInstallationYear?: number | undefined;
    mainHeatingSystemDontKnowInstallationYear?: boolean | undefined;
    mainHeatingSystemMaintenanceContract?: YesNoDontKnow | undefined;
    mainHeatingSystemUndergroundOilTank?: YesNoDontKnow | undefined;
    mainHeatingSystemUndergroundOilTankInspectedRecently?: YesNoDontKnow | undefined;
    mainHeatingSystemOilLastInspectionYear?: number | undefined;
    heatPumpHasHeatPump?: YesNoDontKnow | undefined;
    heatPumpProblems?: YesNoDontKnow | undefined;
    heatPumpProblemsDetails?: string | undefined;
    heatPumpInstallationYear?: number | undefined;
    heatPumpDontKnowInstallationYear?: boolean | undefined;
    heatPumpMaintenanceContract?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemHasSystem?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemProblems?: YesNoDontKnow | undefined;
    permanentAirConditioningSystemProblemsDetails?: string | undefined;
    permanentAirConditioningSystemInstallationYear?: number | undefined;
    permanentAirConditioningSystemDontKnowInstallationYear?: boolean | undefined;
    permanentAirConditioningSystemMaintenanceContract?: YesNoDontKnow | undefined;
    fireplaceHasFireplace?: YesNoDontKnow | undefined;
    fireplaceWorksWell?: YesNoDontKnow | undefined;
    fireplaceProblems?: YesNoDontKnow | undefined;
    fireplaceNonComplianceNotice?: YesNoDontKnow | undefined;
    fireplaceProblemsDetails?: string | undefined;
    fireplaceNonComplianceNoticeDetails?: string | undefined;
    fireplaceInstallationYear?: number | undefined;
    fireplaceDontKnowInstallationYear?: boolean | undefined;
    fireplaceUsageFrequency?: string | undefined;
    fireplaceDontKnowUsageFrequency?: boolean | undefined;
    fireplaceChimneySweptFrequency?: string | undefined;
    fireplaceDontKnowChimneySweptFrequency?: boolean | undefined;
    fireplaceLastChimneySweptYear?: number | undefined;
    fireplaceDontKnowLastChimneySweptYear?: boolean | undefined;
}

export class DeclarationMiscellaneousDto implements IDeclarationMiscellaneousDto {
    inspectionReports?: YesNoDontKnow | undefined;
    reportsAvailable?: YesNoDontKnow | undefined;
    insectOrPestProblems?: YesNoDontKnow | undefined;
    pestProblemsYear?: number | undefined;
    pestSpecies?: string | undefined;
    pestControlMeasures?: string | undefined;
    propertyDamage?: YesNoDontKnow | undefined;
    damageYear?: number | undefined;
    damageNature?: string | undefined;
    damageRepairs?: string | undefined;
    violenceOrSuicideProblems?: YesNoDontKnow | undefined;
    usedToProduceControversialMaterials?: YesNoDontKnow | undefined;
    otherProblems?: YesNoDontKnow | undefined;
    otherProblemsDetails?: string | undefined;

    constructor(data?: IDeclarationMiscellaneousDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionReports = _data["inspectionReports"];
            this.reportsAvailable = _data["reportsAvailable"];
            this.insectOrPestProblems = _data["insectOrPestProblems"];
            this.pestProblemsYear = _data["pestProblemsYear"];
            this.pestSpecies = _data["pestSpecies"];
            this.pestControlMeasures = _data["pestControlMeasures"];
            this.propertyDamage = _data["propertyDamage"];
            this.damageYear = _data["damageYear"];
            this.damageNature = _data["damageNature"];
            this.damageRepairs = _data["damageRepairs"];
            this.violenceOrSuicideProblems = _data["violenceOrSuicideProblems"];
            this.usedToProduceControversialMaterials = _data["usedToProduceControversialMaterials"];
            this.otherProblems = _data["otherProblems"];
            this.otherProblemsDetails = _data["otherProblemsDetails"];
        }
    }

    static fromJS(data: any): DeclarationMiscellaneousDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationMiscellaneousDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionReports"] = this.inspectionReports;
        data["reportsAvailable"] = this.reportsAvailable;
        data["insectOrPestProblems"] = this.insectOrPestProblems;
        data["pestProblemsYear"] = this.pestProblemsYear;
        data["pestSpecies"] = this.pestSpecies;
        data["pestControlMeasures"] = this.pestControlMeasures;
        data["propertyDamage"] = this.propertyDamage;
        data["damageYear"] = this.damageYear;
        data["damageNature"] = this.damageNature;
        data["damageRepairs"] = this.damageRepairs;
        data["violenceOrSuicideProblems"] = this.violenceOrSuicideProblems;
        data["usedToProduceControversialMaterials"] = this.usedToProduceControversialMaterials;
        data["otherProblems"] = this.otherProblems;
        data["otherProblemsDetails"] = this.otherProblemsDetails;
        return data;
    }
}

export interface IDeclarationMiscellaneousDto {
    inspectionReports?: YesNoDontKnow | undefined;
    reportsAvailable?: YesNoDontKnow | undefined;
    insectOrPestProblems?: YesNoDontKnow | undefined;
    pestProblemsYear?: number | undefined;
    pestSpecies?: string | undefined;
    pestControlMeasures?: string | undefined;
    propertyDamage?: YesNoDontKnow | undefined;
    damageYear?: number | undefined;
    damageNature?: string | undefined;
    damageRepairs?: string | undefined;
    violenceOrSuicideProblems?: YesNoDontKnow | undefined;
    usedToProduceControversialMaterials?: YesNoDontKnow | undefined;
    otherProblems?: YesNoDontKnow | undefined;
    otherProblemsDetails?: string | undefined;
}

export class DeclarationRenovationsAndConstructionDto implements IDeclarationRenovationsAndConstructionDto {
    significantWorkDone?: YesNoDontKnow | undefined;
    workDetails?: string | undefined;

    constructor(data?: IDeclarationRenovationsAndConstructionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.significantWorkDone = _data["significantWorkDone"];
            this.workDetails = _data["workDetails"];
        }
    }

    static fromJS(data: any): DeclarationRenovationsAndConstructionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationRenovationsAndConstructionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["significantWorkDone"] = this.significantWorkDone;
        data["workDetails"] = this.workDetails;
        return data;
    }
}

export interface IDeclarationRenovationsAndConstructionDto {
    significantWorkDone?: YesNoDontKnow | undefined;
    workDetails?: string | undefined;
}

export class CreateSubscriptionCheckoutSessionCommand implements ICreateSubscriptionCheckoutSessionCommand {
    selectedProductSubscriptionPriceId?: string | undefined;
    forceNewCheckout?: boolean;
    selectedProducts?: SelectedProductInput[] | undefined;
    successRedirectUrl?: string | undefined;
    subscriptionCode?: string | undefined;
    isOneTimePayment?: boolean;

    constructor(data?: ICreateSubscriptionCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedProductSubscriptionPriceId = _data["selectedProductSubscriptionPriceId"];
            this.forceNewCheckout = _data["forceNewCheckout"];
            if (Array.isArray(_data["selectedProducts"])) {
                this.selectedProducts = [] as any;
                for (let item of _data["selectedProducts"])
                    this.selectedProducts!.push(SelectedProductInput.fromJS(item));
            }
            this.successRedirectUrl = _data["successRedirectUrl"];
            this.subscriptionCode = _data["subscriptionCode"];
            this.isOneTimePayment = _data["isOneTimePayment"];
        }
    }

    static fromJS(data: any): CreateSubscriptionCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedProductSubscriptionPriceId"] = this.selectedProductSubscriptionPriceId;
        data["forceNewCheckout"] = this.forceNewCheckout;
        if (Array.isArray(this.selectedProducts)) {
            data["selectedProducts"] = [];
            for (let item of this.selectedProducts)
                data["selectedProducts"].push(item.toJSON());
        }
        data["successRedirectUrl"] = this.successRedirectUrl;
        data["subscriptionCode"] = this.subscriptionCode;
        data["isOneTimePayment"] = this.isOneTimePayment;
        return data;
    }
}

export interface ICreateSubscriptionCheckoutSessionCommand {
    selectedProductSubscriptionPriceId?: string | undefined;
    forceNewCheckout?: boolean;
    selectedProducts?: SelectedProductInput[] | undefined;
    successRedirectUrl?: string | undefined;
    subscriptionCode?: string | undefined;
    isOneTimePayment?: boolean;
}

export class SelectedProductInput implements ISelectedProductInput {
    productPriceId?: string | undefined;
    quantity?: number;

    constructor(data?: ISelectedProductInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productPriceId = _data["productPriceId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): SelectedProductInput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productPriceId"] = this.productPriceId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ISelectedProductInput {
    productPriceId?: string | undefined;
    quantity?: number;
}

export class StripeProductDto implements IStripeProductDto {
    id?: string | undefined;
    name?: string | undefined;
    active?: boolean;
    description?: string | undefined;
    images?: string[] | undefined;
    url?: string | undefined;
    prices?: StripePriceDto[] | undefined;

    constructor(data?: IStripeProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.description = _data["description"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.url = _data["url"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(StripePriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StripeProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["description"] = this.description;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["url"] = this.url;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStripeProductDto {
    id?: string | undefined;
    name?: string | undefined;
    active?: boolean;
    description?: string | undefined;
    images?: string[] | undefined;
    url?: string | undefined;
    prices?: StripePriceDto[] | undefined;
}

export class StripePriceDto implements IStripePriceDto {
    id?: string | undefined;
    unitAmount?: number;
    currency?: string | undefined;
    setupFeeAmount?: number | undefined;
    lookupKey?: string | undefined;
    reccuring?: StripeReccuringDto | undefined;

    constructor(data?: IStripePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitAmount = _data["unitAmount"];
            this.currency = _data["currency"];
            this.setupFeeAmount = _data["setupFeeAmount"];
            this.lookupKey = _data["lookupKey"];
            this.reccuring = _data["reccuring"] ? StripeReccuringDto.fromJS(_data["reccuring"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StripePriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitAmount"] = this.unitAmount;
        data["currency"] = this.currency;
        data["setupFeeAmount"] = this.setupFeeAmount;
        data["lookupKey"] = this.lookupKey;
        data["reccuring"] = this.reccuring ? this.reccuring.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStripePriceDto {
    id?: string | undefined;
    unitAmount?: number;
    currency?: string | undefined;
    setupFeeAmount?: number | undefined;
    lookupKey?: string | undefined;
    reccuring?: StripeReccuringDto | undefined;
}

export class StripeReccuringDto implements IStripeReccuringDto {
    interval?: string | undefined;
    intervalCount?: number;

    constructor(data?: IStripeReccuringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interval = _data["interval"];
            this.intervalCount = _data["intervalCount"];
        }
    }

    static fromJS(data: any): StripeReccuringDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeReccuringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interval"] = this.interval;
        data["intervalCount"] = this.intervalCount;
        return data;
    }
}

export interface IStripeReccuringDto {
    interval?: string | undefined;
    intervalCount?: number;
}

export class CreateOrEditListingSellerCommand implements ICreateOrEditListingSellerCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    preferredName?: string | undefined;
    birthDate?: Date | undefined;
    residentAddress?: AddressInput | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    residence?: string | undefined;
    citizenship?: string | undefined;
    agreeToDeclaration?: boolean;
    agreeToTermsAndConditions?: boolean;
    agreeToValidateIdentity?: boolean;
    hasASpouseOrPartner?: boolean | undefined;
    agreeToSpousalConsentRequired?: boolean;
    isCompanyOwned?: boolean;
    companyName?: string | undefined;

    constructor(data?: ICreateOrEditListingSellerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.preferredName = _data["preferredName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.residentAddress = _data["residentAddress"] ? AddressInput.fromJS(_data["residentAddress"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.residence = _data["residence"];
            this.citizenship = _data["citizenship"];
            this.agreeToDeclaration = _data["agreeToDeclaration"];
            this.agreeToTermsAndConditions = _data["agreeToTermsAndConditions"];
            this.agreeToValidateIdentity = _data["agreeToValidateIdentity"];
            this.hasASpouseOrPartner = _data["hasASpouseOrPartner"];
            this.agreeToSpousalConsentRequired = _data["agreeToSpousalConsentRequired"];
            this.isCompanyOwned = _data["isCompanyOwned"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): CreateOrEditListingSellerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditListingSellerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["preferredName"] = this.preferredName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["residentAddress"] = this.residentAddress ? this.residentAddress.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["residence"] = this.residence;
        data["citizenship"] = this.citizenship;
        data["agreeToDeclaration"] = this.agreeToDeclaration;
        data["agreeToTermsAndConditions"] = this.agreeToTermsAndConditions;
        data["agreeToValidateIdentity"] = this.agreeToValidateIdentity;
        data["hasASpouseOrPartner"] = this.hasASpouseOrPartner;
        data["agreeToSpousalConsentRequired"] = this.agreeToSpousalConsentRequired;
        data["isCompanyOwned"] = this.isCompanyOwned;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ICreateOrEditListingSellerCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    preferredName?: string | undefined;
    birthDate?: Date | undefined;
    residentAddress?: AddressInput | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    residence?: string | undefined;
    citizenship?: string | undefined;
    agreeToDeclaration?: boolean;
    agreeToTermsAndConditions?: boolean;
    agreeToValidateIdentity?: boolean;
    hasASpouseOrPartner?: boolean | undefined;
    agreeToSpousalConsentRequired?: boolean;
    isCompanyOwned?: boolean;
    companyName?: string | undefined;
}

export class InviteSellerCommand implements IInviteSellerCommand {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: LanguageType;

    constructor(data?: IInviteSellerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): InviteSellerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InviteSellerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["language"] = this.language;
        return data;
    }
}

export interface IInviteSellerCommand {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: LanguageType;
}

export class EditInvitedSellerCommand implements IEditInvitedSellerCommand {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: LanguageType;

    constructor(data?: IEditInvitedSellerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): EditInvitedSellerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditInvitedSellerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["language"] = this.language;
        return data;
    }
}

export interface IEditInvitedSellerCommand {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: LanguageType;
}

export class ConfirmInviteSellerCommand implements IConfirmInviteSellerCommand {

    constructor(data?: IConfirmInviteSellerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ConfirmInviteSellerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmInviteSellerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IConfirmInviteSellerCommand {
}

export class DeclineInviteSellerCommand implements IDeclineInviteSellerCommand {
    language?: LanguageType;

    constructor(data?: IDeclineInviteSellerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): DeclineInviteSellerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineInviteSellerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        return data;
    }
}

export interface IDeclineInviteSellerCommand {
    language?: LanguageType;
}

export class ListingReviewGroupSectionDto implements IListingReviewGroupSectionDto {
    group?: ListingSectionGroup;
    id?: string | undefined;
    sections?: ListingReviewSectionDto[] | undefined;
    numberOfSections?: number;
    numberOfApprovedSections?: number;
    numberOfRectifiedSections?: number;
    numberOfDeclinedSections?: number;
    isFullyReviewed?: boolean;
    sortOrder?: number;
    listingReviewSectionStatus?: ListingReviewSectionStatus;

    constructor(data?: IListingReviewGroupSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.id = _data["id"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ListingReviewSectionDto.fromJS(item));
            }
            this.numberOfSections = _data["numberOfSections"];
            this.numberOfApprovedSections = _data["numberOfApprovedSections"];
            this.numberOfRectifiedSections = _data["numberOfRectifiedSections"];
            this.numberOfDeclinedSections = _data["numberOfDeclinedSections"];
            this.isFullyReviewed = _data["isFullyReviewed"];
            this.sortOrder = _data["sortOrder"];
            this.listingReviewSectionStatus = _data["listingReviewSectionStatus"];
        }
    }

    static fromJS(data: any): ListingReviewGroupSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingReviewGroupSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["id"] = this.id;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["numberOfSections"] = this.numberOfSections;
        data["numberOfApprovedSections"] = this.numberOfApprovedSections;
        data["numberOfRectifiedSections"] = this.numberOfRectifiedSections;
        data["numberOfDeclinedSections"] = this.numberOfDeclinedSections;
        data["isFullyReviewed"] = this.isFullyReviewed;
        data["sortOrder"] = this.sortOrder;
        data["listingReviewSectionStatus"] = this.listingReviewSectionStatus;
        return data;
    }
}

export interface IListingReviewGroupSectionDto {
    group?: ListingSectionGroup;
    id?: string | undefined;
    sections?: ListingReviewSectionDto[] | undefined;
    numberOfSections?: number;
    numberOfApprovedSections?: number;
    numberOfRectifiedSections?: number;
    numberOfDeclinedSections?: number;
    isFullyReviewed?: boolean;
    sortOrder?: number;
    listingReviewSectionStatus?: ListingReviewSectionStatus;
}

export enum ListingSectionGroup {
    Information = 0,
    Images = 1,
    OwnershipInformation = 2,
    ProofOfOwnership = 3,
    Contract = 4,
    SellerDeclaration = 5,
    PreEmptiveRights = 6,
}

export class ListingReviewSectionDto implements IListingReviewSectionDto {
    name?: ListingSectionName;
    sellerId?: string | undefined;
    reviewSectionStatus?: ListingReviewSectionStatus;
    reviewDateTimeUtc?: Date | undefined;
    reasonForDeclines?: string[] | undefined;
    errorDescription?: string | undefined;
    sortOrder?: number;

    constructor(data?: IListingReviewSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sellerId = _data["sellerId"];
            this.reviewSectionStatus = _data["reviewSectionStatus"];
            this.reviewDateTimeUtc = _data["reviewDateTimeUtc"] ? new Date(_data["reviewDateTimeUtc"].toString()) : <any>undefined;
            if (Array.isArray(_data["reasonForDeclines"])) {
                this.reasonForDeclines = [] as any;
                for (let item of _data["reasonForDeclines"])
                    this.reasonForDeclines!.push(item);
            }
            this.errorDescription = _data["errorDescription"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ListingReviewSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingReviewSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sellerId"] = this.sellerId;
        data["reviewSectionStatus"] = this.reviewSectionStatus;
        data["reviewDateTimeUtc"] = this.reviewDateTimeUtc ? this.reviewDateTimeUtc.toISOString() : <any>undefined;
        if (Array.isArray(this.reasonForDeclines)) {
            data["reasonForDeclines"] = [];
            for (let item of this.reasonForDeclines)
                data["reasonForDeclines"].push(item);
        }
        data["errorDescription"] = this.errorDescription;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IListingReviewSectionDto {
    name?: ListingSectionName;
    sellerId?: string | undefined;
    reviewSectionStatus?: ListingReviewSectionStatus;
    reviewDateTimeUtc?: Date | undefined;
    reasonForDeclines?: string[] | undefined;
    errorDescription?: string | undefined;
    sortOrder?: number;
}

export class ListingStateChangeRecordDto implements IListingStateChangeRecordDto {
    previousState?: ListingState | undefined;
    transitionState?: ListingState;
    stateChangeDateTimeUtc?: Date;

    constructor(data?: IListingStateChangeRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousState = _data["previousState"];
            this.transitionState = _data["transitionState"];
            this.stateChangeDateTimeUtc = _data["stateChangeDateTimeUtc"] ? new Date(_data["stateChangeDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ListingStateChangeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingStateChangeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousState"] = this.previousState;
        data["transitionState"] = this.transitionState;
        data["stateChangeDateTimeUtc"] = this.stateChangeDateTimeUtc ? this.stateChangeDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IListingStateChangeRecordDto {
    previousState?: ListingState | undefined;
    transitionState?: ListingState;
    stateChangeDateTimeUtc?: Date;
}

export class EditListingReviewGroupSectionCommand implements IEditListingReviewGroupSectionCommand {
    groups?: ListingSectionGroupInput[] | undefined;

    constructor(data?: IEditListingReviewGroupSectionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ListingSectionGroupInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditListingReviewGroupSectionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditListingReviewGroupSectionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditListingReviewGroupSectionCommand {
    groups?: ListingSectionGroupInput[] | undefined;
}

export class ListingSectionGroupInput implements IListingSectionGroupInput {
    id?: string | undefined;
    group?: ListingSectionGroup;
    sections?: ListingReviewSectionInput[] | undefined;

    constructor(data?: IListingSectionGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.group = _data["group"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ListingReviewSectionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingSectionGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingSectionGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["group"] = this.group;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingSectionGroupInput {
    id?: string | undefined;
    group?: ListingSectionGroup;
    sections?: ListingReviewSectionInput[] | undefined;
}

export class ListingReviewSectionInput implements IListingReviewSectionInput {
    name?: ListingSectionName;
    sellerId?: string | undefined;
    reviewSectionStatus?: ListingReviewSectionStatus;
    reasonForDeclines?: string[] | undefined;
    errorDescription?: string | undefined;

    constructor(data?: IListingReviewSectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sellerId = _data["sellerId"];
            this.reviewSectionStatus = _data["reviewSectionStatus"];
            if (Array.isArray(_data["reasonForDeclines"])) {
                this.reasonForDeclines = [] as any;
                for (let item of _data["reasonForDeclines"])
                    this.reasonForDeclines!.push(item);
            }
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): ListingReviewSectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingReviewSectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sellerId"] = this.sellerId;
        data["reviewSectionStatus"] = this.reviewSectionStatus;
        if (Array.isArray(this.reasonForDeclines)) {
            data["reasonForDeclines"] = [];
            for (let item of this.reasonForDeclines)
                data["reasonForDeclines"].push(item);
        }
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface IListingReviewSectionInput {
    name?: ListingSectionName;
    sellerId?: string | undefined;
    reviewSectionStatus?: ListingReviewSectionStatus;
    reasonForDeclines?: string[] | undefined;
    errorDescription?: string | undefined;
}

export class ReSubmitListingReviewGroupSectionsCommand implements IReSubmitListingReviewGroupSectionsCommand {
    sectionNames?: ListingSectionName[] | undefined;

    constructor(data?: IReSubmitListingReviewGroupSectionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sectionNames"])) {
                this.sectionNames = [] as any;
                for (let item of _data["sectionNames"])
                    this.sectionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): ReSubmitListingReviewGroupSectionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReSubmitListingReviewGroupSectionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sectionNames)) {
            data["sectionNames"] = [];
            for (let item of this.sectionNames)
                data["sectionNames"].push(item);
        }
        return data;
    }
}

export interface IReSubmitListingReviewGroupSectionsCommand {
    sectionNames?: ListingSectionName[] | undefined;
}

export class GenerateReviewDealContractCommand implements IGenerateReviewDealContractCommand {
    completedVerificationId?: string | undefined;

    constructor(data?: IGenerateReviewDealContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedVerificationId = _data["completedVerificationId"];
        }
    }

    static fromJS(data: any): GenerateReviewDealContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateReviewDealContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedVerificationId"] = this.completedVerificationId;
        return data;
    }
}

export interface IGenerateReviewDealContractCommand {
    completedVerificationId?: string | undefined;
}

export class CloudinaryVideoSignatureDto implements ICloudinaryVideoSignatureDto {
    signature?: string | undefined;
    timestamp?: number;
    publicId?: string | undefined;
    cloudName?: string | undefined;
    uploadUrl?: string | undefined;

    constructor(data?: ICloudinaryVideoSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signature = _data["signature"];
            this.timestamp = _data["timestamp"];
            this.publicId = _data["publicId"];
            this.cloudName = _data["cloudName"];
            this.uploadUrl = _data["uploadUrl"];
        }
    }

    static fromJS(data: any): CloudinaryVideoSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloudinaryVideoSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signature"] = this.signature;
        data["timestamp"] = this.timestamp;
        data["publicId"] = this.publicId;
        data["cloudName"] = this.cloudName;
        data["uploadUrl"] = this.uploadUrl;
        return data;
    }
}

export interface ICloudinaryVideoSignatureDto {
    signature?: string | undefined;
    timestamp?: number;
    publicId?: string | undefined;
    cloudName?: string | undefined;
    uploadUrl?: string | undefined;
}

export class AttachVideoToListingCommand implements IAttachVideoToListingCommand {
    publicId?: string | undefined;
    url?: string | undefined;
    caption?: string | undefined;

    constructor(data?: IAttachVideoToListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicId = _data["publicId"];
            this.url = _data["url"];
            this.caption = _data["caption"];
        }
    }

    static fromJS(data: any): AttachVideoToListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AttachVideoToListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicId"] = this.publicId;
        data["url"] = this.url;
        data["caption"] = this.caption;
        return data;
    }
}

export interface IAttachVideoToListingCommand {
    publicId?: string | undefined;
    url?: string | undefined;
    caption?: string | undefined;
}

export class SimpleListingCreatedDto implements ISimpleListingCreatedDto {
    listingId?: number;
    confirmationMessage?: string | undefined;
    emailSentTo?: string | undefined;
    otpCode?: string | undefined;
    previewToken?: string | undefined;

    constructor(data?: ISimpleListingCreatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingId = _data["listingId"];
            this.confirmationMessage = _data["confirmationMessage"];
            this.emailSentTo = _data["emailSentTo"];
            this.otpCode = _data["otpCode"];
            this.previewToken = _data["previewToken"];
        }
    }

    static fromJS(data: any): SimpleListingCreatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleListingCreatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        data["confirmationMessage"] = this.confirmationMessage;
        data["emailSentTo"] = this.emailSentTo;
        data["otpCode"] = this.otpCode;
        data["previewToken"] = this.previewToken;
        return data;
    }
}

export interface ISimpleListingCreatedDto {
    listingId?: number;
    confirmationMessage?: string | undefined;
    emailSentTo?: string | undefined;
    otpCode?: string | undefined;
    previewToken?: string | undefined;
}

export class CreateSimpleListingCommand implements ICreateSimpleListingCommand {
    email?: string | undefined;
    price?: number;
    description?: string | undefined;
    address?: ListingAddressInput | undefined;
    bathroomQuantity?: number;
    bedroomQuantity?: number;
    totalIndoorAreaInMeters?: number;
    sellerFirstName?: string | undefined;
    sellerLastName?: string | undefined;

    constructor(data?: ICreateSimpleListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.price = _data["price"];
            this.description = _data["description"];
            this.address = _data["address"] ? ListingAddressInput.fromJS(_data["address"]) : <any>undefined;
            this.bathroomQuantity = _data["bathroomQuantity"];
            this.bedroomQuantity = _data["bedroomQuantity"];
            this.totalIndoorAreaInMeters = _data["totalIndoorAreaInMeters"];
            this.sellerFirstName = _data["sellerFirstName"];
            this.sellerLastName = _data["sellerLastName"];
        }
    }

    static fromJS(data: any): CreateSimpleListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSimpleListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["price"] = this.price;
        data["description"] = this.description;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["bathroomQuantity"] = this.bathroomQuantity;
        data["bedroomQuantity"] = this.bedroomQuantity;
        data["totalIndoorAreaInMeters"] = this.totalIndoorAreaInMeters;
        data["sellerFirstName"] = this.sellerFirstName;
        data["sellerLastName"] = this.sellerLastName;
        return data;
    }
}

export interface ICreateSimpleListingCommand {
    email?: string | undefined;
    price?: number;
    description?: string | undefined;
    address?: ListingAddressInput | undefined;
    bathroomQuantity?: number;
    bedroomQuantity?: number;
    totalIndoorAreaInMeters?: number;
    sellerFirstName?: string | undefined;
    sellerLastName?: string | undefined;
}

export class PaginatedResultOfInAppNotificationDto extends PaginatedResult implements IPaginatedResultOfInAppNotificationDto {
    entities?: InAppNotificationDto[] | undefined;

    constructor(data?: IPaginatedResultOfInAppNotificationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(InAppNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfInAppNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfInAppNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfInAppNotificationDto extends IPaginatedResult {
    entities?: InAppNotificationDto[] | undefined;
}

export class InAppNotificationDto implements IInAppNotificationDto {
    id?: string;
    type?: NotificationType;
    createdDateTimeUtc?: Date;
    isRead?: boolean;
    subject?: string;
    message?: string;
    metadata?: { [key: string]: any; } | undefined;
    targetUserType?: UserType | undefined;

    constructor(data?: IInAppNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.isRead = _data["isRead"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.targetUserType = _data["targetUserType"];
        }
    }

    static fromJS(data: any): InAppNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InAppNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["isRead"] = this.isRead;
        data["subject"] = this.subject;
        data["message"] = this.message;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["targetUserType"] = this.targetUserType;
        return data;
    }
}

export interface IInAppNotificationDto {
    id?: string;
    type?: NotificationType;
    createdDateTimeUtc?: Date;
    isRead?: boolean;
    subject?: string;
    message?: string;
    metadata?: { [key: string]: any; } | undefined;
    targetUserType?: UserType | undefined;
}

export enum NotificationType {
    ListingIncompleteReminder = 0,
    ListingApproved = 1,
    ListingDenied = 2,
    ListingChangesNoReviewSingle = 3,
    ListingChangesNoReviewMultiple = 4,
    ListingResubmitted = 5,
    ListingChangesSubmittedReview = 6,
    ListingChangesAccepted = 7,
    ListingChangesBuyerUpdate = 8,
    ListingChangesDenied = 9,
    ListingInviteSeller = 10,
    ListingOwnershipVerificationIncorrectInformation = 11,
    ListingOwnershipVerificationMissingOwners = 12,
    ListingFreeCreated = 13,
    ListingFreeDenied = 14,
    ListingNewAdminNotification = 15,
    ListingOwnershipVerificationInProgress = 16,
    ListingOwnershipVerificationApproved = 17,
    ListingSubmittedSellerNotification = 18,
    OfferNewReceived = 19,
    OfferAcceptedSeller = 20,
    OfferAcceptedBuyer = 21,
    OfferExpiring = 22,
    OfferExpired = 23,
    OfferDeclined = 24,
    OfferExtensionSent = 25,
    OfferExtensionReceived = 26,
    OfferExtensionApproved = 27,
    OfferExtensionDeclined = 28,
    OfferToPurchaseSigned = 29,
    OfferCancelledConfirmation = 30,
    OfferCancelledNotice = 31,
    FreeListingOfferUpgrade = 32,
    DealSellerSignatureRequired = 33,
    DealSignedComplete = 34,
    DealCanceledConfirmation = 35,
    DealCanceledNotice = 36,
    DealInviteBuyer = 37,
    DealBuyerSignatureRequired = 38,
    CancellationContractSellerSignatureRequired = 39,
    CancellationContractBuyerSignatureRequired = 40,
    DealSetToFirm = 41,
    FulfillmentContractSellerSignatureRequired = 42,
    FulfillmentContractFullySigned = 43,
    AmendmentSent = 44,
    AmendmentAccepted = 45,
    AmendmentDeclined = 46,
    AmendmentCancelled = 47,
    AmendmentContractSignatureRequired = 48,
    AmendmentContractFullySigned = 49,
    SaleContractFullySigned = 50,
    CancellationContractFullySigned = 51,
    ChatNewMessage = 52,
    ChatRejoinRequested = 53,
    UserRegistration = 54,
    UserVerifyEmail = 55,
    UserEmailVerified = 56,
    UserInformationChanged = 57,
    UserRegistrationAdminNotification = 58,
    OtpRequested = 59,
    OpportunityInviteSent = 60,
    OpportunityInviteReceived = 61,
    OpportunityCreated = 62,
    OpportunityProspectOfferSent = 63,
    SignAddedToProfile = 64,
    SignLinkedToListing = 65,
    SignRemovedFromListing = 66,
    SignScanned = 67,
    TestEmail = 68,
    AppointmentRequested = 69,
    AppointmentAccepted = 70,
    AppointmentDeclined = 71,
    AppointmentRescheduleProposed = 72,
    AppointmentRescheduleAccepted = 73,
    AppointmentRescheduleDeclined = 74,
    AppointmentCancelled = 75,
    AppointmentReminder = 76,
    OpenHouseUpdated = 77,
    OpenHouseCancelled = 78,
    OpenHouseNewRsvp = 79,
    OpenHouseRsvpCancelled = 80,
}

export class TestEmailRequest implements ITestEmailRequest {
    recipientEmail?: string | undefined;
    recipientName?: string | undefined;
    subject?: string | undefined;
    htmlContent?: string | undefined;
    plainTextContent?: string | undefined;
    language?: string | undefined;

    constructor(data?: ITestEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientEmail = _data["recipientEmail"];
            this.recipientName = _data["recipientName"];
            this.subject = _data["subject"];
            this.htmlContent = _data["htmlContent"];
            this.plainTextContent = _data["plainTextContent"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): TestEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientEmail"] = this.recipientEmail;
        data["recipientName"] = this.recipientName;
        data["subject"] = this.subject;
        data["htmlContent"] = this.htmlContent;
        data["plainTextContent"] = this.plainTextContent;
        data["language"] = this.language;
        return data;
    }
}

export interface ITestEmailRequest {
    recipientEmail?: string | undefined;
    recipientName?: string | undefined;
    subject?: string | undefined;
    htmlContent?: string | undefined;
    plainTextContent?: string | undefined;
    language?: string | undefined;
}

export class TestSmsRequest implements ITestSmsRequest {
    phoneNumber?: string | undefined;
    email?: string | undefined;
    recipientName?: string | undefined;
    message?: string | undefined;

    constructor(data?: ITestSmsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.recipientName = _data["recipientName"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TestSmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestSmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["recipientName"] = this.recipientName;
        data["message"] = this.message;
        return data;
    }
}

export interface ITestSmsRequest {
    phoneNumber?: string | undefined;
    email?: string | undefined;
    recipientName?: string | undefined;
    message?: string | undefined;
}

export class TestImmediateRequest implements ITestImmediateRequest {
    recipient?: string | undefined;
    email?: string | undefined;
    recipientName?: string | undefined;
    channel?: NotificationChannel;
    subject?: string | undefined;
    htmlContent?: string | undefined;
    plainTextContent?: string | undefined;
    language?: string | undefined;

    constructor(data?: ITestImmediateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipient = _data["recipient"];
            this.email = _data["email"];
            this.recipientName = _data["recipientName"];
            this.channel = _data["channel"];
            this.subject = _data["subject"];
            this.htmlContent = _data["htmlContent"];
            this.plainTextContent = _data["plainTextContent"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): TestImmediateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestImmediateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient;
        data["email"] = this.email;
        data["recipientName"] = this.recipientName;
        data["channel"] = this.channel;
        data["subject"] = this.subject;
        data["htmlContent"] = this.htmlContent;
        data["plainTextContent"] = this.plainTextContent;
        data["language"] = this.language;
        return data;
    }
}

export interface ITestImmediateRequest {
    recipient?: string | undefined;
    email?: string | undefined;
    recipientName?: string | undefined;
    channel?: NotificationChannel;
    subject?: string | undefined;
    htmlContent?: string | undefined;
    plainTextContent?: string | undefined;
    language?: string | undefined;
}

export enum NotificationChannel {
    Email = 0,
    Sms = 1,
    InApp = 2,
    Push = 3,
}

export class TestBatchRequest implements ITestBatchRequest {
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ITestBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): TestBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ITestBatchRequest {
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class GeneratePdfRequest implements IGeneratePdfRequest {
    html?: string | undefined;

    constructor(data?: IGeneratePdfRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.html = _data["html"];
        }
    }

    static fromJS(data: any): GeneratePdfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePdfRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["html"] = this.html;
        return data;
    }
}

export interface IGeneratePdfRequest {
    html?: string | undefined;
}

export class AddWatermarkRequest implements IAddWatermarkRequest {
    pdfBase64?: string | undefined;
    watermarkText?: string | undefined;

    constructor(data?: IAddWatermarkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdfBase64 = _data["pdfBase64"];
            this.watermarkText = _data["watermarkText"];
        }
    }

    static fromJS(data: any): AddWatermarkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddWatermarkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdfBase64"] = this.pdfBase64;
        data["watermarkText"] = this.watermarkText;
        return data;
    }
}

export interface IAddWatermarkRequest {
    pdfBase64?: string | undefined;
    watermarkText?: string | undefined;
}

export class PaginatedResultOfProjectLookupDto extends PaginatedResult implements IPaginatedResultOfProjectLookupDto {
    entities?: ProjectLookupDto[] | undefined;

    constructor(data?: IPaginatedResultOfProjectLookupDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ProjectLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfProjectLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfProjectLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfProjectLookupDto extends IPaginatedResult {
    entities?: ProjectLookupDto[] | undefined;
}

export class ProjectLookupDto implements IProjectLookupDto {
    id?: number;
    name?: string | undefined;
    supportsClientLeads?: boolean;
    company?: NestedCompanyDto | undefined;
    index?: number;
    pricePerSquareFoot?: number | undefined;
    supportsCheckout?: boolean;
    builderId?: number;

    constructor(data?: IProjectLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.supportsClientLeads = _data["supportsClientLeads"];
            this.company = _data["company"] ? NestedCompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.index = _data["index"];
            this.pricePerSquareFoot = _data["pricePerSquareFoot"];
            this.supportsCheckout = _data["supportsCheckout"];
            this.builderId = _data["builderId"];
        }
    }

    static fromJS(data: any): ProjectLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["supportsClientLeads"] = this.supportsClientLeads;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["index"] = this.index;
        data["pricePerSquareFoot"] = this.pricePerSquareFoot;
        data["supportsCheckout"] = this.supportsCheckout;
        data["builderId"] = this.builderId;
        return data;
    }
}

export interface IProjectLookupDto {
    id?: number;
    name?: string | undefined;
    supportsClientLeads?: boolean;
    company?: NestedCompanyDto | undefined;
    index?: number;
    pricePerSquareFoot?: number | undefined;
    supportsCheckout?: boolean;
    builderId?: number;
}

export class NestedCompanyDto implements INestedCompanyDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;

    constructor(data?: INestedCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.modifiedDateTimeUtc = _data["modifiedDateTimeUtc"] ? new Date(_data["modifiedDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NestedCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["modifiedDateTimeUtc"] = this.modifiedDateTimeUtc ? this.modifiedDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface INestedCompanyDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    createdDateTimeUtc?: Date;
    modifiedDateTimeUtc?: Date;
}

export class ProjectEmailContentDto implements IProjectEmailContentDto {
    subject?: string | undefined;
    description?: string | undefined;

    constructor(data?: IProjectEmailContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ProjectEmailContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEmailContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["description"] = this.description;
        return data;
    }
}

export interface IProjectEmailContentDto {
    subject?: string | undefined;
    description?: string | undefined;
}

export class GetProjectEmailCopyQuery implements IGetProjectEmailCopyQuery {
    projectId?: number;
    noteType?: NoteType;
    requestedCulture?: LanguageType;
    clientsName?: string | undefined;

    constructor(data?: IGetProjectEmailCopyQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.noteType = _data["noteType"];
            this.requestedCulture = _data["requestedCulture"];
            this.clientsName = _data["clientsName"];
        }
    }

    static fromJS(data: any): GetProjectEmailCopyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectEmailCopyQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["noteType"] = this.noteType;
        data["requestedCulture"] = this.requestedCulture;
        data["clientsName"] = this.clientsName;
        return data;
    }
}

export interface IGetProjectEmailCopyQuery {
    projectId?: number;
    noteType?: NoteType;
    requestedCulture?: LanguageType;
    clientsName?: string | undefined;
}

export class ProjectDto implements IProjectDto {
    id?: number;
    name?: string | undefined;
    phases?: NestedPhaseDto[] | undefined;
    buildings?: NestedBuildingDto[] | undefined;
    properties?: NestedListingDto[] | undefined;
    logoImage?: ImageMediaDto | undefined;
    builderName?: string | undefined;
    projectMarketingWebsiteUrl?: string | undefined;
    company?: NestedCompanyDto | undefined;
    supportsClientLeads?: boolean;
    supportsCheckout?: boolean;
    pricePerSquareFoot?: number | undefined;
    contactEmail?: string | undefined;
    contactPhoneNumber?: string | undefined;
    address?: AddressDto | undefined;
    faqUrl?: string | undefined;
    marketingWebsiteUrl?: string | undefined;
    includeSellersDeclaration?: boolean;
    hasCustomSaleTemplateEn?: boolean;
    hasCustomSaleTemplateFr?: boolean;
    hasCustomSampleContractEn?: boolean;
    hasCustomSampleContractFr?: boolean;
    hasCustomTermsAndConditionsEn?: boolean;
    hasCustomTermsAndConditionsFr?: boolean;
    hasCustomAppendixEn?: boolean;
    hasCustomAppendixFr?: boolean;
    customSaleTemplateFileNameEn?: string | undefined;
    customSaleTemplateFileNameFr?: string | undefined;
    customSampleContractFileNameEn?: string | undefined;
    customSampleContractFileNameFr?: string | undefined;
    customTermsAndConditionsFileNameEn?: string | undefined;
    customTermsAndConditionsFileNameFr?: string | undefined;
    customAppendixFileNameEn?: string | undefined;
    customAppendixFileNameFr?: string | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["phases"])) {
                this.phases = [] as any;
                for (let item of _data["phases"])
                    this.phases!.push(NestedPhaseDto.fromJS(item));
            }
            if (Array.isArray(_data["buildings"])) {
                this.buildings = [] as any;
                for (let item of _data["buildings"])
                    this.buildings!.push(NestedBuildingDto.fromJS(item));
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(NestedListingDto.fromJS(item));
            }
            this.logoImage = _data["logoImage"] ? ImageMediaDto.fromJS(_data["logoImage"]) : <any>undefined;
            this.builderName = _data["builderName"];
            this.projectMarketingWebsiteUrl = _data["projectMarketingWebsiteUrl"];
            this.company = _data["company"] ? NestedCompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.supportsClientLeads = _data["supportsClientLeads"];
            this.supportsCheckout = _data["supportsCheckout"];
            this.pricePerSquareFoot = _data["pricePerSquareFoot"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.faqUrl = _data["faqUrl"];
            this.marketingWebsiteUrl = _data["marketingWebsiteUrl"];
            this.includeSellersDeclaration = _data["includeSellersDeclaration"];
            this.hasCustomSaleTemplateEn = _data["hasCustomSaleTemplateEn"];
            this.hasCustomSaleTemplateFr = _data["hasCustomSaleTemplateFr"];
            this.hasCustomSampleContractEn = _data["hasCustomSampleContractEn"];
            this.hasCustomSampleContractFr = _data["hasCustomSampleContractFr"];
            this.hasCustomTermsAndConditionsEn = _data["hasCustomTermsAndConditionsEn"];
            this.hasCustomTermsAndConditionsFr = _data["hasCustomTermsAndConditionsFr"];
            this.hasCustomAppendixEn = _data["hasCustomAppendixEn"];
            this.hasCustomAppendixFr = _data["hasCustomAppendixFr"];
            this.customSaleTemplateFileNameEn = _data["customSaleTemplateFileNameEn"];
            this.customSaleTemplateFileNameFr = _data["customSaleTemplateFileNameFr"];
            this.customSampleContractFileNameEn = _data["customSampleContractFileNameEn"];
            this.customSampleContractFileNameFr = _data["customSampleContractFileNameFr"];
            this.customTermsAndConditionsFileNameEn = _data["customTermsAndConditionsFileNameEn"];
            this.customTermsAndConditionsFileNameFr = _data["customTermsAndConditionsFileNameFr"];
            this.customAppendixFileNameEn = _data["customAppendixFileNameEn"];
            this.customAppendixFileNameFr = _data["customAppendixFileNameFr"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.phases)) {
            data["phases"] = [];
            for (let item of this.phases)
                data["phases"].push(item.toJSON());
        }
        if (Array.isArray(this.buildings)) {
            data["buildings"] = [];
            for (let item of this.buildings)
                data["buildings"].push(item.toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["logoImage"] = this.logoImage ? this.logoImage.toJSON() : <any>undefined;
        data["builderName"] = this.builderName;
        data["projectMarketingWebsiteUrl"] = this.projectMarketingWebsiteUrl;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["supportsClientLeads"] = this.supportsClientLeads;
        data["supportsCheckout"] = this.supportsCheckout;
        data["pricePerSquareFoot"] = this.pricePerSquareFoot;
        data["contactEmail"] = this.contactEmail;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["faqUrl"] = this.faqUrl;
        data["marketingWebsiteUrl"] = this.marketingWebsiteUrl;
        data["includeSellersDeclaration"] = this.includeSellersDeclaration;
        data["hasCustomSaleTemplateEn"] = this.hasCustomSaleTemplateEn;
        data["hasCustomSaleTemplateFr"] = this.hasCustomSaleTemplateFr;
        data["hasCustomSampleContractEn"] = this.hasCustomSampleContractEn;
        data["hasCustomSampleContractFr"] = this.hasCustomSampleContractFr;
        data["hasCustomTermsAndConditionsEn"] = this.hasCustomTermsAndConditionsEn;
        data["hasCustomTermsAndConditionsFr"] = this.hasCustomTermsAndConditionsFr;
        data["hasCustomAppendixEn"] = this.hasCustomAppendixEn;
        data["hasCustomAppendixFr"] = this.hasCustomAppendixFr;
        data["customSaleTemplateFileNameEn"] = this.customSaleTemplateFileNameEn;
        data["customSaleTemplateFileNameFr"] = this.customSaleTemplateFileNameFr;
        data["customSampleContractFileNameEn"] = this.customSampleContractFileNameEn;
        data["customSampleContractFileNameFr"] = this.customSampleContractFileNameFr;
        data["customTermsAndConditionsFileNameEn"] = this.customTermsAndConditionsFileNameEn;
        data["customTermsAndConditionsFileNameFr"] = this.customTermsAndConditionsFileNameFr;
        data["customAppendixFileNameEn"] = this.customAppendixFileNameEn;
        data["customAppendixFileNameFr"] = this.customAppendixFileNameFr;
        return data;
    }
}

export interface IProjectDto {
    id?: number;
    name?: string | undefined;
    phases?: NestedPhaseDto[] | undefined;
    buildings?: NestedBuildingDto[] | undefined;
    properties?: NestedListingDto[] | undefined;
    logoImage?: ImageMediaDto | undefined;
    builderName?: string | undefined;
    projectMarketingWebsiteUrl?: string | undefined;
    company?: NestedCompanyDto | undefined;
    supportsClientLeads?: boolean;
    supportsCheckout?: boolean;
    pricePerSquareFoot?: number | undefined;
    contactEmail?: string | undefined;
    contactPhoneNumber?: string | undefined;
    address?: AddressDto | undefined;
    faqUrl?: string | undefined;
    marketingWebsiteUrl?: string | undefined;
    includeSellersDeclaration?: boolean;
    hasCustomSaleTemplateEn?: boolean;
    hasCustomSaleTemplateFr?: boolean;
    hasCustomSampleContractEn?: boolean;
    hasCustomSampleContractFr?: boolean;
    hasCustomTermsAndConditionsEn?: boolean;
    hasCustomTermsAndConditionsFr?: boolean;
    hasCustomAppendixEn?: boolean;
    hasCustomAppendixFr?: boolean;
    customSaleTemplateFileNameEn?: string | undefined;
    customSaleTemplateFileNameFr?: string | undefined;
    customSampleContractFileNameEn?: string | undefined;
    customSampleContractFileNameFr?: string | undefined;
    customTermsAndConditionsFileNameEn?: string | undefined;
    customTermsAndConditionsFileNameFr?: string | undefined;
    customAppendixFileNameEn?: string | undefined;
    customAppendixFileNameFr?: string | undefined;
}

export class QrCodeDto implements IQrCodeDto {
    id?: number;
    associatedUserId?: string | undefined;
    associatedUserEmail?: string | undefined;
    code?: string | undefined;
    url?: string | undefined;
    associatedListingId?: number | undefined;
    language?: LanguageType;
    signType?: SignType;
    status?: QRCodeStatus;
    listing?: AddressDto | undefined;
    qrCodeImageMedia?: ImageMediaDto | undefined;
    qrCodeScans?: number;

    constructor(data?: IQrCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.associatedUserId = _data["associatedUserId"];
            this.associatedUserEmail = _data["associatedUserEmail"];
            this.code = _data["code"];
            this.url = _data["url"];
            this.associatedListingId = _data["associatedListingId"];
            this.language = _data["language"];
            this.signType = _data["signType"];
            this.status = _data["status"];
            this.listing = _data["listing"] ? AddressDto.fromJS(_data["listing"]) : <any>undefined;
            this.qrCodeImageMedia = _data["qrCodeImageMedia"] ? ImageMediaDto.fromJS(_data["qrCodeImageMedia"]) : <any>undefined;
            this.qrCodeScans = _data["qrCodeScans"];
        }
    }

    static fromJS(data: any): QrCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QrCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["associatedUserId"] = this.associatedUserId;
        data["associatedUserEmail"] = this.associatedUserEmail;
        data["code"] = this.code;
        data["url"] = this.url;
        data["associatedListingId"] = this.associatedListingId;
        data["language"] = this.language;
        data["signType"] = this.signType;
        data["status"] = this.status;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        data["qrCodeImageMedia"] = this.qrCodeImageMedia ? this.qrCodeImageMedia.toJSON() : <any>undefined;
        data["qrCodeScans"] = this.qrCodeScans;
        return data;
    }
}

export interface IQrCodeDto {
    id?: number;
    associatedUserId?: string | undefined;
    associatedUserEmail?: string | undefined;
    code?: string | undefined;
    url?: string | undefined;
    associatedListingId?: number | undefined;
    language?: LanguageType;
    signType?: SignType;
    status?: QRCodeStatus;
    listing?: AddressDto | undefined;
    qrCodeImageMedia?: ImageMediaDto | undefined;
    qrCodeScans?: number;
}

export enum SignType {
    Sale = 0,
    Rent = 1,
}

export enum QRCodeStatus {
    Unlinked = 0,
    Linked = 1,
    Pending = 2,
}

export class GenerateQrCodesCommand implements IGenerateQrCodesCommand {
    numberOfQrCodesToGenerate?: number;
    language?: LanguageType;
    signType?: SignType;
    paddingZeros?: number;

    constructor(data?: IGenerateQrCodesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfQrCodesToGenerate = _data["numberOfQrCodesToGenerate"];
            this.language = _data["language"];
            this.signType = _data["signType"];
            this.paddingZeros = _data["paddingZeros"];
        }
    }

    static fromJS(data: any): GenerateQrCodesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateQrCodesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfQrCodesToGenerate"] = this.numberOfQrCodesToGenerate;
        data["language"] = this.language;
        data["signType"] = this.signType;
        data["paddingZeros"] = this.paddingZeros;
        return data;
    }
}

export interface IGenerateQrCodesCommand {
    numberOfQrCodesToGenerate?: number;
    language?: LanguageType;
    signType?: SignType;
    paddingZeros?: number;
}

export class LinkQRCodesToUserCommand implements ILinkQRCodesToUserCommand {
    qrCodes?: string[] | undefined;

    constructor(data?: ILinkQRCodesToUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["qrCodes"])) {
                this.qrCodes = [] as any;
                for (let item of _data["qrCodes"])
                    this.qrCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): LinkQRCodesToUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LinkQRCodesToUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.qrCodes)) {
            data["qrCodes"] = [];
            for (let item of this.qrCodes)
                data["qrCodes"].push(item);
        }
        return data;
    }
}

export interface ILinkQRCodesToUserCommand {
    qrCodes?: string[] | undefined;
}

export class LinkQrCodesToListingCommand implements ILinkQrCodesToListingCommand {
    qrCodes?: string[] | undefined;
    listingId?: number;

    constructor(data?: ILinkQrCodesToListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["qrCodes"])) {
                this.qrCodes = [] as any;
                for (let item of _data["qrCodes"])
                    this.qrCodes!.push(item);
            }
            this.listingId = _data["listingId"];
        }
    }

    static fromJS(data: any): LinkQrCodesToListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LinkQrCodesToListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.qrCodes)) {
            data["qrCodes"] = [];
            for (let item of this.qrCodes)
                data["qrCodes"].push(item);
        }
        data["listingId"] = this.listingId;
        return data;
    }
}

export interface ILinkQrCodesToListingCommand {
    qrCodes?: string[] | undefined;
    listingId?: number;
}

export class UnlinkQRCodesToListingCommand implements IUnlinkQRCodesToListingCommand {
    qrCodes?: string[] | undefined;

    constructor(data?: IUnlinkQRCodesToListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["qrCodes"])) {
                this.qrCodes = [] as any;
                for (let item of _data["qrCodes"])
                    this.qrCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): UnlinkQRCodesToListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkQRCodesToListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.qrCodes)) {
            data["qrCodes"] = [];
            for (let item of this.qrCodes)
                data["qrCodes"].push(item);
        }
        return data;
    }
}

export interface IUnlinkQRCodesToListingCommand {
    qrCodes?: string[] | undefined;
}

export class PaginatedResultOfQrCodeDto extends PaginatedResult implements IPaginatedResultOfQrCodeDto {
    entities?: QrCodeDto[] | undefined;

    constructor(data?: IPaginatedResultOfQrCodeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(QrCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfQrCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfQrCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfQrCodeDto extends IPaginatedResult {
    entities?: QrCodeDto[] | undefined;
}

export class ImportQrCodesCommand implements IImportQrCodesCommand {
    folderPath?: string | undefined;
    language?: LanguageType;
    signType?: SignType;

    constructor(data?: IImportQrCodesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderPath = _data["folderPath"];
            this.language = _data["language"];
            this.signType = _data["signType"];
        }
    }

    static fromJS(data: any): ImportQrCodesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportQrCodesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderPath"] = this.folderPath;
        data["language"] = this.language;
        data["signType"] = this.signType;
        return data;
    }
}

export interface IImportQrCodesCommand {
    folderPath?: string | undefined;
    language?: LanguageType;
    signType?: SignType;
}

export class ReferrerLookUpDto implements IReferrerLookUpDto {
    id?: number;
    translations?: ReferrerTranslation[] | undefined;
    sortPriority?: number;

    constructor(data?: IReferrerLookUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(ReferrerTranslation.fromJS(item));
            }
            this.sortPriority = _data["sortPriority"];
        }
    }

    static fromJS(data: any): ReferrerLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferrerLookUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["sortPriority"] = this.sortPriority;
        return data;
    }
}

export interface IReferrerLookUpDto {
    id?: number;
    translations?: ReferrerTranslation[] | undefined;
    sortPriority?: number;
}

export class ReferrerTranslation extends Translation implements IReferrerTranslation {
    id?: number;
    name?: string | undefined;
    referredId?: number;

    constructor(data?: IReferrerTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.referredId = _data["referredId"];
        }
    }

    static fromJS(data: any): ReferrerTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ReferrerTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["referredId"] = this.referredId;
        super.toJSON(data);
        return data;
    }
}

export interface IReferrerTranslation extends ITranslation {
    id?: number;
    name?: string | undefined;
    referredId?: number;
}

export class CreateAppointmentCommand implements ICreateAppointmentCommand {
    listingId?: number;
    startAt?: Date;
    endAt?: Date;
    message?: string | undefined;

    constructor(data?: ICreateAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingId = _data["listingId"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateAppointmentCommand {
    listingId?: number;
    startAt?: Date;
    endAt?: Date;
    message?: string | undefined;
}

export class AppointmentListDto implements IAppointmentListDto {
    id?: number;
    opportunityId?: string | undefined;
    listing?: NestedListingDto | undefined;
    buyer?: NestedUserDto | undefined;
    seller?: NestedUserDto | undefined;
    startAt?: Date;
    endAt?: Date;
    status?: AppointmentStatus;
    message?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    requestedBy?: NestedUserDto | undefined;
    proposedStartAt?: Date | undefined;
    proposedEndAt?: Date | undefined;
    proposedBy?: NestedUserDto | undefined;
    rescheduleReason?: string | undefined;

    constructor(data?: IAppointmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.listing = _data["listing"] ? NestedListingDto.fromJS(_data["listing"]) : <any>undefined;
            this.buyer = _data["buyer"] ? NestedUserDto.fromJS(_data["buyer"]) : <any>undefined;
            this.seller = _data["seller"] ? NestedUserDto.fromJS(_data["seller"]) : <any>undefined;
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.requestedBy = _data["requestedBy"] ? NestedUserDto.fromJS(_data["requestedBy"]) : <any>undefined;
            this.proposedStartAt = _data["proposedStartAt"] ? new Date(_data["proposedStartAt"].toString()) : <any>undefined;
            this.proposedEndAt = _data["proposedEndAt"] ? new Date(_data["proposedEndAt"].toString()) : <any>undefined;
            this.proposedBy = _data["proposedBy"] ? NestedUserDto.fromJS(_data["proposedBy"]) : <any>undefined;
            this.rescheduleReason = _data["rescheduleReason"];
        }
    }

    static fromJS(data: any): AppointmentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        data["seller"] = this.seller ? this.seller.toJSON() : <any>undefined;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["proposedStartAt"] = this.proposedStartAt ? this.proposedStartAt.toISOString() : <any>undefined;
        data["proposedEndAt"] = this.proposedEndAt ? this.proposedEndAt.toISOString() : <any>undefined;
        data["proposedBy"] = this.proposedBy ? this.proposedBy.toJSON() : <any>undefined;
        data["rescheduleReason"] = this.rescheduleReason;
        return data;
    }
}

export interface IAppointmentListDto {
    id?: number;
    opportunityId?: string | undefined;
    listing?: NestedListingDto | undefined;
    buyer?: NestedUserDto | undefined;
    seller?: NestedUserDto | undefined;
    startAt?: Date;
    endAt?: Date;
    status?: AppointmentStatus;
    message?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    requestedBy?: NestedUserDto | undefined;
    proposedStartAt?: Date | undefined;
    proposedEndAt?: Date | undefined;
    proposedBy?: NestedUserDto | undefined;
    rescheduleReason?: string | undefined;
}

export enum AppointmentStatus {
    Pending = 0,
    Accepted = 1,
    Declined = 2,
    RescheduleProposed = 3,
    Cancelled = 4,
    Completed = 5,
}

export enum AppointmentRoleFilter {
    Buyer = 0,
    Seller = 1,
    Both = 2,
}

export class AppointmentDetailDto implements IAppointmentDetailDto {
    id?: number;
    opportunityId?: string | undefined;
    listing?: NestedListingDto | undefined;
    buyer?: NestedUserDto | undefined;
    seller?: NestedUserDto | undefined;
    startAt?: Date;
    endAt?: Date;
    status?: AppointmentStatus;
    message?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    requestedBy?: NestedUserDto | undefined;
    proposedStartAt?: Date | undefined;
    proposedEndAt?: Date | undefined;
    proposedBy?: NestedUserDto | undefined;
    rescheduleReason?: string | undefined;
    declineReason?: string | undefined;
    cancelReason?: string | undefined;
    cancelledBy?: NestedUserDto | undefined;
    allowedActions?: string[] | undefined;

    constructor(data?: IAppointmentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.listing = _data["listing"] ? NestedListingDto.fromJS(_data["listing"]) : <any>undefined;
            this.buyer = _data["buyer"] ? NestedUserDto.fromJS(_data["buyer"]) : <any>undefined;
            this.seller = _data["seller"] ? NestedUserDto.fromJS(_data["seller"]) : <any>undefined;
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.requestedBy = _data["requestedBy"] ? NestedUserDto.fromJS(_data["requestedBy"]) : <any>undefined;
            this.proposedStartAt = _data["proposedStartAt"] ? new Date(_data["proposedStartAt"].toString()) : <any>undefined;
            this.proposedEndAt = _data["proposedEndAt"] ? new Date(_data["proposedEndAt"].toString()) : <any>undefined;
            this.proposedBy = _data["proposedBy"] ? NestedUserDto.fromJS(_data["proposedBy"]) : <any>undefined;
            this.rescheduleReason = _data["rescheduleReason"];
            this.declineReason = _data["declineReason"];
            this.cancelReason = _data["cancelReason"];
            this.cancelledBy = _data["cancelledBy"] ? NestedUserDto.fromJS(_data["cancelledBy"]) : <any>undefined;
            if (Array.isArray(_data["allowedActions"])) {
                this.allowedActions = [] as any;
                for (let item of _data["allowedActions"])
                    this.allowedActions!.push(item);
            }
        }
    }

    static fromJS(data: any): AppointmentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        data["seller"] = this.seller ? this.seller.toJSON() : <any>undefined;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["proposedStartAt"] = this.proposedStartAt ? this.proposedStartAt.toISOString() : <any>undefined;
        data["proposedEndAt"] = this.proposedEndAt ? this.proposedEndAt.toISOString() : <any>undefined;
        data["proposedBy"] = this.proposedBy ? this.proposedBy.toJSON() : <any>undefined;
        data["rescheduleReason"] = this.rescheduleReason;
        data["declineReason"] = this.declineReason;
        data["cancelReason"] = this.cancelReason;
        data["cancelledBy"] = this.cancelledBy ? this.cancelledBy.toJSON() : <any>undefined;
        if (Array.isArray(this.allowedActions)) {
            data["allowedActions"] = [];
            for (let item of this.allowedActions)
                data["allowedActions"].push(item);
        }
        return data;
    }
}

export interface IAppointmentDetailDto {
    id?: number;
    opportunityId?: string | undefined;
    listing?: NestedListingDto | undefined;
    buyer?: NestedUserDto | undefined;
    seller?: NestedUserDto | undefined;
    startAt?: Date;
    endAt?: Date;
    status?: AppointmentStatus;
    message?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    requestedBy?: NestedUserDto | undefined;
    proposedStartAt?: Date | undefined;
    proposedEndAt?: Date | undefined;
    proposedBy?: NestedUserDto | undefined;
    rescheduleReason?: string | undefined;
    declineReason?: string | undefined;
    cancelReason?: string | undefined;
    cancelledBy?: NestedUserDto | undefined;
    allowedActions?: string[] | undefined;
}

export class AcceptAppointmentCommand implements IAcceptAppointmentCommand {
    appointmentId?: number;
    note?: string | undefined;

    constructor(data?: IAcceptAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AcceptAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["note"] = this.note;
        return data;
    }
}

export interface IAcceptAppointmentCommand {
    appointmentId?: number;
    note?: string | undefined;
}

export class DeclineAppointmentCommand implements IDeclineAppointmentCommand {
    appointmentId?: number;
    reason?: string | undefined;

    constructor(data?: IDeclineAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): DeclineAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IDeclineAppointmentCommand {
    appointmentId?: number;
    reason?: string | undefined;
}

export class ProposeRescheduleCommand implements IProposeRescheduleCommand {
    appointmentId?: number;
    startAt?: Date;
    endAt?: Date;
    reason?: string | undefined;

    constructor(data?: IProposeRescheduleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ProposeRescheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProposeRescheduleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IProposeRescheduleCommand {
    appointmentId?: number;
    startAt?: Date;
    endAt?: Date;
    reason?: string | undefined;
}

export class CancelAppointmentCommand implements ICancelAppointmentCommand {
    appointmentId?: number;
    reason?: string | undefined;

    constructor(data?: ICancelAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CancelAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICancelAppointmentCommand {
    appointmentId?: number;
    reason?: string | undefined;
}

export class SetAvailabilityCommand implements ISetAvailabilityCommand {
    timezone?: string | undefined;
    meetingDurationMinutes?: number;
    maxBookingDaysInAdvance?: number;
    allowedLocations?: string[] | undefined;
    weeklyRules?: WeeklyRuleInput[] | undefined;
    overrides?: OverrideInput[] | undefined;

    constructor(data?: ISetAvailabilityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.meetingDurationMinutes = _data["meetingDurationMinutes"];
            this.maxBookingDaysInAdvance = _data["maxBookingDaysInAdvance"];
            if (Array.isArray(_data["allowedLocations"])) {
                this.allowedLocations = [] as any;
                for (let item of _data["allowedLocations"])
                    this.allowedLocations!.push(item);
            }
            if (Array.isArray(_data["weeklyRules"])) {
                this.weeklyRules = [] as any;
                for (let item of _data["weeklyRules"])
                    this.weeklyRules!.push(WeeklyRuleInput.fromJS(item));
            }
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(OverrideInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetAvailabilityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetAvailabilityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["meetingDurationMinutes"] = this.meetingDurationMinutes;
        data["maxBookingDaysInAdvance"] = this.maxBookingDaysInAdvance;
        if (Array.isArray(this.allowedLocations)) {
            data["allowedLocations"] = [];
            for (let item of this.allowedLocations)
                data["allowedLocations"].push(item);
        }
        if (Array.isArray(this.weeklyRules)) {
            data["weeklyRules"] = [];
            for (let item of this.weeklyRules)
                data["weeklyRules"].push(item.toJSON());
        }
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetAvailabilityCommand {
    timezone?: string | undefined;
    meetingDurationMinutes?: number;
    maxBookingDaysInAdvance?: number;
    allowedLocations?: string[] | undefined;
    weeklyRules?: WeeklyRuleInput[] | undefined;
    overrides?: OverrideInput[] | undefined;
}

export class WeeklyRuleInput implements IWeeklyRuleInput {
    dayOfWeek?: string | undefined;
    isEnabled?: boolean;
    timeWindows?: TimeWindowInput[] | undefined;

    constructor(data?: IWeeklyRuleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["timeWindows"])) {
                this.timeWindows = [] as any;
                for (let item of _data["timeWindows"])
                    this.timeWindows!.push(TimeWindowInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeeklyRuleInput {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyRuleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.timeWindows)) {
            data["timeWindows"] = [];
            for (let item of this.timeWindows)
                data["timeWindows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeeklyRuleInput {
    dayOfWeek?: string | undefined;
    isEnabled?: boolean;
    timeWindows?: TimeWindowInput[] | undefined;
}

export class TimeWindowInput implements ITimeWindowInput {
    startTime?: string | undefined;
    endTime?: string | undefined;

    constructor(data?: ITimeWindowInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): TimeWindowInput {
        data = typeof data === 'object' ? data : {};
        let result = new TimeWindowInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface ITimeWindowInput {
    startTime?: string | undefined;
    endTime?: string | undefined;
}

export class OverrideInput implements IOverrideInput {
    date?: string | undefined;
    isUnavailableAllDay?: boolean;
    timeWindows?: TimeWindowInput[] | undefined;

    constructor(data?: IOverrideInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.isUnavailableAllDay = _data["isUnavailableAllDay"];
            if (Array.isArray(_data["timeWindows"])) {
                this.timeWindows = [] as any;
                for (let item of _data["timeWindows"])
                    this.timeWindows!.push(TimeWindowInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OverrideInput {
        data = typeof data === 'object' ? data : {};
        let result = new OverrideInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["isUnavailableAllDay"] = this.isUnavailableAllDay;
        if (Array.isArray(this.timeWindows)) {
            data["timeWindows"] = [];
            for (let item of this.timeWindows)
                data["timeWindows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOverrideInput {
    date?: string | undefined;
    isUnavailableAllDay?: boolean;
    timeWindows?: TimeWindowInput[] | undefined;
}

export class AvailabilityDto implements IAvailabilityDto {
    userId?: string | undefined;
    timezone?: string | undefined;
    meetingDurationMinutes?: number;
    maxBookingDaysInAdvance?: number;
    allowedLocations?: string[] | undefined;
    isEnabled?: boolean;
    weeklyRules?: WeeklyRuleDto[] | undefined;
    overrides?: OverrideDto[] | undefined;

    constructor(data?: IAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.timezone = _data["timezone"];
            this.meetingDurationMinutes = _data["meetingDurationMinutes"];
            this.maxBookingDaysInAdvance = _data["maxBookingDaysInAdvance"];
            if (Array.isArray(_data["allowedLocations"])) {
                this.allowedLocations = [] as any;
                for (let item of _data["allowedLocations"])
                    this.allowedLocations!.push(item);
            }
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["weeklyRules"])) {
                this.weeklyRules = [] as any;
                for (let item of _data["weeklyRules"])
                    this.weeklyRules!.push(WeeklyRuleDto.fromJS(item));
            }
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(OverrideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["timezone"] = this.timezone;
        data["meetingDurationMinutes"] = this.meetingDurationMinutes;
        data["maxBookingDaysInAdvance"] = this.maxBookingDaysInAdvance;
        if (Array.isArray(this.allowedLocations)) {
            data["allowedLocations"] = [];
            for (let item of this.allowedLocations)
                data["allowedLocations"].push(item);
        }
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.weeklyRules)) {
            data["weeklyRules"] = [];
            for (let item of this.weeklyRules)
                data["weeklyRules"].push(item.toJSON());
        }
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailabilityDto {
    userId?: string | undefined;
    timezone?: string | undefined;
    meetingDurationMinutes?: number;
    maxBookingDaysInAdvance?: number;
    allowedLocations?: string[] | undefined;
    isEnabled?: boolean;
    weeklyRules?: WeeklyRuleDto[] | undefined;
    overrides?: OverrideDto[] | undefined;
}

export class WeeklyRuleDto implements IWeeklyRuleDto {
    dayOfWeek?: DayOfWeek;
    isEnabled?: boolean;
    timeWindows?: TimeWindowDto[] | undefined;

    constructor(data?: IWeeklyRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["timeWindows"])) {
                this.timeWindows = [] as any;
                for (let item of _data["timeWindows"])
                    this.timeWindows!.push(TimeWindowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeeklyRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.timeWindows)) {
            data["timeWindows"] = [];
            for (let item of this.timeWindows)
                data["timeWindows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWeeklyRuleDto {
    dayOfWeek?: DayOfWeek;
    isEnabled?: boolean;
    timeWindows?: TimeWindowDto[] | undefined;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class TimeWindowDto implements ITimeWindowDto {
    startTime?: string | undefined;
    endTime?: string | undefined;

    constructor(data?: ITimeWindowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): TimeWindowDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeWindowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface ITimeWindowDto {
    startTime?: string | undefined;
    endTime?: string | undefined;
}

export class OverrideDto implements IOverrideDto {
    date?: string | undefined;
    isUnavailableAllDay?: boolean;
    timeWindows?: TimeWindowDto[] | undefined;

    constructor(data?: IOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.isUnavailableAllDay = _data["isUnavailableAllDay"];
            if (Array.isArray(_data["timeWindows"])) {
                this.timeWindows = [] as any;
                for (let item of _data["timeWindows"])
                    this.timeWindows!.push(TimeWindowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["isUnavailableAllDay"] = this.isUnavailableAllDay;
        if (Array.isArray(this.timeWindows)) {
            data["timeWindows"] = [];
            for (let item of this.timeWindows)
                data["timeWindows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOverrideDto {
    date?: string | undefined;
    isUnavailableAllDay?: boolean;
    timeWindows?: TimeWindowDto[] | undefined;
}

export class EditAppointmentDetailsCommand implements IEditAppointmentDetailsCommand {
    timezone?: string | undefined;
    meetingDurationMinutes?: number;
    maxBookingDaysInAdvance?: number;
    allowedLocations?: string[] | undefined;

    constructor(data?: IEditAppointmentDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.meetingDurationMinutes = _data["meetingDurationMinutes"];
            this.maxBookingDaysInAdvance = _data["maxBookingDaysInAdvance"];
            if (Array.isArray(_data["allowedLocations"])) {
                this.allowedLocations = [] as any;
                for (let item of _data["allowedLocations"])
                    this.allowedLocations!.push(item);
            }
        }
    }

    static fromJS(data: any): EditAppointmentDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditAppointmentDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["meetingDurationMinutes"] = this.meetingDurationMinutes;
        data["maxBookingDaysInAdvance"] = this.maxBookingDaysInAdvance;
        if (Array.isArray(this.allowedLocations)) {
            data["allowedLocations"] = [];
            for (let item of this.allowedLocations)
                data["allowedLocations"].push(item);
        }
        return data;
    }
}

export interface IEditAppointmentDetailsCommand {
    timezone?: string | undefined;
    meetingDurationMinutes?: number;
    maxBookingDaysInAdvance?: number;
    allowedLocations?: string[] | undefined;
}

export class EditWeeklyAvailabilityCommand implements IEditWeeklyAvailabilityCommand {
    weeklyRules?: WeeklyRuleInput[] | undefined;

    constructor(data?: IEditWeeklyAvailabilityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weeklyRules"])) {
                this.weeklyRules = [] as any;
                for (let item of _data["weeklyRules"])
                    this.weeklyRules!.push(WeeklyRuleInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditWeeklyAvailabilityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditWeeklyAvailabilityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weeklyRules)) {
            data["weeklyRules"] = [];
            for (let item of this.weeklyRules)
                data["weeklyRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditWeeklyAvailabilityCommand {
    weeklyRules?: WeeklyRuleInput[] | undefined;
}

export class EditOverridesCommand implements IEditOverridesCommand {
    overrides?: OverrideInput[] | undefined;

    constructor(data?: IEditOverridesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(OverrideInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditOverridesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditOverridesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditOverridesCommand {
    overrides?: OverrideInput[] | undefined;
}

export class AvailableSlot implements IAvailableSlot {
    startAt?: Date;
    endAt?: Date;

    constructor(data?: IAvailableSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailableSlot {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAvailableSlot {
    startAt?: Date;
    endAt?: Date;
}

export class MutualAvailabilityResult implements IMutualAvailabilityResult {
    mode?: string | undefined;
    slots?: AvailableSlot[] | undefined;

    constructor(data?: IMutualAvailabilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(AvailableSlot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutualAvailabilityResult {
        data = typeof data === 'object' ? data : {};
        let result = new MutualAvailabilityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutualAvailabilityResult {
    mode?: string | undefined;
    slots?: AvailableSlot[] | undefined;
}

export class ConflictCheckResult implements IConflictCheckResult {
    hasConflict?: boolean;
    conflictReason?: string | undefined;

    constructor(data?: IConflictCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasConflict = _data["hasConflict"];
            this.conflictReason = _data["conflictReason"];
        }
    }

    static fromJS(data: any): ConflictCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConflictCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasConflict"] = this.hasConflict;
        data["conflictReason"] = this.conflictReason;
        return data;
    }
}

export interface IConflictCheckResult {
    hasConflict?: boolean;
    conflictReason?: string | undefined;
}

export class CheckConflictsQuery implements ICheckConflictsQuery {
    participantUserIds?: string[] | undefined;
    startAt?: Date;
    endAt?: Date;

    constructor(data?: ICheckConflictsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participantUserIds"])) {
                this.participantUserIds = [] as any;
                for (let item of _data["participantUserIds"])
                    this.participantUserIds!.push(item);
            }
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckConflictsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CheckConflictsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participantUserIds)) {
            data["participantUserIds"] = [];
            for (let item of this.participantUserIds)
                data["participantUserIds"].push(item);
        }
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICheckConflictsQuery {
    participantUserIds?: string[] | undefined;
    startAt?: Date;
    endAt?: Date;
}

export class ListingSchedulingSummaryDto implements IListingSchedulingSummaryDto {
    listingId?: number;
    sellerUserId?: string | undefined;
    canRequestAppointment?: boolean;
    slots?: ListingScheduleSlotDto[] | undefined;

    constructor(data?: IListingSchedulingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingId = _data["listingId"];
            this.sellerUserId = _data["sellerUserId"];
            this.canRequestAppointment = _data["canRequestAppointment"];
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(ListingScheduleSlotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListingSchedulingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingSchedulingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        data["sellerUserId"] = this.sellerUserId;
        data["canRequestAppointment"] = this.canRequestAppointment;
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListingSchedulingSummaryDto {
    listingId?: number;
    sellerUserId?: string | undefined;
    canRequestAppointment?: boolean;
    slots?: ListingScheduleSlotDto[] | undefined;
}

export class ListingScheduleSlotDto implements IListingScheduleSlotDto {
    startAt?: Date;
    endAt?: Date;
    isOpenHouse?: boolean;
    openHouseId?: number | undefined;
    rsvpMode?: RsvpMode | undefined;

    constructor(data?: IListingScheduleSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.isOpenHouse = _data["isOpenHouse"];
            this.openHouseId = _data["openHouseId"];
            this.rsvpMode = _data["rsvpMode"];
        }
    }

    static fromJS(data: any): ListingScheduleSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingScheduleSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["isOpenHouse"] = this.isOpenHouse;
        data["openHouseId"] = this.openHouseId;
        data["rsvpMode"] = this.rsvpMode;
        return data;
    }
}

export interface IListingScheduleSlotDto {
    startAt?: Date;
    endAt?: Date;
    isOpenHouse?: boolean;
    openHouseId?: number | undefined;
    rsvpMode?: RsvpMode | undefined;
}

export enum RsvpMode {
    Required = 0,
    Optional = 1,
}

export class CreateOpenHouseCommand implements ICreateOpenHouseCommand {
    listingId?: number;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;

    constructor(data?: ICreateOpenHouseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingId = _data["listingId"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.rsvpMode = _data["rsvpMode"];
        }
    }

    static fromJS(data: any): CreateOpenHouseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOpenHouseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingId"] = this.listingId;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["rsvpMode"] = this.rsvpMode;
        return data;
    }
}

export interface ICreateOpenHouseCommand {
    listingId?: number;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;
}

export class OpenHouseListDto implements IOpenHouseListDto {
    id?: number;
    listingId?: number;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;
    status?: OpenHouseStatus;
    rsvpCount?: number;
    createdAt?: Date;

    constructor(data?: IOpenHouseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listingId = _data["listingId"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.rsvpMode = _data["rsvpMode"];
            this.status = _data["status"];
            this.rsvpCount = _data["rsvpCount"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OpenHouseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenHouseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listingId"] = this.listingId;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["rsvpMode"] = this.rsvpMode;
        data["status"] = this.status;
        data["rsvpCount"] = this.rsvpCount;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOpenHouseListDto {
    id?: number;
    listingId?: number;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;
    status?: OpenHouseStatus;
    rsvpCount?: number;
    createdAt?: Date;
}

export enum OpenHouseStatus {
    Scheduled = 0,
    Cancelled = 1,
    Completed = 2,
}

export class MyRsvpDto implements IMyRsvpDto {
    openHouseId?: number;
    opportunityId?: string | undefined;
    listing?: NestedListingDto | undefined;
    startAt?: Date;
    endAt?: Date;
    openHouseStatus?: OpenHouseStatus;
    rsvpStatus?: RsvpStatus;
    rsvpCreatedAt?: Date;

    constructor(data?: IMyRsvpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openHouseId = _data["openHouseId"];
            this.opportunityId = _data["opportunityId"];
            this.listing = _data["listing"] ? NestedListingDto.fromJS(_data["listing"]) : <any>undefined;
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.openHouseStatus = _data["openHouseStatus"];
            this.rsvpStatus = _data["rsvpStatus"];
            this.rsvpCreatedAt = _data["rsvpCreatedAt"] ? new Date(_data["rsvpCreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MyRsvpDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyRsvpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openHouseId"] = this.openHouseId;
        data["opportunityId"] = this.opportunityId;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["openHouseStatus"] = this.openHouseStatus;
        data["rsvpStatus"] = this.rsvpStatus;
        data["rsvpCreatedAt"] = this.rsvpCreatedAt ? this.rsvpCreatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMyRsvpDto {
    openHouseId?: number;
    opportunityId?: string | undefined;
    listing?: NestedListingDto | undefined;
    startAt?: Date;
    endAt?: Date;
    openHouseStatus?: OpenHouseStatus;
    rsvpStatus?: RsvpStatus;
    rsvpCreatedAt?: Date;
}

export enum RsvpStatus {
    Going = 0,
    NotGoing = 1,
    Cancelled = 2,
}

export class ListingOpenHouseDto implements IListingOpenHouseDto {
    id?: number;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;
    status?: OpenHouseStatus;
    rsvpCount?: number;
    currentUserRsvpStatus?: RsvpStatus | undefined;

    constructor(data?: IListingOpenHouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.rsvpMode = _data["rsvpMode"];
            this.status = _data["status"];
            this.rsvpCount = _data["rsvpCount"];
            this.currentUserRsvpStatus = _data["currentUserRsvpStatus"];
        }
    }

    static fromJS(data: any): ListingOpenHouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingOpenHouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["rsvpMode"] = this.rsvpMode;
        data["status"] = this.status;
        data["rsvpCount"] = this.rsvpCount;
        data["currentUserRsvpStatus"] = this.currentUserRsvpStatus;
        return data;
    }
}

export interface IListingOpenHouseDto {
    id?: number;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;
    status?: OpenHouseStatus;
    rsvpCount?: number;
    currentUserRsvpStatus?: RsvpStatus | undefined;
}

export class OpenHouseDetailDto implements IOpenHouseDetailDto {
    id?: number;
    listingId?: number;
    sellerUserId?: string | undefined;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;
    status?: OpenHouseStatus;
    cancelReason?: string | undefined;
    rsvpCount?: number;
    currentUserRsvpStatus?: RsvpStatus | undefined;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IOpenHouseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listingId = _data["listingId"];
            this.sellerUserId = _data["sellerUserId"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.rsvpMode = _data["rsvpMode"];
            this.status = _data["status"];
            this.cancelReason = _data["cancelReason"];
            this.rsvpCount = _data["rsvpCount"];
            this.currentUserRsvpStatus = _data["currentUserRsvpStatus"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OpenHouseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenHouseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listingId"] = this.listingId;
        data["sellerUserId"] = this.sellerUserId;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["rsvpMode"] = this.rsvpMode;
        data["status"] = this.status;
        data["cancelReason"] = this.cancelReason;
        data["rsvpCount"] = this.rsvpCount;
        data["currentUserRsvpStatus"] = this.currentUserRsvpStatus;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOpenHouseDetailDto {
    id?: number;
    listingId?: number;
    sellerUserId?: string | undefined;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;
    status?: OpenHouseStatus;
    cancelReason?: string | undefined;
    rsvpCount?: number;
    currentUserRsvpStatus?: RsvpStatus | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export class UpdateOpenHouseCommand implements IUpdateOpenHouseCommand {
    openHouseId?: number;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;

    constructor(data?: IUpdateOpenHouseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openHouseId = _data["openHouseId"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : <any>undefined;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : <any>undefined;
            this.rsvpMode = _data["rsvpMode"];
        }
    }

    static fromJS(data: any): UpdateOpenHouseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOpenHouseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openHouseId"] = this.openHouseId;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : <any>undefined;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : <any>undefined;
        data["rsvpMode"] = this.rsvpMode;
        return data;
    }
}

export interface IUpdateOpenHouseCommand {
    openHouseId?: number;
    startAt?: Date;
    endAt?: Date;
    rsvpMode?: RsvpMode;
}

export class CancelOpenHouseCommand implements ICancelOpenHouseCommand {
    openHouseId?: number;
    reason?: string | undefined;

    constructor(data?: ICancelOpenHouseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openHouseId = _data["openHouseId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CancelOpenHouseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOpenHouseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openHouseId"] = this.openHouseId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICancelOpenHouseCommand {
    openHouseId?: number;
    reason?: string | undefined;
}

export class RsvpToOpenHouseCommand implements IRsvpToOpenHouseCommand {
    openHouseId?: number;
    status?: RsvpStatus;

    constructor(data?: IRsvpToOpenHouseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openHouseId = _data["openHouseId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RsvpToOpenHouseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RsvpToOpenHouseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openHouseId"] = this.openHouseId;
        data["status"] = this.status;
        return data;
    }
}

export interface IRsvpToOpenHouseCommand {
    openHouseId?: number;
    status?: RsvpStatus;
}

export class RsvpDto implements IRsvpDto {
    id?: number;
    userId?: string | undefined;
    userName?: string | undefined;
    status?: RsvpStatus;
    createdAt?: Date;
    opportunityId?: string | undefined;

    constructor(data?: IRsvpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.opportunityId = _data["opportunityId"];
        }
    }

    static fromJS(data: any): RsvpDto {
        data = typeof data === 'object' ? data : {};
        let result = new RsvpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["opportunityId"] = this.opportunityId;
        return data;
    }
}

export interface IRsvpDto {
    id?: number;
    userId?: string | undefined;
    userName?: string | undefined;
    status?: RsvpStatus;
    createdAt?: Date;
    opportunityId?: string | undefined;
}

export class PaginatedResultOfSharedOpportunityLookupDto extends PaginatedResult implements IPaginatedResultOfSharedOpportunityLookupDto {
    entities?: SharedOpportunityLookupDto[] | undefined;

    constructor(data?: IPaginatedResultOfSharedOpportunityLookupDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(SharedOpportunityLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfSharedOpportunityLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfSharedOpportunityLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfSharedOpportunityLookupDto extends IPaginatedResult {
    entities?: SharedOpportunityLookupDto[] | undefined;
}

export class SharedOpportunityLookupDto implements ISharedOpportunityLookupDto {
    id?: string | undefined;
    sharedOpportunityLeads?: SharedOpportunityLeadDto[] | undefined;
    contacts?: SharedOpportunityContactDto[] | undefined;
    numberOfLeads?: number;
    listingName?: string | undefined;
    listingPrice?: number | undefined;
    listing?: AddressDto | undefined;
    listingId?: number;
    listingState?: ListingState;
    dealId?: string | undefined;
    status?: SharedOpportunityStatus;
    language?: LanguageType;
    dealTotalSalePrice?: number | undefined;
    index?: number;
    dealState?: DealState | undefined;
    tier?: ListingTier;

    constructor(data?: ISharedOpportunityLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["sharedOpportunityLeads"])) {
                this.sharedOpportunityLeads = [] as any;
                for (let item of _data["sharedOpportunityLeads"])
                    this.sharedOpportunityLeads!.push(SharedOpportunityLeadDto.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(SharedOpportunityContactDto.fromJS(item));
            }
            this.numberOfLeads = _data["numberOfLeads"];
            this.listingName = _data["listingName"];
            this.listingPrice = _data["listingPrice"];
            this.listing = _data["listing"] ? AddressDto.fromJS(_data["listing"]) : <any>undefined;
            this.listingId = _data["listingId"];
            this.listingState = _data["listingState"];
            this.dealId = _data["dealId"];
            this.status = _data["status"];
            this.language = _data["language"];
            this.dealTotalSalePrice = _data["dealTotalSalePrice"];
            this.index = _data["index"];
            this.dealState = _data["dealState"];
            this.tier = _data["tier"];
        }
    }

    static fromJS(data: any): SharedOpportunityLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharedOpportunityLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.sharedOpportunityLeads)) {
            data["sharedOpportunityLeads"] = [];
            for (let item of this.sharedOpportunityLeads)
                data["sharedOpportunityLeads"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["numberOfLeads"] = this.numberOfLeads;
        data["listingName"] = this.listingName;
        data["listingPrice"] = this.listingPrice;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        data["listingId"] = this.listingId;
        data["listingState"] = this.listingState;
        data["dealId"] = this.dealId;
        data["status"] = this.status;
        data["language"] = this.language;
        data["dealTotalSalePrice"] = this.dealTotalSalePrice;
        data["index"] = this.index;
        data["dealState"] = this.dealState;
        data["tier"] = this.tier;
        return data;
    }
}

export interface ISharedOpportunityLookupDto {
    id?: string | undefined;
    sharedOpportunityLeads?: SharedOpportunityLeadDto[] | undefined;
    contacts?: SharedOpportunityContactDto[] | undefined;
    numberOfLeads?: number;
    listingName?: string | undefined;
    listingPrice?: number | undefined;
    listing?: AddressDto | undefined;
    listingId?: number;
    listingState?: ListingState;
    dealId?: string | undefined;
    status?: SharedOpportunityStatus;
    language?: LanguageType;
    dealTotalSalePrice?: number | undefined;
    index?: number;
    dealState?: DealState | undefined;
    tier?: ListingTier;
}

export class SharedOpportunityLeadDto implements ISharedOpportunityLeadDto {
    id?: string | undefined;
    lead?: LeadDto | undefined;
    creationDateTimeUtc?: Date | undefined;

    constructor(data?: ISharedOpportunityLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lead = _data["lead"] ? LeadDto.fromJS(_data["lead"]) : <any>undefined;
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SharedOpportunityLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharedOpportunityLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lead"] = this.lead ? this.lead.toJSON() : <any>undefined;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISharedOpportunityLeadDto {
    id?: string | undefined;
    lead?: LeadDto | undefined;
    creationDateTimeUtc?: Date | undefined;
}

export class LeadDto implements ILeadDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    assignedTo?: NestedUserDto | undefined;
    creationDateTimeUtc?: Date | undefined;
    linkedUserId?: string | undefined;
    profileImage?: ImageMediaDto | undefined;

    constructor(data?: ILeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.assignedTo = _data["assignedTo"] ? NestedUserDto.fromJS(_data["assignedTo"]) : <any>undefined;
            this.creationDateTimeUtc = _data["creationDateTimeUtc"] ? new Date(_data["creationDateTimeUtc"].toString()) : <any>undefined;
            this.linkedUserId = _data["linkedUserId"];
            this.profileImage = _data["profileImage"] ? ImageMediaDto.fromJS(_data["profileImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["assignedTo"] = this.assignedTo ? this.assignedTo.toJSON() : <any>undefined;
        data["creationDateTimeUtc"] = this.creationDateTimeUtc ? this.creationDateTimeUtc.toISOString() : <any>undefined;
        data["linkedUserId"] = this.linkedUserId;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILeadDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    assignedTo?: NestedUserDto | undefined;
    creationDateTimeUtc?: Date | undefined;
    linkedUserId?: string | undefined;
    profileImage?: ImageMediaDto | undefined;
}

export class SharedOpportunityContactDto implements ISharedOpportunityContactDto {
    id?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactType?: SharedOpportunityContactType;
    linkedUserId?: string | undefined;
    hasLeft?: boolean;
    leftDateTimeUtc?: Date | undefined;

    constructor(data?: ISharedOpportunityContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactType = _data["contactType"];
            this.linkedUserId = _data["linkedUserId"];
            this.hasLeft = _data["hasLeft"];
            this.leftDateTimeUtc = _data["leftDateTimeUtc"] ? new Date(_data["leftDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SharedOpportunityContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharedOpportunityContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactType"] = this.contactType;
        data["linkedUserId"] = this.linkedUserId;
        data["hasLeft"] = this.hasLeft;
        data["leftDateTimeUtc"] = this.leftDateTimeUtc ? this.leftDateTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISharedOpportunityContactDto {
    id?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactType?: SharedOpportunityContactType;
    linkedUserId?: string | undefined;
    hasLeft?: boolean;
    leftDateTimeUtc?: Date | undefined;
}

export enum SharedOpportunityContactType {
    Buyer = 0,
    BuyerBroker = 1,
    Seller = 2,
    SellerBroker = 3,
}

export enum SharedOpportunityStatus {
    PreAccepted = 0,
    Browsing = 1,
    Offer = 2,
    Deal = 3,
    Cancelled = 4,
}

export class SharedOpportunityDto implements ISharedOpportunityDto {
    id?: string | undefined;
    sharedOpportunityLeads?: SharedOpportunityLeadDto[] | undefined;
    contacts?: SharedOpportunityContactDto[] | undefined;
    numberOfLeads?: number;
    listingName?: string | undefined;
    listing?: AddressDto | undefined;
    listingId?: number;
    dealId?: string | undefined;
    status?: SharedOpportunityStatus;
    language?: LanguageType;
    dealTotalSalePrice?: number | undefined;
    index?: number;
    finalizationStartedDateTimeUtc?: Date | undefined;
    finalizationExpiresAtDateTimeUtc?: Date | undefined;
    listingState?: ListingState;
    dealState?: DealState | undefined;
    tier?: ListingTier;

    constructor(data?: ISharedOpportunityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["sharedOpportunityLeads"])) {
                this.sharedOpportunityLeads = [] as any;
                for (let item of _data["sharedOpportunityLeads"])
                    this.sharedOpportunityLeads!.push(SharedOpportunityLeadDto.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(SharedOpportunityContactDto.fromJS(item));
            }
            this.numberOfLeads = _data["numberOfLeads"];
            this.listingName = _data["listingName"];
            this.listing = _data["listing"] ? AddressDto.fromJS(_data["listing"]) : <any>undefined;
            this.listingId = _data["listingId"];
            this.dealId = _data["dealId"];
            this.status = _data["status"];
            this.language = _data["language"];
            this.dealTotalSalePrice = _data["dealTotalSalePrice"];
            this.index = _data["index"];
            this.finalizationStartedDateTimeUtc = _data["finalizationStartedDateTimeUtc"] ? new Date(_data["finalizationStartedDateTimeUtc"].toString()) : <any>undefined;
            this.finalizationExpiresAtDateTimeUtc = _data["finalizationExpiresAtDateTimeUtc"] ? new Date(_data["finalizationExpiresAtDateTimeUtc"].toString()) : <any>undefined;
            this.listingState = _data["listingState"];
            this.dealState = _data["dealState"];
            this.tier = _data["tier"];
        }
    }

    static fromJS(data: any): SharedOpportunityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SharedOpportunityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.sharedOpportunityLeads)) {
            data["sharedOpportunityLeads"] = [];
            for (let item of this.sharedOpportunityLeads)
                data["sharedOpportunityLeads"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["numberOfLeads"] = this.numberOfLeads;
        data["listingName"] = this.listingName;
        data["listing"] = this.listing ? this.listing.toJSON() : <any>undefined;
        data["listingId"] = this.listingId;
        data["dealId"] = this.dealId;
        data["status"] = this.status;
        data["language"] = this.language;
        data["dealTotalSalePrice"] = this.dealTotalSalePrice;
        data["index"] = this.index;
        data["finalizationStartedDateTimeUtc"] = this.finalizationStartedDateTimeUtc ? this.finalizationStartedDateTimeUtc.toISOString() : <any>undefined;
        data["finalizationExpiresAtDateTimeUtc"] = this.finalizationExpiresAtDateTimeUtc ? this.finalizationExpiresAtDateTimeUtc.toISOString() : <any>undefined;
        data["listingState"] = this.listingState;
        data["dealState"] = this.dealState;
        data["tier"] = this.tier;
        return data;
    }
}

export interface ISharedOpportunityDto {
    id?: string | undefined;
    sharedOpportunityLeads?: SharedOpportunityLeadDto[] | undefined;
    contacts?: SharedOpportunityContactDto[] | undefined;
    numberOfLeads?: number;
    listingName?: string | undefined;
    listing?: AddressDto | undefined;
    listingId?: number;
    dealId?: string | undefined;
    status?: SharedOpportunityStatus;
    language?: LanguageType;
    dealTotalSalePrice?: number | undefined;
    index?: number;
    finalizationStartedDateTimeUtc?: Date | undefined;
    finalizationExpiresAtDateTimeUtc?: Date | undefined;
    listingState?: ListingState;
    dealState?: DealState | undefined;
    tier?: ListingTier;
}

export class SendbirdMessage implements ISendbirdMessage {
    type?: string | undefined;
    message_id?: number;
    message?: string | undefined;
    data?: string | undefined;
    custom_type?: string | undefined;
    file?: any | undefined;
    created_at?: number;
    user?: User | undefined;
    channel_url?: string | undefined;
    updated_at?: number;
    message_survival_seconds?: number;
    mentioned_users?: any[] | undefined;
    mention_type?: string | undefined;
    silent?: boolean;
    message_retention_hour?: number;
    channel_type?: string | undefined;
    translations?: { [key: string]: string; } | undefined;
    is_removed?: boolean;
    is_op_msg?: boolean;
    message_events?: MessageEvent | undefined;

    constructor(data?: ISendbirdMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.message_id = _data["message_id"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.custom_type = _data["custom_type"];
            this.file = _data["file"];
            this.created_at = _data["created_at"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.channel_url = _data["channel_url"];
            this.updated_at = _data["updated_at"];
            this.message_survival_seconds = _data["message_survival_seconds"];
            if (Array.isArray(_data["mentioned_users"])) {
                this.mentioned_users = [] as any;
                for (let item of _data["mentioned_users"])
                    this.mentioned_users!.push(item);
            }
            this.mention_type = _data["mention_type"];
            this.silent = _data["silent"];
            this.message_retention_hour = _data["message_retention_hour"];
            this.channel_type = _data["channel_type"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key];
                }
            }
            this.is_removed = _data["is_removed"];
            this.is_op_msg = _data["is_op_msg"];
            this.message_events = _data["message_events"] ? MessageEvent.fromJS(_data["message_events"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendbirdMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SendbirdMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["message_id"] = this.message_id;
        data["message"] = this.message;
        data["data"] = this.data;
        data["custom_type"] = this.custom_type;
        data["file"] = this.file;
        data["created_at"] = this.created_at;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["channel_url"] = this.channel_url;
        data["updated_at"] = this.updated_at;
        data["message_survival_seconds"] = this.message_survival_seconds;
        if (Array.isArray(this.mentioned_users)) {
            data["mentioned_users"] = [];
            for (let item of this.mentioned_users)
                data["mentioned_users"].push(item);
        }
        data["mention_type"] = this.mention_type;
        data["silent"] = this.silent;
        data["message_retention_hour"] = this.message_retention_hour;
        data["channel_type"] = this.channel_type;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = (<any>this.translations)[key];
            }
        }
        data["is_removed"] = this.is_removed;
        data["is_op_msg"] = this.is_op_msg;
        data["message_events"] = this.message_events ? this.message_events.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendbirdMessage {
    type?: string | undefined;
    message_id?: number;
    message?: string | undefined;
    data?: string | undefined;
    custom_type?: string | undefined;
    file?: any | undefined;
    created_at?: number;
    user?: User | undefined;
    channel_url?: string | undefined;
    updated_at?: number;
    message_survival_seconds?: number;
    mentioned_users?: any[] | undefined;
    mention_type?: string | undefined;
    silent?: boolean;
    message_retention_hour?: number;
    channel_type?: string | undefined;
    translations?: { [key: string]: string; } | undefined;
    is_removed?: boolean;
    is_op_msg?: boolean;
    message_events?: MessageEvent | undefined;
}

export class User implements IUser {
    user_id?: string | undefined;
    profile_url?: string | undefined;
    require_auth_for_profile_image?: boolean;
    nickname?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    role?: string | undefined;
    is_active?: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_id = _data["user_id"];
            this.profile_url = _data["profile_url"];
            this.require_auth_for_profile_image = _data["require_auth_for_profile_image"];
            this.nickname = _data["nickname"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.role = _data["role"];
            this.is_active = _data["is_active"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_id"] = this.user_id;
        data["profile_url"] = this.profile_url;
        data["require_auth_for_profile_image"] = this.require_auth_for_profile_image;
        data["nickname"] = this.nickname;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["role"] = this.role;
        data["is_active"] = this.is_active;
        return data;
    }
}

export interface IUser {
    user_id?: string | undefined;
    profile_url?: string | undefined;
    require_auth_for_profile_image?: boolean;
    nickname?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    role?: string | undefined;
    is_active?: boolean;
}

export class MessageEvent implements IMessageEvent {
    send_push_notification?: string | undefined;
    update_unread_count?: boolean;
    update_mention_count?: boolean;
    update_last_message?: boolean;

    constructor(data?: IMessageEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.send_push_notification = _data["send_push_notification"];
            this.update_unread_count = _data["update_unread_count"];
            this.update_mention_count = _data["update_mention_count"];
            this.update_last_message = _data["update_last_message"];
        }
    }

    static fromJS(data: any): MessageEvent {
        data = typeof data === 'object' ? data : {};
        let result = new MessageEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["send_push_notification"] = this.send_push_notification;
        data["update_unread_count"] = this.update_unread_count;
        data["update_mention_count"] = this.update_mention_count;
        data["update_last_message"] = this.update_last_message;
        return data;
    }
}

export interface IMessageEvent {
    send_push_notification?: string | undefined;
    update_unread_count?: boolean;
    update_mention_count?: boolean;
    update_last_message?: boolean;
}

export class RequestOpportunityChatCommand implements IRequestOpportunityChatCommand {
    message?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IRequestOpportunityChatCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): RequestOpportunityChatCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RequestOpportunityChatCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IRequestOpportunityChatCommand {
    message?: string | undefined;
    userId?: string | undefined;
}

export class AcceptRequestOpportunityChatCommand implements IAcceptRequestOpportunityChatCommand {
    message?: string | undefined;

    constructor(data?: IAcceptRequestOpportunityChatCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AcceptRequestOpportunityChatCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptRequestOpportunityChatCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IAcceptRequestOpportunityChatCommand {
    message?: string | undefined;
}

export class DeclineRequestOpportunityChatCommand implements IDeclineRequestOpportunityChatCommand {
    message?: string | undefined;

    constructor(data?: IDeclineRequestOpportunityChatCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeclineRequestOpportunityChatCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineRequestOpportunityChatCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IDeclineRequestOpportunityChatCommand {
    message?: string | undefined;
}

export class RejoinOpportunityChatCommand implements IRejoinOpportunityChatCommand {

    constructor(data?: IRejoinOpportunityChatCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RejoinOpportunityChatCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejoinOpportunityChatCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRejoinOpportunityChatCommand {
}

export class LeaveOpportunityChatCommand implements ILeaveOpportunityChatCommand {

    constructor(data?: ILeaveOpportunityChatCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): LeaveOpportunityChatCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveOpportunityChatCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ILeaveOpportunityChatCommand {
}

export class CreateSharedOpportunityCommand implements ICreateSharedOpportunityCommand {
    language?: LanguageType;
    leads?: LeadInput[] | undefined;
    existingLeadIds?: string[] | undefined;
    selectedListingId?: number | undefined;
    prospectListing?: ListingOpportunityInput | undefined;
    initialBuyerMessage?: string | undefined;

    constructor(data?: ICreateSharedOpportunityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(LeadInput.fromJS(item));
            }
            if (Array.isArray(_data["existingLeadIds"])) {
                this.existingLeadIds = [] as any;
                for (let item of _data["existingLeadIds"])
                    this.existingLeadIds!.push(item);
            }
            this.selectedListingId = _data["selectedListingId"];
            this.prospectListing = _data["prospectListing"] ? ListingOpportunityInput.fromJS(_data["prospectListing"]) : <any>undefined;
            this.initialBuyerMessage = _data["initialBuyerMessage"];
        }
    }

    static fromJS(data: any): CreateSharedOpportunityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSharedOpportunityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        if (Array.isArray(this.existingLeadIds)) {
            data["existingLeadIds"] = [];
            for (let item of this.existingLeadIds)
                data["existingLeadIds"].push(item);
        }
        data["selectedListingId"] = this.selectedListingId;
        data["prospectListing"] = this.prospectListing ? this.prospectListing.toJSON() : <any>undefined;
        data["initialBuyerMessage"] = this.initialBuyerMessage;
        return data;
    }
}

export interface ICreateSharedOpportunityCommand {
    language?: LanguageType;
    leads?: LeadInput[] | undefined;
    existingLeadIds?: string[] | undefined;
    selectedListingId?: number | undefined;
    prospectListing?: ListingOpportunityInput | undefined;
    initialBuyerMessage?: string | undefined;
}

export class LeadInput implements ILeadInput {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;

    constructor(data?: ILeadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
        }
    }

    static fromJS(data: any): LeadInput {
        data = typeof data === 'object' ? data : {};
        let result = new LeadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        return data;
    }
}

export interface ILeadInput {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
}

export class ListingOpportunityInput implements IListingOpportunityInput {
    address?: ListingAddressInput | undefined;
    seller?: ListingSellerOpportunityInput | undefined;

    constructor(data?: IListingOpportunityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? ListingAddressInput.fromJS(_data["address"]) : <any>undefined;
            this.seller = _data["seller"] ? ListingSellerOpportunityInput.fromJS(_data["seller"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListingOpportunityInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingOpportunityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["seller"] = this.seller ? this.seller.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListingOpportunityInput {
    address?: ListingAddressInput | undefined;
    seller?: ListingSellerOpportunityInput | undefined;
}

export class ListingSellerOpportunityInput implements IListingSellerOpportunityInput {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IListingSellerOpportunityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): ListingSellerOpportunityInput {
        data = typeof data === 'object' ? data : {};
        let result = new ListingSellerOpportunityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IListingSellerOpportunityInput {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class UpdateSharedOpportunityStatusCommand implements IUpdateSharedOpportunityStatusCommand {
    id?: string | undefined;
    status?: SharedOpportunityStatus;

    constructor(data?: IUpdateSharedOpportunityStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateSharedOpportunityStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSharedOpportunityStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateSharedOpportunityStatusCommand {
    id?: string | undefined;
    status?: SharedOpportunityStatus;
}

export enum CommunicationConsentStatus {
    Accepted = 0,
    Denied = 1,
}

export class CreateCommunicationConsentCommand implements ICreateCommunicationConsentCommand {
    recipientEmail?: string | undefined;
    status?: CommunicationConsentStatus;

    constructor(data?: ICreateCommunicationConsentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientEmail = _data["recipientEmail"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateCommunicationConsentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommunicationConsentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientEmail"] = this.recipientEmail;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateCommunicationConsentCommand {
    recipientEmail?: string | undefined;
    status?: CommunicationConsentStatus;
}

export class CreateLeadCommand implements ICreateLeadCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;

    constructor(data?: ICreateLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
        }
    }

    static fromJS(data: any): CreateLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        return data;
    }
}

export interface ICreateLeadCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
}

export class UserDto implements IUserDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    preferredName?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    websiteUrl?: string | undefined;
    linkedinUrl?: string | undefined;
    instagram?: string | undefined;
    tikTok?: string | undefined;
    agreeToPostProfile?: boolean;
    fieldsHiddenFromPublic?: string[] | undefined;
    createdDateTimeUtc?: Date | undefined;
    lastLoginDateTimeUtc?: Date | undefined;
    creationSource?: ApplicationUserCreationSource;
    profileImage?: ImageMediaDto | undefined;
    identityVerification?: IdentityVerificationDto | undefined;
    lastPersonaIdentityVerification?: PersonaVerificationDto | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.preferredName = _data["preferredName"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.websiteUrl = _data["websiteUrl"];
            this.linkedinUrl = _data["linkedinUrl"];
            this.instagram = _data["instagram"];
            this.tikTok = _data["tikTok"];
            this.agreeToPostProfile = _data["agreeToPostProfile"];
            if (Array.isArray(_data["fieldsHiddenFromPublic"])) {
                this.fieldsHiddenFromPublic = [] as any;
                for (let item of _data["fieldsHiddenFromPublic"])
                    this.fieldsHiddenFromPublic!.push(item);
            }
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : <any>undefined;
            this.lastLoginDateTimeUtc = _data["lastLoginDateTimeUtc"] ? new Date(_data["lastLoginDateTimeUtc"].toString()) : <any>undefined;
            this.creationSource = _data["creationSource"];
            this.profileImage = _data["profileImage"] ? ImageMediaDto.fromJS(_data["profileImage"]) : <any>undefined;
            this.identityVerification = _data["identityVerification"] ? IdentityVerificationDto.fromJS(_data["identityVerification"]) : <any>undefined;
            this.lastPersonaIdentityVerification = _data["lastPersonaIdentityVerification"] ? PersonaVerificationDto.fromJS(_data["lastPersonaIdentityVerification"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["preferredName"] = this.preferredName;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["websiteUrl"] = this.websiteUrl;
        data["linkedinUrl"] = this.linkedinUrl;
        data["instagram"] = this.instagram;
        data["tikTok"] = this.tikTok;
        data["agreeToPostProfile"] = this.agreeToPostProfile;
        if (Array.isArray(this.fieldsHiddenFromPublic)) {
            data["fieldsHiddenFromPublic"] = [];
            for (let item of this.fieldsHiddenFromPublic)
                data["fieldsHiddenFromPublic"].push(item);
        }
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : <any>undefined;
        data["lastLoginDateTimeUtc"] = this.lastLoginDateTimeUtc ? this.lastLoginDateTimeUtc.toISOString() : <any>undefined;
        data["creationSource"] = this.creationSource;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["identityVerification"] = this.identityVerification ? this.identityVerification.toJSON() : <any>undefined;
        data["lastPersonaIdentityVerification"] = this.lastPersonaIdentityVerification ? this.lastPersonaIdentityVerification.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    preferredName?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    websiteUrl?: string | undefined;
    linkedinUrl?: string | undefined;
    instagram?: string | undefined;
    tikTok?: string | undefined;
    agreeToPostProfile?: boolean;
    fieldsHiddenFromPublic?: string[] | undefined;
    createdDateTimeUtc?: Date | undefined;
    lastLoginDateTimeUtc?: Date | undefined;
    creationSource?: ApplicationUserCreationSource;
    profileImage?: ImageMediaDto | undefined;
    identityVerification?: IdentityVerificationDto | undefined;
    lastPersonaIdentityVerification?: PersonaVerificationDto | undefined;
}

export enum ApplicationUserCreationSource {
    Manual = 0,
    Google = 1,
    Apple = 2,
    OtpSignIn = 3,
}

export class PaginatedResultOfUserDto extends PaginatedResult implements IPaginatedResultOfUserDto {
    entities?: UserDto[] | undefined;

    constructor(data?: IPaginatedResultOfUserDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfUserDto extends IPaginatedResult {
    entities?: UserDto[] | undefined;
}

export enum VerificationFilter {
    All = 0,
    Verified = 1,
    Unverified = 2,
}

export class SendVerificationCommand implements ISendVerificationCommand {
    verificationType?: VerificationType;

    constructor(data?: ISendVerificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationType = _data["verificationType"];
        }
    }

    static fromJS(data: any): SendVerificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationType"] = this.verificationType;
        return data;
    }
}

export interface ISendVerificationCommand {
    verificationType?: VerificationType;
}

export enum VerificationType {
    Email = 0,
    Phone = 1,
}

export class ValidateVerificationCommand implements IValidateVerificationCommand {
    verificationId?: string | undefined;
    code?: string | undefined;

    constructor(data?: IValidateVerificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationId = _data["verificationId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ValidateVerificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateVerificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationId"] = this.verificationId;
        data["code"] = this.code;
        return data;
    }
}

export interface IValidateVerificationCommand {
    verificationId?: string | undefined;
    code?: string | undefined;
}

export class ResendVerificationCommand implements IResendVerificationCommand {
    verificationId?: string | undefined;

    constructor(data?: IResendVerificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationId = _data["verificationId"];
        }
    }

    static fromJS(data: any): ResendVerificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationId"] = this.verificationId;
        return data;
    }
}

export interface IResendVerificationCommand {
    verificationId?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}